{
    "type": "FeatureCollection",
    "features": [
        {
            "id": "08f8011b347310c4039c1443b0fa63be",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -40.35,
                    -3.7
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "fountain",
                        "monument"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/340529576105512"
                ],
                "phones": [
                    "+558894143498"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "APRAZIVEL",
                        "locality": "Sobral",
                        "postcode": null,
                        "region": "CE",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "340529576105512",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DIOGO PVC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f75c6c86b045038a21728ca06b23",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.403268,
                    37.4314451
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "travel",
                        "beach"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.pietraemaremykonos.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/235556439800068"
                ],
                "phones": [
                    "+302289071152"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kalo Livadi beach",
                        "locality": null,
                        "postcode": "846 00",
                        "region": null,
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "235556439800068",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pietra e Mare - Mykonos Moments",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19436d1860c150358e3f8a9a32082",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.9032817,
                    52.3293792
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hardware_store",
                    "alternate": [
                        "furniture_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/290957851238816"
                ],
                "phones": [
                    "+441604281278"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "128c Northampton Road",
                        "locality": "Northampton",
                        "postcode": "NN6 9BU",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "290957851238816",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ace Reuse Ltd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4995ba5d8059c036d05e44a41db37",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.186315,
                    19.381645
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "landmark_and_historical_building",
                        "mexican_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/334281536779673"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "334281536779673",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Holbein Place",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa82994980a0cb03ba7904f278d7f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -54.249864,
                    -24.0821057
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "professional_services",
                        "event_photography"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.giovanitrebien.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/454990801225930"
                ],
                "phones": [
                    "+554436421616"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Mate Laranjeiras, 764",
                        "locality": "Guaíra",
                        "postcode": "85980-000",
                        "region": "PR",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "454990801225930",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Revelest agora é Trebien Fotografias",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8d45d4604150329229c4fd983df",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.525764,
                    48.139857
                ]
            },
            "properties": {
                "categories": {
                    "primary": "private_investigation",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.apex-detektive.de/einsatzgebiete/bayern/muenchen.html"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08999919727"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Landsberger Str. 155",
                        "locality": "München",
                        "postcode": "80687",
                        "region": "Bayern",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949961748247",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849865753688",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Detektei Apex Detektive GmbH München",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fcf9e8e9449c0203db4cce2d9e0dd6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -67.5969028,
                    -45.9972299
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/371736286577004"
                ],
                "phones": [
                    "+542974470989"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Comodoro Rivadavia",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "371736286577004",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Servicio de Medicina Nuclear",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194276d35635b03ff9d9715d6899f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.4694,
                    53.30473
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114165153699462"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dronfield",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114165153699462",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Perfectly personlised by Steph",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1951a6151370503373aa8b1c06cb9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.2444445,
                    53.3147336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": [
                        "wholesale_store"
                    ]
                },
                "confidence": 0.9897612903225806,
                "websites": [
                    "http://www.cdtcars.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104972751892202"
                ],
                "phones": [
                    "+447891661833"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Chesham Road",
                        "locality": "Wilmslow",
                        "postcode": "SK9 6EZ",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104972751892202",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474979052522",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CDT CARS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44db82216079003b8daa75ac9e562",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.3198943,
                    35.7239156
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mexican_restaurant",
                    "alternate": [
                        "restaurant",
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "https://onlineordering.rmpos.com/order/?wci=xkwtl2vp"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108225589218981"
                ],
                "phones": [
                    "+18283283600"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "715 Lenoir Rhyne Blvd SE",
                        "locality": "Hickory",
                        "postcode": "28602-4132",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108225589218981",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rancho Viejo Mexican Grill",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe0e2ac4d234803f32994479581ad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    151.3258958,
                    -33.638034
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "education",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9084967320261438,
                "websites": [
                    "https://www.integratedbowen.com/bowen-therapy-training-options/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189036671263550"
                ],
                "phones": [
                    "+61422999480"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ellerina Road",
                        "locality": "Mount Martha",
                        "postcode": "3934",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189036671263550",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Integrated Bowen Therapy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2bae543b84165037a390f2ec70d2a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.6982967,
                    46.6153258
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "beauty_and_spa",
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.uniprix.com/fr/succursales/germain-et-trepanier-shawinigan"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8195381655"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1050, 8e Rue",
                        "locality": "Grand-Mère",
                        "postcode": "G9T 4L4",
                        "region": "QC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899907616966",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Uniprix Philippe Germain et David Trépanier - Pharmacie affiliée",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8b2c8a46da79103bf7688fc4be23f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -66.1470938,
                    -17.4196064
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101622855685377"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Cochabamba",
                        "postcode": null,
                        "region": null,
                        "country": "BO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101622855685377",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "A&R aviones artesanales ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb5e192046031f3fe3902531ee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.88854,
                    21.07301
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/387149144474208"
                ],
                "phones": [
                    "+84352354753"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "116 Đường Nam Đuống",
                        "locality": "Quận Long Biên",
                        "postcode": "11808",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "387149144474208",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kenpengshoop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa25092cdb4b250330496ac2958f26",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.27964,
                    -20.99925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_consultant",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.proteinlabs.re/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/157657734091461"
                ],
                "phones": [
                    "+262692300307"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Saint-Paul",
                        "postcode": null,
                        "region": "RE",
                        "country": "RE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "157657734091461",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Protein Labs ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6acc2cb11898503850898ce8590a3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.5739463,
                    0.3310101
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "theatre",
                        "taxi_service"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2187051551573937"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "wandegeya",
                        "locality": "Kampala",
                        "postcode": null,
                        "region": null,
                        "country": "UG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2187051551573937",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "kalerwe,kasangati,mpererwe,bwaise,kawempe stage",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0b8065b95503ed4c6c40d5418f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.20912,
                    24.95191
                ]
            },
            "properties": {
                "categories": {
                    "primary": "middle_school",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/923783094374814"
                ],
                "phones": [
                    "+886963591912"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "育達路160號",
                        "locality": "桃園市",
                        "postcode": "324",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "923783094374814",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "「 Third Person 」產品設計",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415dc2874b08003bb93739541d85c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.43711,
                    21.17729
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112026008661378"
                ],
                "phones": [
                    "+84869717729"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Marie Molly Jr",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "17729 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112026008661378",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Niko Pulliam Melia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa0a164010c30337dd52ba3faa73",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.01489,
                    50.71504
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://nwc-media.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101003115736725"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "La Calamine",
                        "postcode": null,
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101003115736725",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "nwc-media.com",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f269c24b729a74032cccdd7c87b334",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -107.8750803,
                    38.4803656
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.9905427631578948,
                "websites": [
                    "http://www.montrosecf.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/168705193248921"
                ],
                "phones": [
                    "+19702493900"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "15 S Uncompahgre Ave",
                        "locality": "Montrose",
                        "postcode": "81401-3980",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "168705193248921",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949966249560",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799821319261",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Montrose Community Foundation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa2249c3486003f67be82daf9a9c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.972184,
                    49.4954013
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.jesus.lu/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113888338648411"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "138 Rue Victor Hugo",
                        "locality": "Esch-sur-Alzette",
                        "postcode": "4141",
                        "region": null,
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113888338648411",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eglise La Source",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab2c9b31c533031c87d4a7da8c4e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.4043432,
                    42.3945179
                ]
            },
            "properties": {
                "categories": {
                    "primary": "surgical_appliances_and_supplies",
                    "alternate": [
                        "medical_supply",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.binsons.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2131744653505986"
                ],
                "phones": [
                    "+17346552865"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Binson's Medical Equipment & Supplies",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "36475 5 Mile Rd",
                        "locality": "Livonia",
                        "postcode": "48154-1971",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2131744653505986",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424933801437",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932544884",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Binson's Medical Equipment and Supplies",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2832ba14b4475031f6a87308a6dfd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.383415,
                    38.599809
                ]
            },
            "properties": {
                "categories": {
                    "primary": "general_dentistry",
                    "alternate": [
                        "pediatric_dentist",
                        "dentist"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://brightsmilesacramento.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9164822777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1901 Watt Ave Ste 6",
                        "locality": "Sacramento",
                        "postcode": "95825",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799819562538",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mohamed Elhassanin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a9a942c1d730332bfa45a579547",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.55695,
                    28.52057
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_school",
                    "alternate": [
                        "art_school",
                        "tutoring_center"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "http://bamazingmusic.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/456558851185563"
                ],
                "phones": [
                    "+13213179641"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Windermere dr. ",
                        "locality": "Windermere",
                        "postcode": "34786",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "456558851185563",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "B Amazing Music, Central Florida's Premier In-Home Music Lessons",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f605a1d8984503db795d7b1acb31",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.15602,
                    56.9867382
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.kristianahandmade.lv/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115790148287595"
                ],
                "phones": [
                    "+37129361712"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pavasara iela 7",
                        "locality": "Tukums",
                        "postcode": "3101",
                        "region": null,
                        "country": "LV"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115790148287595",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KristianaHandmade",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19598ca4905140387dfd5d8ecce1d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.2125077,
                    50.9532315
                ]
            },
            "properties": {
                "categories": {
                    "primary": "acupuncture",
                    "alternate": [
                        "health_and_medical",
                        "professional_services"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.fourthplinthacupuncture.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/134114863115438"
                ],
                "phones": [
                    "+447387824812"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "At Health Space, The Square",
                        "locality": null,
                        "postcode": "SO32 1AF",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "134114863115438",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fourth Plinth Acupuncture",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f818375161a2c503f6b3da0be4e21a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -34.8525059,
                    -7.1924102
                ]
            },
            "properties": {
                "categories": {
                    "primary": "adult_entertainment",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/553001631377657"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "País Das Maravilhas",
                        "locality": "São José",
                        "postcode": null,
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "553001631377657",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Em Algum Lugar Entre O Céu E A Terra",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3060142130e0324ba638be9dadf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.226708,
                    42.447138
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://www.chyten.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7815416279"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1723 Massachusetts Ave",
                        "locality": "Lexington",
                        "postcode": "02420",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976788899",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chyten Premier Tutoring and Test Preparation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66e0904311a2403524e1c8430e83b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.11739,
                    4.62005
                ]
            },
            "properties": {
                "categories": {
                    "primary": "jewelry_store",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://wa.me/c/573017992558"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297203593468588"
                ],
                "phones": [
                    "+573017992558"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Tienda Virtual",
                        "locality": "Bogotá",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297203593468588",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "5 Diamantes Relojeria Y Joyeria",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4519a449935560357971f2815544b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.72686,
                    21.22358
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110251838273083"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Isla Mujeres",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110251838273083",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cámara Hiperbarica Isla Mujeres",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f12682a7046303a7ca10666e22f0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.0742141,
                    51.1077076
                ]
            },
            "properties": {
                "categories": {
                    "primary": "veterinarian",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.tgz-am-rothaarsteig.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109767451293951"
                ],
                "phones": [
                    "+4927237167280"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wigeystraße 10",
                        "locality": "Lennestadt",
                        "postcode": "57368",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109767451293951",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tiergesundheitszentrum am Rothaarsteig",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415d09c7b3988036e5566ac38cec1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.06657,
                    21.47601
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106988762503070"
                ],
                "phones": [
                    "+84869747601"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "McKelvey Roni Petro",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "47601 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106988762503070",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Donnelly Matt Emma",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6636982a14e03608cc2a344e112",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    137.3071289,
                    35.0884506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "educational_research_institute",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1483913051845826"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": " Aichi Ken Nagoya Meitoku",
                        "locality": null,
                        "postcode": "454-0996",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1483913051845826",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "日本語,英語,フィリピン語,学び",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f608e4f4b0ea200319078d7484d7f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.73439,
                    19.08915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": [
                        "travel",
                        "bank_credit_union"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1417619774964095"
                ],
                "phones": [
                    "+102412343439"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ahmednagar",
                        "locality": null,
                        "postcode": "414001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1417619774964095",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ahmednagar Shahar Sahakari Bank Maliwada Branch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6145501544803a3cb562b216d4d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.7293053,
                    35.0047269
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "religious_organization",
                        "church_cathedral"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://kasuga.or.jp/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/410619095989326"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Saiinkasugacho",
                        "locality": null,
                        "postcode": "615-0015",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "410619095989326",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "2258684547534870",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "100942721524182",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "西院春日神社勤皇隊",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19586e20768b0039bc48dc32aee64",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.9887866,
                    51.3229138
                ]
            },
            "properties": {
                "categories": {
                    "primary": "nursery_and_gardening",
                    "alternate": [
                        "farm",
                        "rv_park"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.slimeridgefarm.co.uk"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1518709754807544"
                ],
                "phones": [
                    "+101934641641"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Links Rd",
                        "locality": null,
                        "postcode": "BS23 4XY",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1518709754807544",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Slimeridge Farm",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196ba1cab1a50039da649a3f40bd7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.3267484,
                    51.8497853
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "irish_pub",
                        "irish_restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.murraysirishpub.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/444615989073994"
                ],
                "phones": [
                    "+31181507010"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Spuistraat 2",
                        "locality": "Spijkenisse",
                        "postcode": "3201 AR",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "444615989073994",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Murray's Irish Pub & Whiskey Bar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f261a75b76244b03ca334132e1b763",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -100.62221,
                    40.1949
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/216164238245114"
                ],
                "phones": [
                    "+13083453614"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "203 Karrer St",
                        "locality": "McCook",
                        "postcode": "69001",
                        "region": "NE",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "216164238245114",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Angelina Jolie Fanclub",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f596c4329b4003f24a961d9c086e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.3812786,
                    34.9771776
                ]
            },
            "properties": {
                "categories": {
                    "primary": "central_government_office",
                    "alternate": [
                        "public_and_government_association",
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/158385167556514"
                ],
                "phones": [
                    "+81542549131"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "静岡県静岡市葵区追手町９−５０",
                        "locality": "静岡市葵区",
                        "postcode": "420-0853",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "158385167556514",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "静岡地方法務局登記事項証明書交付等問い合わせ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe0e35c0cb59e03ab9288c723ccb7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    151.2084469,
                    -33.8575259
                ]
            },
            "properties": {
                "categories": {
                    "primary": "barber",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.uptownbarbers.com.au/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "1800878696"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "31 George St",
                        "locality": "The Rocks",
                        "postcode": "2000",
                        "region": "New South Wales",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474980687442",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Uptown Barbers The Rocks",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a129b40632603639aae18b01fe4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.0754929,
                    26.3717117
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_management_services",
                    "alternate": [
                        "consultant_and_general_service",
                        "software_development"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5613959322"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2424 N Federal Hwy 100",
                        "locality": "Boca Raton",
                        "postcode": "33431",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424931979494",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Runner EDQ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f45263610e455803c618d09ea36c30",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.9930152,
                    14.9411721
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "cabin",
                        "hotel"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/426040494232128"
                ],
                "phones": [
                    "+50497071266"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Km 8 carretera La Guama a Peña Blanca",
                        "locality": "Santa Cruz de Yojoa",
                        "postcode": "504",
                        "region": null,
                        "country": "HN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "426040494232128",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cabañas Estoraque",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2675d83d6b46203e365695e6da5e5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.5772297,
                    41.5593593
                ]
            },
            "properties": {
                "categories": {
                    "primary": "florist",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://sbfloraltoo.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    ""
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3811 N Harrison St",
                        "locality": "Davenport",
                        "postcode": "52806",
                        "region": "IA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949966108805",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SB Floral Too",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec2690d2a5950312176e93633f7b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.8049015,
                    40.6698099
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pancake_house",
                    "alternate": [
                        "cafe"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111098962014383"
                ],
                "phones": [
                    "+302316025754"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Πλ. Δημοκρατίας",
                        "locality": null,
                        "postcode": "574 00",
                        "region": null,
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111098962014383",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Panda Yummy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e0418e6c59b3031166717346b069",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.2723717,
                    49.5972024
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://neon-reklama.cz/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/130492187121980"
                ],
                "phones": [
                    "+420732420966"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Olomouc",
                        "postcode": null,
                        "region": null,
                        "country": "CZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "130492187121980",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NEON - nejen světelná reklama",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1042d72ac4603a6cb95aff2139b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.212308,
                    40.9549444
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "cosmetic_dentist",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "http://www.dynamicdentalart.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/335635903298845"
                ],
                "phones": [
                    "+19735958700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "504 Hamburg Tpke",
                        "locality": "Wayne",
                        "postcode": "07470-2011",
                        "region": "NJ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "335635903298845",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949959873821",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949959236202",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dynamic Dental Arts: Lori VanderWende-Bleeker, DMD",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4bb101e53664003e87b103151149e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.35148,
                    22.64637
                ]
            },
            "properties": {
                "categories": {
                    "primary": "italian_restaurant",
                    "alternate": [
                        "restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/524917847596954"
                ],
                "phones": [
                    "+88677805998"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "濱山街57號",
                        "locality": "高雄市",
                        "postcode": "830",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "524917847596954",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "義爵式創意輕食",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29ab8348640ac03c78480a274dbf7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -119.8406677,
                    36.7690315
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "broadcasting_media_production",
                        "dance_club"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/751318228225236"
                ],
                "phones": [
                    "+15595798929"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Fresno",
                        "postcode": null,
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "751318228225236",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blacksheep Productions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30e1ca1cb120a03e204443c9a8b56",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    127.039846,
                    37.517419
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "costume_store",
                        "diner"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1651915338449066"
                ],
                "phones": [
                    "+82222771666"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "논현동 118-4 ",
                        "locality": "Seoul",
                        "postcode": null,
                        "region": null,
                        "country": "KR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1651915338449066",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "김태기선한복",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f608b5565a2d15037bee06717bc081",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    72.99692,
                    19.18856
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "shopping_center"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1884567458465045"
                ],
                "phones": [
                    "+919870263662"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ishwar Nagar, Digha",
                        "locality": null,
                        "postcode": "400708",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1884567458465045",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gajanana Steel Bhandar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a15ca17a6a1a031a3361974c3762",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.5651998,
                    41.2894044
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpet_store",
                    "alternate": [
                        "contractor",
                        "professional_services"
                    ]
                },
                "confidence": 0.9897612903225806,
                "websites": [
                    "http://www.neofloorsct.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/278687832486290"
                ],
                "phones": [
                    "+12034011239"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "311 River Rd",
                        "locality": "Madison",
                        "postcode": "06443-2524",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "278687832486290",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374891053920",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912767337",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "New England Overland Floor Specialists",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6842af12547a203808bda24ac258a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    124.64675,
                    8.47238
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108390382276384"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6",
                        "locality": "Cagayan de Oro",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108390382276384",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "YU MI",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f49ab59329c096034b0dc35404df08",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -103.405,
                    20.65728
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "counseling_and_mental_health",
                        "aromatherapy"
                    ]
                },
                "confidence": 0.9119318181818182,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/306545685886167"
                ],
                "phones": [
                    "+523314859801"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Glorieta Chapalita",
                        "locality": "Zapopan",
                        "postcode": "45040",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "306545685886167",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Claudia Ortiz Terapeuta",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6676359b230c103c57411d768e499",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.75869,
                    7.08693
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/266144709920987"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Frente al CAÍ del malecón ",
                        "locality": "Arauca",
                        "postcode": "810001",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "266144709920987",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Deli Río Arauca",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e6a9d969730375ce9839f66272",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1300822,
                    51.5705472
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "diner"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/175239895675347"
                ],
                "phones": [
                    "+441708897567"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1120 High Road",
                        "locality": "Romford",
                        "postcode": "RM6 4",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "175239895675347",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Million's Lounge & Restaurant",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c1e4294e902503c28d0298a00153",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    86.1352911,
                    25.4173111
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://near-me.hdfcbank.com/branch-atm-locator/hdfc-bank-atm-kutchery-chowk-atm-kutchery-chowk-begusarai-18161/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "09426792001"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Today Market Complex, Kutchery Chowk",
                        "locality": "Begusarai",
                        "postcode": "851101",
                        "region": "Bihar",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863164892",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863163893",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HDFC Bank ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f411cb102712cd03208a4961561ce3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    114.1094,
                    22.37265
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive",
                        "auto_customization"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "http://www.ml-motors.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/140422019320440"
                ],
                "phones": [
                    "+85226882132"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wing Hing Industrial Building, 83 Chai Wan JiaoJie",
                        "locality": "New Territories",
                        "postcode": null,
                        "region": null,
                        "country": "HK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "140422019320440",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "馬霖汽車 M&L Motors Co Ltd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f393367658c4c4039b5e2a2c45135f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -9.136184,
                    38.7112848
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_and_dvd_store",
                    "alternate": [
                        "shopping",
                        "dance_school"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.kizombalovers.pt/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/514612415391548"
                ],
                "phones": [
                    "+351918764533"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Estação do Metro dos Restauradores Loja 8",
                        "locality": "Lisbon",
                        "postcode": null,
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "514612415391548",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KizombaLovers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194d0d1db6216039a4f65e5e62989",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.01609,
                    50.93018
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/215642598463292"
                ],
                "phones": [
                    "+32473861618"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kattestraat 12",
                        "locality": "Staden",
                        "postcode": "8840",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "215642598463292",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Coiffure Chantal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c0f659c0b4034927c80f50bef1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.9776502,
                    29.7376138
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sunglasses_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2812320012"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1015 Polly St Ste 1",
                        "locality": "Baytown",
                        "postcode": "77520",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976913320",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eyewearshop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6032b41cd865d030e6f551e445358",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.70612,
                    11.31018
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108915085088042"
                ],
                "phones": [
                    "+917868958959"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rangampalayam",
                        "locality": "Erode",
                        "postcode": "638009",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108915085088042",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sana Construction",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c138d88ecb01034793ca48006e10",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.09774,
                    25.57029
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_gallery",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109952744654692"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Patna",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109952744654692",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sujata mondal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1940421c3078a0383ff71e84ad417",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.332966,
                    53.788352
                ]
            },
            "properties": {
                "categories": {
                    "primary": "it_service_and_computer_repair",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07907027209"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "50 Langtree Close, Bransholme",
                        "locality": "Hull",
                        "postcode": "HU7 4DZ",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899907406190",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Small Stepps - Computer Repairs In Hull",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4bb18f45aed4003999d1561321927",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.227208,
                    22.95937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "noodles_restaurant",
                    "alternate": [
                        "food_stand",
                        "restaurant"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/185975321456223"
                ],
                "phones": [
                    "+886932804637"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "保華路14號",
                        "locality": "台南市",
                        "postcode": "717",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "185975321456223",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "二空村長涼麵",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa2b804ca6b60394cba13f69344b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.2373211,
                    49.7790761
                ]
            },
            "properties": {
                "categories": {
                    "primary": "playground",
                    "alternate": [
                        "park",
                        "active_life"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2241732032765726"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenue des Combattants 9",
                        "locality": "Herbeumont",
                        "postcode": "6887",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2241732032765726",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Plaine de jeux",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41436950c15160315567da6bea72d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7470989,
                    21.0075466
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/131384696720356"
                ],
                "phones": [
                    "+84941345601"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Nam Từ Liêm",
                        "locality": "Hanoi",
                        "postcode": "12000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "131384696720356",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shop Hoa Tươi Quận Nam Từ Liêm đặt hoa tươi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f186335b709895037c66441755dcce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.1976179,
                    47.6219919
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tobacco_shop",
                    "alternate": [
                        "grocery_store",
                        "caterer"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1544241675874227"
                ],
                "phones": [
                    "+33240076594"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "13B Rue du Château",
                        "locality": "La Chapelle-Glain",
                        "postcode": "44670",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1544241675874227",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "VOTRE Marche Le p'tit Marchand",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da225d46b93303e2798e2276a3c7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.5744998,
                    27.0451302
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://youtube.com/channel/uczvbagvm7jh14xnk-kw79oa"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103427068757764"
                ],
                "phones": [
                    "+917597126224"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "rajsthan ",
                        "locality": "Bandikui",
                        "postcode": "��",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103427068757764",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Status Video",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d29119228a3003d83d06091199f8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.4671,
                    14.63325
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101225194985336"
                ],
                "phones": [
                    "+50256311821"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Guatemala ",
                        "locality": "Guatemala City",
                        "postcode": null,
                        "region": null,
                        "country": "GT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101225194985336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chicky's Socks",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a548495538d03cdd5817451e682",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.7576389,
                    33.5144275
                ]
            },
            "properties": {
                "categories": {
                    "primary": "seafood_restaurant",
                    "alternate": [
                        "restaurant",
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://www.montagehotels.com/lagunabeach/dining/mosaic"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/176391032406220"
                ],
                "phones": [
                    "+19497156020"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "30801 S Coast Hwy",
                        "locality": "Laguna Beach",
                        "postcode": "92651",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "176391032406220",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mosaic Bar and Grille at Montage Laguna Beach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ce460a074aae0306f6caa086431b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.17602,
                    26.36979
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/118684711219812"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "kokrajhar Assam ",
                        "locality": "Kokrajhar",
                        "postcode": "783345",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "118684711219812",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ak bhai",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f266cdac2c4b8a0300b3b43e7b9e61",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.0648483,
                    39.4884768
                ]
            },
            "properties": {
                "categories": {
                    "primary": "taco_restaurant",
                    "alternate": [
                        "mexican_restaurant",
                        "food"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.roscoestacos.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3174946173"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "912 North Morton Street",
                        "locality": "Franklin",
                        "postcode": "46131",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949960148648",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960041209",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885484735",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Roscoe's Tacos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f411cb3204dd36039309c9df9dbe26",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    114.146893,
                    22.336424
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1042050379160890"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "17 Cheung Shun St",
                        "locality": "Kowloon",
                        "postcode": null,
                        "region": null,
                        "country": "HK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1042050379160890",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Maxim's Centre 美心集團中心",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f49956432c82d6037f495755d6a45d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.75693,
                    20.1185974
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_stand",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108119328858872"
                ],
                "phones": [
                    "+527711199206"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "calle quetzalcoatlnncol. aquiles serdan ",
                        "locality": "Pachuca",
                        "postcode": "42034",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108119328858872",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "tacos el danny",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1126d40da50920399ee6a3226ade9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.0730296,
                    60.33106
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://www.ad-finland.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/163485520475605"
                ],
                "phones": [
                    "+35898735722"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rekolantie 60",
                        "locality": "Vantaa",
                        "postcode": "01400",
                        "region": null,
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "163485520475605",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rekolan Autohuolto ja rengasmyynti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eca68ed241ac03ba59315571415c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.6171054,
                    39.549451
                ]
            },
            "properties": {
                "categories": {
                    "primary": "barbecue_restaurant",
                    "alternate": [
                        "steakhouse"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/326684684548583"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "326684684548583",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kucukkuyu Kokoreccisi Serhatin Yeri",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e15b7322ab9b0383d03da16ae25a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.3597668,
                    48.1920084
                ]
            },
            "properties": {
                "categories": {
                    "primary": "doctor",
                    "alternate": [
                        "acupuncture",
                        "naturopathic_holistic"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://dr-waroschitz.at/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/250854332036118"
                ],
                "phones": [
                    "+4315444979"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Margaretenstraße 71-73",
                        "locality": "Wien",
                        "postcode": "1050",
                        "region": "9",
                        "country": "AT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "250854332036118",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dr. Sandra Leeb - Wahlärztin Praxis für Komplementärmedizin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44cbd0c04e4b203b6598a5fa976c4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.2473385,
                    36.0175556
                ]
            },
            "properties": {
                "categories": {
                    "primary": "financial_service",
                    "alternate": [
                        "installment_loans",
                        "mortgage_broker"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "https://www.onemainfinancial.com/branches/tn/oak-ridge/37830/4116?utm_source=facebook&utm_medium=local&utm_campaign=facebook-local"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/168827963127248"
                ],
                "phones": [
                    "+18654822414"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "OneMain Financial",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "1181 Oak Ridge Tpke",
                        "locality": "Oak Ridge",
                        "postcode": "37830-6442",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "168827963127248",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424934517453",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324838642637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890432658",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890431136",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890429544",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "OneMain Financial",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa895748b4c2d003ba294e45deb961",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -40.29822,
                    -20.30567
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/140106716181715"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Doutor Eurico de Aguiar, 131",
                        "locality": "Vitória",
                        "postcode": "29056-200",
                        "region": "ES",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "140106716181715",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Studio Mari Ribeiro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c3a416b7b3039991ac3e25b209",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.8547042,
                    52.4609326
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cleaning_services",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01217535673"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unit 1 Armoury Road Small Heath Tradin, G Estate",
                        "locality": "Birmingham",
                        "postcode": "B11 2RJ",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424930902309",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908607281",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Argonaut Community Enterprises Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81023536059b030ae8aa1b554f7f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.913435,
                    -23.4456657
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": [
                        "pub",
                        "tapas_bar"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104936554903572"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Coronel Raimundo, 25",
                        "locality": "Santana de Parnaíba",
                        "postcode": "06501-010",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104936554903572",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Golden Hop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f265d6957025ad036f7fdaff2ef603",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.732148,
                    35.81816
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": [
                        "bank_credit_union",
                        "financial_service"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://www.simmonsbank.com/locations/jonesboro-woodsprings-atm?utm_source=extnet&utm_medium=yext&utm_campaign=locallistings"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/691079807733028"
                ],
                "phones": [
                    "+18662462400"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Simmons Bank",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "1921 Woodsprings Rd",
                        "locality": "Jonesboro",
                        "postcode": "72401-0936",
                        "region": "AR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "691079807733028",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949962078870",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Simmons Bank ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66b4533a1354e03cfe9ce6b291245",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.021614,
                    9.659502
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://movilteccr.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103512124561576"
                ],
                "phones": [
                    "+50684486582"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "San Marcos de Tarrazú",
                        "locality": "San Marcos",
                        "postcode": "10501",
                        "region": null,
                        "country": "CR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103512124561576",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Móviltec CR",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e881b20a908e039a9dccd8f8b976",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.4914,
                    41.24504
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fishmonger",
                    "alternate": [
                        "eat_and_drink",
                        "seafood_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.paginefianche.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107819981537714"
                ],
                "phones": [
                    "+393450131221"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via della Libertà, 210",
                        "locality": "Bisceglie",
                        "postcode": "76011",
                        "region": "75",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107819981537714",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pescheria da Enrico",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2641ad6d8176d030e176dc8ab3134",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.3739321,
                    37.3972489
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_center",
                    "alternate": [
                        "active_life",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/120987694581202"
                ],
                "phones": [
                    "+12709884944"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2004 Main St",
                        "locality": "Carrsville",
                        "postcode": "42081-9413",
                        "region": "KY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "120987694581202",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Carrsville Community Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4986441261b550394fac121857066",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.653163,
                    19.279813
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_and_dvd_store",
                    "alternate": [
                        "travel_services",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/642661459185648"
                ],
                "phones": [
                    "+527222105739"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Rafael M. Hidalgo 200",
                        "locality": "Toluca",
                        "postcode": "50130",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "642661459185648",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oceanus Rock",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf28855a406503c974b80f241847",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.44324,
                    22.68576
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/224844318020200"
                ],
                "phones": [
                    "+919143281688"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bankim Chaterjee Road",
                        "locality": "Kolkata",
                        "postcode": "700131",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "224844318020200",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Maa Manosha Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12ccc71c9dd09038f2094e61cb2ba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -114.0093834,
                    50.8742062
                ]
            },
            "properties": {
                "categories": {
                    "primary": "builders",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://app.tricohomes.com/community-search/community/wolf-willow"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4034570856"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "103 & 107 Wolf Creek Rise SE",
                        "locality": "Calgary",
                        "postcode": "T2X 4Z2",
                        "region": "AB",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849866231513",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849866231508",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trico Homes Wolf Willow Front Attached",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa7948daac10395fdc6328708f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.56817,
                    55.65153
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://hmns.ru/ru.pdf"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115289353164832"
                ],
                "phones": [
                    "+74993905694"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Херсонская улица 9 корп 1",
                        "locality": "Москва",
                        "postcode": "117461",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115289353164832",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Humans",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f61a5660840303bba6f637b55622",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.58108,
                    -4.5096562
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/349230384941061"
                ],
                "phones": [
                    "+51991095920"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Nauta",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "349230384941061",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ANGEL Y Cupido",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f18b24b8e81903472a7e42f4ffe8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.3820561,
                    52.4943259
                ]
            },
            "properties": {
                "categories": {
                    "primary": "physical_therapy",
                    "alternate": [
                        "beauty_and_spa",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.bellardi.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1735578473368067"
                ],
                "phones": [
                    "+493023624266"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hornstraße 5",
                        "locality": "Berlin",
                        "postcode": "10963",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1735578473368067",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Physiotherapy Practice Bellardi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f81326dd06b0d103ee0afdbe5be0ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -38.9450194,
                    -13.8894251
                ]
            },
            "properties": {
                "categories": {
                    "primary": "property_management",
                    "alternate": [
                        "real_estate",
                        "holiday_rental_home"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.facebook.com/casatrescoqueiros"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104792203633281"
                ],
                "phones": [
                    "+5527999043570"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua H, 1",
                        "locality": "Maraú",
                        "postcode": "45520-000",
                        "region": "BA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104792203633281",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Casa Barra Grande, BA.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f112cd8d5a20f403deae1ce89f843b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.7180552,
                    62.9248841
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": [
                        "cafe"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.trube.fi/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1685381671600756"
                ],
                "phones": [
                    "+358447668366"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kellonkärki 8",
                        "locality": "Kuopio",
                        "postcode": "70460",
                        "region": null,
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1685381671600756",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trube",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea342b20c16203158586c6b20b7c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.5202584,
                    43.6670255
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cinema",
                    "alternate": [
                        "theatre"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.cinemaluxurbania.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/330100363700618"
                ],
                "phones": [
                    "+390722317324"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Giacomo Leopardi, 19",
                        "locality": "Urbania",
                        "postcode": "61049",
                        "region": "57",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "330100363700618",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lux Cinema Theater",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8081889184803b45bcbb6474b32",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.854796,
                    42.3993456
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "home_service"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1335538543231373"
                ],
                "phones": [
                    "+393487460636"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via dei Salici, 8",
                        "locality": "Rieti",
                        "postcode": "02100",
                        "region": "62",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1335538543231373",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Multiservices Rieti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca22ae2c858c03b1cac1fdb24f39",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    82.75467,
                    22.36548
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1039486529528258"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Korba",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1039486529528258",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rashith Kandra",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe0e35c2162ae033c3aef1422b0f8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    151.2034,
                    -33.85847
                ]
            },
            "properties": {
                "categories": {
                    "primary": "record_label",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://www.instagram.com/learnspacerecords/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106119905162850"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "21 Kent St",
                        "locality": "Sydney",
                        "postcode": "2000",
                        "region": "NSW",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106119905162850",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Learnspace Records",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbcc31b362bc0003096a4c05497ae0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.864558,
                    -26.257215
                ]
            },
            "properties": {
                "categories": {
                    "primary": "vocational_and_technical_school",
                    "alternate": [
                        "elementary_school",
                        "education"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1740346319513982"
                ],
                "phones": [
                    "+9861159"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "752 Matlatoe St",
                        "locality": null,
                        "postcode": "1818",
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1740346319513982",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sekwati Primary",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe6356328e14e0371aa2d0fae776e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.9533847,
                    -37.8116005
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "doctor",
                        "family_practice"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.vitamedicalcentre.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/596648297159263"
                ],
                "phones": [
                    "+61391936221"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "375 King St",
                        "locality": "Melbourne",
                        "postcode": "3003",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "596648297159263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vita Medical Centre",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194230e62d108033a4a0c939b6ec2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.1239744,
                    53.3040807
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.thecrossing.co.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01909473375"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Newcastle Street",
                        "locality": "Worksop",
                        "postcode": "S80 2AT",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424931026578",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Crossing Sec Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ee59748e65050353b77338ff2787",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.90938,
                    46.55555
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100814699604803"
                ],
                "phones": [
                    "+40743689669"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unirii nr80",
                        "locality": "Viisoara",
                        "postcode": "407590",
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100814699604803",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Immulina Ro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a24da26c1c03c8646f9be64483",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.4393482,
                    35.8038507
                ]
            },
            "properties": {
                "categories": {
                    "primary": "acupuncture",
                    "alternate": [
                        "chiropractor",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://kotesashi-ekimae.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0429412123"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "所沢市小手指町1丁目26--1",
                        "locality": null,
                        "postcode": "〒359-1141",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474980575354",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "小手指駅前通り接骨院・整体院",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48e8509260484033aa5b5b9278e7e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -110.8653849,
                    32.2189886
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gift_shop",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.atticsalt.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5203142216"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5870 E Broadway Blvd Ste 358",
                        "locality": "Tucson",
                        "postcode": "85711",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374887556928",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909418886",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "fuego / ATTIC SALT",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1969522d9357403ce8aab9e718800",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.8912256,
                    52.3529575
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mobile_phone_store",
                    "alternate": [
                        "shopping",
                        "telecommunications_company"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.telefoonstad.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104587998612942"
                ],
                "phones": [
                    "+31206722251"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ferdinand Bolstraat 111",
                        "locality": "Amsterdam",
                        "postcode": "1072 LE",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104587998612942",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "telefoonstad",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f603386d4e31400397686041b28cb7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.9546569,
                    10.9959889
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.rohitcashandcarry.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/698856576842273"
                ],
                "phones": [
                    "+919843230507"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "407-E, N H ROAD, PRIYA TOWER,",
                        "locality": "Coimbatore",
                        "postcode": "641001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "698856576842273",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fancy Chudidhar WholeSale in Coimbatore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f416814b72d6c00370314178345e7d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.679779,
                    17.056292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "central_government_office",
                    "alternate": [
                        "community_center",
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/208440639219920"
                ],
                "phones": [
                    "+1042579416"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "208440639219920",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ที่ว่าการอำเภอเรณูนคร",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6ad8c1a5a9c890304e5a7cab7562c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.75125,
                    -2.08466
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110898294871971"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Muhanga",
                        "locality": "Gitarama",
                        "postcode": null,
                        "region": null,
                        "country": "RW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110898294871971",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "G.S MATA by REmy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b56561242f303cf06f9dba87f44",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.7356339,
                    10.8689845
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2219258201718754"
                ],
                "phones": [
                    "+84909903009"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Đường Gò Dưa 95",
                        "locality": "Hồ Chí Minh",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2219258201718754",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NGŨ CỐC NAVAN - Lợi sữa sau sinh",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195cb0316c52b03580faf464b19fe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.3072014,
                    52.6756535
                ]
            },
            "properties": {
                "categories": {
                    "primary": "stadium_arena",
                    "alternate": [
                        "funeral_services_and_cemeteries",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.markfieldnbg.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/411286539287943"
                ],
                "phones": [
                    "+447927739424"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Markfield Lane, Markfield",
                        "locality": "Markfield",
                        "postcode": "LE67 9TB",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "411286539287943",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Markfield Natural Burial Ground",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f268ccf52cba5b03b6569409ca671a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.9230843,
                    39.5331178
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://www.hartmannphoto.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/191905067623312"
                ],
                "phones": [
                    "+13036838777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10077 Glenstone Cir",
                        "locality": "Littleton",
                        "postcode": "80130-8014",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "191905067623312",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hartmannphoto - Photography Denver",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3caa31160876e035634dd2c99791a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.80507,
                    22.54577
                ]
            },
            "properties": {
                "categories": {
                    "primary": "comedy_club",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101880046259315"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "chaibasa",
                        "locality": "Ranchi",
                        "postcode": "833201",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101880046259315",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trzan__reals video",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196d0c628ac6b03f25ff481a8f3bb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.9394182,
                    52.9336699
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "psychologist"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.centrumregenboogkind.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/185252811599591"
                ],
                "phones": [
                    "+31644925837"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Zilverweg 6",
                        "locality": "Heerenveen",
                        "postcode": "8445 PE",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "185252811599591",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centrum Regenboogkind",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c1014ca9102603f68bb993709599",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    84.3603,
                    26.22425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "medical_service_organizations",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/919957381387416"
                ],
                "phones": [
                    "+919431265220"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sadhu medecine complex,Babunia more,west of punjab national bank",
                        "locality": "Siwan",
                        "postcode": "841226",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "919957381387416",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ananya pharma.Medecine wholesale,Sadhu medecine  complex Siwan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe63460b80b030344fc374cb99482",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.8488821,
                    -37.7107201
                ]
            },
            "properties": {
                "categories": {
                    "primary": "plumbing",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.garciaplumbing.com.au/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0430447555"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6/35 Logistics Street",
                        "locality": "Keilor Park",
                        "postcode": "3042",
                        "region": "Victoria",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474979239330",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Garcia Plumbing & Gasfitting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6108bd428c0037131e181556fc9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.6003482,
                    34.845869
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": [
                        "health_food_store",
                        "supermarket"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://www.super-fresco.co.jp/wp/store/fresco/osaka/takatsuki/imashiro"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/253042485158942"
                ],
                "phones": [
                    "+81726860771"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "大阪府高槻市今城町１７−１",
                        "locality": "高槻市",
                        "postcode": "569-1135",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "253042485158942",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "フレスコ今城店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f260958c82386e038823e7709a1cf1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.8603539,
                    40.3454228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gas_station",
                    "alternate": [
                        "food_delivery_service",
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.caseys.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6605623268"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1123 E 1st St",
                        "locality": "Maryville",
                        "postcode": "64468",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949953541097",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Casey's General Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a34c4236bda1035de1cec089fcf0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -69.9966337,
                    43.9118967
                ]
            },
            "properties": {
                "categories": {
                    "primary": "canoe_and_kayak_hire_service",
                    "alternate": [
                        "active_life",
                        "sports_club_and_league"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.seaspraykayaking.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/183605531687527"
                ],
                "phones": [
                    "+12074041100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "209 Pleasant St",
                        "locality": "Brunswick",
                        "postcode": "04011-2233",
                        "region": "ME",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "183605531687527",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Seaspray Kayaking and Paddle Maine",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194249d81032d037f3fb60435c737",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.3237895,
                    53.6418699
                ]
            },
            "properties": {
                "categories": {
                    "primary": "liquor_store",
                    "alternate": [
                        "discount_store",
                        "shopping"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/215353298992597"
                ],
                "phones": [
                    "+441706822265"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "50 Bolton Road West",
                        "locality": "Bury",
                        "postcode": "BL0 9ND",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "215353298992597",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474980723918",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Local Ramsbottom",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a111d845053032726037423fdae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.1369247,
                    25.7920353
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "real_estate_agent",
                        "professional_services"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "https://miami.manhattanmiami.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/767793983554192"
                ],
                "phones": [
                    "+13052968885"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Manhattan Miami Real Estate",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "1688 Meridian Ave",
                        "locality": "Miami Beach",
                        "postcode": "33139-2700",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "767793983554192",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932303784",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949966341730",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799821039509",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Manhattan Miami Real Estate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d3495aa9096e03f5fdd6f69bb080",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.1098418,
                    40.1945299
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/378230512315344"
                ],
                "phones": [
                    "+905383979756"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Samanlı Caddesi 43A",
                        "locality": "Bursa",
                        "postcode": "16370",
                        "region": "16",
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "378230512315344",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pak Ev Yemekleri",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea01647123a60356a37a155b5cc7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.071746,
                    45.0265698
                ]
            },
            "properties": {
                "categories": {
                    "primary": "jewelry_and_watches_manufacturer",
                    "alternate": [
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/323232168233006"
                ],
                "phones": [
                    "+390426995801"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Antonio Gramsci, 1",
                        "locality": "Adria",
                        "postcode": "45011",
                        "region": "34",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "323232168233006",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mater-Biotech",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f83833963d5a036fe67fedc0a6e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.596144,
                    47.562658
                ]
            },
            "properties": {
                "categories": {
                    "primary": "internal_medicine",
                    "alternate": [
                        "doctor",
                        "medical_center"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0616813040"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Clarastrasse 19",
                        "locality": "Basel",
                        "postcode": "4058",
                        "region": "Basel-Stadt",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949959454588",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jalci Dana",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa97657376dd80039e8b9b6bb2fb82",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -53.80225,
                    -29.70046
                ]
            },
            "properties": {
                "categories": {
                    "primary": "butcher_shop",
                    "alternate": [
                        "supermarket",
                        "bakery"
                    ]
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1048854298523308"
                ],
                "phones": [
                    "+555533473051"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Tamanday, 266",
                        "locality": "Santa Maria",
                        "postcode": "97060-540",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1048854298523308",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Super Xika Açougue & Padaria",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea6acc12db9e03701b1c1da609eb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.0649885,
                    44.8858202
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": [
                        "sex_therapist",
                        "psychotherapist"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/247916275693074"
                ],
                "phones": [
                    "+393472322475"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Piazza Celso Ceretti, 11",
                        "locality": "Mirandola",
                        "postcode": "41037",
                        "region": "45",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "247916275693074",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dott.ssa Emanuela Capucci, Psicologo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24371532ed2503697e14168d787e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.22867,
                    -31.43689
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.amarillasinternet.com/monicacan"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/247544771922484"
                ],
                "phones": [
                    "+543515052342"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Córdoba",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "247544771922484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amarillas Internet Sigue Creciendo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26940169a438c03e6fb3fba3a548f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -110.970063,
                    41.255114
                ]
            },
            "properties": {
                "categories": {
                    "primary": "medical_supply",
                    "alternate": [
                        "hospital_equipment_and_supplies",
                        "b2b_medical_support_services"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.lincare.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3077896621"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "80 YELLOW CREEK Rd",
                        "locality": "EVANSTON",
                        "postcode": "82930",
                        "region": "WY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899909781214",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LINCARE INC.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab3adab55a0a034f592a98c0fb4d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.5894161,
                    41.0098926
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://locator.chase.com/?jp_cmp=rb%2FLocalListings%2Faff%2Fatm%2Fna&y_source=1_MTIyOTc4NjAtNDgzLWxvY2F0aW9uLndlYnNpdGU%3D"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8009359935"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "444 ROBINSON AVE",
                        "locality": "BARBERTON",
                        "postcode": "44203",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949959607287",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chase ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2832b2065394c033527985426bc3b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.54226,
                    38.5076899
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_security",
                    "alternate": [
                        "business_manufacturing_and_supply",
                        "professional_services"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.allmightysecurity.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/265462367741"
                ],
                "phones": [
                    "+19164272731"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Sacramento",
                        "postcode": null,
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "265462367741",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "All Mighty Security & Sound",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec910e95aa400318674aaed14ae5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.949376,
                    41.069275
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "tutoring_center",
                        "retirement_home"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1970326293214483"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1970326293214483",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eyup Ozel Egitim Ve Mesleki Egitim Merkezi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f346954222e9730376cf28bded785f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -14.0109189,
                    28.6858564
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "holiday_rental_home",
                        "island"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/150505718372556"
                ],
                "phones": [
                    "+34667588288"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Los Lagos, 6",
                        "locality": "La Oliva",
                        "postcode": "35650",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "150505718372556",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "El Cotillo Fuerteventura",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3466ac267502e03f839c3ed4c68e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -16.9789696,
                    32.6496752
                ]
            },
            "properties": {
                "categories": {
                    "primary": "winery",
                    "alternate": [
                        "liquor_store",
                        "wine_bar"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.henriquesehenriques.pt"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/314444638711802"
                ],
                "phones": [
                    "+351291941551"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida da Autonomia 8",
                        "locality": "Câmara de Lobos",
                        "postcode": "9300-138",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "314444638711802",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Henriques & Henriques",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26d150a11d20d0359745448981873",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.8212167,
                    35.1485581
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "flowers_and_gifts_shop",
                        "jewelry_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/993882037322623"
                ],
                "phones": [
                    "+18062905515"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1602 SE 58th Ave",
                        "locality": "Amarillo",
                        "postcode": "79118-6213",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "993882037322623",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Qian's Jewelry Box",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1aa071b2b633303b7895f2219bbc8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -52.9225159,
                    47.537833
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cupcake_shop",
                    "alternate": [
                        "bakery"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.instagram.com/lovelaurabakery"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1892182304359517"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Conception Bay South",
                        "postcode": null,
                        "region": "NL",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1892182304359517",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Love, Laura Bakery",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf2d5a284d86030dc79ac7967a9f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.3105,
                    22.54336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "makeup_artist",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100138768815153"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "railkolony, ruby ",
                        "locality": "Kolkata",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100138768815153",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Soma Bridel Makeover",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c324acd2d186034646fdb7b6cfed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.647138,
                    -7.6818027
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": [
                        "cafetaria"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/405327893380821"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jalan Merdeka",
                        "locality": "Pangandaran",
                        "postcode": "46596",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "405327893380821",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Indomaret Merdeka",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e60c2c561d4303fbfd70cb860ac6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.93394,
                    -11.50515
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/275873442283510"
                ],
                "phones": [
                    "+51907172040"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sta Rosa Sacco",
                        "locality": "La Oroya",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "275873442283510",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Natúlove Cosmética Natural",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8107a43866e0036afcd5a46f9472",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.3510513,
                    -23.4921207
                ]
            },
            "properties": {
                "categories": {
                    "primary": "desserts",
                    "alternate": [
                        "cupcake_shop",
                        "bakery"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1080131388665942"
                ],
                "phones": [
                    "+5511951782799"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Itaquaquecetuba",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1080131388665942",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cupcakeja",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d8091a1306280376b8764460670c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    112.78121,
                    -7.27204
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112341500159615"
                ],
                "phones": [
                    "+6287880997650"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Surabaya",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112341500159615",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Property Masa Depan Surabaya",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c932a8811403991bf0b304dd40",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.5841229,
                    53.1190463
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive",
                        "engineering_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1400672833541273"
                ],
                "phones": [
                    "+441629824537"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18 Yeoman Street",
                        "locality": "Matlock",
                        "postcode": "DE4 2AA",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1400672833541273",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Auto Engineering Service & Repairs",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3945ceb2d4741038bf875bfb935f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.0358136,
                    41.960447
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_advertising",
                    "alternate": [
                        "marketing_agency",
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.goodmoodgrafic.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/193094940743423"
                ],
                "phones": [
                    "+34972640126"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carrer Pont, 17",
                        "locality": "La Bisbal d'Empordà",
                        "postcode": "17100",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "193094940743423",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GOODMOOD estudi gràfic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa845cd0d70503dbc4429b6d9787",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.9925723,
                    38.9258288
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": [
                        "flowers_and_gifts_shop",
                        "desserts"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.sweetdames.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/188358671205798"
                ],
                "phones": [
                    "+12025949039"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2800 10th St NE",
                        "locality": "Washington",
                        "postcode": "20017-3404",
                        "region": "DC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "188358671205798",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sweet Dames Artisan Confections",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6842a612c309403560fabc3c871f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    124.73934,
                    8.67335
                ]
            },
            "properties": {
                "categories": {
                    "primary": "central_government_office",
                    "alternate": [
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/438312033183411"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "National Hwy",
                        "locality": "Jasaan",
                        "postcode": "9003",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "438312033183411",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jampason Barangay Hall",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60987652c986103786dd498c2f316",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.776137,
                    20.901982
                ]
            },
            "properties": {
                "categories": {
                    "primary": "ice_cream_shop",
                    "alternate": [
                        "bakery"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/381470689032847"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1509 Old Agra Road, Navnath Nager",
                        "locality": null,
                        "postcode": "424001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "381470689032847",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Laxmi Ice Cream",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81b8708cda14037f20647fd5b7f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.8906109,
                    -20.7421435
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_entertainment",
                    "alternate": [
                        "farmers_market",
                        "doctor"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1997899533792547"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Abrão Nej Aidar, 148",
                        "locality": "Olímpia",
                        "postcode": "15400-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1997899533792547",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Praça da Cohab",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c108cddb49680398199a50cd9fa9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.89065,
                    -6.90739
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108140588437983"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Cisaat",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108140588437983",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rumah cantik jafra",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ef5616015c5603925da766611256",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.6875609,
                    43.7235909
                ]
            },
            "properties": {
                "categories": {
                    "primary": "social_service_organizations",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2079249992405163"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kraljevo",
                        "postcode": null,
                        "region": null,
                        "country": "RS"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2079249992405163",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Opstina Kraljevo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f61892e0573a5803aaf7f357fe6875",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.696201,
                    12.997523
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "theme_restaurant"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/291979427335453"
                ],
                "phones": [
                    "+919980545447"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Phoenix Market City & Mall of Asia",
                        "locality": "Bangalore",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "291979427335453",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dobaraa Bangalore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f95a4d1b916829034ad51f09ec16b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    115.1492087,
                    -8.6380795
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_store",
                    "alternate": [
                        "electronics",
                        "audio_visual_equipment_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/221649408417464"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Denpasar",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "221649408417464",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bw Audio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3e662948e8691032501764b05ef3b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.9681791,
                    30.4395582
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mattress_store",
                    "alternate": [
                        "furniture_store",
                        "b2b_textiles"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1797822663563956"
                ],
                "phones": [
                    "+201281661515"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Al Gomhriya Street",
                        "locality": "Sirs al Layyan",
                        "postcode": "00000",
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1797822663563956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "سنتر مكة للمفروشات",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6119c55e9000390517c04f9ed14",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.7842053,
                    34.7694394
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "church_cathedral",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/155919718267047"
                ],
                "phones": [
                    "+81774943319"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "京都府相楽郡精華町下狛鈴ノ庄８",
                        "locality": "相楽郡精華町",
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "155919718267047",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "安楽寺",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c0e58cc34603dab5576d889d59",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.9850922,
                    52.5675015
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_company",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.onzizo.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/534172667493640"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "UNIT H  Brockhurst crecent ",
                        "locality": "Walsall",
                        "postcode": "WS5 4AX",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "534172667493640",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Onzizo casual wear",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48eba7264a826034b7fd8e9ef6221",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.86083,
                    33.390513
                ]
            },
            "properties": {
                "categories": {
                    "primary": "jewelry_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4809626409"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1445 W Southern Ave",
                        "locality": "Mesa",
                        "postcode": "85202",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949955249394",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955001666",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Helzberg Diamonds",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad014ec81c730318745002468a0e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.92579,
                    34.55074
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1784530758292481"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Burgaw",
                        "postcode": null,
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1784530758292481",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Teen Revival",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f90201baed5203d8b517b1956de1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.7512229,
                    45.7765794
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "campus_building",
                        "real_estate"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.sante-partners.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/194099737276973"
                ],
                "phones": [
                    "+33474138816"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "104 Route de Paris",
                        "locality": "Charbonnières-les-Bains",
                        "postcode": "69260",
                        "region": "ARA",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "194099737276973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Santé Partners",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab122e98d94903e4b7c9cafde40f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.281929,
                    41.0408358
                ]
            },
            "properties": {
                "categories": {
                    "primary": "it_service_and_computer_repair",
                    "alternate": [
                        "information_technology_company",
                        "professional_services"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110709720472300"
                ],
                "phones": [
                    "+17249239919"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "209 Kathleen Dr",
                        "locality": "Hickory Twp",
                        "postcode": "16105-6544",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110709720472300",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863654725",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Wizard Works",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e84c361536360379ef8ebd893cfd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.4921434,
                    43.0589495
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bed_and_breakfast",
                    "alternate": [
                        "hotel",
                        "accommodation"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.portacastellana.it"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1936790409956788"
                ],
                "phones": [
                    "+390577839001"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Santa Lucia, 20",
                        "locality": "Montalcino",
                        "postcode": "53024",
                        "region": "52",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1936790409956788",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "B & B Porta Castellana",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f521ea0d32a78e03c099b3adb54e82",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    42.9417113,
                    16.6057543
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "health_and_medical",
                        "dance_club"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1436306490003013"
                ],
                "phones": [
                    "+966173326222"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "المملكه العربيه السعوديه - جازان - صامطه - شرق مستشفى صامطه العام",
                        "locality": "Samta",
                        "postcode": "45922 ",
                        "region": null,
                        "country": "SA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1436306490003013",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "مجمع د.عبد الكريم الحكمي الطبي",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2756b54a4265003961c57b2c9ed61",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -91.6997378,
                    46.5166913
                ]
            },
            "properties": {
                "categories": {
                    "primary": "laundromat",
                    "alternate": [
                        "dry_cleaning",
                        "shopping"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/213062338738036"
                ],
                "phones": [
                    "+12183483989"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11585 E Railroad Rd",
                        "locality": "Lake Nebagamon",
                        "postcode": "54849-6014",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "213062338738036",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lake Nebagamon Laundromat",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa841172394603dbaa11e278a17f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.1274703,
                    39.0523312
                ]
            },
            "properties": {
                "categories": {
                    "primary": "spas",
                    "alternate": [
                        "hospital",
                        "massage_therapy"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.bodyworkmagic.co/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110719797924554"
                ],
                "phones": [
                    "+13014125709"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6236 Montrose Rd",
                        "locality": "Rockville",
                        "postcode": "20852-4119",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110719797924554",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bodyworkmagic LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f268cd913ab35003963def485c8a1e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.11706,
                    39.7104
                ]
            },
            "properties": {
                "categories": {
                    "primary": "game_publisher",
                    "alternate": [
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://fishsoftllc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101505609605260"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10600 W Alameda Ave",
                        "locality": "Lakewood",
                        "postcode": "80226",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101505609605260",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "FishSoftLLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa0a6162e0f603e76a2803250ce7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.358072,
                    50.84404
                ]
            },
            "properties": {
                "categories": {
                    "primary": "driving_school",
                    "alternate": [
                        "education",
                        "specialty_school"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.fahrschule-dahmen.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/301385666726082"
                ],
                "phones": [
                    "+491732502207"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rathausstraße 19A",
                        "locality": "Inden",
                        "postcode": "52459",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "301385666726082",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fahrschule Dahmen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f38298a342599e039f85fb54d358f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.69089,
                    36.46679
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fabric_store",
                    "alternate": [
                        "superstore"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113953366632743"
                ],
                "phones": [
                    "+213798942571"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "موزاية ",
                        "locality": "Blida",
                        "postcode": "لايوجد",
                        "region": null,
                        "country": "DZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113953366632743",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "بيع اقماش النسيج",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44eeb6b844a8003f61e2e74cb6593",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.225735,
                    32.356576
                ]
            },
            "properties": {
                "categories": {
                    "primary": "doctor",
                    "alternate": [
                        "hospital",
                        "women's_health_clinic"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://baptistbreastsurgery.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2173611302898824"
                ],
                "phones": [
                    "+13346137070"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4749 Berry Blvd",
                        "locality": "Montgomery",
                        "postcode": "36106-3079",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2173611302898824",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "UAB Medicine Breast Health Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d34963c9e12a0325e0273473dd8b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.9723673,
                    40.2514887
                ]
            },
            "properties": {
                "categories": {
                    "primary": "preschool",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.bilinclioyunanaokulu.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106400238946970"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Işıltı Sokak 22/9",
                        "locality": "Mudanya",
                        "postcode": "16940",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106400238946970",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bilinçli Oyun Anaokulu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194a8360b4b8c036c96dba43b58ec",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.4095198,
                    51.2946989
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "professional_services",
                        "real_estate_investment"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.spacezprop.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110902047242165"
                ],
                "phones": [
                    "+447784927206"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "19 Swan Street",
                        "locality": "West Malling",
                        "postcode": "ME19 6JU",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110902047242165",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Spacez",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100a8c8d66203e12d56164370bc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.5382335,
                    -23.6532653
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.oficinadefestas.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/317486298384007"
                ],
                "phones": [
                    "+49928009"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua das Esmeraldas, 638",
                        "locality": "Santo André",
                        "postcode": "09090-770",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "317486298384007",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oficina de Festas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a90b688d584503f5e5ba452ca99d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.12689,
                    40.09647
                ]
            },
            "properties": {
                "categories": {
                    "primary": "software_development",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.vargosolutions.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6148761163"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "400 Metro Pl N Ste 340",
                        "locality": "Dublin",
                        "postcode": "43017",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324838823179",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "VARGO® Tech Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c10683c754a603d119c696ddb6fd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.7509975,
                    -6.1131897
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beach",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/154325544728937"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jakarta",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "154325544728937",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tepian Laut, Pantai Indah Kapuk Estate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa945acbba198c0352132c2faf2909",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.5085,
                    -27.07027
                ]
            },
            "properties": {
                "categories": {
                    "primary": "attractions_and_activities",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/567690233638983"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ARJP Ñeembucú",
                        "locality": "Pilar",
                        "postcode": null,
                        "region": null,
                        "country": "PY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "567690233638983",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ARJP Regional Ñeembucú",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f498e361b09208031869caf24a873e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -102.30313,
                    21.89665
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104203385703635"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Aguascalientes",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104203385703635",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Aparatos de Rehabilitación y Ortopedia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184b74c0c4443036255de02180763",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.6698741,
                    42.8388976
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "brewery",
                        "pub"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/416362591881060"
                ],
                "phones": [
                    "+34945139619"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Flandes, 14",
                        "locality": "Vitoria",
                        "postcode": "01006",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "416362591881060",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bar The Pikas In Flandes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aae9009552ea0348ad3bf73dd753",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.8639815,
                    40.2269213
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "diner",
                        "burmese_restaurant"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100625032773507"
                ],
                "phones": [
                    "+14157134054"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "213 3rd St",
                        "locality": "New Cumberland",
                        "postcode": "17070-2154",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100625032773507",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374889201292",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Golden Luck",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65206d3c70d6c03064232620e8135",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    102.95424,
                    1.84325
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "skate_park",
                        "cosmetic_and_beauty_supplies"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.wasap.my/601116707804"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/202576683472416"
                ],
                "phones": [
                    "+601116707804"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "TAMAN BUKIT PERDANA",
                        "locality": "Batu Pahat",
                        "postcode": "83000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "202576683472416",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "D'luv Aina Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab3ae0792a1e03eded789d07b3ac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.4820078,
                    41.0948627
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_to_business",
                    "alternate": null
                },
                "confidence": 0.8333575883575883,
                "websites": [
                    "http://www.raeboydconstruction.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3306349882"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "931 Evans Ave.",
                        "locality": "Akron",
                        "postcode": "44305",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949963469097",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "100329806159093",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RaeBoyd Construction Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f10f1ad044200803dbecd1f3c09211",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    56.2401814,
                    58.0119695
                ]
            },
            "properties": {
                "categories": {
                    "primary": "antique_store",
                    "alternate": [
                        "jewelry_store",
                        "flowers_and_gifts_shop"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://xn----8sbe7aeqbhx6k.xn--p1ai/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101255341511634"
                ],
                "phones": [
                    "+73422474471"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Твоя полка",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "улица Ленина 39",
                        "locality": "Пермь",
                        "postcode": "614000",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101255341511634",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Твоя полка",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c64b8658ea03470033d2b6953e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.2054265,
                    52.1847216
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "industrial_equipment"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103455178234661"
                ],
                "phones": [
                    "+447494437730"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "144 London Road",
                        "locality": "Worcester",
                        "postcode": "WR5 2",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103455178234661",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Affordable Recliners",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cc5d9ec0285003ff713139e7907a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    91.93906,
                    24.4333
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116038058212533"
                ],
                "phones": [
                    "+8801772699070"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Brammanbazar to shamshernagar",
                        "locality": "Kulaura",
                        "postcode": null,
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116038058212533",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Etz Junahid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60b52d9105cc60348d8b12dd26151",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    78.5339293,
                    17.4806023
                ]
            },
            "properties": {
                "categories": {
                    "primary": "topic_publisher",
                    "alternate": [
                        "bookstore",
                        "print_media"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.analpabooks.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109204745077676"
                ],
                "phones": [
                    "+917093800303"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "G K Colony, Neredmet",
                        "locality": null,
                        "postcode": "500094",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109204745077676",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Analpa Books",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8470a9b20a803cdf3838c164ebc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.0967009,
                    48.4907597
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_consultant",
                    "alternate": [
                        "automotive_services_and_repair",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.dekra-norisko.fr/dekra/controle-technique/vezelise,54330/13-rue-de-beauregard?s054d155"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105787902381226"
                ],
                "phones": [
                    "+33383266331"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Contrôle technique Dekra",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "13 Rue de Beauregard",
                        "locality": "Vézelise",
                        "postcode": "54330",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105787902381226",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DEKRA Technical Inspection Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195dac25948d103fe2f4bde6a595e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.4690457,
                    51.5746991
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "professional_services",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.ltcscaffolding.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/746676635728931"
                ],
                "phones": [
                    "+441895273227"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Harefield Oil Terminal, Harvil Rd",
                        "locality": null,
                        "postcode": "UB9 6JL",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "746676635728931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LTC Scaffolding",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a33389048c3003081eff572a5c4a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.5378197,
                    41.4651158
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": [
                        "real_estate",
                        "home_improvement_store"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "https://www.mistymountainconstruction.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/503022683094967"
                ],
                "phones": [
                    "+14014800252"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "332 Chestnut Hill Rd",
                        "locality": "Wakefield",
                        "postcode": "02879-7647",
                        "region": "RI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "503022683094967",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849865041134",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Misty Mountain Construction",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fae3125046e803c212311bc17d49",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.6309023,
                    49.8853626
                ]
            },
            "properties": {
                "categories": {
                    "primary": "software_development",
                    "alternate": [
                        "internet_service_provider",
                        "information_technology_company"
                    ]
                },
                "confidence": 0.9826508620689655,
                "websites": [
                    "https://www.brightsolutions.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111212208916956"
                ],
                "phones": [
                    "+496151276470"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pfnorstraße 10",
                        "locality": "Darmstadt",
                        "postcode": "64293",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111212208916956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324839110669",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324839097522",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890782533",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bright Solutions GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29868ce913d66031a9862d98310c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -115.0255541,
                    36.0597212
                ]
            },
            "properties": {
                "categories": {
                    "primary": "metal_fabricator",
                    "alternate": [
                        "construction_services",
                        "fence_and_gate_sales_service"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://customcustomsinc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/664410926995087"
                ],
                "phones": [
                    "+17028381234"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "480 Mirror Ct",
                        "locality": "Henderson",
                        "postcode": "89011-4061",
                        "region": "NV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "664410926995087",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Custom Customs Inc.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44db82acd6708035c45cbae5ea963",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.3319417,
                    35.7700643
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mobile_phone_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.att.com/stores/north-carolina/hickory/158302"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6153004030"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2910 N Center St",
                        "locality": "Hickory",
                        "postcode": "28601",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978380624",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AT&T",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26563a4895a36038aa0455f105c86",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.2754,
                    39.01828
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://www.ashrubalcava.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/402078349648876"
                ],
                "phones": [
                    "+18166884682"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Blue Springs",
                        "postcode": null,
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "402078349648876",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Health Coverage Solutions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e114c079444003c083f61aca5350",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.3400992,
                    46.4948393
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "health_food_restaurant",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.termesvetimartin.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2319206925026626"
                ],
                "phones": [
                    "+38540371111"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Izvorska 3",
                        "locality": "Sveti Martin na Muri",
                        "postcode": "40313",
                        "region": null,
                        "country": "HR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2319206925026626",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Le Batat",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec91b56d684003bd456ca5a63752",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.724298,
                    40.985535
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campus_building",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/495075224333420"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "495075224333420",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "T.C İstanbul Üniversitesi İşletme Fakültesi Pazarlama Anabilimdalı Katı",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1422335b315037514cb722bec75",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.8999984,
                    41.4070404
                ]
            },
            "properties": {
                "categories": {
                    "primary": "counseling_and_mental_health",
                    "alternate": [
                        "psychotherapist",
                        "hospital"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2202687626610866"
                ],
                "phones": [
                    "+12038009797"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3074 Whitney Ave",
                        "locality": "Hamden",
                        "postcode": "06518-2324",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2202687626610866",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nuevo Dia Family Wellness",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c107ab09554503f3edf8476dbf2d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.8183581,
                    -6.2628338
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2023996581264545"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jakarta",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2023996581264545",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kawal & Pathners Lawfirm",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48eba36c0b82b03920ba30576fa68",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.68683,
                    33.26471
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hvac_services",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.makinglifecomfortable.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/455738441243590"
                ],
                "phones": [
                    "+14806008617"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8490 S Power Rd",
                        "locality": "Gilbert",
                        "postcode": "85297-8027",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "455738441243590",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Expert Cooling",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f838e32c59d50c032f51785010c16f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.3083858,
                    -4.3047244
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101962116161887"
                ],
                "phones": [
                    "+243842373953"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bas-congo ",
                        "locality": "Kinshasa",
                        "postcode": "012",
                        "region": null,
                        "country": "CD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101962116161887",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Boutique de Bruxelles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44f0095c8360c03d9a732ed016698",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.6418332,
                    30.2935616
                ]
            },
            "properties": {
                "categories": {
                    "primary": "apartments",
                    "alternate": [
                        "condominium"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.sanmarcovillagejax.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9043989492"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2166 Dunsford Ter",
                        "locality": "Jacksonville",
                        "postcode": "32207",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949964571382",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963800713",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911485893",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "San Marco Village Apartment Community",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8329c1b3a19031d4f8cf2a1f015",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.2217765,
                    40.8424478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bed_and_breakfast",
                    "alternate": [
                        "breakfast_and_brunch_restaurant",
                        "holiday_rental_home"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://5d5d5cadd7a2f.site123.me/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2307963536128160"
                ],
                "phones": [
                    "+393341938160"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Santa Maria della Libera, 13",
                        "locality": "Napoli",
                        "postcode": "80127",
                        "region": "72",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2307963536128160",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "B&B Baggere",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c9338da1479103c1218c49e2bdaa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    48.1226616,
                    29.1530393
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_developer",
                    "alternate": [
                        "hotel",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/204822106766124"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Mahboula",
                        "postcode": null,
                        "region": null,
                        "country": "KW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "204822106766124",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mahaboula Block 2",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa89ac9d1a20b303af0ae19cbf2684",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -39.74093,
                    -17.5397
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102511768661774"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Teixeira de Freitas",
                        "postcode": null,
                        "region": "BA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102511768661774",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fstore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d26261d960460347dca3fcc53a88",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.3749,
                    17.98918
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shoe_store",
                    "alternate": [
                        "fashion",
                        "clothing_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1439773649596006"
                ],
                "phones": [
                    "+529373721496"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Cuauhtémoc",
                        "locality": "Cárdenas",
                        "postcode": "86500",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1439773649596006",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Venta de Calzado Impuls",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f602631901440b03cefd2bb9979079",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.9587,
                    8.49414
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107677708688797"
                ],
                "phones": [
                    "+916282463410"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Eyyakunnuvila veedu TC 22/1249",
                        "locality": "Thiruvananthapuram",
                        "postcode": "695005",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107677708688797",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Siva_chand_11",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c1051e909402037f905f8e98fb94",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    107.236718,
                    -6.355036
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/521911667873975"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Telukjambe",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "521911667873975",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pangeran Hotel Pekanbaru",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a186ad1c19103bdd63ef80cf42a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.8219055,
                    34.1527207
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://agents.goosehead.com/ca/westlake-village/2945-townsgate-rd-0013c00001uanxiaaw?utm_source=extnet&utm_medium=yext&y_source=1_mji2otgwntitntu5lwxvy2f0aw9ulndlynnpdgu%3d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103755871805941"
                ],
                "phones": [
                    "+18053086384"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2945 Townsgate Rd",
                        "locality": "Westlake Village",
                        "postcode": "91361-5803",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103755871805941",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Goosehead Insurance - Elizabeth Miles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2986b806c181403b93f15e4d5241f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -115.169844,
                    36.1262221
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "department_store"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.neimanmarcus.com/stores/store.jsp?storeid=15%2flv"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105878072787258"
                ],
                "phones": [
                    "+18002887741"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Neiman Marcus",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "3200 S Las Vegas Blvd",
                        "locality": "Las Vegas",
                        "postcode": "89109-0714",
                        "region": "NV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105878072787258",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374883817809",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Neiman Marcus",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c10686a72b5e030b4bceec39aa1d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.77482,
                    -6.12835
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "food_beverage_service_distribution"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1667909956797873"
                ],
                "phones": [
                    "+62215416838"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jl Kapuk Muara 1",
                        "locality": "Jakarta",
                        "postcode": "14460",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1667909956797873",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kurnia Dewi Toko",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1422a8982dd03ebfbff90fb1e43",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.901993,
                    41.383102
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.8333575883575883,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2032309494"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2357 Whitney Ave",
                        "locality": "Hamden",
                        "postcode": "06518",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849860628614",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "85211808365",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "D'Camm Limited",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651d8f36e46ca038365d5c9324e3f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.4295176,
                    5.4391639
                ]
            },
            "properties": {
                "categories": {
                    "primary": "spas",
                    "alternate": [
                        "beauty_salon",
                        "cosmetic_and_beauty_supplies"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "http://www.wasap.my/60106654971"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108982220714727"
                ],
                "phones": [
                    "+60106654971"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11 Lorong Perda Utama 3",
                        "locality": "Bukit Mertajam",
                        "postcode": "14000",
                        "region": "07",
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108982220714727",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nss Spa & Salon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42c02cca182ec039f97f294300899",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    70.91019,
                    22.64941
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112170931465342"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "New Ratidevri ",
                        "locality": "Wankaner",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112170931465342",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sanjay",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3db55750e1da203685fd7479b77e4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.52588,
                    26.32336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102988001674116"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Pisangan",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102988001674116",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sethu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d8c6b4a86c4803e447db68858b6a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    110.425303,
                    -7.019103
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "coffee_shop",
                        "health_food_restaurant"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://motionfitnessbali.com/food-solutions/avocado-cafe-menu"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/477918935575675"
                ],
                "phones": [
                    "+62248315217"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "82, Jalan Dr Wahidin",
                        "locality": "Semarang Kota",
                        "postcode": "50253",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "477918935575675",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Avocado Garden Cafe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f588264e2d8d640354ff5b0390faa2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.35208,
                    6.60153
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://shop.thisiswaje.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107914557242041"
                ],
                "phones": [
                    "+2348064916662"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9 Allen Ave",
                        "locality": "Lagos",
                        "postcode": null,
                        "region": "LA",
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107914557242041",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shop Waje",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e80813684ae03e92a401b52fea2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.2864914,
                    33.1858406
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tire_shop",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2562494044"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2585 Old Birmingham Hwy",
                        "locality": "Sylacauga",
                        "postcode": "35150",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849862996979",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Miller Tire Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44aebb1cb4d4603bb6b5f236127c7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.088372,
                    26.80883
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fast_food_restaurant",
                    "alternate": [
                        "restaurant",
                        "mexican_restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.limefreshmexicangrill.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1927989924159573"
                ],
                "phones": [
                    "+15616265001"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3331 Northlake Blvd",
                        "locality": "Palm Beach Gardens",
                        "postcode": "33403-1708",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1927989924159573",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lime Fresh Mexican Grill",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3825b21d2572e03a75ef6a04ebaaa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.1012895,
                    37.9953058
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sporting_goods",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.joma-sport.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104610524580518"
                ],
                "phones": [
                    "+34968933282"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle de la Ermita Vieja, 18",
                        "locality": "Murcia",
                        "postcode": "30006",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104610524580518",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RevySport",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e60d8b4aa25003abf0da18a31390",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    137.2475068,
                    35.0308813
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "church_cathedral",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1240247629407250"
                ],
                "phones": [
                    "+81565581845"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "愛知県豊田市滝脇町藤治洞３",
                        "locality": "豊田市",
                        "postcode": "444-2212",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1240247629407250",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "専光寺",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf519ac13b2003598c4ad4d5e9d5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    89.1386872,
                    24.4997593
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110204961699297"
                ],
                "phones": [
                    "+8801863231642"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Natore",
                        "locality": "Natore",
                        "postcode": "5065",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110204961699297",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Habib Fashion House",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196bb53701448039218a7f048980f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.49061,
                    51.88923
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": [
                        "marketing_agency",
                        "business_advertising"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/788427371329540"
                ],
                "phones": [
                    "+31644555777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Rotterdam",
                        "postcode": null,
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "788427371329540",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pierogi domowe Rotterdam",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f659b64ad54144030b260526bab3c7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.72206,
                    15.95658
                ]
            },
            "properties": {
                "categories": {
                    "primary": "doctor",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/117316074805684"
                ],
                "phones": [
                    "+84987654321"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Olive Cummings",
                        "locality": "Ban Thanon Hak Noi",
                        "postcode": "10001",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "117316074805684",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Olive Cummings",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb092065391a03358d915c728d80",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.5891935,
                    48.8788123
                ]
            },
            "properties": {
                "categories": {
                    "primary": "printing_services",
                    "alternate": [
                        "sign_making"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://chelles.pointdencre.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/874926289220604"
                ],
                "phones": [
                    "+33182832131"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "36 Rue Louis Éterlet",
                        "locality": "Chelles",
                        "postcode": "77500",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "874926289220604",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Point d'Encre Chelles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c93a8bdad0550318a83617d27b58",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    47.9358603,
                    29.3030253
                ]
            },
            "properties": {
                "categories": {
                    "primary": "jewelry_store",
                    "alternate": [
                        "shopping",
                        "bar"
                    ]
                },
                "confidence": 0.6382978723404256,
                "websites": [
                    "http://www.boucheron.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/264677954329551"
                ],
                "phones": [
                    "+96522200992"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Boucheron",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "The Avenues, Prestige, Ground floor, Shop N E007",
                        "locality": "Kuwait City",
                        "postcode": "5132",
                        "region": null,
                        "country": "KW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "264677954329551",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Boucheron",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a0628b9a5700367b0bad2ad4e24",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.373794,
                    -22.9318908
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mass_media",
                    "alternate": [
                        "arts_and_entertainment",
                        "broadcasting_media_production"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.radiorelogioam.com.br"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/173328806077421"
                ],
                "phones": [
                    "+552130775151"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Estrada dos Bandeirantes, 1000",
                        "locality": "Rio de Janeiro",
                        "postcode": "22710-112",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "173328806077421",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Radio e Televisao Modelo Paulista Ltda",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2830ca9a0d00003ee657559ec4849",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.7766672,
                    37.9880797
                ]
            },
            "properties": {
                "categories": {
                    "primary": "retirement_home",
                    "alternate": [
                        "hospital",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/203751989966985"
                ],
                "phones": [
                    "+19257754347"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3105 Ferngrove Way",
                        "locality": "Antioch",
                        "postcode": "94531-6647",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "203751989966985",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bula Home Care Llc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ca2b4915462a03c65a5972a37019",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    44.44204,
                    33.35966
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_and_medical",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.facebook.com/alihadi200/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110820481510491"
                ],
                "phones": [
                    "+9647710183646"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "شارع الداخل, بغداد, العراق",
                        "locality": "Baghdad",
                        "postcode": null,
                        "region": null,
                        "country": "IQ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110820481510491",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "عيادة الدكتور علي عبدالهادي عبدالواحد Dr.Ali Abdulhadi Abdulwahid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274117065e3b1037cfb13040cb6e3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.7742233,
                    44.6659842
                ]
            },
            "properties": {
                "categories": {
                    "primary": "boat_rental_and_training",
                    "alternate": [
                        "boat_service_and_repair",
                        "sports_and_recreation_venue"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.americanboatrentals.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101107763305585"
                ],
                "phones": [
                    "+12316451191"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9830 Tenor Dr",
                        "locality": "Green Lake Twp",
                        "postcode": "49643-9184",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101107763305585",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "American Boat Rentals",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e20f1d4474003794be00797db34",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.73819,
                    30.89286
                ]
            },
            "properties": {
                "categories": {
                    "primary": "american_restaurant",
                    "alternate": [
                        "bar"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/595137023891072"
                ],
                "phones": [
                    "+12297355693"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2054 E Main St",
                        "locality": "Barwick",
                        "postcode": "31720-2002",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "595137023891072",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Last Chance Saloon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a1998d5391e03f9fe24dfeddb27",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.40966,
                    34.06518
                ]
            },
            "properties": {
                "categories": {
                    "primary": "counseling_and_mental_health",
                    "alternate": [
                        "naturopathic_holistic",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.sexloveyoga.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/177203489396210"
                ],
                "phones": [
                    "+19494780228"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "152 S Lasky Dr",
                        "locality": "Beverly Hills",
                        "postcode": "90212-1704",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "177203489396210",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dr. Cat Meyer, LMFT",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b054f4636b2103ebb9332abc4745",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -63.1713336,
                    46.2896492
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "contractor"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104066251140865"
                ],
                "phones": [
                    "+19029165254"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4 Melody Ln",
                        "locality": "Charlottetown",
                        "postcode": "C1E 0S2",
                        "region": "PE",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104066251140865",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "VP Building Materials",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f262dd9aa1b10e03fdc878ebe41f78",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -92.49114,
                    44.0416
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114868376606885"
                ],
                "phones": [
                    "+15073581632"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1836 18th St NW",
                        "locality": "Rochester",
                        "postcode": "55901-1676",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114868376606885",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Feathered Treasures Taxidermy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3064b2b18c103f33b9d736644a1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.13085,
                    42.2489
                ]
            },
            "properties": {
                "categories": {
                    "primary": "motorcycle_repair",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105966752380413"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1550 River St",
                        "locality": "Boston",
                        "postcode": "02136-1634",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105966752380413",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Extreme motorsports",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3921058a4482d03a8ac72d7ff8a53",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.605738,
                    42.56529
                ]
            },
            "properties": {
                "categories": {
                    "primary": "ev_charging_station",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.repsol.es/particulares/vehiculos/movilidad-electrica/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    ""
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "CL AVENIDA ASTURIAS, 137",
                        "locality": "Ponferrada",
                        "postcode": "24404",
                        "region": "León",
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324842159994",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Punto de recarga eléctrica Repsol",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2798d9664a81403f66b3bcac4fc23",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -108.5652487,
                    45.7733152
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "religious_organization"
                    ]
                },
                "confidence": 0.9588815789473685,
                "websites": [
                    "http://www.billingsopenbible.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/577502475638886"
                ],
                "phones": [
                    "+14066564946"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "302 19th St W",
                        "locality": "Billings",
                        "postcode": "59102-4916",
                        "region": "MT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "577502475638886",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Open Bible Christian Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2814a2334b6aa0309d0254315a764",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.620974,
                    39.7639886
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "professional_services"
                    ]
                },
                "confidence": 0.9895250069851914,
                "websites": [
                    "http://bhgwelcomehome.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1399234170314875"
                ],
                "phones": [
                    "+15309613400"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6141 Center St",
                        "locality": "Paradise",
                        "postcode": "95969-3911",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1399234170314875",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909579588",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Better Homes and Gardens Real Estate Welcome Home",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08b3d1186a02003c3ef3bfa006b15",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.5320912,
                    58.3694958
                ]
            },
            "properties": {
                "categories": {
                    "primary": "equestrian_facility",
                    "alternate": [
                        "active_life",
                        "horseback_riding_service"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/477899939253272"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "SV",
                        "locality": null,
                        "postcode": "583 93",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "477899939253272",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Naterstad Hästcenter",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65a66dba118ad0309b3a44b70fe63",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.3343946,
                    9.9323663
                ]
            },
            "properties": {
                "categories": {
                    "primary": "seafood_restaurant",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://hungbien.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/826735874354965"
                ],
                "phones": [
                    "+84988988149"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8 Đường Trần Phú",
                        "locality": "Trà Vinh",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "826735874354965",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hùng Biển Seafood",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb46713303120359d8cd7b5f4a75",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.3546303,
                    48.8414467
                ]
            },
            "properties": {
                "categories": {
                    "primary": "used_vintage_and_consignment",
                    "alternate": [
                        "thrift_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104621105285372"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Rue Georges Desplas",
                        "locality": "Paris",
                        "postcode": "75005",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104621105285372",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Friperie du 5",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24d36e75662a03fec83180b970bd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.7,
                    -31.6333
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "shopping",
                        "food_beverage_service_distribution"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/470291873041862"
                ],
                "phones": [
                    "+543424525389"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Costanera",
                        "locality": "Santa Fe",
                        "postcode": "3000",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "470291873041862",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "El Gran Barón",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2834cae4dd75503f3f96d063f2216",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.647032,
                    36.878399
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://camptlcgoldens.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4086566402"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Leo Pl",
                        "locality": "Aromas",
                        "postcode": "95004",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949965854615",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Camp TLC Goldens",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca90acb1d2ac03e7f0e209f12d77",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    86.90804,
                    23.85588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_service",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://gmail.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109379030506763"
                ],
                "phones": [
                    "+919474839386"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kalyangram-5,chittaranjan,w.burdwan,India",
                        "locality": "Chittaranjan",
                        "postcode": "713335",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109379030506763",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bliss massage parlour",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa8d0b8b16e203a0043a2e0394a8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.5853159,
                    39.3979848
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": [
                        "department_store"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.kirklands.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111231652917055"
                ],
                "phones": [
                    "+14103376895"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "803 Goucher Blvd",
                        "locality": "Towson",
                        "postcode": "21286-5676",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111231652917055",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908952182",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kirkland's",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195245b3b22dc03043c1b321753dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.5274332,
                    54.1015988
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": [
                        "shopping",
                        "supermarket"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167642943669861"
                ],
                "phones": [
                    "+442830860708"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "33 Silverbridge Road",
                        "locality": "Newry",
                        "postcode": "BT35 9LF",
                        "region": "NIR",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167642943669861",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Murphys Vivo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ed6198ece10324976cf015e8fe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.0534058,
                    14.8003764
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102483128692724"
                ],
                "phones": [
                    "+639175350810"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Muzon, San Jose Del Monte Bulacan",
                        "locality": "San Jose del Monte",
                        "postcode": "3023",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102483128692724",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LC. P Construction",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f498575372c41003a9b73768478105",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.9546349,
                    19.6878256
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": [
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/124381177745047"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Cherán",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "124381177745047",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Concejo de Asuntos Civiles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e31134688cb03f704fd5171295a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.37344,
                    -34.6085
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.cursosfem.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/496824550496743"
                ],
                "phones": [
                    "+541123885233"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "BUENOS AIRES",
                        "locality": "Buenos Aires",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "496824550496743",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Entrena Mejor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a10473aa27890343de0af1814fe8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2265796,
                    40.8813174
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pet_sitting",
                    "alternate": [
                        "pet_groomer",
                        "pet_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://pawcouture.portal.gingrapp.com/?fbclid=paaabght-62bmsjsuvc6adducaxh3us41djpp2a9hdtmdisdpir1mbsxdn8jm_aem_au4ok8kyuhgxugzihqz1aw1jlsz2tlvd0dzfngmqgq4ovqf9kjamp88vuxyexvouk1s#/public/login"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/265551240612776"
                ],
                "phones": [
                    "+19737064387"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "60 Main St",
                        "locality": "Little Falls",
                        "postcode": "07424-1549",
                        "region": "NJ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "265551240612776",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paw Couture Pet Grooming & Bakery | Little Falls NJ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a160e34b601603081a4eceaa5f2a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.6348136,
                    41.6392579
                ]
            },
            "properties": {
                "categories": {
                    "primary": "financial_service",
                    "alternate": [
                        "professional_services",
                        "brokers"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "http://www.barrigerandcompany.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/976451269080500"
                ],
                "phones": [
                    "+18457916600"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "196 Bridgeville Rd",
                        "locality": "Thompson",
                        "postcode": "12701-3846",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "976451269080500",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949962690617",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799818438271",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Barriger & Company",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a930e41aea9e036e04f9844e29fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.43908,
                    39.11681
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "real_estate",
                        "real_estate_agent"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.parkwaytitlellc.com/contact.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1843868875844793"
                ],
                "phones": [
                    "+15137016216"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3505 Columbia Pkwy",
                        "locality": "Cincinnati",
                        "postcode": "45226-2181",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1843868875844793",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Parkway Title Agency",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa8004b2a2c303e5c05b931d3ee3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.5222702,
                    38.9767036
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hvac_services",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.annapolishvacservice.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4439246696"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1803 Margaret Ave",
                        "locality": "Annapolis",
                        "postcode": "21401",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324837986904",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Complete Mechanical Services, LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f116abbb33aa0382526bbb251d99",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.5597356,
                    52.2360274
                ]
            },
            "properties": {
                "categories": {
                    "primary": "parking",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://hermann-lons-park-brunswick-de.placestars.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115327831880704"
                ],
                "phones": [
                    "+495314708513"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Siedlerweg 9",
                        "locality": "Braunschweig",
                        "postcode": "38126",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115327831880704",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Spielplatz Hermann-Löns-Park",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f902c516b32803cbf1070f57782c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.86103,
                    45.67756
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112877105064701"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Feyzin",
                        "postcode": null,
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112877105064701",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NS.services69",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f283082bdaad92034de6ce746ca125",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.40937,
                    37.78846
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "charity_organization",
                        "lodge"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "http://www.sfelks.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1692480074327995"
                ],
                "phones": [
                    "+14154215230"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "450 Post St",
                        "locality": "San Francisco",
                        "postcode": "94102-1526",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1692480074327995",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SFElks",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f262492058c73203109c4cc05c7b46",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.8792038,
                    47.4691988
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dog_walkers",
                    "alternate": [
                        "pet_sitting"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109108198886992"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bemidji",
                        "postcode": null,
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109108198886992",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "K9 Kings",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a83888a93860335b2aa40dab715",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.660338,
                    27.998228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "health_and_medical",
                        "family_practice"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "https://hpprimarycare.com/palmbay/alan-katz-md/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/497208907426062"
                ],
                "phones": [
                    "+13217332966"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Healthy Partners",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "470 Malabar Rd SE",
                        "locality": "Palm Bay",
                        "postcode": "32907-3124",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "497208907426062",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Healthy Partners",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2759ad00c392903af8a674c77e6fb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.93439,
                    42.15319
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_health_care",
                    "alternate": [
                        "personal_care_service",
                        "skilled_nursing"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://wheeling-234.comfortkeepers.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8472158550"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1400 E Lake Cook Rd Ste 110",
                        "locality": "Buffalo Grove",
                        "postcode": "60089",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932433525",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Comfort Keepers Home Care",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19586c430251a036614f348f4bdda",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.9963579,
                    51.2992401
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "cafe"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://diamondfarm.co.uk/diamond-farm-cafe-shop/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101586488320891"
                ],
                "phones": [
                    "+447922839432"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Weston Road ",
                        "locality": "Brean",
                        "postcode": "TA8 2RL",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101586488320891",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Diamond Farm Cafe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f9020d8c3c2d03c49c95340e3b91",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.80791,
                    45.78391
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/255786551573893"
                ],
                "phones": [
                    "+33472537929"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "59 Rue de Saint-Cyr",
                        "locality": "Lyon",
                        "postcode": "69009",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "255786551573893",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "U2P Rhône et Métropole",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196988b85d091032769ff4eb48b04",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.600639,
                    52.336246
                ]
            },
            "properties": {
                "categories": {
                    "primary": "surfing",
                    "alternate": [
                        "beach"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1720505881394241"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Zuiderzeepad",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1720505881394241",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Zuiderzeestrand",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ef5900d85b1a03aae5a6efae4687",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.4551,
                    44.7116
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/447484929337885"
                ],
                "phones": [
                    "+381693433772"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Улица Славка Миљковића 11",
                        "locality": "Београд",
                        "postcode": "11231",
                        "region": null,
                        "country": "RS"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "447484929337885",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salon lepote Sedam zelja",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f289489a61d74e03786f93dedb9782",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.00322,
                    43.69686
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "home_cleaning",
                        "damage_restoration"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104486458217970"
                ],
                "phones": [
                    "+12085419988"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lewisville",
                        "postcode": null,
                        "region": "ID",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104486458217970",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yellowstone Restoration",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29b6c1496451c036a6e1d10bccee4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.03085,
                    33.6409
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102595278310628"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "850 E North Ln",
                        "locality": "Phoenix",
                        "postcode": "85020",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102595278310628",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fair Organizations",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48eba36c0b82b037dfe2193d3b4f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.6868362,
                    33.2647171
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pool_and_hot_tub_services",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://bluelagoonpm.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6024007289"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8490 S Power Rd Ste 105-239",
                        "locality": "Gilbert",
                        "postcode": "85297",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849862708501",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blue Lagoon Pool Management",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e037460ed1000321fa7c48a37385",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    19.335302,
                    47.610425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.dieselgodollo.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103141411294794"
                ],
                "phones": [
                    "+36306590936"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Dózsa György út 69",
                        "locality": "Gödöllő",
                        "postcode": "2100",
                        "region": "PE",
                        "country": "HU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103141411294794",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Diesel Service Gödöllő",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6520db36b0c2a0303dbf3f9b487a2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.85818,
                    1.2994
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": [
                        "professional_services",
                        "business_advertising"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.clearchannel.com.sg/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189365677761705"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Fraser St",
                        "locality": "Singapore",
                        "postcode": "189352",
                        "region": null,
                        "country": "SG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189365677761705",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Clear Channel Singapore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195804a040373035a4e39c9e62226",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.3952833,
                    51.5300355
                ]
            },
            "properties": {
                "categories": {
                    "primary": "attractions_and_activities",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/256267541064752"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bristol",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "256267541064752",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Top Field",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e0371c432c7003b4502fbb05b913",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    19.1173053,
                    47.5674778
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "music_production"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://e-music.hu/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104586264975086"
                ],
                "phones": [
                    "+36706019990"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Batthyány utca 36",
                        "locality": "Budapest",
                        "postcode": "1151",
                        "region": "BU",
                        "country": "HU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104586264975086",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "e-Music Records",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f89510581b5203ecf741f3140f6b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.947286,
                    47.398324
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.alpbach.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/143161979030238"
                ],
                "phones": [
                    "+4317181711"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Congress Centrum Alpbach, Alpbach 246",
                        "locality": "Alpbach",
                        "postcode": "6236",
                        "region": "7",
                        "country": "AT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "143161979030238",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "European Forum Alpbach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ef52646a98a0034f5a683f6d2837",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.44226,
                    44.09422
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1343189255790643"
                ],
                "phones": [
                    "+381621508014"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Улица Деспота Стефана Лазаревића 97",
                        "locality": "Деспотовац",
                        "postcode": "35213",
                        "region": null,
                        "country": "RS"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1343189255790643",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Majče Zmajče",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eda76a89b2f503925662363c7d88",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.7486762,
                    38.0246299
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafetaria",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110283921564840"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "43 Συρακουσών",
                        "locality": "Αθήνα",
                        "postcode": "111 42",
                        "region": "I",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110283921564840",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Meli'n All Day Bar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa0d8292c65503d749f97044277b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.86139,
                    50.47264
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "education"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://cta.asty-moulin.be/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/682304298526722"
                ],
                "phones": [
                    "+3281729058"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rue de la Pépinière 101",
                        "locality": "Namur",
                        "postcode": "5002",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "682304298526722",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centre de Technologie Avancée",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c310075015032b985d94a7a4d7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.2995,
                    29.8575
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/156016144261473"
                ],
                "phones": null,
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Stephen Love",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Waqas 329",
                        "locality": "Houston",
                        "postcode": "77001",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "156016144261473",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Waqas 329",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8f641ca2911403059936b1d128cb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.0499302,
                    -19.3157416
                ]
            },
            "properties": {
                "categories": {
                    "primary": "post_office",
                    "alternate": [
                        "cafetaria"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.correios.com.br"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2106312196046700"
                ],
                "phones": [
                    "+553436713023"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Rui Barbosa, 571",
                        "locality": "São Gotardo",
                        "postcode": "38800-000",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2106312196046700",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Agência dos Correios - Agf Rui Barbosa - Agência de Correios Franqueada",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aaed6c4cc1220355c810f7f51a08",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.212307,
                    40.2021601
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.pftfit.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7174610901"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1225 Ritner Highway Ste 101",
                        "locality": "Carlisle",
                        "postcode": "17013",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474980575204",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Performance Fitness Training Carlisle",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12db7666a675c03e04e67ab14e7f4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.4156695,
                    47.6703874
                ]
            },
            "properties": {
                "categories": {
                    "primary": "high_school",
                    "alternate": [
                        "public_school",
                        "school"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/151149791565520"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "99201",
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "151149791565520",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Continuation High School",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28dc45cc4a16b03079985b0b604e4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.8780551,
                    49.0528147
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "sporting_goods"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.tradingpostfeedandtack.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/366334010088400"
                ],
                "phones": [
                    "+12502452115"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3345 Island Hwy",
                        "locality": "Lantzville",
                        "postcode": "V0R",
                        "region": "BC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "366334010088400",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Trading Post Feed & Tack",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f83ab51640b103c893db3674c0d2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.07564,
                    47.38807
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100244798558905"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Aarau",
                        "postcode": null,
                        "region": null,
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100244798558905",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cakebynila",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1951b7395eb100307099668a857d5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.2638748,
                    53.4607925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "charity_organization",
                    "alternate": [
                        "community_services_non_profits",
                        "financial_service"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://nooraid.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/426172754067996"
                ],
                "phones": [
                    "+447946335036"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "124 Shrewsbury Street",
                        "locality": "Manchester",
                        "postcode": "M16 7NY",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "426172754067996",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799819734691",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Noor Aid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28300682b5c4d038c0d9ac3ec27bc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.4494447,
                    38.2476268
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive",
                        "oil_change_station"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "http://www.autotech-sonoma.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1132356133511000"
                ],
                "phones": [
                    "+17079399188"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "22690 Broadway",
                        "locality": "Sonoma",
                        "postcode": "95476-8200",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1132356133511000",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474979443915",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Autotech",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41436b1c1152c035a76a56f7b5f72",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.76925,
                    20.96588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105479252130956"
                ],
                "phones": [
                    "+84989167330"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Chung cư Unimax, 210 Quang Trung, Hà Đông",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105479252130956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mẩn Ngứa Nổi Mề Đay",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f483294265bc3303f9eb56f4fc7f26",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.3547359,
                    22.0498702
                ]
            },
            "properties": {
                "categories": {
                    "primary": "smoothie_juice_bar",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2396370290599456"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Pericos",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2396370290599456",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Frappe Cesarin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f2654445c66903b84c4d7f52e1b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.57773,
                    56.47853
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1650877928306180"
                ],
                "phones": [
                    "+4597856300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Struer",
                        "postcode": null,
                        "region": null,
                        "country": "DK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1650877928306180",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ledige lejemål i Struer og omegn",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6434a9b81b6f503944797cba8269a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.8889553,
                    8.6694303
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "thai_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "https://www.youtube.com/watch?v=itcxzcxjoq8"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104883308015431"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "หมู่ 9 ตำบลไทยบุรี อำเภอท่าศาลา จังหวัดนครศรีธรรมราช",
                        "locality": "Amphoe Tha Sala",
                        "postcode": "80160",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104883308015431",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "วัดโคกเหล็ก ตำบลไทยบุรี อำเภอท่าศาลา จังหวัดนครศรีธรรมราช",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb46cc1419960315e8b371ef920d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.3773704,
                    48.6952248
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/469680653065947"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Juvisy-sur-Orge",
                        "postcode": null,
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "469680653065947",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Promenade De L'orge",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d9005b15dcc903bbd12aeefd7652",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.6813,
                    23.309592
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hindu_temple",
                    "alternate": [
                        "post_office"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/134555700569777"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Shujalpur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "134555700569777",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dunglay Post Office",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f029a992381b0343bad844f1048c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.8652221,
                    53.9555701
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "cafe",
                        "german_restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.luzifer-sylt.de"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/150645838309858"
                ],
                "phones": [
                    "+494502307811"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Auf dem Baggersand 3",
                        "locality": "Lübeck",
                        "postcode": "23570",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "150645838309858",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Luzifer Travemünde",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e835c1b187603f0e30bbd79d43d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.7880563,
                    33.479916
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.mcgriffinsurance.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2059868130"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Independence Plz",
                        "locality": "Birmingham",
                        "postcode": "35209",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899911118488",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911109956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "McGriff Insurance Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d56af3a332c30316c164dc32ee29",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    40.2533087,
                    43.6849604
                ]
            },
            "properties": {
                "categories": {
                    "primary": "stadium_arena",
                    "alternate": [
                        "football_stadium"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101691482294153"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Эстонская улица 51",
                        "locality": "Сочи",
                        "postcode": "354392",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101691482294153",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RED ARENA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48b2a7196b88a03d3c9fb975943e8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.45442,
                    25.83882
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/230632026802605"
                ],
                "phones": [
                    "+528689042457"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Tecnológico",
                        "locality": "Matamoros",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "230632026802605",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eternal Flowers CLRH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2db0568574ce6031fa019f208c28f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    34.9432494,
                    32.1035498
                ]
            },
            "properties": {
                "categories": {
                    "primary": "theme_restaurant",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1100494669981333"
                ],
                "phones": [
                    "+972542645245"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "מלאווח אדיר-שוק ראש העין",
                        "locality": "Rosh Ha`Ayin",
                        "postcode": null,
                        "region": null,
                        "country": "IL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1100494669981333",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "718447808255547",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "מלאווח אדיר-שוק ראש העין",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664c9e0d97a803fdefa97e238b61",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.8350335,
                    41.8603604
                ]
            },
            "properties": {
                "categories": {
                    "primary": "urologist",
                    "alternate": [
                        "doctor",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.loyolamedicine.org/provider/denise-abena-asafu-adjei-md-urology"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8885847888"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2160 S 1st Ave",
                        "locality": "Maywood",
                        "postcode": "60153",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374888277654",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Denise Asafu-Adjei, MD",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c1c06417503783df5b4a50240",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0948,
                    -12.06395
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297295071141150"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "callao",
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297295071141150",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Especialista En EXCEL",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f390ca241ae0f00357b540445db11f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.66883,
                    40.4465
                ]
            },
            "properties": {
                "categories": {
                    "primary": "books_mags_music_and_video",
                    "alternate": [
                        "used_bookstore",
                        "cards_and_stationery_store"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "914151740"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Ramos Carrión, 7",
                        "locality": "Madrid",
                        "postcode": "28002",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949963759893",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Papeleria Resma",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d333296d6823035f8ac2172edd72",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.8586429,
                    39.9412446
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/255670978637597"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "255670978637597",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mermercizade İshani",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195d16e4a937003d5b617a431851f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.6632419,
                    51.82064
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01296661267"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8 Vicarage Road, Marsworth",
                        "locality": "Tring",
                        "postcode": "HP23 4LR",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424931062630",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Small Business It Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ecc2009485b0033828a53ec723a1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.3477675,
                    41.8964554
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2271263019615151"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2271263019615151",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "S.S Kapaklı Koop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b57022c51990367651573a159b4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.9430611,
                    10.7579235
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_staging",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100734676156048"
                ],
                "phones": [
                    "+84384449175"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "QW5V+65H, Hiệp Phước, Nhơn Trạch, Đồng Nai 76250, Việt Nam",
                        "locality": "Nhơn Trạch",
                        "postcode": "76250",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100734676156048",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Màn cửa Hải Đăng 2 - Long Thành",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f92ab476228d03e78c9818adeb7b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.7873972,
                    45.0124103
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "college_university",
                        "vocational_and_technical_school"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.ifp43.fr"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/182653631791296"
                ],
                "phones": [
                    "+33471579800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "220 Rue des Camélias",
                        "locality": "Bains",
                        "postcode": "43370",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "182653631791296",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ifp 43 - Institute Vocational Training Haute-Loire",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f0885cadcce7ab03abc6690f22c33a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.7663441,
                    60.6263025
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hardware_store",
                    "alternate": [
                        "wholesale_store",
                        "shopping"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "http://www.ahlsell.se/butiker/sandviken/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/177905062593277"
                ],
                "phones": [
                    "+46104712747"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Ahlsell Sverige",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Förrådsgatan 4",
                        "locality": "Sandviken",
                        "postcode": "811 40",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "177905062593277",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863999005",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ahlsell",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1e48047278d0397b82a66b81b0a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.79308,
                    51.49798
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "delicatessen",
                        "liquor_store"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "https://www.eckes-edlelikoere.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1164705493581973"
                ],
                "phones": [
                    "+4936316360"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bahnhofstraße 25",
                        "locality": "Nordhausen",
                        "postcode": "99734",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1164705493581973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ECKES Liköre",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0b736808aa03757f7ce52f2c54",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.8690453,
                    33.7754292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_decor",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7149532805"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2800 N Main St Ste 740",
                        "locality": "Santa Ana",
                        "postcode": "92705",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949955268559",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955118056",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sleep Number",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195b91e68db86035cd85fe488b7a0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.7171258,
                    51.1479425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "video_game_store",
                    "alternate": null
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/180806945291181"
                ],
                "phones": [
                    "+441458898423"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 St John's Square",
                        "locality": "Glastonbury",
                        "postcode": "BA6 9LJ",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "180806945291181",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Exchange Den",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a139ad440e903d3a7e1cf23ef94",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.11018,
                    26.20155
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "boat_tours",
                        "travel_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://cruiseshipcenters.com/scottetheredge"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1956363544646310"
                ],
                "phones": [
                    "+19546950313"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Fort Lauderdale",
                        "postcode": null,
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1956363544646310",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cruiseshipcenters.com/scottetheredge",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f52249aaddb30301d86b39b79514",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.0587478,
                    52.1391173
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_product_supplier",
                    "alternate": [
                        "business_equipment_and_supply",
                        "business_to_business"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://staramydlarnia.pl/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "224651991"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Aleja Komisji Edukacji Narodowej 36a",
                        "locality": "Warszawa",
                        "postcode": "02-797",
                        "region": "Woj. Mazowieckie",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849864060329",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Stara Mydlarnia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3919336ce34950364817ad0e23b20",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.623021,
                    37.1386324
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elevator_service",
                    "alternate": [
                        "television_service_providers",
                        "professional_services"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://ascensionan.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/657038714720466"
                ],
                "phones": [
                    "+34858810219"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Huesca, 7",
                        "locality": "Armilla",
                        "postcode": "18100",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "657038714720466",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ascensores Nevada",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa84cc873d5403a68daeba1a3606",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.1105301,
                    38.8954775
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elementary_school",
                    "alternate": [
                        "private_school",
                        "day_care_preschool"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.saintagnes.org/school/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/125490607484063"
                ],
                "phones": [
                    "+17035275423"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2024 N Randolph St",
                        "locality": "Arlington",
                        "postcode": "22207-3031",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "125490607484063",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "St Agnes School",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28308a8c019ad0305fd46cd74b9e4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.2446089,
                    37.8587863
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "marketing_agency"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "http://www.decisioncounsel.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/438547183155485"
                ],
                "phones": [
                    "+15108593605"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2907 Claremont Ave",
                        "locality": "Berkeley",
                        "postcode": "94705-2410",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "438547183155485",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890357874",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Decision Counsel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1edcd244a4d5503ffa8e37867d2e4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.9435395,
                    40.6334062
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_hardware_company",
                    "alternate": [
                        "information_technology_company",
                        "community_center"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.lancom.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/193277800768945"
                ],
                "phones": [
                    "+302141001000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Βασιλέως Ηρακλείου 40",
                        "locality": "Θεσσαλονίκη",
                        "postcode": "546 23",
                        "region": "B",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "193277800768945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lancom Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f658bd020c526903a78126c7efd940",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.8678669,
                    12.9115417
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9119318181818182,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/133701183170636"
                ],
                "phones": [
                    "+66949191597"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "338 พระตำหนัก",
                        "locality": "พัทยา",
                        "postcode": "20150",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "133701183170636",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Zen Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f99cd5961ac503bbe8b1283b5c7f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.11367,
                    45.49456
                ]
            },
            "properties": {
                "categories": {
                    "primary": "interior_design",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://renderincanto.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106063322259522"
                ],
                "phones": [
                    "+393463293202"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Milan",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106063322259522",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Renderincanto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa08d2552d71039a73e5745b13b8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.5743299,
                    50.6422301
                ]
            },
            "properties": {
                "categories": {
                    "primary": "supermarket",
                    "alternate": [
                        "butcher_shop",
                        "bakery"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.intermarche.be/magasins/intermarche-liege-humblet/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100367726302154"
                ],
                "phones": [
                    "+3243686222"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rue de la Cathédrale 63",
                        "locality": "Liège",
                        "postcode": "4000",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100367726302154",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424933988714",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Intermarché Liège Humblet",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f266212816d52503f023f8ff20fbb5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.0065668,
                    40.4851925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "plumbing",
                    "alternate": [
                        "hvac_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "http://www.ckbrush.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106441432158888"
                ],
                "phones": [
                    "+13098083768"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "715 N Morris Ave",
                        "locality": "Bloomington",
                        "postcode": "61701-2708",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106441432158888",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890035582",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CK Brush Plumbing, & Drain Cleaning",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e2a8416d344b031a8bc41f800272",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.013723,
                    50.033694
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.sinsay.com/pl/pl/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "508406300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "al. Jana Pawła II 29",
                        "locality": "Tarnów",
                        "postcode": "33-100",
                        "region": "Małopolskie",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849866477443",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sinsay",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eca75a40e4210328a7b70df9ee60",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.8093124,
                    39.7451907
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fish_and_chips_restaurant",
                    "alternate": [
                        "structure_and_geography"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/395835700489945"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bayramiç",
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "395835700489945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kaz Dağları, Ayazma Alabalık Tesisleri",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa9564c90293420305b5ec90c8317c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -52.621745,
                    -27.1169653
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hunting_and_fishing_supplies",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102434142238714"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Quero-quero",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102434142238714",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dias Caça & Pesca",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa82d0949642c903887335e6428bbd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -53.7192566,
                    -24.7123163
                ]
            },
            "properties": {
                "categories": {
                    "primary": "commercial_refrigeration",
                    "alternate": [
                        "hvac_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1511509139154558"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Josefina Passarini, 303",
                        "locality": "Toledo",
                        "postcode": "85906-390",
                        "region": "PR",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1511509139154558",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Doutor do Ar Condicionado Toledo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415dd800f102603e73c3396bfa4e1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.64889,
                    21.25354
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/120519841137640"
                ],
                "phones": [
                    "+84869725354"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Maines Kenzie Nino",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "25354 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "120519841137640",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eddie Larkin Moore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf10caa1c99d03470db8fd99a212",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.3791839,
                    23.7527955
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "delicatessen"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/341837139834922"
                ],
                "phones": [
                    "+8801717580000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sukrabad ",
                        "locality": "Dhaka",
                        "postcode": "1207",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "341837139834922",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fleek Mart",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b52482a9c980395526f2384651b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.34152,
                    10.47229
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/126181630588451"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wo0I K6hVe",
                        "locality": "Ho Chi Minh City",
                        "postcode": "183541",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "126181630588451",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nguyễn Thu Đoan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3065a6ca84e03a893be9331c30d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.2340877,
                    42.284917
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tennis_court",
                    "alternate": [
                        "sports_club_and_league",
                        "active_life"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://needhamtennisclub.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167785900343255"
                ],
                "phones": [
                    "+17814447613"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kingsbury St",
                        "locality": null,
                        "postcode": "02492",
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167785900343255",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Needham Tennis Club",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f499512d05526e034cb18e60daef73",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.933556,
                    19.412426
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": [
                        "legal_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100715201876728"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Chimalhuacán",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100715201876728",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Responsabilidad y Seriedad",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650510adb280c03ac566e6bd40477",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.694,
                    2.82085
                ]
            },
            "properties": {
                "categories": {
                    "primary": "water_treatment_equipment_and_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://emall.coway.com.my/?agentcode=cd112947"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110790408073867"
                ],
                "phones": [
                    "+60136562145"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Coway(Malaysia)Sdn.Bhd.(735420-H) No1-5 Jalan Warisan Sentral1 KIP Sentral Kota Warisan,43900 Sepang Selangor",
                        "locality": "Sepang",
                        "postcode": "43900",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110790408073867",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Laila Coway",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6026226d280a903603a663b09c14a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.95139,
                    8.50519
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_service",
                    "alternate": [
                        "home_cleaning"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109760854976838"
                ],
                "phones": [
                    "+917736591680"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Thiruvananthapuram",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109760854976838",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Anugraha Home Nursing Service in Trivandrum",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e3647211e893035d264014d53197",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.126584,
                    49.118613
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.dr-lehner-regenstauf.de/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "094026733"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Regensburger Str. 31",
                        "locality": "Regenstauf",
                        "postcode": "93128",
                        "region": "Bayern",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949958827770",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jonas Lehner Zahnarzt",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8b2c8b11525350369a46296f6e7f8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -66.1105111,
                    -17.3891443
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105781304416054"
                ],
                "phones": [
                    "+59178916648"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "AV MAXIMILIANO KOLBE",
                        "locality": "Cochabamba",
                        "postcode": "5914",
                        "region": null,
                        "country": "BO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105781304416054",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Piccos Burger",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb475a34cd6b0324925dbeff0fab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.293792,
                    48.8761576
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "hotel",
                        "travel"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.hotelphenix.fr"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/120598838023482"
                ],
                "phones": [
                    "+33144090505"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5 Rue du Général Lanrezac",
                        "locality": "Paris",
                        "postcode": "75017",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "120598838023482",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hôtel Phénix",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f089b1a2865381030896e53078bdfa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    24.7444,
                    59.44071
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.laboratooriumi23.ee/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103098317931833"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Laboratooriumi 23",
                        "locality": "Tallinn",
                        "postcode": "10133",
                        "region": null,
                        "country": "EE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103098317931833",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lb 23",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe08b32d934e40359ddb6514b6480",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    150.337078,
                    -34.504872
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_center",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://app.boxdivvy.com.au/hub-profile/new-berrima-brisbane-st"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    ""
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Available to Hub Members only",
                        "locality": "New Berrima",
                        "postcode": "2577",
                        "region": "New South Wales",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799821435715",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "New Berrima - Brisbane St.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d8caee654a2a03a6159d62e0f2bf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    110.10623,
                    -7.75994
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107233982235964"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Desa donorejo dusun jogowono kaligesing purworejo",
                        "locality": "Purworejo",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107233982235964",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rejeki garden",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1959715b19ab203b5ebe6607c417f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.8403801,
                    50.7224208
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://homes.trovit.co.uk/san-remo-towers-boscombe-parking"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/723555744358962"
                ],
                "phones": [
                    "+441202397331"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "San Remo Towers, Sea Rd",
                        "locality": null,
                        "postcode": "BH5 1JT",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "723555744358962",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "San Remo Towers, Bournemouth",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbb09699486886031c25ea6df8d4b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    176.2191313,
                    -38.0500056
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lodge",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.awahomesteadtreehouse.co.nz/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0273423030"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "44 Gloucester Road",
                        "locality": "Rotorua",
                        "postcode": "3097",
                        "region": "Bay of Plenty",
                        "country": "NZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799820090104",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Awa Homestead Lodge",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f5bb5b913d2a0330e660d995dc9a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.88036,
                    31.20704
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/700466640092521"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ابو يوسف, 2 شارع الاشراف",
                        "locality": "الاسكندرية",
                        "postcode": null,
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "700466640092521",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "اوريفلام المال والجمال",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f91a62435240034ba39a66cfb6b1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.22312,
                    46.38785
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "medical_service_organizations",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://podologues-nyon.ch/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/127664294546181"
                ],
                "phones": [
                    "+41799364865"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Chemin d'Eysins 12",
                        "locality": "Nyon",
                        "postcode": "1260",
                        "region": "VD",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "127664294546181",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Julie Podologie",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea4c5ecf31350395e578afea67ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.7849391,
                    45.727996
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "hotel",
                        "service_apartments"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.villalvento.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1734240276897186"
                ],
                "phones": [
                    "+393472574986"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via De Loc, 19",
                        "locality": "Brenzone sul Garda",
                        "postcode": "37010",
                        "region": "34",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1734240276897186",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Villalvento",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f395a48e12694c0386e3c359b74c25",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.076,
                    36.748
                ]
            },
            "properties": {
                "categories": {
                    "primary": "park",
                    "alternate": [
                        "botanical_garden",
                        "public_plaza"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.jardinbotaniqueduhamma.dz"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/257095064457347"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rue Hassiba Ben Bouali - B.P. 141, Hamma - El Anasser",
                        "locality": null,
                        "postcode": "16000",
                        "region": null,
                        "country": "DZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "257095064457347",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "367225473380350",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jardin d'essais d'El Hamma",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8833368aa755035221423610d895",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -42.55947,
                    -19.43646
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.uselozane.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100343842803808"
                ],
                "phones": [
                    "+5531982219137"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Ipatinga",
                        "postcode": null,
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100343842803808",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Elеve-sе",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f0b3742f396103a90e9491362324",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    18.0672406,
                    53.1249059
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.planetcash.pl/znajdz-bankomat-i-wplatomat"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "801501601"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Fordońska 141",
                        "locality": "Bydgoszcz",
                        "postcode": "85-739",
                        "region": "Kujawsko-pomorskie",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849865733192",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849865391947",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Planet Cash",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f110566db5ca6d03d512becec45f0e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.1455,
                    61.6863
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/484283165024204"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "484283165024204",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Метсякюля",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3925c43aac28c037320680340201b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.2193362,
                    43.490309
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": [
                        "home_improvement_store",
                        "accommodation"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.cocinasfeal.es/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/331391743544870"
                ],
                "phones": [
                    "+34981311366"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Estrada de Castela, 149",
                        "locality": "Ferrol",
                        "postcode": "15404",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "331391743544870",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cocinas Feal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a819899a20203a36a0765843fa1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.4225685,
                    27.6243359
                ]
            },
            "properties": {
                "categories": {
                    "primary": "office_cleaning",
                    "alternate": [
                        "home_cleaning",
                        "cleaning_services"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.cleaningsolutionservice.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7725674504"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1226 36th Ave",
                        "locality": "Vero Beach",
                        "postcode": "32960",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932674916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932674598",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cleaning Solution service Inc.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195438b7b4798032460b9e8e9d284",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.5969693,
                    54.9377891
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://www.newabbeyholsteins.co.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01387880604"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Midtown",
                        "locality": "Dumfries",
                        "postcode": "DG2 8DL",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424931029034",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bunting D & Son",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f960542a8e9c94032301213840ed66",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.68056,
                    -13.97547
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/194217361128668"
                ],
                "phones": [
                    "+260977507183"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Riverside near Zambia railways ",
                        "locality": "Kapiri Mposhi",
                        "postcode": null,
                        "region": null,
                        "country": "ZM"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "194217361128668",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Church of Christ Youths Kapiri Central",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2db0560a6ad7003bfbb4636669808",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    34.88694,
                    32.08883
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102210585321596"
                ],
                "phones": [
                    "+972507158316"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "עוזר חיים 15",
                        "locality": "פתח תקווה",
                        "postcode": "4936117",
                        "region": "M",
                        "country": "IL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102210585321596",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eli Levy - אלי לוי",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65187760e945103967aee1b495cc9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.489815,
                    7.0711575
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101172999161754"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101172999161754",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ร้านน้ำลูกหมี",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa818cb03418ac03cb90ca4a562681",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.1855,
                    -21.7732544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pilates_studio",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101529649151151"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Manoel Rodrigues Jacob, 1131",
                        "locality": "Araraquara",
                        "postcode": "14802-195",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101529649151151",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pilates Fabiana Pampani",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f685e170963b4d0352e1290a987410",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    124.64661,
                    6.46865
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103657011761823"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Manuel Roxas, Santo Niño, Soccsksargen, Philippines",
                        "locality": "Manuel Roxas",
                        "postcode": "9509",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103657011761823",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LV Goldazzle",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2792609a1b6dc03dd54c85005dd72",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.0282971,
                    46.5988885
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9554838709677419,
                "websites": [
                    "https://www.helenamt.gov/recreation"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116861938372964"
                ],
                "phones": [
                    "+14064438774"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5 Memorial Dr",
                        "locality": "Helena",
                        "postcode": "59601-2900",
                        "region": "MT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116861938372964",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Memorial Park Ice Rink",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184db628ed89a0381191a1d048a7b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.0942948,
                    44.3117912
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https%3a%2f%2fwww.lolo-detailing.fr%2f&ved=2ahukewiy1n6cx6qfaxwktqqehexqchiqfnoecbmqaq&usg=aovvaw3c-bywer9xepcc6hzmoaqg"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/191729484017065"
                ],
                "phones": [
                    "+33749691485"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "15 Route de Villefranche",
                        "locality": "Casteljaloux",
                        "postcode": "47700",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "191729484017065",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lolo detailing",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa811c1d66e62903093a734eda258a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.37402,
                    -23.39597
                ]
            },
            "properties": {
                "categories": {
                    "primary": "counseling_and_mental_health",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109148675611393"
                ],
                "phones": [
                    "+5515996742065"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Pedro Natividade da Silva, 184",
                        "locality": "Sorocaba",
                        "postcode": "18105-255",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109148675611393",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Espaço Florescer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2cb402c6469b0340e11a01d93f2c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.7512,
                    -30.39551
                ]
            },
            "properties": {
                "categories": {
                    "primary": "comedy_club",
                    "alternate": [
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1909764082659012"
                ],
                "phones": [
                    "+543458400050"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3187",
                        "locality": "San José de Feliciano",
                        "postcode": "3187",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1909764082659012",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AltoImpacto.com.ar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ee5cca11007103ea557f8aafd908",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.5690708,
                    45.9569417
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9285033365109628,
                "websites": [
                    "https://www.instagram.com/beautyvit.sebes?igsh=dhdwdhcyzwplanlv"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122102620887452"
                ],
                "phones": [
                    "+40770879575"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bulevardul Lucian Blaga 38",
                        "locality": "Sebeș",
                        "postcode": "515800",
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122102620887452",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beautyvit.Sebes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb604c091803c7eafa6e932900",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.9165167,
                    20.9632434
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/771381192920916"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hung Yen",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "771381192920916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nhà Của Lan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a8dbb54a5a8e0387f6026a42cfe2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.365668,
                    37.215393
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gas_station",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://mybpstation.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8046299832"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2156 County Dr",
                        "locality": "Petersburg",
                        "postcode": "23803",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424930432230",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e82c54a10d80346d40e011143fd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.6243041,
                    33.6409086
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.rubytuesday.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2056558284"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5957 Chalkville Mountain Rd",
                        "locality": "Birmingham",
                        "postcode": "35235",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949953551135",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ruby Tuesday",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12ecc86da9ce303831214ed192f78",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -113.4882803,
                    53.5702671
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "automotive_dealer",
                        "automotive"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://flyupskyautotrust.v12soft.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/282885618903766"
                ],
                "phones": [
                    "+17802003042"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9521 118 Ave NW",
                        "locality": "Edmonton",
                        "postcode": "T5G 0N8",
                        "region": "AB",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "282885618903766",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flyup Sky Auto Trust Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274d221a68c4203f8797bc85dfeaa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.6117065,
                    42.5810858
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_rental",
                    "alternate": [
                        "video_and_video_game_rentals",
                        "clothing_store"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.redbox.com/locations/michigan/milford/48381/20169"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8667332693"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "140 S Milford Rd",
                        "locality": "Milford",
                        "postcode": "48381",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949956967216",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955266841",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Redbox",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f80a5672ab5d0310fa40da12d256",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.4643408,
                    48.2620693
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "wedding_planning"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1775314886118517"
                ],
                "phones": [
                    "+33651209208"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "12 Rue des Roses",
                        "locality": "Sélestat",
                        "postcode": "67600",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1775314886118517",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Planif'",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66c481515e8e203d4cb9eddb4a6ac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.29044,
                    2.93223
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://tastescoffee.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100204901566312"
                ],
                "phones": [
                    "+573128221047"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Neiva",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100204901566312",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tastes Coffee",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab2c32c356c5034ec8e613f80667",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.196091,
                    42.545637
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.tammaralomedico.com/contact.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/569075396452473"
                ],
                "phones": [
                    "+15865305033"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Birmingham",
                        "postcode": null,
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "569075396452473",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tammara Lomedico - Makeup Artist",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa835749c4838e03ae5004c4d3c331",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.8772499,
                    -26.33815
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "spas",
                        "counseling_and_mental_health"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.youtube.com/@massagemtantricajoinville/videos"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1392468337506662"
                ],
                "phones": [
                    "+5547999550496"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Raul Ventura dos Santos, 170",
                        "locality": "Joinville",
                        "postcode": "89214-712",
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1392468337506662",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Regiane Santos Deva  -  Terapias Naturais",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c1436c308c0309c80d97bcb52a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.2406276,
                    29.6233766
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9897612903225806,
                "websites": [
                    "https://madisononthelakeapts.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103582712414373"
                ],
                "phones": [
                    "+12819415495"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9988 Windmill Lakes Blvd",
                        "locality": "Houston",
                        "postcode": "77075-3338",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103582712414373",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424934379343",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Madison on the Lake",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ed528a5536032b95836724b2c7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.0098,
                    14.67073
                ]
            },
            "properties": {
                "categories": {
                    "primary": "souvenir_shop",
                    "alternate": [
                        "printing_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104500019384106"
                ],
                "phones": [
                    "+639555000100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "RIVERA",
                        "locality": "Quezon City",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104500019384106",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Print Impression Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e832acae089603a6217cd049b5f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.2784691,
                    40.94765
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gym",
                    "alternate": [
                        "active_life"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100748792812428"
                ],
                "phones": [
                    "+393664616385"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Francesco D'Ambrosio, 58",
                        "locality": "Frattamaggiore",
                        "postcode": "80027",
                        "region": "72",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100748792812428",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Invictus Frattamaggiore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2dac08cb00c6e03def31b8e36966b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    36.6329002,
                    37.0264397
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": [
                        "car_dealer",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/749751978484104"
                ],
                "phones": [
                    "+905343151173"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "serinevler mah. 371 nolu sok toki işmerkezi",
                        "locality": "Islahiye",
                        "postcode": "27800",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "749751978484104",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yüksel Oto Ve Hali Yikama",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2e2191d64b930385c8f8374e5776",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.4898998,
                    -31.8992345
                ]
            },
            "properties": {
                "categories": {
                    "primary": "airport_lounge",
                    "alternate": [
                        "fast_food_restaurant",
                        "lounge"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/343628066193620"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ruta 5",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "343628066193620",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Picá Paletitta",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f0d8acaed66a035c6ebcebe9d589",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.9601,
                    -3.45228
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122096421008009531"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Santa Rosa",
                        "postcode": null,
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122096421008009531",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Andry López ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a10125ca2821030ebe53bb779ce9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.5979654,
                    41.038644
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "dance_school"
                    ]
                },
                "confidence": 0.9084967320261438,
                "websites": [
                    "http://www.petiteballet.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/344207782115826"
                ],
                "phones": [
                    "+12033401105"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "241 E Putnam Ave",
                        "locality": "Greenwich",
                        "postcode": "06807-2703",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "344207782115826",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Petite Ballet at Beam & Barre",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2af605bca481903201725fa7db201",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.3524933,
                    37.0454903
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/956878711021822"
                ],
                "phones": [
                    "+17577234361"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "123 Ransone St",
                        "locality": "Hampton",
                        "postcode": "23669-2514",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "956878711021822",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jest Delivered",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1942cca68e4a903f15ea68478adaf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.7627024,
                    53.768665
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_management_services",
                    "alternate": [
                        "hobby_shop",
                        "consultant_and_general_service"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.postoffice.co.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "03456112970"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1052 Manchester Road",
                        "locality": "Bradford",
                        "postcode": "BD5 8NN",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863367597",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Post Office-Wibsey Bank Foot",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3141c0ea4319c038b566617fc4082",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    129.56444,
                    41.63833
                ]
            },
            "properties": {
                "categories": {
                    "primary": "structure_and_geography",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/700574903424123"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "KP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "700574903424123",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paekt'o-ryŏng (bergspass i Nordkorea, lat 41,64, long 129,56)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66089b311ab6a0365f776c4a3059d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.1161881,
                    7.1162731
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "real_estate",
                        "professional_services"
                    ]
                },
                "confidence": 0.9119318181818182,
                "websites": [
                    "https://grupoinmoskalar.inmo.co/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1151170245039298"
                ],
                "phones": [
                    "+573147377161"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 9A-24",
                        "locality": "Bucaramanga",
                        "postcode": "680002",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1151170245039298",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Grupo Inmobiliario Skalar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90e0832733550322e119d1f7e46d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -50.87829,
                    -29.38689
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/150877934782901"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Piratini, 815",
                        "locality": "Gramado",
                        "postcode": "95670-000",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "150877934782901",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Le Belle Canto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664c1a9240610353be985a62cd74",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.6258837,
                    41.8856634
                ]
            },
            "properties": {
                "categories": {
                    "primary": "electrician",
                    "alternate": [
                        "fashion",
                        "professional_services"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://akelectrical.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/118486697932031"
                ],
                "phones": [
                    "+17737210081"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "63 E Lake St",
                        "locality": "Chicago",
                        "postcode": "60601-5921",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "118486697932031",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "A and K Electrical Chicago",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4065cea3ae0210362e7e3364f3c55",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    102.10504,
                    21.6833
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_goods_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104833505904083"
                ],
                "phones": [
                    "+8562097833633"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "phongsaly",
                        "locality": "Phôngsali",
                        "postcode": "12333",
                        "region": null,
                        "country": "LA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104833505904083",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Team Wang - Kid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa9033312a9503039ad16cf0ec9cc4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -50.27565,
                    -29.89535
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_company",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114473670352023"
                ],
                "phones": [
                    "+51998509216"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Ângelo Gabriel Boff Guasselli, 831",
                        "locality": "Osório",
                        "postcode": "95520-000",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114473670352023",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kiles Veículos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f390396a8544920311cafd4eb0d7e4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -5.8456,
                    39.33811
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_beverage_service_distribution",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110666237383062"
                ],
                "phones": [
                    "+59175049599"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "calle libertad # 800 (entre 1er y 2do anillo)",
                        "locality": "Santa Cruz de la Sierra",
                        "postcode": "10260",
                        "region": null,
                        "country": "BO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110666237383062",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Rotonda Lácteos Bolivia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c10400ac3a98035f98781596f986",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    107.1201688,
                    -6.3016218
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_service_and_government",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/286775631944500"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bekasi",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "286775631944500",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rest area km 72",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2c1c09306554039829a7b48e328e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.67651,
                    -34.1736
                ]
            },
            "properties": {
                "categories": {
                    "primary": "veterinarian",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105640107696971"
                ],
                "phones": [
                    "+56974031769"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle El Yunque Norte 39",
                        "locality": "Machalí",
                        "postcode": "2910000",
                        "region": null,
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105640107696971",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vet a Domicilio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c106c478bcab03583a7d9e20a719",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.6198005,
                    -6.175561
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/530249497133083"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Tangerang",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "530249497133083",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GBI ECCLESiA Jl Otista Raya Tangerang",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a36529704cc03c227aefacb10c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.345722,
                    -21.7606909
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/311949855337053"
                ],
                "phones": [
                    "+5532991935115"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Halfeld ",
                        "locality": "Juiz de Fora",
                        "postcode": "36100000",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "311949855337053",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paula Assumpção 30.456",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf2c7500b3850303cec792c99952",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.3462522,
                    22.5376016
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_school",
                    "alternate": [
                        "education",
                        "school"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2008125999512717"
                ],
                "phones": [
                    "+919836728559"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4 Ashutosh Mukherjee Road",
                        "locality": "Kolkata",
                        "postcode": "700025",
                        "region": "WB",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2008125999512717",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "রং Pencil",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e5325715283031b19918f72af40",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.3793884,
                    30.3865056
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "teeth_whitening",
                        "cosmetic_dentist"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "http://www.seacrestdental.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1502955113259133"
                ],
                "phones": [
                    "+18502132626"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "66 N Holiday Rd",
                        "locality": "Miramar Beach",
                        "postcode": "32550-6936",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1502955113259133",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849862723441",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Seacrest Dental Miramar Beach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26498982294500315707ac731aa59",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.0310323,
                    35.198787
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": [
                        "legal_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://hhulaw.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/904806852873477"
                ],
                "phones": [
                    "+19313634571"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "119 S 1st St",
                        "locality": "Pulaski",
                        "postcode": "38478-3215",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "904806852873477",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949956523506",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Henry Henry & Underwood PC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8af68e18ae53603ba79a19c95be2f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.021219,
                    -3.137444
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://wa.me/559294171209"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1956200571112545"
                ],
                "phones": [
                    "+5592994171209"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Leovegildo Coelho, 393",
                        "locality": "Manaus",
                        "postcode": "69005-090",
                        "region": "AM",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1956200571112545",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hotel Fortaleza II Manaus",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81d850a438150384253ab4e4fdb4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.96243,
                    -22.22659
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://maisquepiquenique.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/182428502453943"
                ],
                "phones": [
                    "+5514991635025"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Marília",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "182428502453943",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Maisquepiquenique",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8329d42e840037510554f6d0d8d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.2498773,
                    40.8390642
                ]
            },
            "properties": {
                "categories": {
                    "primary": "school",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106107484192233"
                ],
                "phones": [
                    "+393392123732"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Santa Brigida, 67",
                        "locality": "Napoli",
                        "postcode": "80132",
                        "region": "72",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106107484192233",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Antonella Terrazas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1b54401a26b0367bca1d4828eb3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.6187941,
                    51.1068747
                ]
            },
            "properties": {
                "categories": {
                    "primary": "physical_therapy",
                    "alternate": [
                        "active_life",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.animo-therapie.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/337707373023055"
                ],
                "phones": [
                    "+493514797438"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kötitzer Straße 31",
                        "locality": "Radebeul",
                        "postcode": "01445",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "337707373023055",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ANIMO-Präventions- u. Therapiezentrum GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f68418268c01a203fd9c3b65dd82d4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    125.5966,
                    10.010693
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_and_garden",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108578444271022"
                ],
                "phones": [
                    "+639271889108"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dinagat",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108578444271022",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Planter's Haven",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26cbd0d40982803b3d1ba290d225f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.1430465,
                    32.7212834
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "tanning_salon"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://hairbymandymoler.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1618534468159154"
                ],
                "phones": [
                    "+12148019967"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2223 W Park Row Dr",
                        "locality": "Arlington",
                        "postcode": "76013-3400",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1618534468159154",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hair by Mandy Moler",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446ca82790c09039fdf2d5ff2ed4d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.3613281,
                    29.7071393
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_school",
                    "alternate": [
                        "topic_publisher"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.enovativestrings.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/117234242280117"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "117234242280117",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "eNovativeStrings, by Steven McMillan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a138ed721a8034be39cb5ef7c2d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.1728945,
                    26.1843428
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.ltluxuryhomes.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116087098251467"
                ],
                "phones": [
                    "+15164585918"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Charles Rutenberg Realty, 2201 W Prospect Rd",
                        "locality": "Fort Lauderdale",
                        "postcode": "33309-3077",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116087098251467",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LT Luxury Homes Group",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c2a1b366e00305664c8799231e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.917122,
                    52.293007
                ]
            },
            "properties": {
                "categories": {
                    "primary": "engineering_services",
                    "alternate": [
                        "commercial_industrial",
                        "machine_shop"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://www.mmturnedparts.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1414938455453085"
                ],
                "phones": [
                    "+441527500888"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unit 3, Securehold Business Centre, Studley Road",
                        "locality": "Redditch",
                        "postcode": "B98 7LG",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1414938455453085",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955403827",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "M&M Turned Parts Ltd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f73c56b736c803e9b4dc9df6e0c5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.1289767,
                    35.3348597
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": null
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.wearepharmacy.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111159197129444"
                ],
                "phones": [
                    "+302810241004"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Σπιναλόγγας 8",
                        "locality": "Ηράκλειο",
                        "postcode": "712 01",
                        "region": "M",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111159197129444",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Φαρμακείο Αναστασία Ψαρουδάκη",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1958443620c8c03578566a0f11c23",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.0324634,
                    51.6553551
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpet_cleaning",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.servicemasterclean.co.uk/gwent-glamorgan-south/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01633864530"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unit 8 Springvale Ind Estate",
                        "locality": "Cwmbran",
                        "postcode": "NP44 5AZ",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908561676",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Servicemaster Furniture Medic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f586ae4eb1400387615530f1ae3c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.670805,
                    35.2799001
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chinese_restaurant",
                    "alternate": [
                        "restaurant",
                        "japanese_restaurant"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.shanghai-tei.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/394688923952701"
                ],
                "phones": [
                    "+81468232316"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "神奈川県横須賀市若松町１丁目４",
                        "locality": "横須賀市",
                        "postcode": "238-0007",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "394688923952701",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "上海亭",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da106469ace2036d2fe56db84429",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.3139,
                    28.58341
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9285033365109628,
                "websites": [
                    "https://digitalcampus.academy/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/224289837435793"
                ],
                "phones": [
                    "+918527647899"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "C/22",
                        "locality": "Noida",
                        "postcode": "201301",
                        "region": "UP",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "224289837435793",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Digital Campus Best Digital Marketing Institute",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2834d0e30e7240393548f9f07232d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.8018019,
                    36.6847155
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_and_dvd_store",
                    "alternate": [
                        "musical_instrument_store",
                        "music_venue"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.musiczoneshop.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/429173770623948"
                ],
                "phones": [
                    "+18318838000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3112 Del Monte Blvd",
                        "locality": "Marina",
                        "postcode": "93933-3049",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "429173770623948",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Music Zone",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e7aa51228103cd255abd453c50",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1551652,
                    51.7137358
                ]
            },
            "properties": {
                "categories": {
                    "primary": "limo_services",
                    "alternate": [
                        "taxi_service",
                        "plumbing"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.esv.org.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01279422700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bassett Business Units, Hurricane Way",
                        "locality": "Epping",
                        "postcode": "CM16 6AA",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908412396",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "E S V",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f90646541cdb03950e1b6b3d16aa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.51295,
                    45.47419
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/679232815751747"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "51 cure andrijab mogofler",
                        "locality": "Saint-Chamond",
                        "postcode": "42400",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "679232815751747",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Leo.bruno",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1909a890291a30371a865e8561a2d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -4.4034109,
                    55.9084076
                ]
            },
            "properties": {
                "categories": {
                    "primary": "desserts",
                    "alternate": [
                        "restaurant",
                        "candy_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.bbqhutperiperi.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111988544911426"
                ],
                "phones": [
                    "+441419410339"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5 Montrose Street",
                        "locality": "Clydebank",
                        "postcode": "G81 2JF",
                        "region": "SCT",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111988544911426",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dessert Corner",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f984030c9b8b0385dd69af7e251e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.6879971,
                    45.0671366
                ]
            },
            "properties": {
                "categories": {
                    "primary": "antique_store",
                    "alternate": [
                        "diner"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/156207364401398"
                ],
                "phones": [
                    "+390118178663"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via San Francesco di Paola, 14M",
                        "locality": "Torino",
                        "postcode": "10123",
                        "region": "21",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "156207364401398",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Antichità Dutto Di Biancotto Nadia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa650696000103dfc7748b110dad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.8988711,
                    42.7486435
                ]
            },
            "properties": {
                "categories": {
                    "primary": "liquor_store",
                    "alternate": [
                        "wine_bar",
                        "shopping"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.wanakahwinesandliquor.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103286368415540"
                ],
                "phones": [
                    "+17169803000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4931 Lake Shore Rd",
                        "locality": "Hamburg",
                        "postcode": "14075-5600",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103286368415540",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "1772711012809974",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wanakah Wines & Liquor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba291670284803e48ef79e7541f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.4096892,
                    24.078715
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "hotel",
                        "gym"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://sclohas.cbshow.org.tw/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/153882294669320"
                ],
                "phones": [
                    "+886975617310"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "鹿工路6號",
                        "locality": "鹿港鎮",
                        "postcode": "505",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "153882294669320",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "秀傳樂活自然療癒中心",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf2c44cf58cd03232071adc31333",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.37864,
                    22.52846
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152453351278593"
                ],
                "phones": [
                    "+919830189300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kasba post office nKolkatan",
                        "locality": "Kolkata",
                        "postcode": "700042",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152453351278593",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pharmacy Gplus",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274cae6c0905803e46d9903e0411e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.37679,
                    43.62411
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/127411901242355"
                ],
                "phones": [
                    "+19892645162"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "454 N McCann Dr",
                        "locality": "Midland",
                        "postcode": "48640-9051",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "127411901242355",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MGK Handyman Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44caa4d1adbad0354ca1bc713499b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.1346425,
                    35.9159989
                ]
            },
            "properties": {
                "categories": {
                    "primary": "damage_restoration",
                    "alternate": [
                        "environmental_conservation_and_ecological_organizations",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://moldmasterstn.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104678715059717"
                ],
                "phones": [
                    "+18652883990"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10427 Cogdill Rd",
                        "locality": "Knoxville",
                        "postcode": "37932-3356",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104678715059717",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mold Masters",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c7219c0f303f3783a09f4b508",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.99799,
                    -12.08374
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_company",
                    "alternate": [
                        "tours",
                        "travel_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1165340440147347"
                ],
                "phones": [
                    "+51993973696"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1165340440147347",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Agencia de Turismo de Romance",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa9d350f4c6e035a28c429d66d86",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.732161,
                    50.424631
                ]
            },
            "properties": {
                "categories": {
                    "primary": "theatre",
                    "alternate": [
                        "topic_concert_venue",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.theater-hildburghausen.de"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/219671814857981"
                ],
                "phones": [
                    "+493685402177"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Coburger Straße 10",
                        "locality": "Hildburghausen",
                        "postcode": "98646",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "219671814857981",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Theater Hildburghausen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3dacb939138600379fd4dc5b8b33d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    78.40957,
                    29.15444
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/132297159965845"
                ],
                "phones": [
                    "+9675500303"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "noorpur ",
                        "locality": "Noorpur",
                        "postcode": "246734",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "132297159965845",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Adv ajayveer chaudhary",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca8c9ab2961e03d460f34aeb1e17",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.29021,
                    23.36174
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/365158716688430"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "harmu itki",
                        "locality": "Ranchi",
                        "postcode": "835303",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "365158716688430",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "sushma Topno ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f20e60166a1c64032ef06be2f12488",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.91289,
                    43.27081
                ]
            },
            "properties": {
                "categories": {
                    "primary": "commercial_industrial",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://lmb2022.kz/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122326147640143"
                ],
                "phones": [
                    "+77717651101"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Әліхан Бөкейханов көшесі 11",
                        "locality": "Алматы",
                        "postcode": "050014",
                        "region": null,
                        "country": "KZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122326147640143",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Литой модифицированный бетон",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b5659933191033d61d625c8bc8b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.63067,
                    10.85881
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152034991623565"
                ],
                "phones": [
                    "+84972423908"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Đường Dương Thị Mười 48A",
                        "locality": "Hồ Chí Minh",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152034991623565",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shop mẹ Tỏi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c729066f29b4032f00f881f5b897",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    47.4823,
                    42.97398
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "school"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/303928260227191"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "проспект Имама Шамиля 38",
                        "locality": "Махачкала",
                        "postcode": "367026",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "303928260227191",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Я Права",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39a9856a6d12303d02dfad3d77840",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.07985,
                    35.06028
                ]
            },
            "properties": {
                "categories": {
                    "primary": "school_sports_league",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113839384938637"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "العوامرة",
                        "locality": "El Aouamra",
                        "postcode": "9252",
                        "region": null,
                        "country": "MA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113839384938637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "السوسيو الرياضي الثقافي بالعوامرة",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446caee044d2803487746242cc98b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.59289,
                    29.78328
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://kirkwoodandassociatesllc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102205231783823"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11757 Katy Fwy",
                        "locality": "Houston",
                        "postcode": "77079-0011",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102205231783823",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kirkwood and Associates LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab41aeb552dd03eca1de3b0a70bc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.9199379,
                    43.3678481
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5192761342"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Road 110, 3888",
                        "locality": "Stratford",
                        "postcode": "n5a 6s5",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978082687",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sebben Consulting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aacb36ade9820387d9e2181e6675",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.32197,
                    39.974286
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "restaurant",
                        "italian_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.bravopizzahavertown.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/443930915715480"
                ],
                "phones": [
                    "+16104463810"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1345 West Chester Pike",
                        "locality": "Havertown",
                        "postcode": "19083-2930",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "443930915715480",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bravo Pizza Manoa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2830c6e8b382003183419bf854745",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.0576214,
                    37.9389988
                ]
            },
            "properties": {
                "categories": {
                    "primary": "veterinarian",
                    "alternate": [
                        "pest_control_service",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9119318181818182,
                "websites": [
                    "http://www.vacavilleanimalcontrol.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/125673920797122"
                ],
                "phones": [
                    "+19253817199"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3478 Buskirk Ave",
                        "locality": "Pleasant Hill",
                        "postcode": "94523-4344",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "125673920797122",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Advanced Animal Removal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29ae24a7acb1203f1933fbea8d198",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -119.017499,
                    36.0702399
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "professional_services"
                    ]
                },
                "confidence": 0.9588815789473685,
                "websites": [
                    "https://roni.cacentralvalleyhomesforsale.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111502811562848"
                ],
                "phones": [
                    "+15593103565"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "259 N Hockett St",
                        "locality": "Porterville",
                        "postcode": "93257-3636",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111502811562848",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Roni Long Real Estate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2af622b67154a03968be055a7991b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.20908,
                    36.80823
                ]
            },
            "properties": {
                "categories": {
                    "primary": "topic_concert_venue",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129772633782738"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Virginia Beach",
                        "postcode": null,
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129772633782738",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DJ Iamaris",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60145a6b960c0031a0bc03d6c4332",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.56432,
                    12.943513
                ]
            },
            "properties": {
                "categories": {
                    "primary": "indian_restaurant",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.chaatimes.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/444129919002948"
                ],
                "phones": [
                    "+919845253399"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "39 4th Cross Road",
                        "locality": "Bengaluru",
                        "postcode": "560019",
                        "region": "KA",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "444129919002948",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chaatimes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415dc2541340e03d90a3cb803dced",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.50754,
                    21.15026
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100228245107554"
                ],
                "phones": [
                    "+84886849161"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hanoi",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100228245107554",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vàng bạc Anh Đức",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d64404909a94035d86529ef23f98",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.2056376,
                    14.0338864
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elementary_school",
                    "alternate": [
                        "high_school",
                        "school"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.shadaischool.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106465682743776"
                ],
                "phones": [
                    "+50496414961"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Col.Loarque Sur",
                        "locality": "Tegucigalpa",
                        "postcode": "504",
                        "region": null,
                        "country": "HN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106465682743776",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shadai School",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651876458e41e031f83ac70774029",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.45798,
                    7.00324
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106239835667838"
                ],
                "phones": [
                    "+66644182677"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "21/7 ถนน เพชรเกษม",
                        "locality": "หาดใหญ่",
                        "postcode": "90110",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106239835667838",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "เสริมสวยโกล์เด้นแฮร์",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa80c93055230203bede8ce9d8af0b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -51.9218119,
                    -23.4159771
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_manufacturing_and_supply",
                    "alternate": [
                        "fire_protection_service",
                        "professional_services"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.paranaextintores.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/311885215670387"
                ],
                "phones": [
                    "+554432685566"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Colombo, 4026",
                        "locality": "Maringá",
                        "postcode": "87030-120",
                        "region": "PR",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "311885215670387",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paraná Extintores",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4b1154d48a03f3942d8699128b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.496574,
                    13.7431709
                ]
            },
            "properties": {
                "categories": {
                    "primary": "audio_visual_equipment_store",
                    "alternate": [
                        "professional_services",
                        "electronics"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110429187892132"
                ],
                "phones": [
                    "+66929450978"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "บ้านหม้อพลาซ่า, 154/4 ซอย ทิพย์วารี",
                        "locality": "กรุงเทพมหานคร",
                        "postcode": "10200",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110429187892132",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ร้านดวงเดือน Byชะเอม-ชะเอมฟลาวเวอร์รับจัดดอกไม้สด",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6482c69c15da903360ca8b0a9d8b2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.976659,
                    18.791606
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "retirement_home"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1553530271459530"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1553530271459530",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "หอพักพยาบาลคณะแพทย์ศาสตร์ 6",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a065c10e74a0300736b84c7c40a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.4307345,
                    -22.8114358
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "evangelical_church",
                        "religious_organization"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/306561819458815"
                ],
                "phones": [
                    "+5521984551022"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Coronel França Leite, 2015",
                        "locality": "Nilópolis",
                        "postcode": "26520-651",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "306561819458815",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Comunidade Cristã A Serviço Do Rei Jesus",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa5da668972803d0f28e54f817db",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.4674821,
                    51.460302
                ]
            },
            "properties": {
                "categories": {
                    "primary": "nutritionist",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.9285033365109628,
                "websites": [
                    "http://succesvol-afvallen.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/228059083925801"
                ],
                "phones": [
                    "+31402445015"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sebastiaan van Noyestraat 13",
                        "locality": "Eindhoven",
                        "postcode": "5622 KG",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "228059083925801",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bianca's Finishing Touch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa498d518c810375dca4298e2032",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.5719136,
                    42.9400887
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "pub",
                        "restaurant"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "https://seatgeek.com/venues/swifty-s/tickets"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/137299203010466"
                ],
                "phones": [
                    "+13152526309"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "45 Perrine St",
                        "locality": "Auburn",
                        "postcode": "13021-1118",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "137299203010466",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Swifty's",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6526ac8a0850203dc7fea5fffcc8e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.90542,
                    1.31558
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "uniform_store"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "https://greenchef.global/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1480761058805217"
                ],
                "phones": [
                    "+6562912345"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "163 Still Rd",
                        "locality": "Singapore",
                        "postcode": "423996",
                        "region": null,
                        "country": "SG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1480761058805217",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GC Collective",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb32199e982d7003fdd90aeeb41f62",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -68.06835,
                    -16.53034
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": null
                },
                "confidence": 0.9456869009584664,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189840387855943"
                ],
                "phones": [
                    "+59177505473"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Achumani - Zona Sur ",
                        "locality": "La Paz",
                        "postcode": null,
                        "region": null,
                        "country": "BO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189840387855943",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HYPE HOUSE Clothing",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26e0cb2a83a8c030a7ec7cdae82b4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.620774,
                    38.842618
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "religious_organization",
                        "episcopal_church"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://www.ame-church.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109236472449687"
                ],
                "phones": [
                    "+17858237397"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1021 W Ash St",
                        "locality": "Salina",
                        "postcode": "67401-2718",
                        "region": "KS",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109236472449687",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Allen Chapel Ame Church",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30d9ad48ddc5003a40b8889d1026c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.3627331,
                    33.5713781
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.teatro-f.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/364834286880831"
                ],
                "phones": [
                    "+81928228686"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "城南区別府2-20-44 　Mスマート別府2F",
                        "locality": "Fukuoka-shi",
                        "postcode": "814-0104",
                        "region": "40",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "364834286880831",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ティアトロ×リミテ（teatro×limite)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64b5b81d367a6036f351d2844a289",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.184082,
                    16.0873825
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104206558850664"
                ],
                "phones": [
                    "+66836093746"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104206558850664",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AO333",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f083209184c32903f348b17d7bb785",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.1228291,
                    62.4759694
                ]
            },
            "properties": {
                "categories": {
                    "primary": "river",
                    "alternate": [
                        "landmark_and_historical_building",
                        "waterfall"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/138520662839880"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "NO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "138520662839880",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mardøla",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f9840625000903d76f59f57f55c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.6489319,
                    45.0813059
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://m.europages.it/nuova-balma-buildings-sas-di-balma-tiziana/seac006766513-001.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/358069478389212"
                ],
                "phones": [
                    "+390117576440"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Balme, 47",
                        "locality": "Torino",
                        "postcode": "10143",
                        "region": "21",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "358069478389212",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nuova Baildings Sas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e2e02a532a760350a2ab22ff85ed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.04997,
                    50.56286
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1698516133776891"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sędziszów",
                        "locality": "Sedziszow",
                        "postcode": "28-340",
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1698516133776891",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "K-Clean",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f618c4d606b115036c6760913615bb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.22524,
                    13.0834564
                ]
            },
            "properties": {
                "categories": {
                    "primary": "vegetarian_restaurant",
                    "alternate": [
                        "food_stand",
                        "coffee_shop"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://order.chaiwaale.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102038312149263"
                ],
                "phones": [
                    "+919025938641"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "112,D BLOCK Chintamani Anna Nagar East",
                        "locality": "Chennai",
                        "postcode": "600102",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102038312149263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chai waale AnnaNagar East Chintamani",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f80088098d301303c6a0c263212c15",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -44.2404206,
                    -2.4888911
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "children's_clothing_store"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.kingtees.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/452681078167596"
                ],
                "phones": [
                    "+559887120868"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "São Luís",
                        "postcode": null,
                        "region": "MA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "452681078167596",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KING TEESS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f6c515a4da6803f6f674b0800307",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.28244,
                    37.71721
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1384351778275411"
                ],
                "phones": [
                    "+905077665144"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "burdur",
                        "locality": "Burdur",
                        "postcode": "15001",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1384351778275411",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Burdur Lastikçi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8e406d35068b03f513b7abb12c13",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -50.919587,
                    -20.1963788
                ]
            },
            "properties": {
                "categories": {
                    "primary": "b2b_science_and_technology",
                    "alternate": [
                        "engineering_services",
                        "mobile_home_dealer"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "https://linktr.ee/beniniengcivil"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1255575171209286"
                ],
                "phones": [
                    "+5517981417816"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua França, 53",
                        "locality": "Santa Fé do Sul",
                        "postcode": "15775-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1255575171209286",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Benini Engenharia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8183981048af0035432cadf37e00f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -34.9303225,
                    -8.0468351
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122144649219151"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Cláudio Brotherhood, 73",
                        "locality": "Recife",
                        "postcode": "50721-260",
                        "region": "PE",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122144649219151",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Senhorita Mermaid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f54c9b3440d5033008ecc319e604",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    19.3665824,
                    53.883498
                ]
            },
            "properties": {
                "categories": {
                    "primary": "topic_concert_venue",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/211158565587035"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Stary Dzierzgon",
                        "postcode": null,
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "211158565587035",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Stare Miasto k. Dzierzgonia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f95a4c283019a8032c0e0a72999141",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    115.2538,
                    -8.65531
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sports_club_and_league",
                    "alternate": [
                        "esports_league"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/858097681209640"
                ],
                "phones": [
                    "+6285855461334"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "88, Jalan Bypass Ngurah Rai",
                        "locality": "Denpasar",
                        "postcode": "80237",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "858097681209640",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Liga Bali Arena",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa54855238a0035616b4849d8bfb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.8436942,
                    50.9947518
                ]
            },
            "properties": {
                "categories": {
                    "primary": "firework_retailer",
                    "alternate": [
                        "shopping",
                        "tattoo_and_piercing"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.sparkles-vuurwerk.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1510896705836947"
                ],
                "phones": [
                    "+31615476970"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Oslostraat 80",
                        "locality": "Sittard",
                        "postcode": "6135 LM",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1510896705836947",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sparkles Vuurwerk",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4b0ad5888c0364e58113ea474a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.4297,
                    13.71901
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://lin.ee/xthdoaa"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115295371649972"
                ],
                "phones": [
                    "+66818877898"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "88/99",
                        "locality": "Phasi Charoen",
                        "postcode": "10200",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115295371649972",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "เว็บพนันออนไลน์",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da815e7a071603b665d27a1993e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.419,
                    28.35793
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112635618291804"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Imperial mall old bus stand ",
                        "locality": "Bareilly",
                        "postcode": "243001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112635618291804",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The zaan bright solutions counsltency ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48d621e335384036cf2ecd0697ac5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -103.13691,
                    32.74722
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.kimcrowder.jamberrynails.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/644585592255372"
                ],
                "phones": [
                    "+15754416168"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hobbs",
                        "postcode": null,
                        "region": "NM",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "644585592255372",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kim Crowder, Jamberry Independent Consultant",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274820a355b21037b98ee5443e2de",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.1807714,
                    42.3172357
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://agents.farmers.com/nroblescruz"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/164472383415602"
                ],
                "phones": [
                    "+12698884297"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "68 Michigan Ave E",
                        "locality": "Battle Creek",
                        "postcode": "49017-4001",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "164472383415602",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Farmers Insurance - Natanael Robles-Cruz",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194d386448770036baad70e86a60c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.1922339,
                    50.8116103
                ]
            },
            "properties": {
                "categories": {
                    "primary": "web_designer",
                    "alternate": [
                        "information_technology_company",
                        "internet_service_provider"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.thatswhy.be/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/369416879925115"
                ],
                "phones": [
                    "+32494458683"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kortrijkstraat 145",
                        "locality": "Wevelgem",
                        "postcode": "8560",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "369416879925115",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "That's Why",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f489e9ab4dbd3603fd5cf37adf4e64",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.45198,
                    29.5033949
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pet_groomer",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110434511723995"
                ],
                "phones": [
                    "+12109293177"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "620 St Paul St",
                        "locality": "Gonzales",
                        "postcode": "78629-3552",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110434511723995",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dog Gonnit Grooming",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42ca95ba6a31d031e9e0033f066b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.0973526,
                    22.4100967
                ]
            },
            "properties": {
                "categories": {
                    "primary": "garbage_collection_service",
                    "alternate": [
                        "industrial_company",
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/206695033153234"
                ],
                "phones": [
                    "+102652840390"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Plot No 134/1, G I D C Estate",
                        "locality": null,
                        "postcode": "391340",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "206695033153234",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nandesari Industries Association",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d1c68a70ec6403e9312fca8fe253",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.0170153,
                    39.7505486
                ]
            },
            "properties": {
                "categories": {
                    "primary": "turkish_restaurant",
                    "alternate": [
                        "restaurant",
                        "steakhouse"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/383434605050561"
                ],
                "phones": [
                    "+903466547595"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Atatürk Bulvarı 10A",
                        "locality": "Sivas",
                        "postcode": "58040",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "383434605050561",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Meşhur Sivas Köftecisi Yeniçubuk-Sivas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f696bdb5a9d0c403b3b9594407971f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.53688,
                    16.67636
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116628434721718"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Alta Vista, Patul",
                        "locality": "Santiago",
                        "postcode": "3311",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116628434721718",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Arts&Son",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2641286c82a9503adffb3c492a11a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.7005202,
                    37.16245
                ]
            },
            "properties": {
                "categories": {
                    "primary": "safety_equipment",
                    "alternate": [
                        "car_inspector",
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.intoxalock.com/locations/il/metropolis/1805-east-5th-st-4175?utm_medium=yext&utm_source=bing&y_source=1_MTUzNzkyMjUtNDgzLWxvY2F0aW9uLndlYnNpdGU%3D"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6185094276"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1805 East 5th St",
                        "locality": "Metropolis",
                        "postcode": "62960",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949960201063",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Intoxalock Ignition Interlock",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e15b0b80b44d035abbdaec03c347",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.27946,
                    48.16153
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_production",
                    "alternate": [
                        "mass_media"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.synchronstage.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1634971316772204"
                ],
                "phones": [
                    "+43188605270"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Engelshofengasse 2",
                        "locality": "Wien",
                        "postcode": "1230",
                        "region": "9",
                        "country": "AT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1634971316772204",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Synchron Stage Vienna",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2656391b05cf60313c0176984b1bb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.35816,
                    38.92959
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landscaping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101436388234183"
                ],
                "phones": [
                    "+18162673241"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ryan Rd",
                        "locality": "Lees Summit",
                        "postcode": "64086",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101436388234183",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lisa’s Lawn Care LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1185490828d16038e5d885905c41c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    36.26534,
                    54.51292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "retail",
                        "children's_clothing_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.hollydolly.ru/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/513729875366170"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "улица Кирова 70",
                        "locality": "Калуга",
                        "postcode": "248001",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "513729875366170",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HOLLY DOLLY, магазин детской натуральной одежды",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f2c76edab2a00332052c4b507c75",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.8014501,
                    56.8491213
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/149045138505245"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Växjö",
                        "postcode": null,
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "149045138505245",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hemma",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274dc066123ab0313020a4c6c2801",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.1475379,
                    43.3290927
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hvac_services",
                    "alternate": [
                        "contractor",
                        "commercial_industrial"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://mj-mechanical.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/315894655161685"
                ],
                "phones": [
                    "+19898659633"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11787 Prior Rd",
                        "locality": "Swan Creek Twp",
                        "postcode": "48655-9559",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "315894655161685",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "M J Mechanical",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100ec5816a5033a41b83d06d1ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.68228,
                    -23.58876
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://ev.braip.com/ref?pv=proov3yx&af=afi3vd1q68"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/190058987531761"
                ],
                "phones": [
                    "+5521992218395"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Leopoldo Couto Magalhães Júnior, 987",
                        "locality": "São Paulo",
                        "postcode": "04542-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "190058987531761",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lara Beauty",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f283409b3a125403fb92d12081e281",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.9525548,
                    37.2727508
                ]
            },
            "properties": {
                "categories": {
                    "primary": "self_storage_facility",
                    "alternate": [
                        "storage_facility"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.extraspace.com/storage/facilities/us/california/campbell/501672/?cid=org%3a%3afbsp&utm_source=facebook&utm_medium=social&utm_campaign=org%3a%3afbsp"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1539795336280611"
                ],
                "phones": [
                    "+14083793052"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Extra Space Storage",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "187 E Sunnyoaks Ave",
                        "locality": "Campbell",
                        "postcode": "95008-6607",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1539795336280611",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "757665407644945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949957569509",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949954988715",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474976833325",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890564067",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911577699",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Extra Space Storage",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6ca03c5069a037537b92549bae4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    134.3621644,
                    34.0692602
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": null
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102151485740015"
                ],
                "phones": [
                    "+81883221016"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kamojimacho Nakajima, 字大止４６７－１",
                        "locality": null,
                        "postcode": "776-0004",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102151485740015",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "喫茶店ピノキオ 徳島鴨島店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f398c2a224210b03c198dfb0bf57e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.35208,
                    32.33952
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104515616056438"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": " 4 vc",
                        "locality": "Beni Mellal",
                        "postcode": null,
                        "region": null,
                        "country": "MA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104515616056438",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "الوظيفه والخدمات",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c76011ea9403915aa5b3729f0e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.105173,
                    52.43124
                ]
            },
            "properties": {
                "categories": {
                    "primary": "steakhouse",
                    "alternate": [
                        "restaurant",
                        "pub"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.beefeatergrill.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1097180893659644"
                ],
                "phones": [
                    "+441562883120"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Beefeater",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Birmingham Road, Hagley",
                        "locality": "Stourbridge",
                        "postcode": "DY9 9JS",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1097180893659644",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424930947402",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949956340739",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Badgers Sett Beefeater",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f489c0f540c5260345f4cedc3faef4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.4916664,
                    29.6450075
                ]
            },
            "properties": {
                "categories": {
                    "primary": "printing_services",
                    "alternate": [
                        "active_life"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://www.epochcenter.io/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/145668421961036"
                ],
                "phones": [
                    "+12102433613"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "21750 Hardy Oak Blvd",
                        "locality": "San Antonio",
                        "postcode": "78258-3108",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "145668421961036",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Epoch Innovation Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30d9ac0c9a9a203bf31a39b394607",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.411089,
                    33.5892921
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "seafood_restaurant"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://donmai.owst.jp"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/181096265331390"
                ],
                "phones": [
                    "+81922632302"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "福岡県福岡市博多区住吉１丁目２−２２",
                        "locality": "福岡市博多区",
                        "postcode": "812-0018",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "181096265331390",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "博多海鮮丼屋 どん舞",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2674cdac8a009031ed90d17e636f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -91.6182113,
                    42.0254311
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": [
                        "bridal_shop",
                        "clothing_store"
                    ]
                },
                "confidence": 0.9880576923076922,
                "websites": [
                    "http://elegantrepeats.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/134197463259007"
                ],
                "phones": [
                    "+13193651070"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4700 Tama St SE",
                        "locality": "Cedar Rapids",
                        "postcode": "52403-4537",
                        "region": "IA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "134197463259007",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799813744868",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849860813688",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Elegant Repeats & Elegant Bridal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e61466c09a9d031237441ac0ddbe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.763164,
                    34.931777
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://location.sevenbank.co.jp/sevenbank/spot/detail?code=0000018570"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0120771179"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "伏見区新町4丁目474-1",
                        "locality": "京都市",
                        "postcode": "〒612-8081",
                        "region": "京都府",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899910115129",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899910112020",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "セブン銀行ATM セブン-イレブン 伏見新町4丁目店 共同出張所",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad6b91ca998303ca83fe6dbc1156",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.5485336,
                    35.3815275
                ]
            },
            "properties": {
                "categories": {
                    "primary": "optometrist",
                    "alternate": [
                        "eyewear_and_optician",
                        "eye_care_clinic"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://www.nceyecare.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/162894482507"
                ],
                "phones": [
                    "+19198947570"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "113 W Main St",
                        "locality": "Benson",
                        "postcode": "27504-1343",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "162894482507",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Professional Eye Care",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea21a140c24803ba35ce93f1307e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.1018479,
                    43.8684684
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": [
                        "hospital",
                        "home_service"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://www.arkeprato.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1730181300426120"
                ],
                "phones": [
                    "+390574057824"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Beniamino Gigli, 3",
                        "locality": "Prato",
                        "postcode": "59100",
                        "region": "52",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1730181300426120",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centro Arké - Centro multidisciplinare per la salute dell'infanzia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a86c8366380403d09c64a53d49dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.4855454,
                    40.7711742
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "religious_organization"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://local.churchofjesuschrist.org/en/us/oh/massillon/2625-ohio-state-drive-southeast?utm_source=fb&utm_medium=yext"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/861411917269408"
                ],
                "phones": [
                    "+13308307391"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "The Church of Jesus Christ of Latter-day Saints",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "2625 Ohio State Dr SE",
                        "locality": "Massillon",
                        "postcode": "44646-9616",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "861411917269408",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963500966",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Church of Jesus Christ of Latter-day Saints",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1487610410d03da7c1c797fbc7e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.5592212,
                    42.0040639
                ]
            },
            "properties": {
                "categories": {
                    "primary": "farmers_market",
                    "alternate": [
                        "fruits_and_vegetables",
                        "grocery_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.gigisnativeproduce.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/549661411811130"
                ],
                "phones": [
                    "+18608818297"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "48 Shaker Rd",
                        "locality": "Enfield",
                        "postcode": "06082-3112",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "549661411811130",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GiGi's Native Produce",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa3610923713031236b88f860565",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.7521444,
                    49.3312834
                ]
            },
            "properties": {
                "categories": {
                    "primary": "ice_cream_shop",
                    "alternate": [
                        "cafe",
                        "gelato"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "https://www.oiv-roden.de/azindexcustom/volpe-concetta"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/207037525979071"
                ],
                "phones": [
                    "+49683182537"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lindenstraße 102",
                        "locality": "Saarlouis",
                        "postcode": "66740",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "207037525979071",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paradiso",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1865840b82c1d0326c7cc9479aca8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.0176744,
                    49.2872468
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "college_university"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://greta.ac-normandie.fr/greta/greta-portes-normandes/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/142402079724761"
                ],
                "phones": [
                    "+33232969494"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4B Cours Carnot",
                        "locality": "Elbeuf",
                        "postcode": "76500",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "142402079724761",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GRETA Portes Normandes - Antenne d'Elbeuf",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c8d1d710dc035af570952d4180",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.2268386,
                    29.4338484
                ]
            },
            "properties": {
                "categories": {
                    "primary": "veterinarian",
                    "alternate": [
                        "hospital",
                        "pet_services"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://www.alvinanimalclinic.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/119305224779297"
                ],
                "phones": [
                    "+12815855183"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1200 N Highway 35 Byp",
                        "locality": "Alvin",
                        "postcode": "77511-8232",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "119305224779297",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324839531909",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890100644",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alvin Animal Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24dadd30222d03e3724ad21ffe38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.7280874,
                    -31.5554994
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hardware_store",
                    "alternate": [
                        "men's_clothing_store",
                        "clothing_company"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1757495141147372"
                ],
                "phones": [
                    "+543424905545"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "JUAN DE GARAY 6112",
                        "locality": "Recreo",
                        "postcode": "3018",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1757495141147372",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CASA Andres S.A.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f611e859db501003e4e5765e7a195c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.19257,
                    8.0729
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fish_farm",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104172328622117"
                ],
                "phones": [
                    "+94718939350"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Gampola",
                        "postcode": null,
                        "region": null,
                        "country": "LK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104172328622117",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chaතු Aqwa Gampola",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60a259694404003510e5548e0e152",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    78.486979,
                    17.434319
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111325483636254"
                ],
                "phones": [
                    "+914027840288"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2/3/147",
                        "locality": "Secunderabad",
                        "postcode": "500003",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111325483636254",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sumair Industrial Corporation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26610926d48ac03a94395c13120b7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.075554,
                    39.7600915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "storage_facility",
                    "alternate": null
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://brotherbearstorage.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105493941594402"
                ],
                "phones": [
                    "+17652801144"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8607 E Old 36 Rd",
                        "locality": "Rockville",
                        "postcode": "47872-7715",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105493941594402",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brother Bear Storage",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa84713aa0b3033e5e40c846df8f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.953671,
                    38.967838
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": [
                        "real_estate"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/260659380672173"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6504 Belcrest Rd",
                        "locality": "Hyattsville",
                        "postcode": "20782",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "260659380672173",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Metro Lost & Found",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e614dac3171e0365262c5f105d2d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.80335,
                    50.52194
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sports_and_recreation_venue",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://valset.in.ua/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/641436552952987"
                ],
                "phones": [
                    "+380967542528"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Симона Петлюри вулиця, 20",
                        "locality": "Броварський район",
                        "postcode": null,
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "641436552952987",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Valset.in.ua",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29b28b14ea9660300ef2aefa6e300",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.3701172,
                    34.7855236
                ]
            },
            "properties": {
                "categories": {
                    "primary": "social_service_organizations",
                    "alternate": [
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103811668501514"
                ],
                "phones": [
                    "+15208401215"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5550 E Longhorn Rd",
                        "locality": "Chino Valley",
                        "postcode": "86323-8715",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103811668501514",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Four Star Ranch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c329b38ba10033a2d3fa245ece2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.91492,
                    34.3811
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campground",
                    "alternate": [
                        "travel"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://koa.com/campgrounds/hartwell-lakeside/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8885628821"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "330 Hart State Park Rd",
                        "locality": "Hartwell",
                        "postcode": "30643",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424934467889",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374888435112",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hartwell Lakeside KOA Holiday",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6045a56508103dbcde8e7279cbf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    136.7735074,
                    35.3498548
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sunglasses_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.owndays.com/jp/ja/shops/2122"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0120900298"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "一宮市, 木曽川町黒田字南ハツケ池25-1, イオンモ-ル木曽川 3F",
                        "locality": null,
                        "postcode": "〒493-0001",
                        "region": "愛知県",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424934630519",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912205631",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912205021",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "OWNDAYS イオンモール木曽川店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa94e5a807398c03fe76c615c3e739",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -57.45509,
                    -25.37453
                ]
            },
            "properties": {
                "categories": {
                    "primary": "television_service_providers",
                    "alternate": [
                        "internet_service_provider",
                        "mobile_phone_store"
                    ]
                },
                "confidence": 0.926605504587156,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/165428169986837"
                ],
                "phones": [
                    "+595972789722"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Doc López Godoy ",
                        "locality": "Capiatá",
                        "postcode": null,
                        "region": null,
                        "country": "PY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "165428169986837",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Asesora de personal ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe630ad4680840370c16ac06d9549",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.6884678,
                    -37.8634224
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "barber"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/957105027738966"
                ],
                "phones": [
                    "+61397346072"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "109 Hogans Rd",
                        "locality": "Melbourne",
                        "postcode": "3029",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "957105027738966",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "First Choice Hair & Beauty Salon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f264626892da5b03bb8430ec09b964",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.2759209,
                    38.6050215
                ]
            },
            "properties": {
                "categories": {
                    "primary": "motorcycle_dealer",
                    "alternate": [
                        "motorcycle_repair",
                        "auto_company"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.billythekidcustomcycles.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/293440794011676"
                ],
                "phones": [
                    "+13145445455"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3122 Brannon Ave",
                        "locality": "St Louis",
                        "postcode": "63139-1422",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "293440794011676",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424930203820",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Billy the kid custom cycles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195da116ed9060385ccd72c453886",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.410931,
                    51.6930394
                ]
            },
            "properties": {
                "categories": {
                    "primary": "record_label",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115060143474555"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Watford",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115060143474555",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Christ In Me Records",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe5622a0dc30a030d557c027589e6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    147.5497319,
                    -33.332937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lake",
                    "alternate": [
                        "landmark_and_historical_building",
                        "fountain"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/142441869460164"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "2871",
                        "region": null,
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "142441869460164",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Back Creek/The Back Lagoon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44f402ccd51ad03615c672e223028",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.199156,
                    29.215322
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "hair_salon",
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.supercuts.com/locations/fl/ocala/shops-at-foxwood-shopping-ctr-haircuts-82887.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/835534129895385"
                ],
                "phones": [
                    "+13523511722"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Supercuts",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "2765 NW 49th Ave",
                        "locality": "Ocala",
                        "postcode": "34482-6214",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "835534129895385",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849860481931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909377361",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Supercuts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f300628dda3c1e036fc2023b80f66a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.634909,
                    38.919938
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "restaurant",
                        "seafood_restaurant"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/246940342834303"
                ],
                "phones": [
                    "+1041182808888"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "火车站",
                        "locality": null,
                        "postcode": "116000",
                        "region": null,
                        "country": "CN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "246940342834303",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "九洲华美达酒店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a252830bdb50392b674a37f86db",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -42.0185657,
                    -22.878336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "engineering_services"
                    ]
                },
                "confidence": 0.9398496240601504,
                "websites": [
                    "http://www.gecprojetos.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/160629557601536"
                ],
                "phones": [
                    "+5522999530525"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Boulevard Canal, 138",
                        "locality": "Cabo Frio",
                        "postcode": "28906-400",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "160629557601536",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "G & C Projetos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c2421abb4003653ef3ed7c4595",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.4580607,
                    30.1283817
                ]
            },
            "properties": {
                "categories": {
                    "primary": "property_management",
                    "alternate": [
                        "public_and_government_association",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://cmicares.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102642125829304"
                ],
                "phones": [
                    "+19365216900"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "25211 Grogans Mill Rd",
                        "locality": "Spring",
                        "postcode": "77380-2170",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102642125829304",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Community Management Innovations",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f453529008e806038b9b94e045a90e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.56817,
                    15.4838681
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_and_medical",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105949865621568"
                ],
                "phones": [
                    "+50495655997"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle central contiguo a la sucursal principal del banco Atlántidan",
                        "locality": "Olanchito",
                        "postcode": null,
                        "region": null,
                        "country": "HN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105949865621568",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Laboratorio Clínico Familiar Olanchito",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a2a61a6500a0302d78eedf05e8c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.05645,
                    -22.81961
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://wa.me/5521996403589"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/244305322105500"
                ],
                "phones": [
                    "+5521996403589"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Candido mota filho",
                        "locality": "São Gonçalo",
                        "postcode": "24465310",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "244305322105500",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Feijoada gourmet",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2690d8b134898031cd21f013cb522",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.4068189,
                    40.4902721
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://intermountainhealthcare.org/find-a-doctor/john-m-rector-phd-1629442835"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4356574400"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "454 E Medical Way",
                        "locality": "Heber City",
                        "postcode": "84032",
                        "region": "UT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799821288792",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "John M. Rector, PhD",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba259c89e03303ea455350e05878",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.31348,
                    23.30096
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101146036249226"
                ],
                "phones": [
                    "+88666320506"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "延平路56號",
                        "locality": "台南市",
                        "postcode": "730",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101146036249226",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "湘園飯包",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48d887599c86603ae780236a2469a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -106.56937,
                    35.10551
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hair_stylist",
                    "alternate": [
                        "barber",
                        "hair_salon"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://sportclips.com/us-nm-albuquerque-nm105"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5052070308"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6600 Menaul Blvd NE Ste T005",
                        "locality": "Albuquerque",
                        "postcode": "87110",
                        "region": "NM",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374888381301",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909319081",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909258573",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sport Clips Haircuts of Albuquerque - Coronado Mall",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81894dca682e032447424fe63105",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.019976,
                    -21.8896224
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "spas"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/548343515372973"
                ],
                "phones": [
                    "+551432941599"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Nove de Julho, 665",
                        "locality": "Iacanga",
                        "postcode": "17180-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "548343515372973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salão da Maria",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08a950ca5d98e0379b3c55332d975",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.777188,
                    62.9317517
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "pizza_restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "https://www.pappasrestaurang.se/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/218405448033913"
                ],
                "phones": [
                    "+4661213300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Torggatan 3",
                        "locality": "Kramfors",
                        "postcode": "872 30",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "218405448033913",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pappas Restaurang",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66e4644db36c103ef96bc7381d856",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2612588,
                    4.7282217
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": [
                        "screen_printing_t_shirt_printing"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105386112282735"
                ],
                "phones": [
                    "+573212605899"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carrera 1 #6-79, El Rodeo, Torre 10, Ap 402",
                        "locality": "Madrid",
                        "postcode": "250030",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105386112282735",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Titas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa961bae02d98e03f5ae029c8503b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -59.42559,
                    -28.65536
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109343391551724"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "El Sombrerito, General Obligado, Santa Fe, Argentina",
                        "locality": "Ingeniero Chanourdie",
                        "postcode": "3585",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109343391551724",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Metalúrgica gobetti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2c085e41626a0348e082fc37b105",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.21328,
                    -33.68738
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189714634224831"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Melipilla ",
                        "locality": "Melipilla",
                        "postcode": null,
                        "region": null,
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189714634224831",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tutifruti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65056f3a6504403b4209453e41198",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.359,
                    3.42709
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/221219518089242"
                ],
                "phones": [
                    "+60192918092"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kuala Selangor",
                        "postcode": null,
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "221219518089242",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pakar Hilang Bau Badan Sepantas 3 Saat",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3044cc8b75003e499dcc3b16d38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.2032879,
                    42.6957016
                ]
            },
            "properties": {
                "categories": {
                    "primary": "preschool",
                    "alternate": [
                        "child_care_and_day_care",
                        "school"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://littlesprouts.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8779777688"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "15 NE Business Ctr Dr",
                        "locality": "Andover",
                        "postcode": "01810",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978033273",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799818749336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Little Sprouts - Andover NEBC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa351e82510203421ed6d3fb2ac8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.08529,
                    49.479824
                ]
            },
            "properties": {
                "categories": {
                    "primary": "drywall_services",
                    "alternate": [
                        "home_staging"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.nouvel-air-agencement.lu/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "691155578"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "94 Avenue Grande-Duchesse Charlotte",
                        "locality": "Dudelange",
                        "postcode": "3440",
                        "region": "Luxembourg",
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424934510056",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nouvel'Air Agencement SARLS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f61108b45cc2032220734481a6c1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.3924337,
                    38.081929
                ]
            },
            "properties": {
                "categories": {
                    "primary": "emergency_room",
                    "alternate": [
                        "ambulance_and_ems_services",
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1493460394201061"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1493460394201061",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Çal 112 Acil Sağlık Hizmetleri İstasyonu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c3a189620840334e6767e73eed2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.3438642,
                    33.9849774
                ]
            },
            "properties": {
                "categories": {
                    "primary": "liquor_store",
                    "alternate": [
                        "food_beverage_service_distribution",
                        "beer_bar"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.jandlventuresllc.com/classiccitybeverages-contact"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/272015146210618"
                ],
                "phones": [
                    "+17063531650"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "530 Calhoun Dr",
                        "locality": "Athens",
                        "postcode": "30601-1514",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "272015146210618",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beverage South (formerly Classic City Beverages)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f80104c078848e03b369af9c4c7d1e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -38.4899,
                    -3.73885
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": [
                        "rental_service",
                        "atv_rentals_and_tours"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/847004835507137"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Santos Dumont, 3743",
                        "locality": "Fortaleza",
                        "postcode": "60150-165",
                        "region": "CE",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "847004835507137",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Regia Fashion",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f391c6c80914e50304f5933029f203",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -5.71984,
                    37.15355
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/450895598791681"
                ],
                "phones": [
                    "+34639442359"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle San Sebastián, 37",
                        "locality": "Los Molares",
                        "postcode": "41750",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "450895598791681",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sunonmoonworld",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa4225d294d8038e0ef4d66c4790",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.3101425,
                    51.2293635
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2272443303042303"
                ],
                "phones": [
                    "+32473833413"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Einderpad 25",
                        "locality": "Lommel",
                        "postcode": "3920",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2272443303042303",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hairline Geoffrey",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa812aaaca1cee03fc1f37e1ff415f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -45.90338,
                    -23.21918
                ]
            },
            "properties": {
                "categories": {
                    "primary": "amateur_sports_team",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/217608082294093"
                ],
                "phones": [
                    "+5512991799606"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Comendador Vicente de Paulo Penido, 526",
                        "locality": "São José dos Campos",
                        "postcode": "12246-856",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "217608082294093",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Studio Diego Nogueira",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9d10b94969a03bd37cf41c24d70",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.1842652,
                    37.8066818
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_parts_and_supply_store",
                    "alternate": [
                        "automotive",
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://stores.advanceautoparts.com/wv/beckley/4006-robert-c-byrd-dr?utm_medium=local&utm_source=yext&utm_content=listing-2016-12-29&utm_campaign=aap"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3042534871"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4006 Robert C Byrd Dr",
                        "locality": "Beckley",
                        "postcode": "25801",
                        "region": "WV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949956748478",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Advance Auto Parts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8159d4c560cd90314dccdc1845477",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.08814,
                    -5.34359
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cosmetic_and_beauty_supplies",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2253108508044548"
                ],
                "phones": [
                    "+5594992342381"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Folha 20 Quadra 13 Lote 1, 12",
                        "locality": "Marabá",
                        "postcode": null,
                        "region": "PA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2253108508044548",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hypnose Maquiagens",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24214ddb131103e88fb3a48f35d0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.80672,
                    -30.71988
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107490591048977"
                ],
                "phones": [
                    "+543549457244"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Cruz del Eje, Córdoba, Argentina",
                        "locality": "Cruz del Eje",
                        "postcode": "5280",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107490591048977",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Doña Elena",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8ab9908e24a2039bb5ad72e6fc3b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -45.43235,
                    -20.46261
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "dentist"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/727227430803491"
                ],
                "phones": [
                    "+553733218823"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Doutor Henrique Braga",
                        "locality": "Formiga",
                        "postcode": "35570000",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "727227430803491",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Consultorio Odontológico Lucas e Paula",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a4524058c7403211b520a0491da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -116.7550993,
                    32.6752891
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "wedding_planning",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://thebradfordranch.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/708280129200151"
                ],
                "phones": [
                    "+16199473029"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2459 Mount Elena Way",
                        "locality": "Jamul",
                        "postcode": "91935-6840",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "708280129200151",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Bradford Ranch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08a4d8b949ac303d8e5a039a82b7c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.6679697,
                    60.2724691
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1059852830739550"
                ],
                "phones": [
                    "+4741488540"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hadelandsvegen 1801",
                        "locality": "Grua",
                        "postcode": "2742",
                        "region": "30",
                        "country": "NO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1059852830739550",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hadeland Cruisers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d1245e92a826035ef1808ef5d1c9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    35.3195147,
                    36.9837701
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mobile_phone_store",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.elmalik.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110358151776726"
                ],
                "phones": [
                    "+905362962307"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "اضنة شارع السورين",
                        "locality": "Adana",
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110358151776726",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "اتصالات الملك",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f424d055969b2d037f425bd7ada7eb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.300326,
                    31.478915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "automotive_parts_and_accessories",
                        "motorsports_store"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1850026171929232"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "PK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1850026171929232",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Car Valley",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f450b8b5ba94c103e36c4e9ee954b5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.15787,
                    21.13724
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": [
                        "business_advertising"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105686904491405"
                ],
                "phones": [
                    "+529861530833"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 54A 459",
                        "locality": "Tizimín",
                        "postcode": "97700",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105686904491405",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PubliTizi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa92e14e844cb5030a0ff137b3731b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -52.3355338,
                    -31.7495349
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.sitemercado.com.br/mercadotocadocoelho"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109309407511963"
                ],
                "phones": [
                    "+555332713385"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Pelotas",
                        "postcode": null,
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109309407511963",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mercado Toca do Coelho",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f088661d65bd9303422b7e3123c853",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    18.0813369,
                    59.3393002
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pub",
                    "alternate": [
                        "restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.thelondoner.se/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2048294122062541"
                ],
                "phones": [
                    "+4686650987"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Karlavägen 52",
                        "locality": "Stockholm",
                        "postcode": "114 49",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2048294122062541",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Londoner",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1869ba8c80586030590edc707a5ee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.7358672,
                    45.4666406
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": null
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://www.pharmaciedesmonedieres-lelonzac.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/506256936545375"
                ],
                "phones": [
                    "+33555982520"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "17 Avenue des Martyrs",
                        "locality": "Le Lonzac",
                        "postcode": "19470",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "506256936545375",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pharmacie Marsaleix",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275d748292ab20337ff7ace932953",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.0268927,
                    43.0030278
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sandwich_shop",
                    "alternate": [
                        "restaurant",
                        "delicatessen"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://www.cousinssubs.com/order/cousins-subs-west-allis-92nd-lincoln-ave"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104873492889291"
                ],
                "phones": [
                    "+14143272122"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Cousins Subs",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "9124 W Lincoln Ave",
                        "locality": "West Allis",
                        "postcode": "53227-2412",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104873492889291",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890775102",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912141193",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cousins Subs",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39601ae290b28033f1ebea5cd3e1b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.44567,
                    43.60373
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.youtube.com/channel/uccmit6suoe0vbggzf9glg9g"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109290134636693"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "43 Rue d'Alsace-Lorraine, 31000 Toulouse, France",
                        "locality": "Toulouse",
                        "postcode": "31000",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109290134636693",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cercle Jean Mermoz",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5ad5ed33a400347dfe8acec8a5b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    140.5679847,
                    35.7131762
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "landmark_and_historical_building",
                        "fountain"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1270813416367610"
                ],
                "phones": [
                    "+81479723188"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "千葉県匝瑳市椿１８４５",
                        "locality": "匝瑳市",
                        "postcode": "289-2102",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1270813416367610",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "常福寺",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1865c68c488c0035e1a27e08a5d03",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.52075,
                    49.37865
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "barber",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/345913932486478"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "rue Gambetta",
                        "locality": null,
                        "postcode": "27500",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "345913932486478",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Médard Coiffure",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44ce80016894403c355a7c50f7eb0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.0413361,
                    34.3592171
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tire_shop",
                    "alternate": [
                        "automotive",
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.mavis.com/locations/dawsonville-ga.asp?ab=MTB&utm_source=yext&utm_medium=local&utm_campaign=local"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7066865180"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "445 Power Center Dr.",
                        "locality": "Dawsonville",
                        "postcode": "30534",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949957906120",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mavis Tires & Brakes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe63d51531a35034c313ca7eba16b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    145.174177,
                    -38.145535
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://www.langwarrin.repcoservice.net/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0359259119"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7/385 McClelland Drive",
                        "locality": "Langwarrin",
                        "postcode": "3910",
                        "region": "Victoria",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324839265010",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909782171",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Repco Authorised Car Service Langwarrin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4803b9d4ccd2e033a8172ff792efd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -108.47075,
                    25.5673794
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_food_store",
                    "alternate": [
                        "grocery_store"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102308749329392"
                ],
                "phones": [
                    "+526871076054"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "eucaliptos col.del bosque ",
                        "locality": "Guasave",
                        "postcode": "81000",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102308749329392",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Delicias Snacks",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8736dd6a508c035ce1c227bdf5de",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -54.6082628,
                    -20.4492008
                ]
            },
            "properties": {
                "categories": {
                    "primary": "employment_agencies",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.trainner.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/409196889113407"
                ],
                "phones": [
                    "+5567992214646"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Doutor Arthur Jorge, 1870",
                        "locality": "Campo Grande",
                        "postcode": "79010-210",
                        "region": "MS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "409196889113407",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trainner Recursos Humanos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f658b493db465803dee57ab6c95fa6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.634298,
                    13.641153
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": [
                        "cafe",
                        "restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115626496792284"
                ],
                "phones": [
                    "+10909615732"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "10270",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115626496792284",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NK cafe ศรีนครินทร์",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea5a0c6940aa0365acdc4dfeb09a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.21833,
                    46.08022
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "software_development"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.deimosengineering.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/405129879864765"
                ],
                "phones": [
                    "+390432421000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via del Cotonificio, 129b",
                        "locality": "Udine",
                        "postcode": "33100",
                        "region": "36",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "405129879864765",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Deimos Engineering srl",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eacc1a62d81c0332adea487b494d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.579421,
                    45.025281
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/316793615449758"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Punta Di Galetto, Šetalište Dražica 3A",
                        "locality": "Krk",
                        "postcode": "51500",
                        "region": null,
                        "country": "HR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "316793615449758",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Titanic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26636d1058ac103903effd14f52f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.5411027,
                    39.1227599
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://schackmannhearing.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2173420304"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "209 N 3rd St",
                        "locality": "Effingham",
                        "postcode": "62401",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474980746916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912909132",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Schackmann Hearing",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2666895ae09560317bc231fa6b11e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.6854403,
                    41.6332723
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "ice_cream_shop",
                        "diner"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/213989411790890"
                ],
                "phones": [
                    "+18154985084"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "105 S Cherry St",
                        "locality": "Somonauk",
                        "postcode": "60552-9818",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "213989411790890",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Somonauk Delite",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f662c93079435d03500e8ed445c9ad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.735321,
                    10.6469402
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "fashion_accessories_store",
                        "jewelry_store"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/388072794557835"
                ],
                "phones": [
                    "+582617155434"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Maracaibo",
                        "postcode": null,
                        "region": null,
                        "country": "VE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "388072794557835",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MPM Accesorios",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eb496c34936103faee3292fc8751",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.2845149,
                    44.1494788
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "professional_services",
                        "real_estate_service"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.agenziaimmobiliaregp.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103305342708493"
                ],
                "phones": [
                    "+39019626117"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Giacomo Matteotti, 55",
                        "locality": "Pietra Ligure",
                        "postcode": "17027",
                        "region": "42",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103305342708493",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Agenzia Immobiliare GP sas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f396c46d39006003a4a332161e18d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.3808933,
                    43.7998488
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wholesale_store",
                    "alternate": [
                        "building_supply_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.carreauxdazur.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111689910362826"
                ],
                "phones": [
                    "+33618433299"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7 Avenue de la Dame",
                        "locality": "Caissargues",
                        "postcode": "30132",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111689910362826",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Carreaux d'Azur",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fac1241bcdba92038f3c669f867af1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.527277,
                    -22.6407681
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": [
                        "hotel",
                        "lodge"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.swakopmundaccommodation.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1702460006644268"
                ],
                "phones": [
                    "+26464462743"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Bernstein St",
                        "locality": "Swakopmund",
                        "postcode": null,
                        "region": null,
                        "country": "NA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1702460006644268",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Swakopmund Accommodation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f4eb9a029d12030812790dbce834",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.58245,
                    53.92873
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.nursace.relax.by/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/293594474080251"
                ],
                "phones": [
                    "+375445330246"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "г.Минск, ТЦ «Европа», 193, 3 этаж",
                        "locality": "Minsk",
                        "postcode": null,
                        "region": null,
                        "country": "BY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "293594474080251",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Магазин обуви Nursace в Минске",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f27526c5c338d5030162a3274d6d39",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.140495,
                    44.944237
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.aistrupconsulting.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6125811333"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "957 Ashland Ave",
                        "locality": "Saint Paul",
                        "postcode": "55104",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976926371",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Aistrup Consulting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f81a9030186ce303cbfc2872a00b9b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -38.9635587,
                    -8.7555817
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "clothing_store",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": [
                    "https://gardiny.lojavirtualnuvem.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/138154769713713"
                ],
                "phones": [
                    "+558738761905"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Coronel Caribe, 458",
                        "locality": "Belém do São Francisco",
                        "postcode": "56440-000",
                        "region": "PE",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "138154769713713",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gardiny",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c106b56d6d4003f6fbc12222a46f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.808137,
                    -6.140579
                ]
            },
            "properties": {
                "categories": {
                    "primary": "freight_and_cargo_service",
                    "alternate": [
                        "professional_services",
                        "shipping_center"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/452941914904528"
                ],
                "phones": [
                    "+10216919901"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jalan Kali Besar",
                        "locality": null,
                        "postcode": "11230",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "452941914904528",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Satuan Harapan PT",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a100725a0603038717cd77cfd101",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.7312112,
                    40.7916059
                ]
            },
            "properties": {
                "categories": {
                    "primary": "police_department",
                    "alternate": [
                        "law_enforcement",
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://vok-ny.com/police"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/576907852417377"
                ],
                "phones": [
                    "+15164820480"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1a Beverly Rd",
                        "locality": "Great Neck",
                        "postcode": "11021-1302",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "576907852417377",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kensington Police Department",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1949d7135988803fdb9a3799074cc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.6143,
                    50.5493916
                ]
            },
            "properties": {
                "categories": {
                    "primary": "brewery",
                    "alternate": [
                        "bar",
                        "pub"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/683589095181318"
                ],
                "phones": [
                    "+33321524060"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "16 Rue de Saint-Venant",
                        "locality": "Vendin-lès-Béthune",
                        "postcode": "62232",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "683589095181318",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oneshot Brewpub",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ec08c76d8203b3e7ed1f60edc7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.05853,
                    14.57974
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://bit.ly/nwnajnation"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2022074961213151"
                ],
                "phones": [
                    "+639971773158"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "NWorld Center, Belvedere tower, San miguel Avenue, Ortigas Center",
                        "locality": "Pasig",
                        "postcode": "1605",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2022074961213151",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wellness store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c10653686d4c0313b3dba99015ba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.5778,
                    -6.24351
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1483148922008546"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Tangerang",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1483148922008546",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ABBA_mart",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a105051e7a203635f15e76c6519",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -44.5766686,
                    -22.645706
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "burger_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/229076654567035"
                ],
                "phones": [
                    "+551231172203"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Coronel João Ferreira, 10",
                        "locality": "São José do Barreiro",
                        "postcode": "12830-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "229076654567035",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hamburgueria & Pizzaria Coroné",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4b0c39a6a203d953fa916e6099",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.425637,
                    13.6833383
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107297600603443"
                ],
                "phones": [
                    "+66986595192"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "249 ถนน บางบอน 1",
                        "locality": "กรุงเทพมหานคร",
                        "postcode": "10150",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107297600603443",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SomethingSavor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f392238530511b030cb86068050001",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.3257298,
                    41.2034249
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eyewear_and_optician",
                    "alternate": [
                        "hospital"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.eyevision.pt/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104107495389735"
                ],
                "phones": [
                    "+351223170855"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Doutor Francisco Sá Carneiro 135",
                        "locality": "Paredes",
                        "postcode": "4580-104",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104107495389735",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "EyeVision Ótica em Paredes - Óptica e centro auditivo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c107250f366d038d5e9801d30294",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.8370818,
                    -6.4518403
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://shopee.co.id/gibran_herbal?smtt=0.0.9"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/136319727072974"
                ],
                "phones": [
                    "+6287874765156"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Desa Puspanegara Rt.02 Rw.02 No.61A",
                        "locality": "Bogor",
                        "postcode": "16914",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "136319727072974",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gibran Herbal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a56b5420b4503399ea933b03100",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.0603027,
                    33.805491
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_parts_and_accessories",
                    "alternate": [
                        "automotive",
                        "automotive_repair"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://addshiftperformance.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106284058953393"
                ],
                "phones": [
                    "+17147372195"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10881 Portal Dr",
                        "locality": "Los Alamitos",
                        "postcode": "90720-2569",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106284058953393",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Addshift Performance Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da115528d6a60339c7c0873107b1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.2056614,
                    28.5913556
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/278983839420034"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "278983839420034",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Banyan Court",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8dca12e50c803ebf062d8714977",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.81701,
                    26.87937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_company",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/581945715796373"
                ],
                "phones": [
                    "+919956612164"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": " Hardoi road Rahimabad",
                        "locality": "Lucknow",
                        "postcode": "226103",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "581945715796373",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sai Motors Sale, Service & Spares",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8d1940c4452032d328679d12473",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    81.09733,
                    26.89956
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104385515889692"
                ],
                "phones": [
                    "+919919596325"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "बाराबंकी ",
                        "locality": "Lucknow",
                        "postcode": "225208",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104385515889692",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "शौर्य प्रताप सिंह यादव",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f445b2ad85b7ae03b383ed9fa2eb13",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.687001,
                    34.7816868
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172228955977357"
                ],
                "phones": [
                    "+19014911423"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "185 Beale Rd",
                        "locality": "Byhalia",
                        "postcode": "38611-9617",
                        "region": "MS",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172228955977357",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alexander's Auto Repair LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66b69aba94734034afe0a831c6eaa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.5033901,
                    9.5266638
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2047591198623073"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Esterillos",
                        "postcode": null,
                        "region": null,
                        "country": "CR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2047591198623073",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Marea Brava Esterillos Oeste",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ec2d71552a03eb4cd35f4e5fcf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.05151,
                    14.6476604
                ]
            },
            "properties": {
                "categories": {
                    "primary": "graphic_designer",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108921141330866"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Caloocan",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108921141330866",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "El Graphics",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab409438e3a103867feec1095d66",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.150651,
                    43.2478388
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "naturopathic_holistic",
                        "doctor"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://naturalbalancehealthclinic.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1239904789355450"
                ],
                "phones": [
                    "+12263014890"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "481 Water St S",
                        "locality": "St Marys",
                        "postcode": "N4X",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1239904789355450",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374888473287",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885917910",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Natural Balance Health Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca1800a65a8c0333255363e9f16b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    83.52031,
                    24.28764
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.facebook.com/profile.php?id=61550065676057&mibextid=9r9pxo"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122095339178007562"
                ],
                "phones": [
                    "+918348772269"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jangipur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122095339178007562",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NOYAN SK",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e610eac6d2c0035fd832895eee6f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.4958404,
                    34.759521
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "sushi_restaurant",
                        "barbecue_restaurant"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.colowide.co.jp/gs/brand/detail.php?brand_no=48"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1033576323410361"
                ],
                "phones": [
                    "+81663783252"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "豊津町10-2",
                        "locality": null,
                        "postcode": "564-0051",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1033576323410361",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "なにわ味贔屓屋江坂駅前店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4141c5b6858cb036dbb375d22d2da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7442577,
                    19.3548263
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campus_building",
                    "alternate": [
                        "school"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2085422528154521"
                ],
                "phones": [
                    "+84977556024"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "THPT Tĩnh Gia 3",
                        "locality": "Phu Cu",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2085422528154521",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trường THPT Tĩnh Gia 3",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1b58ac8c55503c78f6bf4a33125",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.3402177,
                    50.9148975
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://www.gruene-aktion-sachsen.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1007874825914002"
                ],
                "phones": [
                    "+493731166497"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bebelplatz 3",
                        "locality": "Freiberg",
                        "postcode": "09599",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1007874825914002",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Grüne Aktion Sachsen e.V.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f685d52c36a6c20350c5ff23e4dfd1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    125.8101766,
                    7.4472708
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104591197860895"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "National Hwy 54",
                        "locality": "Tagum",
                        "postcode": "8100",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104591197860895",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rapidtrac Builders Corporation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2da450b642c00037472ac0a75bc85",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    33.3522015,
                    35.1665544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "media_news_website",
                    "alternate": [
                        "textile_museum",
                        "media_news_company"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://iellada.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1035341183154405"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Οδός Μιχαήλ Καραολή 8",
                        "locality": "Λευκωσία",
                        "postcode": "1095",
                        "region": null,
                        "country": "CY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1035341183154405",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "newsbomb.com.cy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e966e886b8e10340236e0cfd8cef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.0427523,
                    39.3170446
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wholesale_store",
                    "alternate": [
                        "fruits_and_vegetables",
                        "grocery_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.joseortofrutta.it"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1693768154238626"
                ],
                "phones": [
                    "+3907022439"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Località Magangiosa, 13",
                        "locality": null,
                        "postcode": "09028",
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1693768154238626",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Josè Ortofrutta",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1e48292da6b03e690ba5303500d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.7802198,
                    51.4957356
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.starcar.de/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "03631470740"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Freiherr-vom-Stein-Str. 38",
                        "locality": "Nordhausen",
                        "postcode": "99734",
                        "region": "Thuringia",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949964911862",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "STARCAR Autovermietung Nordhausen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0b1ba2cd8003cebff16f96de47",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.297894,
                    25.044066
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": [
                        "atms",
                        "banks"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.scsb.com.tw"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/210085199014310"
                ],
                "phones": [
                    "+88632121111"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "民生北路一段538號",
                        "locality": "桃園市",
                        "postcode": "333",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "210085199014310",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "上海商業儲蓄銀行",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec9c5d31bc4803dcc3976254f2ac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.7236,
                    41.0556
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "professional_services",
                        "car_rental_agency"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/218085672947031"
                ],
                "phones": [
                    "+905436781663"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bu Halkali",
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "218085672947031",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Istanbul OTO pazarı",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196958039390e03c77e785108eee8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.63948,
                    52.26941
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "barber",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.salonkylene.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/221220161237875"
                ],
                "phones": [
                    "+31613592135"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Zadelmaker 113",
                        "locality": "Nieuw-Vennep",
                        "postcode": "2152 LP",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "221220161237875",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salon Kylène",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1faea242e2c1503b3a4672e840cac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.6548463,
                    50.2600078
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wholesale_store",
                    "alternate": [
                        "boutique",
                        "shopping"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "http://www.imc-frankfurt.de"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1659235294382770"
                ],
                "phones": [
                    "+496172596720"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Max-Planck-Straße 22B",
                        "locality": "Friedrichsdorf",
                        "postcode": "61381",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1659235294382770",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908346287",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "imc Test & Measurement GmbH Sales & Marketing Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4b86c2d85db430300ee9700545073",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.7150375,
                    22.0882444
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "cottage"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/171625349565873"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Checheng",
                        "postcode": null,
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "171625349565873",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "車城的家",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6088680cec56c03248161be6ca99e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.4002301,
                    18.7467777
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1112027772218376"
                ],
                "phones": [
                    "+918600091608"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lonavala",
                        "locality": "Lonavala",
                        "postcode": "410401",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1112027772218376",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lonavala Ayurvedik Massage & Spa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a134d155e1ae03e01bb9dda95b2b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.1562722,
                    39.9144385
                ]
            },
            "properties": {
                "categories": {
                    "primary": "donuts",
                    "alternate": [
                        "coffee_shop",
                        "breakfast_and_brunch_restaurant"
                    ]
                },
                "confidence": 0.9895250069851914,
                "websites": [
                    "https://locations.dunkindonuts.com/en/pa/philadelphia/330-w.-oregon-ave/304173?utm_source=facebook&utm_medium=local&utm_campaign=localmaps&utm_content=304173&y_source=1_mtixmdcyodktntu5lwxvy2f0aw9ulndlynnpdgu%3d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/235266233175168"
                ],
                "phones": [
                    "+12155517910"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Dunkin' Donuts",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Support Whitman's Fur Babies, 330 W Oregon Ave",
                        "locality": "Philadelphia",
                        "postcode": "19148-4709",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "235266233175168",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958980346",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955192342",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949954983358",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dunkin'",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184439e9216f4039444519f90c1ce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.057186,
                    47.6493529
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "tree_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2234874329921336"
                ],
                "phones": [
                    "+33662606460"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "45 Route Er Mané",
                        "locality": "Ploemel",
                        "postcode": "56400",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2234874329921336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Auprès De Ton Arbre",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1062150ea88032a1ed32af756d5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.1253247,
                    40.6130215
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_law",
                    "alternate": [
                        "professional_services",
                        "lawyer"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://alclosings.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/324380125044286"
                ],
                "phones": [
                    "+18882022285"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "The Law Office of Andrews & Leung",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "1855 Victory Blvd",
                        "locality": "New York",
                        "postcode": "10314-3571",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "324380125044286",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Andrews & Leung",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8aa2416f6b0203e0386fd4611e2f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -44.90417,
                    -20.15338
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/632857340407592"
                ],
                "phones": [
                    "+5537999122757"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Marquês de Olinda, 610",
                        "locality": "Divinópolis",
                        "postcode": "35501-222",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "632857340407592",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tainara Andrade Salão De Beleza",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1862662312816032df81ef0628f43",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.754862,
                    48.5336393
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landscaping",
                    "alternate": [
                        "interior_design"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.sikkens-solutions.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/562831543885628"
                ],
                "phones": [
                    "+33296586868"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Rue du Pont à l'Anglais",
                        "locality": "Plérin",
                        "postcode": "22190",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "562831543885628",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sikkens Solutions Plérin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad0372569b1c0300c1154ef6e5b1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.8396093,
                    34.2799557
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9198963179"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6913 Alamosa Dr",
                        "locality": "Wilmington",
                        "postcode": "28411",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474979006708",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "True Shine Cleaning Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa7a86ab0ee03f39b2a45bd6ef8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.6112611,
                    55.7588436
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103297601686924"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Тверская улица 7",
                        "locality": "Москва",
                        "postcode": "125375",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103297601686924",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Different 7593",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fae61bd143b5032e9fe15b259f3d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.4475746,
                    49.480402
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.profamilia.de/angebote-vor-ort/rheinland-pfalz/ludwigshafen"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "062192102030"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Theaterplatz 6",
                        "locality": "Ludwigshafen am Rhein",
                        "postcode": "67059",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899912431438",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "pro familia Ludwigshafen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2af627477189d037ae7081362cfae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.1644286,
                    36.7952967
                ]
            },
            "properties": {
                "categories": {
                    "primary": "poke",
                    "alternate": [
                        "japanese_restaurant",
                        "bubble_tea"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.oukasora.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112646261493068"
                ],
                "phones": [
                    "+17579103530"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5004 Ferrell Pkwy",
                        "locality": "Virginia Beach",
                        "postcode": "23464-8875",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112646261493068",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ouka Sora Poke•Ramen•Teriyaki•Tea",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a3d76b76b71039cf3cbdcd99925",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.24469,
                    -22.67667
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "barber",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/622683961187947"
                ],
                "phones": [
                    "+5521993596726"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Carlos Maia",
                        "locality": "Duque de Caxias",
                        "postcode": null,
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "622683961187947",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Barbearia dos pretinhos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f483646a49e093031e3e8855820b69",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.8286,
                    21.48585
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": [
                        "business_advertising",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/933166246818234"
                ],
                "phones": [
                    "+523111290769"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle de Mendara 131",
                        "locality": "Tepic",
                        "postcode": "63173",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "933166246818234",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Opción En Impresiones",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a1d50b4826103c1f1bc714712f6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.21213,
                    34.11237
                ]
            },
            "properties": {
                "categories": {
                    "primary": "media_agency",
                    "alternate": [
                        "advertising_agency"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.brandmagicla.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1701992110036165"
                ],
                "phones": [
                    "+13233544415"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4419 San Rafael Ave",
                        "locality": "Los Angeles",
                        "postcode": "90042",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1701992110036165",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brandmagic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2672205328b21038fdacc11f1ce00",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -92.5772258,
                    40.2073035
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "social_service_organizations",
                        "prenatal_perinatal_care"
                    ]
                },
                "confidence": 0.9895250069851914,
                "websites": [
                    "https://lifelinemo.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113064621284354"
                ],
                "phones": [
                    "+16606655688"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1515 N New St",
                        "locality": "Kirksville",
                        "postcode": "63501-2472",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113064621284354",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960946600",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949959794165",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lifeline Pregnancy Help Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48c6c092d6092031b264b9e0defe8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -106.2704322,
                    31.7613836
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pediatrician",
                    "alternate": [
                        "doctor",
                        "occupational_therapy"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://yageltherapy.com/yagel-2-0/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9157036380"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "12135 Montwood Dr Ste s 114",
                        "locality": "El Paso",
                        "postcode": "79936",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374890039374",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yagel Therapy 2.0",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650572a21e46c03e771f4f8825559",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.5127757,
                    3.1611868
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.richiamocoffee.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104265632442674"
                ],
                "phones": [
                    "+60377340520"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "28 Jalan Elektron F U16/F",
                        "locality": "Shah Alam",
                        "postcode": "40160",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104265632442674",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Richiamo Denai Alam",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f186b6c8d49923032a4f98f059f07c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.5558828,
                    44.8417811
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.latelierdenoelie.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1513494335619401"
                ],
                "phones": [
                    "+33669791288"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "32 Rue Paul Camelle",
                        "locality": "Bordeaux",
                        "postcode": "33100",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1513494335619401",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "L'Atelier de Noélie",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2692ba2760cee0344a9509a32be93",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.85549,
                    39.816066
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8013601571"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "HC 60",
                        "locality": "Mona",
                        "postcode": "84645",
                        "region": "UT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976826539",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Spar-Klean Housekeeping LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41642ee23413203121d2f522badad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.160685,
                    16.0784987
                ]
            },
            "properties": {
                "categories": {
                    "primary": "energy_equipment_and_solution",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://dhclight.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112596410479144"
                ],
                "phones": [
                    "+84905040242"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Da Nang",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112596410479144",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DHC Light - Đèn năng lượng Mặt Trời",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d8449e7002e2034474a72866ea98",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    113.51927,
                    -7.0636198
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wholesale_store",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://shopee.co.id/product/27465601/7980347125?smtt=0.27466961-1615539058.9"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102408425257490"
                ],
                "phones": [
                    "+6281938066612"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jalan Raya Pakong-Blumbungan Gapura Bulangan Haji Ponjuk kol cengkol, Pegantenan, Pamekasan, Indonesia",
                        "locality": null,
                        "postcode": "69361",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102408425257490",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LAPAK Sarung Santri",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e2040884154a03b806f7167dbe21",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.0327568,
                    51.10848
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2229145530637882"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rynek",
                        "locality": "Wroclaw",
                        "postcode": "50-102",
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2229145530637882",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mama Wrocław",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2baa90d0ed6a503f0dc787fc50186",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.5155944,
                    45.8879007
                ]
            },
            "properties": {
                "categories": {
                    "primary": "industrial_company",
                    "alternate": [
                        "retail",
                        "hardware_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.fournituresmega.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/233924953303965"
                ],
                "phones": [
                    "+18194773773"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "725 Rue Cormier",
                        "locality": "Drummondville",
                        "postcode": "J2C 6P7",
                        "region": "QC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "233924953303965",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Les Fournitures Industrielles Méga Ltee",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f489c0f56cd310035a440de4f56f6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.4975293,
                    29.6563435
                ]
            },
            "properties": {
                "categories": {
                    "primary": "school",
                    "alternate": [
                        "middle_school",
                        "elementary_school"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.lopezpta.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/347380512059982"
                ],
                "phones": [
                    "+12103565000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "23103 Hardy Oak Blvd",
                        "locality": "San Antonio",
                        "postcode": "78258-1953",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "347380512059982",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lopez Middle School",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f746e955489a03706895705865cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    24.4474046,
                    36.7277346
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "hotel",
                        "accommodation"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.tilemachos-studios.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/366549223391041"
                ],
                "phones": [
                    "+302287022160"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "848 01",
                        "region": null,
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "366549223391041",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tilemachos Rooms and Studios Milos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f269633381391b0382c37e3672d21d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.873177,
                    40.588115
                ]
            },
            "properties": {
                "categories": {
                    "primary": "courier_and_delivery_services",
                    "alternate": [
                        "shipping_center",
                        "post_office"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://locations.ups.com/us/en/ut/sandy/access-point-location-170281.html?utm_source=bing&utm_medium=organic&utm_campaign=rio"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8007425877"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "667 E 9000 S",
                        "locality": "Sandy",
                        "postcode": "84070",
                        "region": "UT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949960318627",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912721381",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "UPS Access Point location",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e610552d384003dfc8baa369ad3e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.501951,
                    34.6741928
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "japanese_restaurant",
                        "sake_bar"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://r.gnavi.co.jp/c242104/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101035691614290"
                ],
                "phones": [
                    "+81662511060"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "大阪府大阪市中央区心斎橋筋１丁目３−２９",
                        "locality": "大阪市中央区",
                        "postcode": "542-0085",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101035691614290",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "心斎橋酒場叶えや",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f395a79921d95903e22a2e8c26ede9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.4740353,
                    36.7566246
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.beddarpharm.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103579294843583"
                ],
                "phones": [
                    "+213553583164"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Boumerdas",
                        "postcode": null,
                        "region": null,
                        "country": "DZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103579294843583",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beddar pharm rouiba",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9241eb6e31803a3c9b497205581",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.95233,
                    40.01227
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/259652389271657"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Follow Dr, Noblesville, IN 46060, United States",
                        "locality": "Noblesville",
                        "postcode": "46060",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "259652389271657",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "L i f e",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4982011acb29003e6e1f183083672",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.76419,
                    20.30126
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108187354913572"
                ],
                "phones": [
                    "+527731326771"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "llano largo ",
                        "locality": "Huichapan Centro",
                        "postcode": "42420",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108187354913572",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Healthy Body",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48ca156b8519b0338e0b211481528",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -108.76323,
                    35.5289
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110448381963502"
                ],
                "phones": [
                    "+12025550157"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1440 W Maloney Ave",
                        "locality": "Gallup",
                        "postcode": "87301-3304",
                        "region": "NM",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110448381963502",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BestView",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f18b24ad49aa0396ce7fa5a5a251",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.3869698,
                    52.4920975
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "beauty_and_spa",
                        "doctor"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.dentalist.de"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2361210900790576"
                ],
                "phones": [
                    "+493078719800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mehringdamm 48",
                        "locality": "Berlin",
                        "postcode": "10961",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2361210900790576",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dentalist Zahn und Implantologiezentrum",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a16351b5c4ae03c6c0026809507b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2714217,
                    41.3626217
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tattoo_and_piercing",
                    "alternate": [
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/120683822394"
                ],
                "phones": [
                    "+18454696869"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18 Railroad Ave",
                        "locality": "Chester",
                        "postcode": "10918-1246",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "120683822394",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rotten NY Tattoo Parlor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8af68ee423cda03d0d3b8c5d38f4b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.0121863,
                    -3.1081768
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9245689655172413,
                "websites": [
                    "https://linktr.ee/oidraaleagendamento"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/546299939199346"
                ],
                "phones": [
                    "+5592991771608"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Salvador, 440",
                        "locality": "Manaus",
                        "postcode": "69057-040",
                        "region": "AM",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "546299939199346",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Clinic Gine Femme",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e15a13c80b9a0375a9d2383ab435",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.2364723,
                    48.0061242
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": [
                        "interior_design"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.g4-concept.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104395979696224"
                ],
                "phones": [
                    "+432252209480"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wassergasse 29",
                        "locality": "Baden",
                        "postcode": "2500",
                        "region": "3",
                        "country": "AT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104395979696224",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "G4 Concept Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f83304e56a839b039529b5f6bffe6c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.55769,
                    -12.84905
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106512725536313"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Caála ",
                        "locality": "Huambo",
                        "postcode": null,
                        "region": null,
                        "country": "AO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106512725536313",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Caála Viber",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c0b8ab2b4036e139f265a9925",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0369034,
                    -12.0987425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "colombian_restaurant",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://lacolochitaempanadas.webs.com/index.htm"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172810812735965"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172810812735965",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Empanadas Colombianas en Perú-La Colochita-San Isidro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f110606062587303859c0ec6c7f4a1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.36117,
                    59.93415
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "flowers_and_gifts_shop"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://flowersboom.ru/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112048933812416"
                ],
                "phones": [
                    "+79116641694"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "переулок Ульяны Громовой 3",
                        "locality": "Санкт-Петербург",
                        "postcode": "191036",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112048933812416",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flowersboom.spb",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f49816d995a1b303e0338e267f11da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.7147,
                    21.11608
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": [
                        "grocery_store"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1262121977174057"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "León",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1262121977174057",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tecfors",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f802b562dc8d03f2aef1eb697e22",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.337675,
                    47.8080921
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eyewear_and_optician",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://www.optic2000.com/magasins/l/wittenheim/20-rue-de-kingersheim/c00530?utm_campaign=fiche+gmb&utm_source=facebook&utm_medium=organic+social"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/188191084986256"
                ],
                "phones": [
                    "+33389625232"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Optic 2000",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "20 Rue de Kingersheim",
                        "locality": "Wittenheim",
                        "postcode": "68270",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "188191084986256",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Optic 2000 - Opticien Wittenheim",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f0b32c1638b603b32dfd34c447c4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.9647728,
                    53.1477475
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": [
                        "nursery_and_gardening",
                        "shopping"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1535245093367580"
                ],
                "phones": [
                    "+48730031717"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ulica Siedlecka 115",
                        "locality": "Bydgoszcz",
                        "postcode": "85-412",
                        "region": "04",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1535245093367580",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kwiaciarnia Dilana",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f182c1431060c603123f4335de4f2b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.2471205,
                    53.2535113
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/166099206903498"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bóthar Chnocán Na Holóige",
                        "locality": "Dublin",
                        "postcode": null,
                        "region": null,
                        "country": "IE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "166099206903498",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Belleek Co.fermanagh",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f5969550b109030709e914d379ef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.00718,
                    31.24405
                ]
            },
            "properties": {
                "categories": {
                    "primary": "industrial_company",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.agromisr.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100420968531761"
                ],
                "phones": [
                    "+2033340517"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Alexandria",
                        "postcode": null,
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100420968531761",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AGRO MISR",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39699118f65b503949ab647e500da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.4981391,
                    43.8587132
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campground",
                    "alternate": [
                        "travel",
                        "business"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.camping-terra-verdon.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152386118105517"
                ],
                "phones": [
                    "+33492836667"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "384 Ham. de la Palud route du",
                        "locality": null,
                        "postcode": "04120",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152386118105517",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Camping Terra Verdon - Ciela Village - Verdon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f0999386b09d6a03a41d89fef80364",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.73016,
                    59.91961
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_company",
                    "alternate": [
                        "tours",
                        "travel_services"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.espnes.no/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/461529470524068"
                ],
                "phones": [
                    "+4722347070"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Oscars gate 27",
                        "locality": "Oslo",
                        "postcode": "0352",
                        "region": "03",
                        "country": "NO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "461529470524068",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Espnes Reiser",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0b6671ab9d03161323995b3e2f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.9194226,
                    33.7238291
                ]
            },
            "properties": {
                "categories": {
                    "primary": "alcohol_and_drug_treatment_centers",
                    "alternate": [
                        "abuse_and_addiction_treatment"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.beachsiderecoverycenter.com/contact-us/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/159249851120774"
                ],
                "phones": [
                    "+18883875576"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "16490 Harbor Blvd",
                        "locality": "Fountain Valley",
                        "postcode": "92708-1369",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "159249851120774",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beachside Recovery",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf602968e08003c4f7bd99fa198f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    87.87891,
                    23.24989
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "caterer"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1422768868020892"
                ],
                "phones": [
                    "+919614109233"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bhadarpally,kanlageat/Tecnical cooleg more sadhanpur",
                        "locality": "Burdwan",
                        "postcode": "713101",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1422768868020892",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shree Balaji caterer & fast food cornar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66e42d696880d03413bb49dd2201e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.050545,
                    4.6809225
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102444552482318"
                ],
                "phones": [
                    "+573024080104"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bogotá",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102444552482318",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Estética mea",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f602687396056e03c7c0cd2df690c0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.3942721,
                    8.1253529
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106782058221220"
                ],
                "phones": [
                    "+916238722804"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mevada",
                        "locality": "Palai",
                        "postcode": "686573",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106782058221220",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SRK Dental Care",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f396199ba4e200038b987d743463a2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.707698,
                    44.08943
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": [
                        "freight_and_cargo_service",
                        "transportation"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1301269066594885"
                ],
                "phones": [
                    "+33565465768"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "23 Rue du Belvédère",
                        "locality": "Villefranche-de-Panat",
                        "postcode": "12430",
                        "region": "OCC",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1301269066594885",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sarl L.S Cazottes Transport & Negoce",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4a1296314c0301da960f898995",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.40737,
                    13.87646
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://www.instagram.com/pigstoryruengkhongmoo/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112224444022833"
                ],
                "phones": [
                    "+66997745713"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ถนนกาญจนาภิเษก",
                        "locality": "Nonthaburi",
                        "postcode": "11140",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112224444022833",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "เรื่องของหมู-Pig story",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aaaa6b51506b03a80d444e8f00d1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.2749491,
                    38.6352033
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "professional_services",
                        "counseling_and_mental_health"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://bubernakdental.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1075800552483650"
                ],
                "phones": [
                    "+17034942545"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1972 Opitz Blvd",
                        "locality": "Woodbridge",
                        "postcode": "22191-3304",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1075800552483650",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949964716845",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949964716832",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958412734",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958406113",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fred A Bubernak DDS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1942ce0ad521b03307d298ca1575a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.6808699,
                    53.8648266
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "party_supply",
                        "shopping"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://woollybabs.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/158455307550097"
                ],
                "phones": [
                    "+447929930501"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1a Football",
                        "locality": "Leeds",
                        "postcode": "LS19 7QF",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "158455307550097",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Woolly Babs Christmas Jumpers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2640c8eb11bb50304abdfb33d34fd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.1482086,
                    38.6051502
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/296893856850546"
                ],
                "phones": [
                    "+16182151060"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2001 Market St",
                        "locality": "East St Louis",
                        "postcode": "62207-1829",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "296893856850546",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "One Way Church of Christ of the Apostolic Faith Inc. ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e6ece047615403b3c00c43d29d39",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.44601,
                    50.07836
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116884194779645"
                ],
                "phones": [
                    "+380507688482"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Соборна вулиця, 12",
                        "locality": "Переяслав-Хмельницький район",
                        "postcode": "08400",
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116884194779645",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Манікюр Нарощення Хмельницький ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f089bc5e24ecd803462c28e0dd3cfc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    24.66927,
                    59.40202
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_venue",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/197427330113445"
                ],
                "phones": [
                    "+37253760345"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ehitajate tee 43",
                        "locality": "Tallinn",
                        "postcode": "12612",
                        "region": null,
                        "country": "EE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "197427330113445",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Barerai Coprimmo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cb02426ae4f1032eb89da23eaebf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    81.54568,
                    21.03581
                ]
            },
            "properties": {
                "categories": {
                    "primary": "middle_school",
                    "alternate": [
                        "educational_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105191809314291"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Barbaspur",
                        "locality": "Patan",
                        "postcode": "491111",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105191809314291",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GTK Education",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f394460e53515b03682beda884c1ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.17001,
                    41.38804
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105774701648362"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Barcelona, Catalunya, Espanya",
                        "locality": "Barcelona",
                        "postcode": "08007",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105774701648362",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "QURAN SUNO",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60a98752cebae03bc2030dfd7f40a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.04753,
                    15.00693
                ]
            },
            "properties": {
                "categories": {
                    "primary": "electronics",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/180615372664488"
                ],
                "phones": [
                    "+918208756504"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Nagarsekar Building Chawdi Canacona goa",
                        "locality": "Canacona",
                        "postcode": "403702",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "180615372664488",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Raj Enterprises",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a90e275a8a6039832e52fdb4714",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.3082624,
                    28.5763877
                ]
            },
            "properties": {
                "categories": {
                    "primary": "retail",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.walmart.com/store/5988-orlando-fl/patio-garden-services"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4075515160"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2271 N Semoran Blvd",
                        "locality": "Orlando",
                        "postcode": "32807",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374890613976",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885490978",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885420555",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885207463",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911673991",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911666336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Walmart",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d28ad17a2cd30341848ede8116be",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    34.3437726,
                    44.5824981
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "https://vk.com/picanto_pizzeria"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/509173456141611"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Фрунзенське шосе, 12",
                        "locality": "Алушта",
                        "postcode": "298542",
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "509173456141611",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Picanto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa82ad512cbcae0374ab8a32148422",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -51.67367,
                    -24.25292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "specialty_school",
                        "school"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/398132726954578"
                ],
                "phones": [
                    "+554334722266"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Souza Naves, 777",
                        "locality": "Ivaiporã",
                        "postcode": "86870-000",
                        "region": "PR",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "398132726954578",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Instituto Cultural Americano",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a16ad2d958b5032cb26e7ac2dde4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2372,
                    41.5271987
                ]
            },
            "properties": {
                "categories": {
                    "primary": "massage_therapy",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://instabio.cc/4062603vqyeme"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1374487395958504"
                ],
                "phones": [
                    "+18452490920"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "165 Ward St",
                        "locality": "Montgomery",
                        "postcode": "12549-1112",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1374487395958504",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alyssa Bella Massage",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5bb233a9400030b436f912ef390",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.8638644,
                    35.0797529
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/373527749383741"
                ],
                "phones": [
                    "+81559314803"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "我入道一本松町189-2",
                        "locality": null,
                        "postcode": "410-0823",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "373527749383741",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ファッションプラザせりざわ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2759ab364047003b3317ce7d25ae6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.0470445,
                    42.2847141
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "nurse_practitioner",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://care.advocatehealth.com/doctors/kristine-r-lira-mundelein-nurse-practitioner"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8475497777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3220 W Il Rte 60",
                        "locality": "Mundelein",
                        "postcode": "60060",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374890610678",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kristine R. Lira, NP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d6442484528c032b26377ed32227",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.1745191,
                    14.0814328
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100903025171193"
                ],
                "phones": [
                    "+50433119205"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Colonia florencia sur, Calle principal, Edificio La Placita, Primer nivel Local No. 2",
                        "locality": "Tegucigalpa",
                        "postcode": "504",
                        "region": null,
                        "country": "HN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100903025171193",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Super Technologies Honduras.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1072195eb9503531a54d03e3673",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.006296,
                    40.7462709
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_gallery",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://www.seanhortonpresents.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103899824750555"
                ],
                "phones": [
                    "+12122432663"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "504 W 22nd St",
                        "locality": "New York",
                        "postcode": "10011-1106",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103899824750555",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sean Horton - NYC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec9c5130e574037ca21bbbc8b965",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.662279,
                    41.061427
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_dealer",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101458679115612"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1695 Sok No:11 Evren Oto Sanayi 1",
                        "locality": null,
                        "postcode": "34500",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101458679115612",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HLK Otomotiv",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa91b4510808450346ea42a8ab859c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.5107799,
                    -27.5346692
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_and_medical",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.orthoeco.com.br/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4832397799"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rod. José Carlos Daux 5500, sl. 210",
                        "locality": "Florianópolis",
                        "postcode": "88032-005",
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799821389328",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dr. Pedro Luz Alves: Especialista em Coluna, Cirurgião em Florianópolis",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a329484d4003c870bfabffdecf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.7532359,
                    35.7155155
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "natural_hot_springs",
                        "spas"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/323550351058674"
                ],
                "phones": [
                    "+81338117014"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "東京都文京区白山１丁目３−５",
                        "locality": "文京区",
                        "postcode": "113-0001",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "323550351058674",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "富士見湯",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41436b320887303bfd710a57b6514",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7561111,
                    20.9890089
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "jewelry_store"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://katastore.vn/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1409264936020618"
                ],
                "phones": [
                    "+84949548988"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "An Khánh - Hoài Đức - Hà Nội",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1409264936020618",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kata Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a91815780a1403c8f10702d3ab0f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.7441506,
                    39.6499281
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": [
                        "shopping",
                        "bridal_shop"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.petalsandpossibilities.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/169738096554075"
                ],
                "phones": [
                    "+17409692911"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "107 N Johns St",
                        "locality": "Amanda",
                        "postcode": "43102-1124",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "169738096554075",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958738418",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949953756031",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Petals & Possibilities",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f68030886c4503152af9b512c860",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.36271,
                    36.79997
                ]
            },
            "properties": {
                "categories": {
                    "primary": "social_media_agency",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172771595913178"
                ],
                "phones": [
                    "+905341453059"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4178/5 sokak numara: 6",
                        "locality": "Manavgat",
                        "postcode": "70000",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172771595913178",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SabanSarikaya  747",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f186ea717a5cf40398faa3878e4e96",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.0951284,
                    47.0101105
                ]
            },
            "properties": {
                "categories": {
                    "primary": "engineering_services",
                    "alternate": [
                        "hvac_services"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.sorins-ingenierie.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111069044552860"
                ],
                "phones": [
                    "+33549224383"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "32 Route de Richelieu",
                        "locality": "Loudun",
                        "postcode": "86200",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111069044552860",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sorins Ingenierie Sas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4b6603510b65c033e495d3fbdf16e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.7429787,
                    32.7790559
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sushi_restaurant",
                    "alternate": [
                        "asian_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.sakamoto-gr.co.jp/sushi-ichiba/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152074788154444"
                ],
                "phones": [
                    "+81962851816"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "熊本県熊本市東区湖東３丁目２−１９",
                        "locality": "熊本市東区",
                        "postcode": "862-0909",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152074788154444",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "九州すし市場江津店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b5751a01221037f1dd71e343887",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.79357,
                    10.73336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167537383117508"
                ],
                "phones": [
                    "+84904216770"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Je05 XxhIm",
                        "locality": "Ho Chi Minh City",
                        "postcode": "24880",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167537383117508",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lý Cẩm Tiên",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d168d085b4d3038004b0a09713f2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.15129,
                    30.37425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "media_news_company",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "https://www.youtube.com/@nriboldapunjab"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101277749167664"
                ],
                "phones": [
                    "+919988444158"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "nabha",
                        "locality": "Nabha",
                        "postcode": "147201",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101277749167664",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nri Bolda Punjab",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a100f12862eb036fca3593430bc1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.8856281,
                    40.7553803
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": [
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.flagstar.com/jackson-heights-flagstar-bank-new-york-2274.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/212933928573188"
                ],
                "phones": [
                    "+17184769700"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Flagstar Bank",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "81-20 Northern Blvd",
                        "locality": "New York",
                        "postcode": "11372",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "212933928573188",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960580725",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flagstar Bank",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f265ea284f1cce03933bf5e92708ce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -91.9632734,
                    36.627582
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.rhineautosalesinc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/946887148789703"
                ],
                "phones": [
                    "+14172552545"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3213 US-160",
                        "locality": "West Plains",
                        "postcode": "65775-6515",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "946887148789703",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rhine Auto Sales Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8c0dca1e5b10336880fe6ccde36",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.3139987,
                    26.4755495
                ]
            },
            "properties": {
                "categories": {
                    "primary": "stock_and_bond_brokers",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://stockbroker.motilaloswal.com/motilal-oswal-financial-services-limited-viraj-gandhi-stock-broker-kanpur-nagar-kanpur-181835/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07411861207"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "No 113/97, Swarup Nagar, Katarijiyora Nawab Ganj, Kanpur Nagar",
                        "locality": "Kanpur",
                        "postcode": "208002",
                        "region": "Uttar Pradesh",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849865209001",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Motilal Oswal Financial Services Limited",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f391864cd5dc9803df1798ca5c0f73",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -4.7743889,
                    36.495572
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "lounge",
                        "pub"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/322592671148410"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Marbella",
                        "postcode": null,
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "322592671148410",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "K-Lounge, Elviria",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb49496da5031ac2953cc0defb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.8059037,
                    21.0250506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "coffee_shop",
                        "cafe"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/419103845140997"
                ],
                "phones": [
                    "+84963211570"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "57 Phố Chùa Láng",
                        "locality": "Quận Đống Đa",
                        "postcode": "11512",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "419103845140997",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hotdog Cafe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a99a5282400360f75e3e5766d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    140.5003133,
                    35.586318
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "accommodation"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1938598123050103"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "289-1803",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1938598123050103",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hasunuma Seaside Inn Ogawaso",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa8c59612aaa0390637b765b6040",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.61981,
                    39.14904
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "home_cleaning",
                        "gym"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102065027184555"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Glen Burnie",
                        "postcode": null,
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102065027184555",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Personal organizer & house cleaning",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44cb174b5446c034b88eae1b31109",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.5395275,
                    36.3912897
                ]
            },
            "properties": {
                "categories": {
                    "primary": "baptist_church",
                    "alternate": [
                        "church_cathedral",
                        "religious_organization"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.lookandlive.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/366598896749343"
                ],
                "phones": [
                    "+14236271611"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1611 Glass House Rd",
                        "locality": "Helenwood",
                        "postcode": "37755-5461",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "366598896749343",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trinity Baptist Church",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e638442b54d103ae4126677b2b46",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.43847,
                    50.51078
                ]
            },
            "properties": {
                "categories": {
                    "primary": "charity_organization",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://angelukraine.com.ua/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100298229300170"
                ],
                "phones": [
                    "+380953230578"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kyiv",
                        "postcode": null,
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100298229300170",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ангел Майбутнього",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8130dbbb2a5c0337627426c5b03a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.57968,
                    -22.42939
                ]
            },
            "properties": {
                "categories": {
                    "primary": "web_designer",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/530597674022377"
                ],
                "phones": [
                    "+5535999653765"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Monte Sião",
                        "postcode": null,
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "530597674022377",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "UTI Internet Monte Sião",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa819080d58d0b0342a18ed5a51ef3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.5194634,
                    -20.8180977
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": [
                        "education"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/888671727871592"
                ],
                "phones": [
                    "+5517991689214"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua São Bento, 1",
                        "locality": "Mirassol",
                        "postcode": "15130-037",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "888671727871592",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Instituto de Estudos Espíritas Francisco de Assis",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e2c3523657ab032993a59cd32c87",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.5688,
                    51.36126
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://novastudio.waw.pl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/276601362442074"
                ],
                "phones": [
                    "+48602292864"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ulica Henryka Sienkiewicza 31",
                        "locality": "Zwoleń",
                        "postcode": "26-700",
                        "region": "14",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "276601362442074",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NOVA Studio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64b1b727744c00318eb9f6c207ac6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.2016506,
                    16.7624536
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "restaurant",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://grab.onelink.me/2695613898?pid=inappsharing&c=3-czahct42efcafe&is_retargeting=true&af_dp=grab%3a%2f%2fopen%3fscreentype%3dgrabfood%26sourceid%3da4pcqczks4%26merchantids%3d3-czahct42efcafe&af_force_deeplink=true&af_web_dp=https%3a%2f%2fwww.grab.com%2fdownload"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/468667427271423"
                ],
                "phones": [
                    "+66875746482"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "38/7 ม.7 ต.ท่าโพธิ์",
                        "locality": "Pitsanulok",
                        "postcode": "65000",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "468667427271423",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ครัว บ้าน บ้าน",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2db1234b8ebb403cc16343fd237a0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    36.169147,
                    33.4368124
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eye_care_clinic",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/195052904748484"
                ],
                "phones": [
                    "+963936695088"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "جديدة عرطوز البلد شارع البعث جانب مشفى الكمال n0116865012 هاتف العيادة",
                        "locality": "Damascus",
                        "postcode": "0116865012",
                        "region": null,
                        "country": "SY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "195052904748484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "عيادة الدكتور بلال عاصي لأمراض العيون وجراحتها",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a80aac08d65303cefdebbaafe1c2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.7984128,
                    39.5143774
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fabric_store",
                    "alternate": [
                        "arts_and_crafts",
                        "b2b_textiles"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.eleanorsquiltsandfabrics.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/549490315188188"
                ],
                "phones": [
                    "+13048646330"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "43 Cedar Dr",
                        "locality": "Reedsville",
                        "postcode": "26547-1114",
                        "region": "WV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "549490315188188",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eleanor's Quilts & Fabrics",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3e628034dd7b303c86b489dade8cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.19856,
                    30.10995
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shoe_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103267614592253"
                ],
                "phones": [
                    "+201140816508"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "33 شارع ترعة السواحل",
                        "locality": "الوراق",
                        "postcode": null,
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103267614592253",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "دارين شوز _ Darren shoes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5bb1a7aeb33038a52c718a69887",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.83315,
                    35.197381
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "religious_organization",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/263600317082480"
                ],
                "phones": [
                    "+10559895516"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "263600317082480",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "愛鷹山水神社",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa7a432ad1003c40eb2360dd8ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.48663,
                    55.73731
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beer_bar",
                    "alternate": [
                        "liquor_store",
                        "pub"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1908407442723465"
                ],
                "phones": [
                    "+79152864817"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Кастанаевская улица 30 корп 1",
                        "locality": "Москва",
                        "postcode": "121096",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1908407442723465",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Пивотека Beer & Deer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e31034958c803be6eef1e6c9460",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.426815,
                    -34.6089361
                ]
            },
            "properties": {
                "categories": {
                    "primary": "financial_advising",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/273520549188324"
                ],
                "phones": [
                    "+573224611368"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Diaz Velez ",
                        "locality": "Buenos Aires",
                        "postcode": "<<not-applicable>>",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "273520549188324",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": " Ganaderos del Valle G.C.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195cac3555b9403a51b679aed2fae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.4834131,
                    52.4107776
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shipping_center",
                    "alternate": [
                        "professional_services",
                        "telecommunications_company"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://parcel.dhl.co.uk/?utm_source=fb&utm_medium=organic&utm_campaign=fb"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/120295187728935"
                ],
                "phones": [
                    "+448442480844"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "DHL Express UK",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "209 Walsgrave Road",
                        "locality": "Coventry",
                        "postcode": "CV2 4HH",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "120295187728935",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "101868185706901",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949964572228",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DHL Express Service Point (Ball Hill Communications - iPayOn)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1969960c80674036c28044661a9c5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.1015426,
                    52.5085431
                ]
            },
            "properties": {
                "categories": {
                    "primary": "energy_company",
                    "alternate": [
                        "public_utility_company"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://www.prowind.com/nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/124101144971683"
                ],
                "phones": [
                    "+31117700590"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Assendorperdijk 1",
                        "locality": "Zwolle",
                        "postcode": "8012 EG",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "124101144971683",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Prowind BV",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca49b6a30926037f54d2fdec8661",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    81.2585901,
                    24.526394
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": [
                        "atms"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://near-me.hdfcbank.com/branch-atm-locator/hdfc-bank-golpark-rewa-banks-vainkat-road-rewa-260188/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "09426792001"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Shop No 5 to 10, GF, Hardev Vaibhav Cplx, Vainkat Road",
                        "locality": "Rewa",
                        "postcode": "486001",
                        "region": "Madhya Pradesh",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849865619127",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HDFC Bank",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42d9d6e0eb0e20382458fe7879b64",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    72.78932,
                    21.1706
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://www.wecanspirit.in/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100563398289350"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "amli steet",
                        "locality": "Surat",
                        "postcode": "395007",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100563398289350",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hindu Tv Network",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1cb6d14e419038faafe479f4a5a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.8151715,
                    53.2787912
                ]
            },
            "properties": {
                "categories": {
                    "primary": "inn",
                    "alternate": [
                        "accommodation"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107427875686947"
                ],
                "phones": [
                    "+4939833269980"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rudolf-Breitscheid-Straße 49",
                        "locality": "Mirow",
                        "postcode": "17252",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107427875686947",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hotel und Restaurant zum bunten Hirsch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44f04e6b9d8e60384a69af58888ef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.39795,
                    30.318588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_inspector",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://housescanfl.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/256738471399008"
                ],
                "phones": [
                    "+19047589225"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "700 3rd St",
                        "locality": "Neptune Beach",
                        "postcode": "32266-5072",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "256738471399008",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HouseScan Home Inspections",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f441a84588eaa803942b8fe709e0b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.8019414,
                    27.9518154
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lighting_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116009701896631"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Clearwater",
                        "postcode": null,
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116009701896631",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "6S LED Pixel Systems",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4440cac67651e03dc729d48e6c5f6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -91.1143033,
                    30.4330002
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://browbars.benefitcosmetics.com/us/la/baton-rouge/7445-corporate-blvd?y_source=1_MTk5MjA5NjEtNDgzLWxvY2F0aW9uLndlYnNpdGU%3D"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2258003457"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7445 Corporate Blvd Ste 500",
                        "locality": "Baton Rouge",
                        "postcode": "70809",
                        "region": "LA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949961558303",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Benefit Cosmetics BrowBar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2755aac8034e503f72641e987ae6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.2418444,
                    45.924012
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gardener",
                    "alternate": [
                        "landscaping",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/863689917123766"
                ],
                "phones": [
                    "+17158915963"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "706 E Burnett St",
                        "locality": "Eagle River",
                        "postcode": "54521-8435",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "863689917123766",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brian's Fairway Look",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1126c35342392039a411451744adb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.1487888,
                    60.2061158
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1253549554804371"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bertha Pauligin katu 4",
                        "locality": "Helsinki",
                        "postcode": "00990",
                        "region": "ES",
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1253549554804371",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bertha Pauligin katu 4",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbcc352c29225503c8210e246f01ff",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.04921,
                    -26.1886
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_production",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102181166140847"
                ],
                "phones": [
                    "+27679210000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Clamn",
                        "locality": "Hillbrow",
                        "postcode": null,
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102181166140847",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blaxk Teddy Rsa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12ee0d083394903fd449bcfba2e02",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -114.2015044,
                    52.5902981
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.frostfreenosepumps.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8668436744"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Box 675 420050 Simpson Rd",
                        "locality": "Alberta",
                        "postcode": "T0C 2J0",
                        "region": "AB",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978301684",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899909187437",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Frostfree Nosepumps Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a48cecc55590301d99b2515f79e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.660409,
                    13.9067861
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107785614159078"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bangkok",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107785614159078",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "หางานแม่บ้าน พี่เลี้ยงเด็ก : มือโปร",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f260030a5522c2038d56fabf238482",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.0815858,
                    43.17009
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bridal_shop",
                    "alternate": [
                        "clothing_store",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.jaksbridal.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/361300480952785"
                ],
                "phones": [
                    "+16057665257"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "111 S Main St",
                        "locality": "Viborg",
                        "postcode": "57070-2115",
                        "region": "SD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "361300480952785",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960329816",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374888442281",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374886643973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jaks Bridal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a33155135b060325e11e3f56e478",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.39511,
                    41.8280949
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chiropractor",
                    "alternate": [
                        "naturopathic_holistic",
                        "counseling_and_mental_health"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.drbois.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115664255169406"
                ],
                "phones": [
                    "+14014159585"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "154 Waterman St",
                        "locality": "Providence",
                        "postcode": "02906-3116",
                        "region": "RI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115664255169406",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Royal Health & Wellness Chiropractic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39238de8ecd0103d74f70bddb1eaf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -7.3535004,
                    41.7291445
                ]
            },
            "properties": {
                "categories": {
                    "primary": "social_service_organizations",
                    "alternate": [
                        "community_services_non_profits",
                        "non_governmental_association"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/342553038944842"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Principal 5",
                        "locality": "Chaves",
                        "postcode": "5400-659",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "342553038944842",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Associacao Recreativa e Cultural de Vila Nova de Monforte",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415d9a882a66e03cd8deb95231f38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.3466558,
                    20.8586514
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_service",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103714482323477"
                ],
                "phones": [
                    "+84815288889"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Phường Trung Minh , Thành phố Hòa Bình",
                        "locality": "Hòa Bình",
                        "postcode": "1000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103714482323477",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Luois Hòa Bình - Casa Del Rio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea2105aa66d30369d21cb090900a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.2149851,
                    43.9823731
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/139236999505483"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Barberino di Mugello",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "139236999505483",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "autostrada firenze_bologna",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d8cbaed8b39103ffdfc46770f52a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    110.37339,
                    -7.82457
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110150401813553"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "jl imogiri barat",
                        "locality": "Yogyakarta City",
                        "postcode": "55187",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110150401813553",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Restho",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e80643a8c881033018f57269b15a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.3471293,
                    41.6453219
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": [
                        "event_planning",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/216070155635973"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Aldo Moro, 68",
                        "locality": "Frosinone",
                        "postcode": "03100",
                        "region": "62",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "216070155635973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Spazio Giò",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa226a06c04003ed9b83e6104663",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.92108,
                    49.52228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "translating_and_interpreting_services",
                    "alternate": [
                        "software_development",
                        "internet_service_provider"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://linktr.ee/wordbee"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/280466841164"
                ],
                "phones": [
                    "+35228771204"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "195 Rue de Differdange",
                        "locality": "Sanem",
                        "postcode": "4463",
                        "region": "LU",
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "280466841164",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wordbee",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3969a0c72d0d5033c66ae96b33805",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.2600351,
                    43.7096223
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "health_and_medical",
                        "surgical_appliances_and_supplies"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.ammedical.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/509434452423361"
                ],
                "phones": [
                    "+33493556203"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Rue Alfred Binet",
                        "locality": "Nice",
                        "postcode": "06000",
                        "region": "PAC",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "509434452423361",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Am Medical",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415d45c28c329038c6fa98d521f7b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.10639,
                    21.62327
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9254658385093167,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108571159008085"
                ],
                "phones": [
                    "+84869762327"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "62327 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108571159008085",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amos Love Murphy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a328ddb918ac0397f992dde4a784",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.0145173,
                    42.8177798
                ]
            },
            "properties": {
                "categories": {
                    "primary": "antique_store",
                    "alternate": [
                        "furniture_store",
                        "thrift_store"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://www.themelaminecup.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/296891030421403"
                ],
                "phones": [
                    "+16035324900"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "105 Peterborough St",
                        "locality": "Jaffrey",
                        "postcode": "03452-6823",
                        "region": "NH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "296891030421403",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Melamine Cup",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3db46f3871d66036a532c8a660cbe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.015229,
                    25.6588894
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113799310020461"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "nh8 barar bhim",
                        "locality": "Bhim",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113799310020461",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jai Bherunath",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19510eb26685503a5c389d7ff993a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.093477,
                    53.3253433
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accountant",
                    "alternate": [
                        "financial_service",
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.duftonkellner.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/138999912835266"
                ],
                "phones": [
                    "+441513426405"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Barnston House, Beacon Ln",
                        "locality": null,
                        "postcode": "CH60 0EE",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "138999912835266",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dufton Kellner",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60354cb8b33400317e5fc39578e1b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.544137,
                    10.120767
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104375847665598"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Road Number 18",
                        "locality": null,
                        "postcode": "625601",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104375847665598",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Munna Textiles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8339512862b03abc42ceea94211",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.130641,
                    47.08002
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gas_station",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.bp.com/de_ch/switzerland.html"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0414951820"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hellbühlerstrasse 30",
                        "locality": "Ruswil",
                        "postcode": "6017",
                        "region": "Luzern",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949956475252",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890883383",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890865469",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374884708312",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f18872c86d4203ecfd37e5f98774",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.04782,
                    52.39969
                ]
            },
            "properties": {
                "categories": {
                    "primary": "record_label",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.cybermusique.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115253261821010"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Potsdam",
                        "postcode": null,
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115253261821010",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cybermusique Netlabel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f688a8692db8530341c0010ea7f630",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    117.27842,
                    -0.5765132
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mining",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/124859670710368"
                ],
                "phones": [
                    "+81257809079"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jl. Cendana",
                        "locality": "Samarinda",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "124859670710368",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rental Excavator Amphibi Indonesia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a100409ab691039259019460e344",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.6656,
                    40.73877
                ]
            },
            "properties": {
                "categories": {
                    "primary": "game_publisher",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://play.google.com/store/apps/details?id=com.neutronized.shovelpirate"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/164036256790418"
                ],
                "phones": [
                    "+8616224450234"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "60185 7th Avenue",
                        "locality": "York",
                        "postcode": "10000",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "164036256790418",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amy Pinder Sarah",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f20c9d16254d03735593323b9c54",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.0516982,
                    56.6888884
                ]
            },
            "properties": {
                "categories": {
                    "primary": "engineering_services",
                    "alternate": [
                        "industrial_company",
                        "commercial_industrial"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://www.skanda.dk"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1496511573738422"
                ],
                "phones": [
                    "+4598583033"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Daniavej 35",
                        "locality": "Mariager",
                        "postcode": "9550",
                        "region": "81",
                        "country": "DK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1496511573738422",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Skanda A/S",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f49b32e14da445030a992d84313332",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.24487,
                    18.92595
                ]
            },
            "properties": {
                "categories": {
                    "primary": "investing",
                    "alternate": [
                        "brokers",
                        "insurance_agency"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://sites.google.com/view/mariolanderosasesorpatrimonial/inicio"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101033398059162"
                ],
                "phones": [
                    "+527775634448"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "62020",
                        "locality": "Cuernavaca",
                        "postcode": "62020",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101033398059162",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mario Landeros  Asesor Patrimonial",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195912b7b279a03df3c85394e6b8c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.3562685,
                    50.9587212
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "home_cleaning",
                        "professional_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1116599605023360"
                ],
                "phones": [
                    "+447488363956"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Southampton",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1116599605023360",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Domestic gods",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fad3122c916e0316a2a5a45cf93c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.0304631,
                    50.973496
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "police_department"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1899655346977186"
                ],
                "phones": [
                    "+491721403637"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hirschlachufer 72",
                        "locality": "Erfurt",
                        "postcode": "99084",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1899655346977186",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Estético",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f95a4c0170b505033274fff6960fc1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    115.23675,
                    -8.70031
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/635654596476008"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Denpasar",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "635654596476008",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nuansa Tukad Balian",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6482c6c45a91803ca12cb13a5a3bc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.0087963,
                    18.7883532
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_company",
                    "alternate": [
                        "automotive_parts_and_accessories",
                        "automotive_repair"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://pslglass.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/349321791793891"
                ],
                "phones": [
                    "+66864217168"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "28 ถ.บำรุงราษฎร์ ต.วัดเกต อ.เมือง จ.เชียงใหม่  ",
                        "locality": "Chiang Mai",
                        "postcode": "50000",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "349321791793891",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "กระจกรถ พัวเซ่งหลี เชียงใหม่",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b8915b813d9103008590cf6ff822",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.6987102,
                    42.6451205
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fast_food_restaurant",
                    "alternate": [
                        "mexican_restaurant",
                        "sandwich_shop"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://locations.moes.com/ny/rensselaer/307-troy-road?utm_source=extnet&utm_medium=organic&utm_campaign=locations_partner"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5183280444"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "307 Troy Road",
                        "locality": "Rensselaer",
                        "postcode": "12144",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949962077249",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863108030",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Moe's Southwest Grill",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e669300e9cc203db37c2f1c87c02",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.2326247,
                    34.80513
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "professional_services",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://hirotacorp.jp/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/338398570237155"
                ],
                "phones": [
                    "+81547383211"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "静岡県島田市大柳南５３２",
                        "locality": "島田市",
                        "postcode": "427-0102",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "338398570237155",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ヒロタ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da1a8e12522e0332ce3774237ef8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.43136,
                    28.68631
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "education"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "http://www.hlmgroup.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/339830609379761"
                ],
                "phones": [
                    "+919999310383"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Delhi Meerut Road",
                        "locality": "Ghaziabad",
                        "postcode": "201001",
                        "region": "UP",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "339830609379761",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "HLM Group of Institutions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2db394cab2d900360fb0bacaf6975",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    35.8380277,
                    32.5542704
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "tattoo_and_piercing"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109281695612494"
                ],
                "phones": [
                    "+962788693639"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": " Jordan ",
                        "locality": "Irbid",
                        "postcode": null,
                        "region": null,
                        "country": "JO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109281695612494",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "نور للتجميل والتاتو - NOUR for Beauty & Tattoo ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3076c48c1220357ee07f05f8715",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.93743,
                    42.46523
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landscaping",
                    "alternate": [
                        "construction_services",
                        "tree_services"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105808665742484"
                ],
                "phones": [
                    "+17815603547"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lynn",
                        "locality": "Lynn",
                        "postcode": "01902",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105808665742484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Country Landscaping And More INC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa54b0a18111030dea634aaad6f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.7653399,
                    50.9903107
                ]
            },
            "properties": {
                "categories": {
                    "primary": "high_school",
                    "alternate": [
                        "non_governmental_association"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.scouting-urmond.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/567382603400836"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kampstraat 1",
                        "locality": "Urmond",
                        "postcode": "6129 EK",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "567382603400836",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Scouting Urmond",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e030db6192c0031c2c32a33f6188",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    19.28497,
                    47.65792
                ]
            },
            "properties": {
                "categories": {
                    "primary": "ice_cream_shop",
                    "alternate": [
                        "shaved_ice_shop",
                        "gelato"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1871708569707487"
                ],
                "phones": [
                    "+3611234567"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Torony Fagyizó Veresegyház",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Ráday utca 6",
                        "locality": "Veresegyház",
                        "postcode": "2112",
                        "region": "PE",
                        "country": "HU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1871708569707487",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Torony Fagyizó Veresegyház",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ce0da3a15d8903650a41bbe7b021",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.14618,
                    26.02774
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109615604803886"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "South Salmara",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109615604803886",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mahamaya Dham Hatsingimari South Salmara Mankachar District",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f111b591ad1ad803c60b2b40f8122a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.85598,
                    59.15447
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.chemebel35.ru/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/411239492766427"
                ],
                "phones": [
                    "+79215319520"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Россия",
                        "locality": "Cherepovets",
                        "postcode": null,
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "411239492766427",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Череповец мебель",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb4290b298da0387b836cfb42b52",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.4308914,
                    48.9277289
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "painting",
                        "contractor"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://mn-isolation.fr/contact-isolation-gaine-panneau/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1703123819947086"
                ],
                "phones": [
                    "+33987362275"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "46 Rue Léon Gambetta",
                        "locality": "Drancy",
                        "postcode": "93700",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1703123819947086",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mn Isolation (SARL)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9920459235a0329def9289ec2b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.6196264,
                    43.0952309
                ]
            },
            "properties": {
                "categories": {
                    "primary": "property_management",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://keyperformancepm.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101630332073046"
                ],
                "phones": [
                    "+15857707126"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2144 Brighton Henrietta Town Line Rd",
                        "locality": "Rochester",
                        "postcode": "14623-2661",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101630332073046",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Key Performance Property Management",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe63560d85561037097b68e3605d0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.997739,
                    -37.8371506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "breakfast_and_brunch_restaurant",
                        "coffee_shop"
                    ]
                },
                "confidence": 0.9895250069851914,
                "websites": [
                    "http://www.thepeacock.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101842794556798"
                ],
                "phones": [
                    "+61385962342"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "68 River St",
                        "locality": "Melbourne",
                        "postcode": "3141",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101842794556798",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799819680223",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Peacock South Yarra",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8112b52558003dabcaa632341e3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.4406654,
                    42.2856319
                ]
            },
            "properties": {
                "categories": {
                    "primary": "machine_shop",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.denobile.it/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "087261062"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Contrada Strutte, 3",
                        "locality": "Strutte",
                        "postcode": "66038",
                        "region": "CH",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949957307637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "De Nobile Sabbiature",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f264eb64cd568803b6b2d4ab62dfbb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.2932205,
                    36.5851954
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dumpster_rentals",
                    "alternate": [
                        "junk_removal_and_hauling",
                        "recycling_center"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2707599694"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1990 State Route 121 S",
                        "locality": "Murray",
                        "postcode": "42071",
                        "region": "KY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949956755361",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KEY RECYCLING",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194d053316b49030453b9fc9eb3ba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.213491,
                    50.9180414
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "beauty_salon",
                        "hair_removal"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.maro-izegem.be/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/207661462757860"
                ],
                "phones": [
                    "+32478161530"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Roeselaarsestraat 20",
                        "locality": "Izegem",
                        "postcode": "8870",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "207661462757860",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MaRo I Huidcoach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e885b0011b6a0373c095a54e649a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.0809034,
                    40.9768223
                ]
            },
            "properties": {
                "categories": {
                    "primary": "organic_grocery_store",
                    "alternate": [
                        "agriculture"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://aziendasaraceno.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/170918869587152"
                ],
                "phones": [
                    "+393277893188"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Giuseppe Coppa, 29",
                        "locality": "Spinazzola",
                        "postcode": "76014",
                        "region": "75",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "170918869587152",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Azienda Agricola Sebastiano Saraceno",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44ae854d5a61e034a7ab1310d50c9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.0938335,
                    26.6735116
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.ithinkfi.org/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8008735100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3301 Gun Club Rd Bldg B-2",
                        "locality": "West Palm Beach",
                        "postcode": "33406",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949960227013",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "iTHINK Financial",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2656088b0b69303e700bd35be587d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.5763285,
                    39.0985271
                ]
            },
            "properties": {
                "categories": {
                    "primary": "central_government_office",
                    "alternate": [
                        "public_service_and_government",
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.gsa.gov"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115511228503344"
                ],
                "phones": [
                    "+18164263963"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "601 E 12th St",
                        "locality": "Kansas City",
                        "postcode": "64106-2806",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115511228503344",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Richard Bolling Federal Building",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3923094b6010d03d9e9189bde14a9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -7.387496,
                    41.335813
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_agents",
                    "alternate": [
                        "travel"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://hollowbrooktravels.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8456037059"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11 Oscawana Lake Rd",
                        "locality": "Putnam-Valley",
                        "postcode": "10579",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949966268256",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hollowbrook Travel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e169d9b64c103b45411894c9fab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -59.116401,
                    -34.5648567
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1469384856656038"
                ],
                "phones": [
                    "+542323461869"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Italia 988",
                        "locality": "Luján",
                        "postcode": "B6700",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1469384856656038",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kimika Special",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1949625b2c0f403893043146dddad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.29768,
                    49.9009
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wedding_planning",
                    "alternate": [
                        "bridal_shop",
                        "event_planning"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.floevents.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/524431904316888"
                ],
                "phones": [
                    "+33688522084"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4 Lieu-dit La Haye",
                        "locality": "Calanhel",
                        "postcode": "22160",
                        "region": "BRE",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "524431904316888",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flo Events Wedding Planner Organisatrice de Mariages",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275268bb4854503782c3f577d5a83",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.2798919,
                    44.9630269
                ]
            },
            "properties": {
                "categories": {
                    "primary": "private_association",
                    "alternate": [
                        "barber"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://clubcarraway.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102834888194507"
                ],
                "phones": [
                    "+18885018624"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "100 W Franklin Ave",
                        "locality": "Minneapolis",
                        "postcode": "55404-2433",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102834888194507",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Club Carraway",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415dcd642e59003e7659e902aff21",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.43127,
                    21.3987
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122093539016018278"
                ],
                "phones": [
                    "+84869739870"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Kwiatkowski Franky Kellie",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "39870 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122093539016018278",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Franky Ryan Cassi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0021176614036f48e4e0c11f9d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.09575,
                    24.73656
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "tanning_salon"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/304957896868901"
                ],
                "phones": [
                    "+886976100373"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "北興路一段616號",
                        "locality": "竹東鎮",
                        "postcode": "310",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "304957896868901",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ruby Queen 美甲/紋繡/除毛/教學",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bcf4a94a6003d348351285bb69",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.5936184,
                    43.6867143
                ]
            },
            "properties": {
                "categories": {
                    "primary": "online_shop",
                    "alternate": [
                        "corporate_office",
                        "private_establishments_and_corporates"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://lots.impark.com/imp#details=9,470"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4163691807"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "901 Dixon Road",
                        "locality": "Toronto",
                        "postcode": "M9W 1J5",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374884801043",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Impark",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a56d1b714500302edac05ad0b7a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.2317168,
                    33.9591478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "agriculture",
                    "alternate": [
                        "agricultural_service",
                        "shopping"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://hoophouseusa.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105004715374828"
                ],
                "phones": [
                    "+18888483760"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8631 S Alameda St",
                        "locality": "Los Angeles",
                        "postcode": "90002-1542",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105004715374828",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hoop House USA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e086b06ce5490385bb947cf82d38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.33938,
                    47.34506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108313451403917"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Marghita",
                        "postcode": null,
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108313451403917",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lilla Nails",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19728b0c862db03c2ac71b1e7f99f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.0056818,
                    56.490258
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/252211324873390"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dundee",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "252211324873390",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Youngies Residence",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4860994732039e59aac1c186f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.6831623,
                    13.6689332
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102588365625963"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102588365625963",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "บีบีซาลอน",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8c5857ae2ae0344c1a905fdc246",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.7818,
                    26.1955986
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://www.youtube.com/@dj_ks_mixing___2024"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/181301958394308"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bhognipur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "181301958394308",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "uD835uDE49uD835uDE5AuD835uDE6C uD835uDE46uD835uDE56uD835uDE62uD835uDE56uD835uDE61 uD835uDE3FuD835uDE5F uD835uDE46uD835uDE5EuD835uDE63uD835uDE5C",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6434b5112075603842c3aedc694a6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.8536639,
                    8.3197838
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "elementary_school",
                        "school"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/312665122913141"
                ],
                "phones": [
                    "+1075349456"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "312665122913141",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "โรงเรียนราษฎร์บำรุง อำเภอลานสกา สพป.นศ เขต ๑",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ce361898b665033cc214912b0a0e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    91.9289374,
                    24.8594937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1015788858561134"
                ],
                "phones": [
                    "+8801711802147"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "HOLY Group. Khaja Complex. Ground floor- 01 Boraya Uttar Bhag. Hz. Shah Poran Toll Plaza. Sylhet. Bangladesh.",
                        "locality": "Sylhet",
                        "postcode": "3100",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1015788858561134",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Holy Group Head Office",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f5f4d74934e2dc037d4fd0a5f874bb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.6872,
                    9.42
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://fb.me/vapeshopanz"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1943817982603396"
                ],
                "phones": [
                    "+584121800737"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Anaco Abajo",
                        "postcode": null,
                        "region": null,
                        "country": "VE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1943817982603396",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vape_ shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194ad136441a603d9bcdfa03fb3c7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.1496799,
                    51.4462887
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fair",
                    "alternate": [
                        "festival",
                        "post_office"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.postoffice.co.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "03456112970"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "92A Balham High Road",
                        "locality": "London",
                        "postcode": "SW12 9AF",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863372622",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Post Office-Balham",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651d812d66358039a818c95f7940c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.557478,
                    5.368231
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "medical_service_organizations",
                        "fertility"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/340310859401782"
                ],
                "phones": [
                    "+1044906204"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "No. 1530, Jalan Hospital",
                        "locality": null,
                        "postcode": "09000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "340310859401782",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Klinik LPPKN",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4994272ad5c8803aaa7e6838f5681",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.1937652,
                    19.3197919
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1777332382502096"
                ],
                "phones": [
                    "+522464635521"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Chiautempan",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1777332382502096",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mario Ferat Psicología & Coaching",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f283214d39d722036d81157f6e0817",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.2609132,
                    38.7682362
                ]
            },
            "properties": {
                "categories": {
                    "primary": "divorce_and_family_law",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.sekifamilylaw.com/contact-us"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104981351912938"
                ],
                "phones": [
                    "+19167276009"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1075 Creekside Ridge Dr",
                        "locality": "Roseville",
                        "postcode": "95678-3502",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104981351912938",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Seki Family Law",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f266d46c6a62400399c378b9534282",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.2001648,
                    38.1952858
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tree_services",
                    "alternate": [
                        "landscaping"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://treeserviceshelbyville.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5025136226"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1013 Old Seven Mile Pike",
                        "locality": "Shelbyville",
                        "postcode": "40065",
                        "region": "KY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424931905754",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Marios Tree Care & Tree Removal of Shelbyville",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184b76a7562d203328b4afe7451b6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.6635378,
                    42.8568923
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "restaurant",
                        "lounge"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/315624948826742"
                ],
                "phones": [
                    "+34945198360"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Portal de Betoño, 4",
                        "locality": "Vitoria",
                        "postcode": "01002",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "315624948826742",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bar Eguren",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65050d1c6c514036513f13164be9f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.5243799,
                    3.07156
                ]
            },
            "properties": {
                "categories": {
                    "primary": "advertising_agency",
                    "alternate": [
                        "professional_services",
                        "social_media_agency"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.brandcharacter.co/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/235768306474742"
                ],
                "phones": [
                    "+601118883000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Vista Alam, 1 Jalan Ikhtisas",
                        "locality": "Shah Alam",
                        "postcode": "40000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "235768306474742",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brandcharacter",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f2818a1326d60386f33f07c0630a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.287038,
                    56.2424411
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_service",
                    "alternate": [
                        "home_cleaning"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://www.omtanken.care/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/653323275061663"
                ],
                "phones": [
                    "+4645778700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Järnbruksvägen 3",
                        "locality": "Kallinge",
                        "postcode": "372 52",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "653323275061663",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "1:A Omtanken Ab",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbc1b66907674003a4138dfd0adb3d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.9461513,
                    -29.8495883
                ]
            },
            "properties": {
                "categories": {
                    "primary": "theatre",
                    "alternate": [
                        "comedy_club",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/768586416637636"
                ],
                "phones": [
                    "+10312641752"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "4091",
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "768586416637636",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chesterville Community Hall",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6943a228d3b09039731343125b7e9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.565384,
                    14.6599604
                ]
            },
            "properties": {
                "categories": {
                    "primary": "asian_restaurant",
                    "alternate": [
                        "bakery"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103520368865546"
                ],
                "phones": [
                    "+639555270410"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Balanga, Central Luzon, Philippines",
                        "locality": "Balanga",
                        "postcode": "2100",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103520368865546",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ehu's Bake Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec46e9b2221003c2dc73bea4d21d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.304189,
                    42.674788
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "landmark_and_historical_building",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.sofbuild.com/#/bg/projects/red-apple/gallery/exterior/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/333954890027911"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ул. Бяла черква",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "BG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "333954890027911",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Red Apple",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d56850d8895c03903a67711848a2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    39.73062,
                    43.61041
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": [
                        "home_goods_store"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://sochi.angstrem-mebel.ru/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100977508424946"
                ],
                "phones": [
                    "+79683009385"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Лазурит - мебель, которая заботится о каждом.",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "улица Гагарина 76",
                        "locality": "Сочи",
                        "postcode": "354065",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100977508424946",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Мебель Лазурит. Успех начинается дома.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f43acd982a1919036e8143ec879406",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    55.287591,
                    25.2571053
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "beauty_and_spa",
                        "spas"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1854800394751867"
                ],
                "phones": [
                    "+97143522899"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Khalid Bin walid RD next to palm beach Hotel",
                        "locality": "Dubai",
                        "postcode": "00000",
                        "region": null,
                        "country": "AE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1854800394751867",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sleekspa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad676b0cd91e033f24aa5e3e3ebf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.958649,
                    35.0677975
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "children's_clothing_store"
                    ]
                },
                "confidence": 0.9880576923076922,
                "websites": [
                    "https://oldnavy.gap.com/products/fayetteville-nc-store-5966.jsp"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/148573895170101"
                ],
                "phones": [
                    "+19107950339"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Old Navy",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "131 Glensford Dr",
                        "locality": "Fayetteville",
                        "postcode": "28314-2363",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "148573895170101",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374886001114",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911250561",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Old Navy Glensford Commons",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c137378256a0302245959f0f82e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.4102464,
                    33.9656098
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dry_cleaning",
                    "alternate": [
                        "laundromat",
                        "shopping"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.debbieleifer.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110372705692034"
                ],
                "phones": [
                    "+17705658460"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4880 Lower Roswell Rd",
                        "locality": "Marietta",
                        "postcode": "30068-4334",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110372705692034",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Anders cleaners",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44f4272711b2603ea151234803f8c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.3890033,
                    29.6739385
                ]
            },
            "properties": {
                "categories": {
                    "primary": "corporate_office",
                    "alternate": [
                        "private_establishments_and_corporates"
                    ]
                },
                "confidence": 0.8986340206185567,
                "websites": [
                    "https://www.cox.com/local/residential/stores/fl/gainesville/2278-nw-43rd-st?sc_id=dp_z_yext_z_store_19Q2?sc_id=dp_z_bing_z_store_19Q95"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3526726083"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2278 NW 43rd St",
                        "locality": "Gainesville",
                        "postcode": "32605",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949955887272",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "140950392678140",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cox Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0b3426848803a43bc8a7a2173e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.7159596,
                    33.6504438
                ]
            },
            "properties": {
                "categories": {
                    "primary": "laboratory_testing",
                    "alternate": [
                        "diagnostic_services",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://acsd4u.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/348006065221581"
                ],
                "phones": [
                    "+19499006643"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Hughes",
                        "locality": "Irvine",
                        "postcode": "92618-2021",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "348006065221581",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ACS Diagnostics, Inc.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aae2d4ad2a58037cdb65522a3691",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.34912,
                    39.32827
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpenter",
                    "alternate": [
                        "professional_services",
                        "structure_and_geography"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2195459020680767"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Shady Side",
                        "postcode": null,
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2195459020680767",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nauti Bay Woodworking",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a930ab906b720316f9aeca2a036a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.5517403,
                    39.1455769
                ]
            },
            "properties": {
                "categories": {
                    "primary": "day_care_preschool",
                    "alternate": [
                        "preschool",
                        "school"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://www.youthlandacademy.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1003144216442142"
                ],
                "phones": [
                    "+15138276808"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3277 Beekman St",
                        "locality": "Cincinnati",
                        "postcode": "45225-1239",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1003144216442142",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799821428335",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Youthland Academy - Beekman",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26e0d464dc66103f41a6c9e9eb4b5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.2159827,
                    38.9168397
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.edwardjones.com/us-en/financial-advisor/bryce-koehn?y_source=1_OTY1NzA5LTQ4My1sb2NhdGlvbi53ZWJzaXRl"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7852630091"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "518 N Buckeye Ave, Suite B",
                        "locality": "Abilene",
                        "postcode": "67410",
                        "region": "KS",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949964799948",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Edward Jones - Financial Advisor: Bryce C Koehn, CFP®|AAMS™",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f0999386663ac4031ef4533e663f50",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.7537633,
                    59.9145927
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://oslocitytannlege.no/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1676760155912181"
                ],
                "phones": [
                    "+4795339999"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Brugata 1",
                        "locality": "Oslo",
                        "postcode": "0186",
                        "region": "03",
                        "country": "NO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1676760155912181",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oslo City Tannlege",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19420ee49e6d9038175366e0bc5f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.4705723,
                    53.4609096
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "construction_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://keppelconstruction88.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/656636971125591"
                ],
                "phones": [
                    "+441142469162"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "15 Nether Ley Croft",
                        "locality": "Sheffield",
                        "postcode": "S35 1AG",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "656636971125591",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932035123",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Keppel Construction",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48a20ec4e999603451ef25e37ef8a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -100.26202,
                    25.7642086
                ]
            },
            "properties": {
                "categories": {
                    "primary": "alcohol_and_drug_treatment_centers",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/141004079094737"
                ],
                "phones": [
                    "+528134528980"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "141004079094737",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Formando Guerreros A.C.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6b8653b6c30037c5867c02a3897",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    132.9673135,
                    35.3188902
                ]
            },
            "properties": {
                "categories": {
                    "primary": "football_stadium",
                    "alternate": [
                        "stadium_arena"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/227821117334611"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Unnan-shi",
                        "postcode": null,
                        "region": "32",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "227821117334611",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "大東球場",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28308a82447220327388a44fdf35a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.26219,
                    37.8714774
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "campus_building",
                        "library"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://ib.berkeley.edu/admin/facilities/vlsb/aboutvlsb.php"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/145498745485007"
                ],
                "phones": [
                    "+15103339523"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Harmon Way",
                        "locality": null,
                        "postcode": "94720",
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "145498745485007",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Valley Life Sciences Building",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8da239371e8b403abd064fa177ff6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    113.7019532,
                    -8.169342
                ]
            },
            "properties": {
                "categories": {
                    "primary": "non_governmental_association",
                    "alternate": [
                        "education",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/130884420404835"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jember",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "130884420404835",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tayeng, Kec.Sumberbaru, Kab.Jember",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100dba3545a03d57a991b86f896",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.6141105,
                    -23.4873465
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1734563520144117"
                ],
                "phones": [
                    "+551178167484"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "São Paulo",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1734563520144117",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Old's ZN",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f804459370158203c6042480884fc0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.4422998,
                    -1.4038316
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114654850083162"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Belém",
                        "postcode": null,
                        "region": "PA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114654850083162",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Studio patricia furtado leosoaresgmail.com",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e69a6ad7445903a916c60d47b4dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    132.34939,
                    34.363579
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bridge",
                    "alternate": [
                        "bar"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/243824996306661"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "243824996306661",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "海老橋",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3dad4a4b35415030cfbedc9b17704",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.26037,
                    28.88632
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100609682514226"
                ],
                "phones": [
                    "+918305777964"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "बिलासपुर-तखतपुर मार्ग",
                        "locality": "Bilaspur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100609682514226",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "डॉ. ज्योति कुशवाहा",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e2a59410325603798d5df5933db3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.020707,
                    49.3978398
                ]
            },
            "properties": {
                "categories": {
                    "primary": "italian_restaurant",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/674038722997134"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "674038722997134",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Restauracja Włoska",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42c0261d4d76b03ad6c9af39e563d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    70.8447222,
                    22.8205556
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "specialty_school"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.lecollege.org"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106922112671361"
                ],
                "phones": [
                    "+912822240743"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "363642",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106922112671361",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lukhdhir Ji Engineering College",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f2d9030718c603018277a9f4cbf7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.5695839,
                    -0.515063
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "cottage",
                        "caterer"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/223460984529866"
                ],
                "phones": [
                    "+593998670413"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Caras 035",
                        "locality": "Machachi",
                        "postcode": "171111",
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "223460984529866",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hostería Refugio Chiguac",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1125ada61102403eda8369db4314d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.7266805,
                    62.6044954
                ]
            },
            "properties": {
                "categories": {
                    "primary": "spas",
                    "alternate": [
                        "podiatrist"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://slotti.fi/booking/koulutettuhierojariikkarautiainen/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103196854360174"
                ],
                "phones": [
                    "+358405727582"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kauppakatu 15",
                        "locality": "Äänekoski",
                        "postcode": "44100",
                        "region": null,
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103196854360174",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Koulutettu Hieroja Riikka Rautiainen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39195b1c2bce40304d448504ea7e5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -4.4384285,
                    36.7136668
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "painting"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102531958159652"
                ],
                "phones": [
                    "+34952342344"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Gerona, 31",
                        "locality": "Málaga",
                        "postcode": "29006",
                        "region": "AN",
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102531958159652",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pinturas Málaga Sol S.L.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2430920c978603bdd126c9964cde",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.26723,
                    -31.32158
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1717068638605833"
                ],
                "phones": [
                    "+543516543990"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Tipayante 7555",
                        "locality": "Córdoba",
                        "postcode": "X5000",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1717068638605833",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Luis Vendedor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ed42d31c110322bb23f212c9b5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.03999,
                    14.7162815
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100391875036186"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Tandang Sora",
                        "locality": "Quezon City",
                        "postcode": "1116",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100391875036186",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trendy Collection",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4145375971d8b0388b7237422553a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.88702,
                    18.36807
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102775655411226"
                ],
                "phones": [
                    "+84976943636"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Thạch Trung",
                        "locality": "Thach Ha",
                        "postcode": "039",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102775655411226",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gia đình Thánh Tâm Gp Hà Tĩnh",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8daa1acb25343036156722135f2d3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    111.309572,
                    -8.23195
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beach",
                    "alternate": [
                        "surfing",
                        "park"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/299920404068916"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "299920404068916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pantai Taman Sidomulyo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a4b11862429032218e0f4c60ac6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.49485,
                    13.72957
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1403994356596202"
                ],
                "phones": [
                    "+66958898186"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "131/26 อิสรภาพ 29",
                        "locality": "กรุงเทพมหานคร",
                        "postcode": "10600",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1403994356596202",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Thamonkorn Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195b445da352803fc27bcef669e4c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.5169644,
                    50.7275977
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105673619095234"
                ],
                "phones": [
                    "+447379498870"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Belmont Rd",
                        "locality": null,
                        "postcode": "EX1 2DH",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105673619095234",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alex's Coffee Trike",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b566066dc28039b07fc00f7d4f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.69008,
                    10.76556
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/170464102813070"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "136 Đường Cống Quỳnh",
                        "locality": "Quận 1",
                        "postcode": "71014",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "170464102813070",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LEO Quận 1",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f64201710b63031f7d7934067734",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.837187,
                    38.91348
                ]
            },
            "properties": {
                "categories": {
                    "primary": "forest",
                    "alternate": [
                        "hotel"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1057065214473055"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1057065214473055",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sarnıç Köyü",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f7249a9b004203391565029f55b2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    18.53347,
                    54.35133
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://dobrzezgrani.pl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101390364978914"
                ],
                "phones": [
                    "+48733188477"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Gdansk",
                        "postcode": null,
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101390364978914",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DobrzeZgrani",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa813b6d2c42400301b971cf4deb66",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.29679,
                    -22.78448
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103570117837148"
                ],
                "phones": [
                    "+5519995704407"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Nova Odessa",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103570117837148",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Petit Gourmet",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f7519168af4363034c1f92ffe2be05",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.9740804,
                    5.2853401
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113479777920056"
                ],
                "phones": [
                    "+2250504585799"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Marcory",
                        "locality": "Cocody",
                        "postcode": "225",
                        "region": "AB",
                        "country": "CI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113479777920056",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bookchone Image",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194ad22d63d8b0387676ca7590fde",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.0237973,
                    51.5051222
                ]
            },
            "properties": {
                "categories": {
                    "primary": "internet_service_provider",
                    "alternate": [
                        "transportation",
                        "taxi_service"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://ridenear.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102569071907856"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "25 Cabot Square",
                        "locality": "London",
                        "postcode": "E14 4QA",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102569071907856",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RideNear",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65846e8a2d2180319bf31cb4d3a62",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.73449,
                    11.50761
                ]
            },
            "properties": {
                "categories": {
                    "primary": "children's_clothing_store",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/563301664149078"
                ],
                "phones": [
                    "+85570210529"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ផ្លូវ 4 150",
                        "locality": "ភ្នំពេញ",
                        "postcode": "120901",
                        "region": null,
                        "country": "KH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "563301664149078",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ah Pov Fashion Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2624b22c6cc6d035390ab2689526a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.57777,
                    47.10139
                ]
            },
            "properties": {
                "categories": {
                    "primary": "museum",
                    "alternate": [
                        "history_museum",
                        "art_gallery"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.casscountymuseum.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/186626011992431"
                ],
                "phones": [
                    "+12185477251"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "205 Minnesota Ave E",
                        "locality": "Walker",
                        "postcode": "56484",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "186626011992431",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cass County Museum & Research Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f618920e61a0e00356b99926293058",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.73703,
                    12.95705
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_cleaning",
                    "alternate": [
                        "financial_service",
                        "pest_control_service"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://vaishnaviventures.in/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1007310772694015"
                ],
                "phones": [
                    "+919620207888"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bangalore",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1007310772694015",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vaishnavi Ventures",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f255a216cf60320382d521f2b6e66c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.9217777,
                    47.9241792
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/139146219536368"
                ],
                "phones": [
                    "+97688805810"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Metro business center 604",
                        "locality": "Ulaanbaatur",
                        "postcode": "976",
                        "region": null,
                        "country": "MN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "139146219536368",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hi shop-онлайн худалдаа хүргэлт",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8d5248534600030047690667f0b6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.932622,
                    -16.115292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sushi_restaurant",
                    "alternate": [
                        "asian_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/356123554512218"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sq 11 Q 12 casa 26",
                        "locality": "Cidade Ocidental",
                        "postcode": "72880000",
                        "region": "GO",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "356123554512218",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tatame Sushi Bar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4995bac023d9e0374b960f4f95fbd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.21176,
                    19.42723
                ]
            },
            "properties": {
                "categories": {
                    "primary": "boutique",
                    "alternate": [
                        "fashion",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/432365977203395"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Plaza del Domo, Avenida Prado Norte 460",
                        "locality": "Miguel Hidalgo",
                        "postcode": "11000",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "432365977203395",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "My Fashion Boutique Mexico",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a11228dc5180308d6a14e45118a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.446072,
                    34.287483
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "automotive_repair",
                        "auto_detailing"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/512275015585314"
                ],
                "phones": [
                    "+18186794223"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1437 San Fernando Rd",
                        "locality": "San Fernando",
                        "postcode": "91340-3239",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "512275015585314",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "OCD Chemicals- Auto Detailing Supply",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664cc4a7581803d2df2d23b467a0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.5960552,
                    41.7999349
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chicken_restaurant",
                    "alternate": [
                        "american_restaurant",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://haroldschicken.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111667715535298"
                ],
                "phones": [
                    "+17737529270"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1208 E 53rd St",
                        "locality": "Chicago",
                        "postcode": "60615-4008",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111667715535298",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849864194874",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Harold's Chicken #14 Hyde Park",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf1394cb1ce90308305b65701990",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.417366,
                    23.7789326
                ]
            },
            "properties": {
                "categories": {
                    "primary": "youth_organizations",
                    "alternate": [
                        "event_planning"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110242728519264"
                ],
                "phones": [
                    "+8801670601372"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Road-135, Gulshan 1",
                        "locality": "Dhaka",
                        "postcode": "1212",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110242728519264",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Team Kamla Syndicate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12c855a3b3ad6037f49ea5b57b6a6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -113.9469734,
                    49.4856711
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": [
                        "clothing_store",
                        "shopping"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "https://rufflesboutique2012.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/283189865093680"
                ],
                "phones": [
                    "+14036274640"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "803 Main St",
                        "locality": "Pincher Creek",
                        "postcode": "T0K",
                        "region": "AB",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "283189865093680",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ruffles Boutique",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28f0170560875036f9c9c20c24f59",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.7856564,
                    45.4203524
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5039687899"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "13727 SW Pacific Hwy",
                        "locality": "Tigard",
                        "postcode": "97223",
                        "region": "OR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949955293213",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955134316",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849860799261",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Thrifty Car Rental",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb6a8d54d4032ad6bc07995ac7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.8577175,
                    20.9792811
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167497430855510"
                ],
                "phones": [
                    "+84818895666"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hanoi",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167497430855510",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tiệm hàng Auth Bích",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44130e36d20d503a67420f7f83d96",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.896781,
                    26.513676
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dialysis_clinic",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.davita.com/locations/fl/fort-myers/8850-gladiolus-dr--4043"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8333732037"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8850 Gladiolus Dr",
                        "locality": "Fort Myers",
                        "postcode": "33908",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949965581414",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DaVita Fort Myers South Dialysis",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d320547087310395c8a0c895f403",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    75.5047073,
                    31.9256023
                ]
            },
            "properties": {
                "categories": {
                    "primary": "water_park",
                    "alternate": [
                        "hotel",
                        "marriage_or_relationship_counselor"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1380523052245187"
                ],
                "phones": [
                    "+918255000004"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kathana",
                        "locality": "Gurdaspur",
                        "postcode": "143528",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1380523052245187",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Riar Resort's",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f268cda862cd3603fbd72e7a891659",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.9914168,
                    39.7333717
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "mortgage_broker",
                        "installment_loans"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://www.megastarfinancial.com/loan_officer/james-stinar/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104193002092594"
                ],
                "phones": [
                    "+13035625971"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1080 Cherokee St",
                        "locality": "Denver",
                        "postcode": "80204-4039",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104193002092594",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Home Loans by Zach Smith [Sko Buffs]",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8d85c20b1982603be833f7fb11810",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    112.6259629,
                    -7.9710915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "property_management"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/635306916507213"
                ],
                "phones": [
                    "+6281311197411"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "buring kota malang",
                        "locality": "Malang",
                        "postcode": "65391",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "635306916507213",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Perumahan Subsidi KOTA Malang",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbc682ca8f1b1d03d6d22763802e4f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    19.7574215,
                    -34.5922203
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.elimhome.org.za/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/708744015915103"
                ],
                "phones": [
                    "+27284821988"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1B Nuwe St",
                        "locality": "Elim",
                        "postcode": "7270",
                        "region": "WC",
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "708744015915103",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Elim Home Agriculture",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4b64d1d92dd80036d6a23f2d7cef9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.6794723,
                    33.7312684
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.mcdonalds.co.jp/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/472962056421087"
                ],
                "phones": [
                    "+81949321110"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "福岡県宮若市本城１０９８−１",
                        "locality": "宮若市",
                        "postcode": "823-0003",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "472962056421087",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "マクドナルド",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29ab9888f0674033f4a24900a8767",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -119.763076,
                    36.8095098
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mexican_restaurant",
                    "alternate": [
                        "seafood_restaurant",
                        "spanish_restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/369680593099321"
                ],
                "phones": [
                    "+15592252581"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1416 E Shaw Ave",
                        "locality": "Fresno",
                        "postcode": "93710-8002",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "369680593099321",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "2palmas Restaurants",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa80e26ad1a303e94d2333148690",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.98268,
                    49.9749399
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/170981047071035"
                ],
                "phones": [
                    "+4915145295444"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Schweinfurter Straße 12",
                        "locality": "Arnstein",
                        "postcode": "97450",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "170981047071035",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NAILS by Ioana",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a142d98e249b032aa940313a2931",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.092003,
                    41.2112384
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "hotel",
                        "business"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.marriott.com/en-us/hotels/bdrri-residence-inn-milford/overview/?scid=d2406702-e8ea-4b45-bb9b-69cddaaef03d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/269325256580631"
                ],
                "phones": [
                    "+2032832100"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Residence Inn by Marriott",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "62 Rowe Ave",
                        "locality": "Milford",
                        "postcode": "06461-3031",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "269325256580631",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955257605",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955112132",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799813772336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799813749390",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324840203078",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911605268",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Residence Inn by Marriott Milford",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8ba6c99b4199203e9bb619e641189",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -56.1368557,
                    -15.6395891
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "sports_and_fitness_instruction",
                        "fitness_trainer"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/590430914663231"
                ],
                "phones": [
                    "+5565999621255"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Doutor Aleixo Ramos da Conceição, 82",
                        "locality": "Várzea Grande",
                        "postcode": "78140-120",
                        "region": "MT",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "590430914663231",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Escola de Futebol Camisa 10",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1865cac776cc203579dbc07ac5e61",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1724,
                    49.50248
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1567554386713718"
                ],
                "phones": [
                    "+33787333638"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "335 Rue de Verdun",
                        "locality": "Le Havre",
                        "postcode": "76600",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1567554386713718",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fk auto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e149ac8d66c03819bbda59d2c01",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.81309,
                    -34.76157
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/426967237513923"
                ],
                "phones": [
                    "+5491138579434"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Marcos Paz",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "426967237513923",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Peluquería a domicilio Para vos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa88cd8a16666503529706b55c80c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -44.0050021,
                    -19.8359069
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2236173393323012"
                ],
                "phones": [
                    "+5531995896012"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Adolfo Lippi Fonseca, 133",
                        "locality": "Belo Horizonte",
                        "postcode": "31545-260",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2236173393323012",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PlaySoft.Tec",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa3ce676dc2903deaa4ee0d45958",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.13783,
                    49.7055
                ]
            },
            "properties": {
                "categories": {
                    "primary": "international_grocery_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.bontaitaliana.shop/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "26331978"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "30 Route de Luxembourg",
                        "locality": "Lorentzweiler",
                        "postcode": "7372",
                        "region": null,
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424933454714",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bonta Italiana",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f499432d99cc00031928f16901d2cf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.2191213,
                    19.0736849
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "wedding_planning"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://convencionesbugatti.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/540652995953586"
                ],
                "phones": [
                    "+522222300704"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida San Felipe 2823",
                        "locality": "Puebla",
                        "postcode": "72040",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "540652995953586",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salones de Fiestas Bugatti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d2901419b7ac03496344d6536fa9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.548355,
                    14.570838
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/354233615351084"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Petapa",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "GT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "354233615351084",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Domino's Pizza Petapa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c14d951212310379b2b85203ec32",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.2207355,
                    -7.3231414
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "korean_restaurant",
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/953383594698887"
                ],
                "phones": [
                    "+62265334999"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "105, Jalan Galunggung",
                        "locality": "Tasikmalaya",
                        "postcode": "46112",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "953383594698887",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kedai Joglo Semar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e6d4b30724031799d7b9a04a9a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1172801,
                    51.5040376
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.camouflagecafe.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106035135786280"
                ],
                "phones": [
                    "+442081919622"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Arnott Close",
                        "locality": "London",
                        "postcode": "SE28 8",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106035135786280",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Camouflage Cafe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb46624d34b2035fb82022d99095",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.353099,
                    48.8504715
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_goods_store",
                    "alternate": [
                        "furniture_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.finnovashop.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1538547963128221"
                ],
                "phones": [
                    "+33143257570"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "35 Quai de la Tournelle",
                        "locality": "Paris",
                        "postcode": "75005",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1538547963128221",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Finnova",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3daab454c5af40315d342f99426e8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.44095,
                    27.74094
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://youtube.com/channel/uc8epiuew23vlapmstnihqfg"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103286075522736"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Rafiabad",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103286075522736",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amit gamieng94",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d33a9c14c43003b0a75a12776ec2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.66368,
                    39.87165
                ]
            },
            "properties": {
                "categories": {
                    "primary": "veterinarian",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://vetangeles.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104030235870483"
                ],
                "phones": [
                    "+905059866893"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3062. Sokak",
                        "locality": "Çankaya",
                        "postcode": "06810",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104030235870483",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vetangelestr",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f392212953567603086a012ab944dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.7768438,
                    41.4299302
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "fruits_and_vegetables"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102792731553661"
                ],
                "phones": [
                    "+351912721125"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua da Codixeira 19",
                        "locality": "Póvoa de Varzim",
                        "postcode": "4495-025",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102792731553661",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Frutaria da Vila",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194d0e3758449031c1aed01f2cbe5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.1238879,
                    50.9330266
                ]
            },
            "properties": {
                "categories": {
                    "primary": "doctor",
                    "alternate": [
                        "family_practice",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/147320632546045"
                ],
                "phones": [
                    "+3251208000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Meenseheirweg 163",
                        "locality": "Roeselare",
                        "postcode": "8800",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "147320632546045",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dokter Trees Decancq",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194ad640337340369fd609692d051",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1621285,
                    51.3944211
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.keepmoat.com/the-mallards-swanley"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07976650475"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Saint Mary's Road",
                        "locality": "Swanley",
                        "postcode": "BR8 7BA",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978744585",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374885826782",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899910157982",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Keepmoat Homes - The Mallards Development",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a814c0634ade034f82c1593b18a5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.9667436,
                    38.7324292
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hardware_store",
                    "alternate": [
                        "nursery_and_gardening",
                        "industrial_equipment"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://liggettsupply.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104676747804523"
                ],
                "phones": [
                    "+13043352345"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "47 Hamill Rd",
                        "locality": "Mill Creek",
                        "postcode": "26280-1800",
                        "region": "WV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104676747804523",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Liggett's Supply LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa3cd07b4b61037c42d0613a958e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.1272606,
                    49.6120612
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_gallery",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100797949105468"
                ],
                "phones": [
                    "+352691850356"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Yseult D.",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "85 Grand-Rue",
                        "locality": "Luxembourg",
                        "postcode": "1661",
                        "region": null,
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100797949105468",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yseult D",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d538009969150339c0edd2c5d901",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    41.97786,
                    44.08623
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114075868441403"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "hi jii",
                        "locality": "Dzhegutinskiy",
                        "postcode": "52721",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114075868441403",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "tu b aja yr3",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415c390b9c98903e757e22b2cd84b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.95541,
                    21.62789
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122098142678007121"
                ],
                "phones": [
                    "+84869762789"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "62789 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122098142678007121",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Carney Logan Neena",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eda74c71475a03f4c5d64fce27b9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.7640291,
                    37.9933909
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/752851378385117"
                ],
                "phones": [
                    "+302106609700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Πανόρμου 119",
                        "locality": "Αθήνα",
                        "postcode": "115 24",
                        "region": "I",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "752851378385117",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Interamerican Ελληνικη Ασφαλιστικη Εταιρια Ζωης",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a32862a8f4039f57e36c840b10",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.7657968,
                    35.7184745
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "sake_bar",
                        "japanese_restaurant"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/519181528471542"
                ],
                "phones": [
                    "+815054625958"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "東京都文京区根津２丁目１６−１",
                        "locality": "文京区",
                        "postcode": "113-0031",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "519181528471542",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "焼鳥 朱夏",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e1907490e540032f0396a30b8c6e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    140.7375861,
                    41.7778001
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "barbecue_restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://park.e-tetora.com/meal"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/327474840786545"
                ],
                "phones": [
                    "+81138230128"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "北海道函館市新川町２９−１５",
                        "locality": "函館市",
                        "postcode": "040-0032",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "327474840786545",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "とり膳",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6056ac020000371a0a79d33b468",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    136.8997912,
                    35.1445112
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "social_service_organizations",
                        "church_cathedral"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/118653395467182"
                ],
                "phones": [
                    "+81523214429"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "愛知県名古屋市中区金山１丁目１５−１６",
                        "locality": "名古屋市中区",
                        "postcode": "460-0022",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "118653395467182",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "休玄寺",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ca27840dd562034b300df4c1ba3e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    44.6668308,
                    32.4006756
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "installment_loans"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/709000182894784"
                ],
                "phones": [
                    "+9647700181089"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "بابل — الحمزه الغربي",
                        "locality": "Hillah",
                        "postcode": null,
                        "region": null,
                        "country": "IQ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "709000182894784",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "مجموعه شركات أسامه السعبري / فرع المدحتية",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa1ba12f328403935492e1f16e5b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.5312487,
                    50.9846873
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "greek_restaurant",
                        "mediterranean_restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/169569653089280"
                ],
                "phones": [
                    "+49226177616"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hohler Straße 18",
                        "locality": "Gummersbach",
                        "postcode": "51645",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "169569653089280",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gaststätte Zum Hohl e.G.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194adab11b29403f9c5894fc7f018",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.2006265,
                    51.4154575
                ]
            },
            "properties": {
                "categories": {
                    "primary": "graphic_designer",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.pejasurveying.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2473869722837418"
                ],
                "phones": [
                    "+447864783678"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "141 Russell Road",
                        "locality": "London",
                        "postcode": "SW19 1LN",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2473869722837418",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PEJA Design Limited",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbcc35749b04c603174c3cebee58fd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.99756,
                    -26.18174
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/278598815330263"
                ],
                "phones": [
                    "+27633151427"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kingsway Campus Auckland Park, Rossmore",
                        "locality": "Johannesburg",
                        "postcode": "2092",
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "278598815330263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "VAKEL Teachers Society",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a30709a9856a03b069f1fb5f8920",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.086586,
                    42.5163498
                ]
            },
            "properties": {
                "categories": {
                    "primary": "educational_services",
                    "alternate": [
                        "education"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://oneononecollegeconsulting.com/contact"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7812464111"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "607 North Ave #14 2nd Fl",
                        "locality": "Wakefield",
                        "postcode": "01880",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424934326237",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863170222",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "One-on-One College Consulting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1973330030bac037b0a9627ce43af",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.6780338,
                    55.1591374
                ]
            },
            "properties": {
                "categories": {
                    "primary": "religious_organization",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.parishofmorpeth.org.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/364576597051830"
                ],
                "phones": [
                    "+101670503326"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "The Parish Office, Shields Road",
                        "locality": "Morpeth",
                        "postcode": "NE61 2SA",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "364576597051830",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Morpeth Parish",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8af68de82478003a910cde32ea0c5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -59.944458,
                    -3.052276
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "cafetaria",
                        "restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/257194214400570"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "257194214400570",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lanchonete e Pizzaria Leão de Judá",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d1029974848b035ade5bf80a7b83",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    78.0623743,
                    30.4600816
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "professional_services",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://hotelsavoyresidency.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100731764804492"
                ],
                "phones": [
                    "+918445796417"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Near Gandhi Chowk, Below Charliville Road, Uttarakhand",
                        "locality": "Mussoorie",
                        "postcode": "248179",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100731764804492",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hotel Savoy Residency Mussorie",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa199b24e58303ec4752f0d2a4d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.968524,
                    50.921799
                ]
            },
            "properties": {
                "categories": {
                    "primary": "human_resource_services",
                    "alternate": [
                        "business_to_business_services",
                        "corporate_office"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://brooklynmaxx.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0221920460"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Agrippinawerft 10",
                        "locality": "Köln",
                        "postcode": "50678",
                        "region": "Nordrhein-Westfalen",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932657139",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brooklynmaxx GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d61772cd871803580e7db8157c8a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.2527056,
                    12.1263328
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108987644805626"
                ],
                "phones": [
                    "+50576495345"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "De Juan Bambash Altamira 1c Arriba , Mano izquierda  . ",
                        "locality": "Managua",
                        "postcode": "14017",
                        "region": null,
                        "country": "NI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108987644805626",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Orquídea - Brows & Esthetics",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa494b603af303723e2d59f99d0a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.75599,
                    51.64312
                ]
            },
            "properties": {
                "categories": {
                    "primary": "electrician",
                    "alternate": [
                        "electronics",
                        "business"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.kuijselektrotechniek.nl"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1415945042015808"
                ],
                "phones": [
                    "+31629566649"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Heulstraat 16",
                        "locality": "Terheijden",
                        "postcode": "4844 SV",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1415945042015808",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kuijs Elektrotechniek",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1862ac892ca84033d32a2754d9978",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.00674,
                    48.64656
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "graphic_designer"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.histoiresdegouts-agence.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/571204309559591"
                ],
                "phones": [
                    "+33672562678"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "20 Rue Théodore Monod",
                        "locality": "Saint-Malo",
                        "postcode": "35400",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "571204309559591",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Histoires de Goûts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1958392345c350386a53f042dffe3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.5866,
                    51.45679
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/160055261210563"
                ],
                "phones": [
                    "+447894567890"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "bs13",
                        "locality": "Bristol",
                        "postcode": "bs13",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "160055261210563",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "JP Handy Solutions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60884053a65a5031436a7172febab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.75734,
                    18.59213
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_advertising",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1088781671290163"
                ],
                "phones": [
                    "+918149822812"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "wakad aundh road, Pune, Maharashtra, 411057",
                        "locality": "Pune",
                        "postcode": "411057",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1088781671290163",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Graphic masala",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a924126432c203acf33de73eca82",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.0119246,
                    40.035821
                ]
            },
            "properties": {
                "categories": {
                    "primary": "propane_supplier",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://bluerhino.com/propane-finder"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3177736136"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1176 S 10th St",
                        "locality": "Noblesville",
                        "postcode": "46060",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949960489825",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blue Rhino Propane Exchange",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196909c6ad7b503b9aab3cb4e1ed2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.0960214,
                    52.0735077
                ]
            },
            "properties": {
                "categories": {
                    "primary": "optometrist",
                    "alternate": [
                        "eyewear_and_optician"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.theoptometrist.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1354265581288093"
                ],
                "phones": [
                    "+31307440234"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Al-Masoedilaan 150",
                        "locality": "Utrecht",
                        "postcode": "3526 GZ",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1354265581288093",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Optometrist",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d14259c72c92037e68040e669297",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.19367,
                    31.32955
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/423214081735505"
                ],
                "phones": [
                    "+916005360134"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mohalla Hazratbal ",
                        "locality": "Anantnag",
                        "postcode": "192101",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "423214081735505",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ideas Anantnag",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e873a70b8a036240fe970961d5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.1603217,
                    52.0550522
                ]
            },
            "properties": {
                "categories": {
                    "primary": "preschool",
                    "alternate": [
                        "education",
                        "school"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.babysensory.com/ipswich"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/565313910246084"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "565313910246084",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ipswich Baby Sensory",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec9c048f1d4e03d36893cb6cdbf4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.458302,
                    41.143025
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_school",
                    "alternate": [
                        "art_gallery",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/140111032737681"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mübadele Müzesi, Bahar Sokak 4",
                        "locality": "Çatalca",
                        "postcode": "34540",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "140111032737681",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "İnci Kılıç Sanat Atölyesi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26ee2cad40c13039b5f5770fd7308",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.9072369,
                    36.1171158
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "medical_spa"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://www.selfbodyandwellness.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105293082298245"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6130 E 32nd St",
                        "locality": "Tulsa",
                        "postcode": "74135",
                        "region": "OK",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105293082298245",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Self Body and Wellness",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e311caae25603a3dfea50a01bcc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.425293,
                    -34.6031174
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107415854416577"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Palermo, capital federal",
                        "locality": "Buenos Aires",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107415854416577",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "rojaclaridad",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a18c0db244e03edec84c3c7e809",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.28309,
                    25.70481
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_service",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/197330060455566"
                ],
                "phones": [
                    "+17864881086"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1515 Sunset Dr",
                        "locality": "Coral Gables",
                        "postcode": "33143-5800",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "197330060455566",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Luis Gonzalez-Roque LGR Miami Real Estate Group",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194238572d859034a2970da315f13",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.334134,
                    53.334069
                ]
            },
            "properties": {
                "categories": {
                    "primary": "delicatessen",
                    "alternate": [
                        "cafe",
                        "coffee_shop"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.deliventure.co.uk"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109610571334804"
                ],
                "phones": [
                    "+441142471144"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18 Longacre Close",
                        "locality": "Sheffield",
                        "postcode": "S20 3",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109610571334804",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Deli express",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba2865376800033075d806686f0d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.721463,
                    24.149367
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chinese_restaurant",
                    "alternate": [
                        "health_and_medical",
                        "naturopathic_holistic"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/149932218422825"
                ],
                "phones": [
                    "+886423917386"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "中山路三段20號",
                        "locality": "台中市",
                        "postcode": "411",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "149932218422825",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "太極中醫診所",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba2862d092d003a590a8896b547c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.6898235,
                    24.1087625
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111334427370850"
                ],
                "phones": [
                    "+886424838265"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "中興路二段251-3號",
                        "locality": "台中市",
                        "postcode": "412",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111334427370850",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "非凡髮藝",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8ed91518b2503754630da467397",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.5533327,
                    47.3575158
                ]
            },
            "properties": {
                "categories": {
                    "primary": "process_servers",
                    "alternate": [
                        "information_technology_company",
                        "web_hosting_service"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0444212414"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Höschgasse 45",
                        "locality": "Zürich",
                        "postcode": "8008",
                        "region": "Zurich",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949959542498",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kreativ Media GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f16a1550576e03c8c32afddac80e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.416796,
                    52.604606
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpet_store",
                    "alternate": [
                        "shopping",
                        "industrial_company"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.evers-tueren.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/229020130589814"
                ],
                "phones": [
                    "+49596394140"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Gewerbegebiet 4",
                        "locality": "Bawinkel",
                        "postcode": "49844",
                        "region": "NI",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "229020130589814",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Evers Holzverarbeitungs GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bd6e46e2e803cb7b729f7a74f0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.2196377,
                    43.7735323
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "professional_services",
                        "real_estate_agent"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.mazharhomes.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/737473643648032"
                ],
                "phones": [
                    "+14372425566"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "22 Slan Ave",
                        "locality": "Toronto",
                        "postcode": "M1G 3B2",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "737473643648032",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Teammazharhussain",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb6bb35a8003748dff76beda53",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.829619,
                    20.969612
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": [
                        "credit_union",
                        "banks"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://oceanbank.vn"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1489053024460772"
                ],
                "phones": [
                    "+841800588815"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9 Phố Nguyễn Hữu Thọ",
                        "locality": "Quận Hoàng Mai",
                        "postcode": "11718",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1489053024460772",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ATM OceanBank Nguyễn Hữu Thọ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8102da82898303a9cab717990b92",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.879418,
                    -23.1881721
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "coffee_shop",
                        "cafe"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/294793497201295"
                ],
                "phones": [
                    "+551145876736"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Doutor Torres Neves, 149",
                        "locality": "Jundiaí",
                        "postcode": "13201-058",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "294793497201295",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Boutique do Café ''Espaço para os Amantes do Café''",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9084ca713230356a07afc0a9ec5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3266749,
                    47.2902915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "community_services_non_profits",
                        "sports_and_recreation_venue"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://zeckipawa.reseauzec.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1879791442107970"
                ],
                "phones": [
                    "+18197262266"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "12 Chemin de Pénétration",
                        "locality": "Béarn",
                        "postcode": "J0Z 1G0",
                        "region": "QC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1879791442107970",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Zec Kipawa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f82de484c46340037aedf2a83f9af4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.20768,
                    4.79384
                ]
            },
            "properties": {
                "categories": {
                    "primary": "comedy_club",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101956656080367"
                ],
                "phones": [
                    "+2349159681758"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Uya Oro",
                        "locality": "Oron",
                        "postcode": null,
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101956656080367",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Funny TV Comedy Zoon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08ae28c413040031d1cd0092d59b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.9681198,
                    61.7291786
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "school",
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.forsafotografi.se/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/387573244645438"
                ],
                "phones": [
                    "+4665036750"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Monvägen 4",
                        "locality": "Forsa",
                        "postcode": "824 62",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "387573244645438",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Forsafotografi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08b4664463c18038225d6df5bdb56",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.15843,
                    58.50331
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297718063425326"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lidköping",
                        "postcode": null,
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297718063425326",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pavin&maryam",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0b9a85d42903bbf525fe25806e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.5440859,
                    33.862063
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105138658051870"
                ],
                "phones": [
                    "+19512731919"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1101 California Ave",
                        "locality": "Corona",
                        "postcode": "92881-6470",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105138658051870",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pacifica Rental Homes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a40aa909154032c2c4af8ba4da2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.120391,
                    32.900216
                ]
            },
            "properties": {
                "categories": {
                    "primary": "engineering_services",
                    "alternate": [
                        "industrial_company",
                        "real_estate"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.cyth.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/130400947019434"
                ],
                "phones": [
                    "+18585371960"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9939 Via Pasar",
                        "locality": "San Diego",
                        "postcode": "92126-4559",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "130400947019434",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978271578",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cyth Systems",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66088a3869469033fce0e1ee2541f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.0621719,
                    6.9720941
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cycling_classes",
                    "alternate": [
                        "bar"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/306986219769276"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "sendero de miraflores conjunto",
                        "locality": "Piedecuesta",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "306986219769276",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Woman sport fit",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa88b4aaadbca903ed46e1b6a9712b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.8176877,
                    -17.1105772
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103113358448652"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bocaiúva",
                        "postcode": null,
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103113358448652",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kelly Estilos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f15d52065192038cc008c975c859",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.85031,
                    53.56064
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/758145860918294"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Ringstedt",
                        "postcode": null,
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "758145860918294",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sportpferdezucht-Klare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60a901b513a1003e332e68a5f373f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.9134749,
                    15.5029325
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/300539473344262"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Panjim",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "300539473344262",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "St. Cathedral, pannaji, goa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c107881a51740375921e6ea59777",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.811511,
                    -6.230777
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/299837653368020"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jakarta",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "299837653368020",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Widya Candra",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100cca81d9a030d7cf7b694da9a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.67755,
                    -23.53554
                ]
            },
            "properties": {
                "categories": {
                    "primary": "soccer_stadium",
                    "alternate": [
                        "football_stadium",
                        "stadium_arena"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.itaquerao.com.br"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100924507171704"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "São Paulo",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100924507171704",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Itaquera Estádio Corinthians",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26d151a69104403dd5a7b5b8518aa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.906679,
                    35.1326798
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "religious_organization"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.evictorychurch.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/174146582609290"
                ],
                "phones": [
                    "+18063599463"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6300 Arden Rd",
                        "locality": "Amarillo",
                        "postcode": "79109-6982",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "174146582609290",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Victory Church",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb476314096c03058d8869b153ef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.26023,
                    48.98975
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://www.etsy.com/fr/shop/debricetdebreloque"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/905770072769063"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Ermont",
                        "postcode": null,
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "905770072769063",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "De Bric et de Breloque",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f15ac398186803d66072db181a50",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.0641282,
                    53.5970304
                ]
            },
            "properties": {
                "categories": {
                    "primary": "plumbing",
                    "alternate": [
                        "professional_services",
                        "contractor"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.carstens-schmidt.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/145592629118852"
                ],
                "phones": [
                    "+4940612183"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bramfelder Chaussee 64",
                        "locality": "Hamburg",
                        "postcode": "22177",
                        "region": "HH",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "145592629118852",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Carstens + Schmidt GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1909ad06e0288032bef1606e5dcef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -4.4012784,
                    55.865662
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bowling_alley",
                    "alternate": [
                        "cinema",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101332646619721"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Glasgow",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101332646619721",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Playdrome, Clydebank",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6845d4b8e1ce903286292d2580a83",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    124.76692,
                    10.60037
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107402788995161"
                ],
                "phones": [
                    "+9675242525"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "bitanhuan ",
                        "locality": "Baybay",
                        "postcode": "6521",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107402788995161",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bitanhuan Fitness Club",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa82b20a996730035ceb1e03599265",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -53.1407,
                    -22.92851
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/223917606294358"
                ],
                "phones": [
                    "+244944257949"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Novo.Horizonte",
                        "locality": "Luanda",
                        "postcode": null,
                        "region": null,
                        "country": "AO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "223917606294358",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Como Clarear Os Dentes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f386e2146cab4c03782b8a816e8587",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.1702694,
                    36.8169812
                ]
            },
            "properties": {
                "categories": {
                    "primary": "college_university",
                    "alternate": [
                        "textile_museum"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://tunis.dauphine.psl.eu/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/477976752273874"
                ],
                "phones": [
                    "+21671957857"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "نهج بودلير 20",
                        "locality": "تونس",
                        "postcode": null,
                        "region": null,
                        "country": "TN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "477976752273874",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "101422717935901",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "776099372512651",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dauphine Tunis",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8dc8b60860203a4c5827ee35945",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.9084752,
                    26.8080119
                ]
            },
            "properties": {
                "categories": {
                    "primary": "legal_services",
                    "alternate": [
                        "political_organization"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/283872908931797"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Moti Nagar, Lucknow",
                        "locality": "Lucknow",
                        "postcode": "226004",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "283872908931797",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Manoj Kumar Rai",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66f1c5592693103710bb0b7e2b71b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.506723,
                    3.489707
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "automotive_parts_and_accessories",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.astransportes.com.co"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100418935242635"
                ],
                "phones": [
                    "+576024858080"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Almotores Kia",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Calle 72A N",
                        "locality": "Cali",
                        "postcode": "760050",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100418935242635",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Almotores Kia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe61613704a1d030999f6e45aa247",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    143.9754083,
                    -38.5431137
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "real_estate",
                        "holiday_rental_home"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.lornebayview.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2125884737638145"
                ],
                "phones": [
                    "+61352891199"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Managers Residence, 3 Bay St",
                        "locality": "Lorne",
                        "postcode": "3232",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2125884737638145",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lorne Bay View Motel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e1544b751aa503061c39a89b8a99",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.7202136,
                    47.4813609
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "mountain_huts"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "06763718566"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Filzmoos 53",
                        "locality": "Filzmoos",
                        "postcode": "5532",
                        "region": "Salzburg",
                        "country": "AT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949963312048",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hofpürglhütte SUDRA Heinz",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44da2c546892103a2750fb37b353e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.2646786,
                    35.7295715
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "used_car_dealer"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.thomasautomotivenc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/165204650017018"
                ],
                "phones": [
                    "+13363008166"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6055 NC-8",
                        "locality": "Lexington",
                        "postcode": "27292-8802",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "165204650017018",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Thomas Automotive Consulting LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da2188421d6903150c030e24e880",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    75.7991168,
                    26.9080013
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://dealers.nexaexperience.com/nexa-vipul-motors-pvt-ltd-car-dealer-c-scheme-jaipur-22693/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "09069954880"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "D 34, Gr Flr, G Business Park, Subhash Marg, C Scheme",
                        "locality": "Jaipur",
                        "postcode": "302001",
                        "region": "Rajasthan",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863226385",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nexa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa918396c6118003660ce781e27c3c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.951044,
                    -28.450781
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": [
                        "delicatessen",
                        "bar"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/776151275863308"
                ],
                "phones": [
                    "+554836233993"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua João Ernesto Ramos, 652",
                        "locality": "Capivari de Baixo",
                        "postcode": "88745-000",
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "776151275863308",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mercado Capivari",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c09621c2d03a8225b3fbb6bef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0196838,
                    -12.1021913
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chicken_restaurant",
                    "alternate": [
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110183660513430"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Andrés Aramburú 996",
                        "locality": "Surquillo",
                        "postcode": "15047",
                        "region": "LIM",
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110183660513430",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pappas Grill",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9a55cb4c87003407efb0c5f3e6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.6477,
                    44.31789
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": [
                        "professional_services",
                        "web_designer"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.dragonflydesigns.ca/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/196440923717348"
                ],
                "phones": [
                    "+15199862912"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "P.O. Box 605",
                        "locality": "Markdale",
                        "postcode": "N0C 1H0",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "196440923717348",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dragonfly Designs Web Design & Development Solutions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275274699202b03dfcf27a1033efc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -92.92811,
                    45.14651
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/414056342326992"
                ],
                "phones": [
                    "+16514392322"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "13519 Isleton Ave N",
                        "locality": "Hugo",
                        "postcode": "55038-9412",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "414056342326992",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Whitaker Farms",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e1915bb80a86039aadb1af502bd6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    140.7220982,
                    41.759408
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "bed_and_breakfast",
                        "accommodation"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/454396771958088"
                ],
                "phones": [
                    "+81138211717"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "北海道函館市宝来町１７−１４",
                        "locality": "函館市",
                        "postcode": "040-0043",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "454396771958088",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ビジネスホテル ぼくんち函館",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6930722b3040d0366db39906c3470",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    109.2041498,
                    13.7650735
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/413699461818881"
                ],
                "phones": [
                    "+84865632848"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "340 Lý Thái Tổ, tp Quy Nhơn, Bình Định",
                        "locality": "Quy Nhon",
                        "postcode": "59000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "413699461818881",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chậu xi măng nhẹ giá xưởng",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f69348ab41aa210379b69e61f5353c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.2094412,
                    15.123755
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100753126454404"
                ],
                "phones": [
                    "+84984717317"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Vũ Hoàng Cầm",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "11698642134305947468 Adam",
                        "locality": "Binh Son",
                        "postcode": "199",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100753126454404",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kim Lan Thương",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a1d50c56426038771fe149b180f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.1913208,
                    34.1103246
                ]
            },
            "properties": {
                "categories": {
                    "primary": "discount_store",
                    "alternate": [
                        "department_store",
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.dollartree.com/locations/ca/highland-park/4584/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3232743009"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5817 N Figueroa St",
                        "locality": "Highland Park",
                        "postcode": "90042",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374885336975",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DollarTree",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa673c1c734036b6e1cd21dc4cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.8563112,
                    55.9161847
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1870413499676158"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Дзержинского ",
                        "locality": "Korolëv",
                        "postcode": null,
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1870413499676158",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Алёна",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44daaf18e2c8d0320234b50dac4d3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.5769362,
                    35.42303
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bingo_hall",
                    "alternate": [
                        "escrow_services",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/366096820445568"
                ],
                "phones": [
                    "+18645051407"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "231c Branchview Dr NE",
                        "locality": "Concord",
                        "postcode": "28025-3487",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "366096820445568",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Branchview Bingo | Concord NC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa5563735a340346aeedac5da44f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.0237,
                    51.2773
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_parts_and_accessories",
                    "alternate": [
                        "motorsports_store",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100917589005050"
                ],
                "phones": [
                    "+31621638844"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Maasstraat 46A",
                        "locality": "Kesseleik",
                        "postcode": "5995 ND",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100917589005050",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "X-Cars",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26c82ae05c22c03d8016d4c1252df",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -96.6105959,
                    32.9524731
                ]
            },
            "properties": {
                "categories": {
                    "primary": "candy_store",
                    "alternate": [
                        "chocolatier",
                        "grocery_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.candyworld.info/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/147900678590738"
                ],
                "phones": [
                    "+19728058109"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "460 Cedar Sage Dr",
                        "locality": "Garland",
                        "postcode": "75040-2949",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "147900678590738",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Candy World",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28de896145c0d03aafc482eceb1f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.8443063,
                    49.1950376
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sporting_goods",
                    "alternate": [
                        "shopping",
                        "clothing_store"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.authenticboardsupply.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/247256658759258"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10604 King George Blvd",
                        "locality": "Surrey",
                        "postcode": "V3T 2X3",
                        "region": "BC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "247256658759258",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Authentic Board Supply CO.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a9056da454b03d48735a1e464ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.37187,
                    28.54204
                ]
            },
            "properties": {
                "categories": {
                    "primary": "charity_organization",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://givebutter.com/concertforcovid19relief"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106673491253843"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "424 E Central Blvd",
                        "locality": "Orlando",
                        "postcode": "32801-1923",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106673491253843",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Concert for Covid-19 Relief",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f390cb1b074601030274b0a73576df",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.7000873,
                    40.4216659
                ]
            },
            "properties": {
                "categories": {
                    "primary": "adult_store",
                    "alternate": [
                        "arts_and_entertainment",
                        "retail"
                    ]
                },
                "confidence": 0.8828720836685439,
                "websites": [
                    "https://belover.es/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "911812723"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle de Hortaleza, 30",
                        "locality": "Madrid",
                        "postcode": "28004",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899912527649",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "420867404615550",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Belover Chueca Sex Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbcd1392a61884034cca7ec68ab930",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.4001142,
                    -25.170102
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": [
                        "criminal_defense_law",
                        "personal_injury_law"
                    ]
                },
                "confidence": 0.981907032181168,
                "websites": [
                    "http://www.mphela.co.za/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/569790359820705"
                ],
                "phones": [
                    "+27861674352"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "30A Bodenstein St",
                        "locality": "Polokwane",
                        "postcode": "0699",
                        "region": "LP",
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "569790359820705",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912598744",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mphela and Associates Attorneys",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb81565e494ae403fb57cd3d7afacb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    131.52115,
                    -28.52969
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bookstore",
                    "alternate": [
                        "book_magazine_distribution",
                        "print_media"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.tiktok.com/@bookmart0?_t=8jcqkdpeqcw&_r=1"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/171341579390298"
                ],
                "phones": [
                    "+201111971458"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "القاهرة ",
                        "locality": "Brisbane",
                        "postcode": "11411",
                        "region": "QLD",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "171341579390298",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bookmart Abdo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f089b535932749038253e6b92dfe46",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    24.75739,
                    59.16657
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "hotel",
                        "bar"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.veski.ee/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103608214588757"
                ],
                "phones": [
                    "+3724890882"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Viljandi maantee 5",
                        "locality": "Kohila",
                        "postcode": "79804",
                        "region": null,
                        "country": "EE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103608214588757",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Veski Baar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e858c8c4200b03e9b384994a4963",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.73502,
                    43.302267
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "automotive",
                        "fashion_accessories_store"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://ksm-italy.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1397271400491795"
                ],
                "phones": [
                    "+393885711816"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Fabio Filzi, 97",
                        "locality": "Civitanova Marche",
                        "postcode": "62012",
                        "region": "57",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1397271400491795",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KSM Accessori",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aac3a868940803c3ac78c4a0aa87",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.8292919,
                    39.6036121
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mexican_restaurant",
                    "alternate": [
                        "eat_and_drink",
                        "restaurant"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116592384668776"
                ],
                "phones": [
                    "+14432075619"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "239 S Bridge St",
                        "locality": "Elkton",
                        "postcode": "21921-5951",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116592384668776",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Taco master restaurant & bar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa72655d1b532d0382eb9325d31522",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    115.7673969,
                    -31.7435901
                ]
            },
            "properties": {
                "categories": {
                    "primary": "nail_salon",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106427195246168"
                ],
                "phones": [
                    "+61893002643"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lakeside Joondalup Shopping City, Lakeside Shopping Centre, 420 Joondalup Dr",
                        "locality": "Perth",
                        "postcode": "6027",
                        "region": "WA",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106427195246168",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nails Idol Joondalup",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f40221b94d4303d6e6e0bce73579",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    25.35006,
                    54.63004
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "automotive_parts_and_accessories"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.amdalys.lt/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/924226120982867"
                ],
                "phones": [
                    "+37066861122"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "V. Sirokomlės gatvė 34",
                        "locality": "Nemėžis",
                        "postcode": "13260",
                        "region": "VL",
                        "country": "LT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "924226120982867",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AMDalys.lt - dalys, remontas ir patarimai",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1b46ad32332030d6a066412f392",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.8002195,
                    51.0003983
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.sternauto.de/traposale/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "03518626515"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Langer Weg 50",
                        "locality": "Dresden",
                        "postcode": "01239",
                        "region": "Sachsen",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374891037320",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "trapoSale",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194bb9ac332c8033fb5afc30452b4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.40459,
                    50.06126
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "men's_clothing_store",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172614150058463"
                ],
                "phones": [
                    "+33381632766"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Bonobo",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "3 Impasse du Grand Marais",
                        "locality": "Mers-les-Bains",
                        "postcode": "80350",
                        "region": "HDF",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172614150058463",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bonobo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28f42ee656cd203757c67ea7734ee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.0446331,
                    44.9189344
                ]
            },
            "properties": {
                "categories": {
                    "primary": "appliance_store",
                    "alternate": [
                        "shopping"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "http://www.vacuumworldsalem.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116689461724807"
                ],
                "phones": [
                    "+15033631677"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2330 Commercial St SE",
                        "locality": "Salem",
                        "postcode": "97302-5319",
                        "region": "OR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116689461724807",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958944049",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vacuum World",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f95a5c0d09c2a803bc8763657a5fe5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    116.2516263,
                    -8.5854534
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elementary_school",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/806008386437850"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Narmada",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "806008386437850",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PAUD Cahaya II",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f264d25da242e9039c05cfe9ec12ce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.442375,
                    35.477342
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "travel",
                        "freight_and_cargo_service"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.yrc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/133082770076534"
                ],
                "phones": [
                    "+19316809491"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "232 Church St",
                        "locality": "Shelbyville",
                        "postcode": "37160-4751",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "133082770076534",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yellow Transportation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664a90409b6d033303dedfdbd503",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.0673191,
                    41.4816925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": [
                        "contractor"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.thestealthstandard.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107192387979360"
                ],
                "phones": [
                    "+17273010599"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1309 Forest Park Ave",
                        "locality": "Valparaiso",
                        "postcode": "46385-3328",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107192387979360",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Stealth Construction LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48d8714d4ca3503cc841184f1257c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.937156,
                    35.687507
                ]
            },
            "properties": {
                "categories": {
                    "primary": "monument",
                    "alternate": [
                        "landmark_and_historical_building",
                        "fountain"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/401611456571825"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "109 E Palace Ave",
                        "locality": "Santa Fe",
                        "postcode": "87501-2010",
                        "region": "NM",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "401611456571825",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "109 East Palace",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f658594e2d9d14034fac729c6ed083",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.0130115,
                    10.2271228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "vitamins_and_supplements",
                    "alternate": [
                        "korean_restaurant",
                        "spas"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/249230143635840"
                ],
                "phones": [
                    "+84984147476"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "tổ 3 ấp Bến Tràm, Cửa Dương, Phú Quốc, Kiên Giang",
                        "locality": "Phu Quoc",
                        "postcode": "92500",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "249230143635840",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hồng Sâm Nội Địa Hàn Quốc, Nhập Khẩu 100% Độc Quyền Bởi Solife Ruby",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f95a4c30c5919803feccc8a95410dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    115.157919,
                    -8.6827668
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "spas"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/440647969324166"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Denpasar",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "440647969324166",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "L Boutique Hotel And Spa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2748ce1429d2403b90a97899e95ba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.6363383,
                    43.0192845
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://www.nightbeatent.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6163890196"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3148 Plainfield Ave NE Ste 125",
                        "locality": "Grand Rapids",
                        "postcode": "49525",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976899357",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NightBeat Entertainment",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f393360c2d88a8035034828445d375",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -9.1483229,
                    38.6869377
                ]
            },
            "properties": {
                "categories": {
                    "primary": "candy_store",
                    "alternate": [
                        "coffee_shop"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106203715480835"
                ],
                "phones": [
                    "+351918997032"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Cândido dos Reis 14",
                        "locality": "Almada",
                        "postcode": "2800-269",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106203715480835",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "East Slavic Sweets",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2cb666cc747a803c4c106271dde76",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    43.59375,
                    29.9828548
                ]
            },
            "properties": {
                "categories": {
                    "primary": "commercial_refrigeration",
                    "alternate": [
                        "hvac_services"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://cooltechintl.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/237875832743435"
                ],
                "phones": [
                    "+971526543074"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Warehouse 45 - Industrial Area 6 - Sharjah - United Arab Emirates",
                        "locality": "Sharjah",
                        "postcode": null,
                        "region": null,
                        "country": "AE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "237875832743435",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cooltech",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aaab0a1264b50326d16d02ee0b55",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.3600407,
                    38.8637813
                ]
            },
            "properties": {
                "categories": {
                    "primary": "children's_clothing_store",
                    "alternate": [
                        "swimwear_store",
                        "designer_clothing"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7033528393"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11759L Fair Oaks Mall",
                        "locality": "Fairfax",
                        "postcode": "22033",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932257913",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949953804299",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Justice",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446ca920528e103ffa4a0eea8fba6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.3014693,
                    29.7051478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant_equipment_and_supply",
                    "alternate": [
                        "convenience_store",
                        "shopping"
                    ]
                },
                "confidence": 0.9897612903225806,
                "websites": [
                    "http://www.acemart.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1385299091537334"
                ],
                "phones": [
                    "+17136451200"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Ace Mart Restaurant Supply",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "6700 Gulf Fwy",
                        "locality": "Houston",
                        "postcode": "77087-2518",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1385299091537334",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978314160",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ace Mart Restaurant Supply",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6526add01058003e9c03f9cb3ae4f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.942035,
                    1.352308
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.bellaskin.com.sg"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/302575589768853"
                ],
                "phones": [
                    "+6518007327677"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Income at Tampines Junction, 300 Tampines Ave 5",
                        "locality": "Singapore",
                        "postcode": "529653",
                        "region": null,
                        "country": "SG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "302575589768853",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bella Skin Care",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f27ad6920e0d1103a518ed3309f847",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.2997514,
                    48.1961315
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bank_credit_union",
                    "alternate": [
                        "financial_service",
                        "banks"
                    ]
                },
                "confidence": 0.9895250069851914,
                "websites": [
                    "https://www.psbvelva.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/360774430954006"
                ],
                "phones": [
                    "+17018520328"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "405 37th Ave SW",
                        "locality": "Minot",
                        "postcode": "58701-7302",
                        "region": "ND",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "360774430954006",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978743156",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Peoples State Bank",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2696243c9a64403f08c9941f445fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.6634885,
                    40.3029099
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1131656040555462"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Provo",
                        "postcode": null,
                        "region": "UT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1131656040555462",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Our startup business",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6934ae84e5b4003284bb986d7ddf7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.7949687,
                    15.118413
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108012941713762"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Quang Ngai",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108012941713762",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MiHie House",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6add92ecdaa24030db44bb64704b0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.67503,
                    -0.60649
                ]
            },
            "properties": {
                "categories": {
                    "primary": "radio_station",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://ww.tr/ug"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1293586527420651"
                ],
                "phones": [
                    "+256706125344"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "kakoba",
                        "locality": "Wandegeya",
                        "postcode": null,
                        "region": null,
                        "country": "UG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1293586527420651",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Team rhino",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f410349ac01588035d3bf6ea756dcf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    114.18334,
                    22.28022
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.mibrowshk.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1461769073856404"
                ],
                "phones": [
                    "+85256142195"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wan Chai",
                        "locality": "Hong Kong",
                        "postcode": null,
                        "region": null,
                        "country": "HK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1461769073856404",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MiBrows",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4a26184d6e000039362ca2d2b776e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    127.728063,
                    26.2729112
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bar",
                    "alternate": [
                        "japanese_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1404821336449093"
                ],
                "phones": [
                    "+81989436084"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "字宇地泊558-16",
                        "locality": null,
                        "postcode": "901-2227",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1404821336449093",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "さびら 宜野湾店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d12a2a35599d035a5c94f17ffad9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.61206,
                    29.9481
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102576378403205"
                ],
                "phones": [
                    "+918449164822"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Khan Alampura",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102576378403205",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kavya beauty salon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6506c7099e0690312d390499ff9e6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.4218,
                    4.22864
                ]
            },
            "properties": {
                "categories": {
                    "primary": "spas",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1879996892092958"
                ],
                "phones": [
                    "+60197917221"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1552 Lorong Padang 2",
                        "locality": "Cukai",
                        "postcode": "24000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1879996892092958",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PLUS X Expert Spa Car & Grooming",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274c8632918130353edcce3b9ca8c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.3618221,
                    43.9802091
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.westernunion.com/?utm_source=bingmaps&utm_medium=pml-yext"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9893590709"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "151 E M61",
                        "locality": "Gladwin",
                        "postcode": "48624",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949964285637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Western Union",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415d506c1e42c035720bbd7d3fca5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.446898,
                    21.49668
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atv_rentals_and_tours",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101089862530830"
                ],
                "phones": null,
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Bannarasee Sathianthai",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "28840",
                        "locality": "Hiep Hoa",
                        "postcode": "25000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101089862530830",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sanouk Ornlamai",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41588462b2ab503cffd7cdc8bc2d2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.41212,
                    21.92404
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122094353192017788"
                ],
                "phones": [
                    "+84869792404"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "92404 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122094353192017788",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mitch Marshall Staudt",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f5363269d72360032ccc7bd514cacd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    50.06012,
                    26.44039
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/548927125314696"
                ],
                "phones": [
                    "+966546151691"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dammam",
                        "postcode": null,
                        "region": null,
                        "country": "SA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "548927125314696",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Basma_design",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f99c6632989003ff8972175e056e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.2115045,
                    45.6996898
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "marketing_agency"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.chiarissima.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/540197012660443"
                ],
                "phones": [
                    "+390362852728"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Carroccio, 8",
                        "locality": "Giussano",
                        "postcode": "20833",
                        "region": "25",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "540197012660443",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chiarissima s.n.c.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a006220495203364a62e6c3d04f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.4241983,
                    34.0052177
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": [
                        "delicatessen",
                        "convenience_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://themissionmarketplace.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101765907956615"
                ],
                "phones": [
                    "+19515340094"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6260 Mission Blvd",
                        "locality": "Jurupa Valley",
                        "postcode": "92509-4257",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101765907956615",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mission Marketplace",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0b664008b1036cd87454288543",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.913094,
                    33.7192207
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive",
                        "travel"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://www.prodesignhotrods.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1698190050216210"
                ],
                "phones": [
                    "+17144361158"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2020 S Susan St",
                        "locality": "Santa Ana",
                        "postcode": "92704-4436",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1698190050216210",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pro Design Hot Rods, Inc.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e34d4cb8a756032222024b79265a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.782347,
                    50.5483665
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_services",
                    "alternate": [
                        "bus_tours",
                        "travel_company"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.lang-reisen.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/911565812226924"
                ],
                "phones": [
                    "+49377481040"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Grünhainer Straße 30",
                        "locality": "Schwarzenberg/Erzgeb.",
                        "postcode": "08340",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "911565812226924",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "LANG Reisen (LANG GmbH)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f44a1e8b208403eca7d9797c393c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    24.3587388,
                    55.7260735
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/117517447607135"
                ],
                "phones": [
                    "+37060305074"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Nepriklausomybės aikštė 8",
                        "locality": "Panevėžys",
                        "postcode": "35228",
                        "region": null,
                        "country": "LT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "117517447607135",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CeKava",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f67480ce9a47680379172539619e20",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -66.38986,
                    9.11375
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106875424808867"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "La quinta",
                        "locality": "Las Mercedes",
                        "postcode": null,
                        "region": null,
                        "country": "VE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106875424808867",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Barber Los Brother",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f5226c6f43a803f8e86dd0e18843",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.98328,
                    52.19603
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1747195238679787"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ul. Baleya",
                        "locality": "Warsaw",
                        "postcode": "02-132",
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1747195238679787",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ESVI Art",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e1b56565400e034db72d1b0d2174",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    141.426881,
                    43.033611
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": [
                        "coffee_shop"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.mik-group.co.jp/antique_open/antiquesapporo_open.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/184766961734121"
                ],
                "phones": [
                    "+81115957250"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "北海道札幌市白石区南郷通（南）１５丁目南３−１２",
                        "locality": "札幌市白石区",
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "184766961734121",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ハートブレッドアンティーク 札幌南郷通店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2649ace69e58203c7c29ea3f3646e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.6368522,
                    34.7265269
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gym",
                    "alternate": [
                        "active_life",
                        "college_university"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://linktr.ee/uahrec"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/177148488978932"
                ],
                "phones": [
                    "+12568245500"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "500 John Wright Dr NW",
                        "locality": "Huntsville",
                        "postcode": "35805",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "177148488978932",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899907609680",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "University Fitness Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1951bb0c5466d0334dd5183dd789b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.663834,
                    53.587021
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "fashion"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.ladbrokes.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2037399883009388"
                ],
                "phones": [
                    "+448007316191"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Ladbrokes",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "3 Pole Street",
                        "locality": "Wigan",
                        "postcode": "WN6 0",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2037399883009388",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ladbrokes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a078bcdc34a034d59e4a1fc4ba0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.1902707,
                    -22.9369542
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.nailz.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1132325596900887"
                ],
                "phones": [
                    "+552135578007"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua das Laranjeiras, 388",
                        "locality": "Rio de Janeiro",
                        "postcode": "22240-006",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1132325596900887",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nailz Laranjeiras",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f5e72b20a36103038367a9de0b1d9b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -59.56314,
                    13.15368
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100846826191276"
                ],
                "phones": [
                    "+17845302292"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Belair",
                        "locality": "Saint George",
                        "postcode": "784",
                        "region": "QLD",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100846826191276",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Coalpott",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6622b26785d4e0312a91d82a559b2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2154888,
                    11.2412171
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_services",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105654381294728"
                ],
                "phones": [
                    "+573016010756"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rodadero, Santa Marta",
                        "locality": "Santa Marta",
                        "postcode": "470006",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105654381294728",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lost City Trek",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48b2a6330b35a03fde5cd1f1b3f64",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.4965462,
                    25.8593877
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100251515501997"
                ],
                "phones": [
                    "+528682111279"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Rafael Solís 1004",
                        "locality": "Matamoros",
                        "postcode": "87370",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100251515501997",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Servicio salazar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e76666a93176032783f5e5e61b22",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.2185561,
                    37.9162544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/246552895690338"
                ],
                "phones": [
                    "+81253625430"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "新潟県新潟市南区犬帰新田中屋敷",
                        "locality": "Shibata-shi",
                        "postcode": "950ー1403",
                        "region": "15",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "246552895690338",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "肉の鶴久",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa353249620303d7a1961b64ec76",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.9874567,
                    49.5033887
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "automotive_parts_and_accessories",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "https://www.autofabrik.lu/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102802445503364"
                ],
                "phones": [
                    "+35226175930"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "110 Rue de Luxembourg, L-4221 Esch-sur-Alzette, Luxembourg",
                        "locality": "Esch-sur-Alzette",
                        "postcode": "4221",
                        "region": null,
                        "country": "LU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102802445503364",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899910715323",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Autofabrik",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f088670368e94d03d82fbb8c53e859",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.7580359,
                    59.328632
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "horse_boarding"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/378080526343973"
                ],
                "phones": [
                    "+46705489392"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "179 75",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "378080526343973",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Berga Gård",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19411292ee3b6034f8efac3246ed3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    1.435472,
                    52.8784789
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/448102649284720"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Norwich",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "448102649284720",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lumberjacks",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1faa0aeda809c0325988f4eca880a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.0921457,
                    49.0231643
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101041886136945"
                ],
                "phones": [
                    "+4971433813800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Georg-Murmann-Straße 6",
                        "locality": "Erligheim",
                        "postcode": "74391",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101041886136945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "A&L Detektei & Sicherheit GbR",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec9021346b6e034a18feaf7d471e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.03088,
                    40.99357
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.saysanat.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101366635855937"
                ],
                "phones": [
                    "+905510555373"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101366635855937",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SAY SANAT",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08d3395d088c503042d94a9ec9fd7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.7074959,
                    64.2214605
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://www.kaswe.fi/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/334148457370603"
                ],
                "phones": [
                    "+358442918179"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Puistolantie 34",
                        "locality": "Kajaani",
                        "postcode": "87150",
                        "region": null,
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "334148457370603",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kaswe Oy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa83530008131b0342838760d6e308",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.11795,
                    -26.51325
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "desserts",
                        "coffee_shop"
                    ]
                },
                "confidence": 0.926605504587156,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1379672145684706"
                ],
                "phones": [
                    "+5547999552680"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Walter Marquardt, 1400",
                        "locality": "Jaraguá do Sul",
                        "postcode": "89260-000",
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1379672145684706",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bari Caffe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81a6f3805d52033a97cc80578b85",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.396038,
                    -20.4929153
                ]
            },
            "properties": {
                "categories": {
                    "primary": "desserts",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100461392309316"
                ],
                "phones": [
                    "+5516992114580"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Heitor Villa-Lobos, 401",
                        "locality": "Franca",
                        "postcode": "14409-409",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100461392309316",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Júlia Ribeiro Confeitaria Artesanal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f08a345a875b13037e18addb16c4b7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.62579,
                    60.6084
                ]
            },
            "properties": {
                "categories": {
                    "primary": "political_organization",
                    "alternate": [
                        "non_governmental_association"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://www.facebook.com/groups/160488366458/?fref=ts"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297528452807"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ölandsgatan 12D",
                        "locality": "Falun",
                        "postcode": "791 60",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297528452807",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ung Vänster Falun",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6945b4186bb4d03668bed55a52855",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.316604,
                    16.617061
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_food_store",
                    "alternate": [
                        "train_station",
                        "grocery_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/418942311796875"
                ],
                "phones": [
                    "+63728882378"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Osmena Street ",
                        "locality": "San Fernando",
                        "postcode": "2500",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "418942311796875",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Union Oriental Trading in La Union",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28de88878e31e0346bb7d2c3ae8a9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.0009117,
                    49.2268278
                ]
            },
            "properties": {
                "categories": {
                    "primary": "temp_agency",
                    "alternate": [
                        "employment_agencies"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.officeteam.com/Vancouver"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6046380409"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4710 Kingsway, Suite1401",
                        "locality": "Burnaby",
                        "postcode": "V5H 4M2",
                        "region": "BC",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324837117631",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "OfficeTeam",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f83763c939a1037aee4047667bff",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.06351,
                    46.99475
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://www.immobilien-verlag.ch/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/290950674112473"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bahnhofstrasse 42",
                        "locality": "Entlebuch",
                        "postcode": "6162",
                        "region": "LU",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "290950674112473",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Immobilien Verlag",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c0405c0e5035a63bc04253467",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.06922,
                    -12.008718
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103373428096166"
                ],
                "phones": [
                    "+51910040756"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103373428096166",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Depor Crack",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12c880d44b8da03e0f05ae5466b36",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -113.2992466,
                    49.9119132
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://cindy-dougglobal.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104160664486336"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104160664486336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cindy-Doug Online Business",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f684416561965503ca2fc976f7e940",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    123.99342,
                    10.401
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107933711376023"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Liloan",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107933711376023",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bagelyaspamore",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651d80688671403b8fb3fd71ba7ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.53466,
                    5.30152
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elementary_school",
                    "alternate": [
                        "school"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.youtube.com/watch?v=-5hwm4dd_-i&feature=player_detailpage"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/185459204841786"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "SJK(C) SIN MIN JUNJONG",
                        "locality": "Kulim",
                        "postcode": "09000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "185459204841786",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PIBG SJKC Sin Min, Junjong",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f609196a6cad130389c3ca4262aba2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77,
                    20
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "men's_clothing_store"
                    ]
                },
                "confidence": 0.926605504587156,
                "websites": [
                    "https://play.google.com/store/apps/details?id=com.hiquick.user_app"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/334430400062577"
                ],
                "phones": [
                    "+918486222230"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sixmile, Guwahati",
                        "locality": "Gauhati",
                        "postcode": "781022",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "334430400062577",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "hiquick.in",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3046d2eb28e03f0c75c101d0250",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.1176191,
                    42.6967552
                ]
            },
            "properties": {
                "categories": {
                    "primary": "physical_therapy",
                    "alternate": [
                        "hospital",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.athleticedgetherapy.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105427219253674"
                ],
                "phones": [
                    "+19789623219"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "595 Chickering Rd",
                        "locality": "North Andover",
                        "postcode": "01845-2805",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105427219253674",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Athletic Edge Physical Therapy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2645069b9441603f76b61d0cbac10",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.2261,
                    38.45747
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/348752188664806"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1412 CR-3",
                        "locality": "Mt Erie",
                        "postcode": "62446-1014",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "348752188664806",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SpeedE's Auto Detailing",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62ced6d86d903b1508747525eef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0086,
                    -12.19332
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fashion",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://wa.link/nnhpyn"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106863191109784"
                ],
                "phones": [
                    "+51970554127"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Av. Alameda #157 - Colonial",
                        "locality": "Lima",
                        "postcode": "051",
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106863191109784",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GaBelle",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe5d32ea3308c0385944d9e333440",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    142.1681302,
                    -34.1924638
                ]
            },
            "properties": {
                "categories": {
                    "primary": "self_storage_facility",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.noshedsherlock.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1026010460844087"
                ],
                "phones": [
                    "+61350211900"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "42-50 Ninth St",
                        "locality": "Mildura",
                        "postcode": "3500",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1026010460844087",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "No Shed Sherlock",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c89973c4db4a03f91f84b01b12f4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.18515,
                    21.8772857
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/194689450400650"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kakdwip",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "194689450400650",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "hot girls ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184585a65559003f7d5f4e2d51aa2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.6537335,
                    47.1957024
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wine_bar",
                    "alternate": [
                        "bar",
                        "tapas_bar"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104722604364838"
                ],
                "phones": [
                    "+33766693806"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "82 Rue Joseph Tahet",
                        "locality": "Indre",
                        "postcode": "44610",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104722604364838",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Agapes & Bouchons",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f58826d3376745039cb4967f84a5ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.23933,
                    6.454
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114268646984330"
                ],
                "phones": [
                    "+2347033119518"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Giwa's street",
                        "locality": "Lagos",
                        "postcode": "Lagos",
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114268646984330",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vicky's Hair Empire",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28f00053912a503f2a6a7317da581",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.6974799,
                    45.5377786
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9588815789473685,
                "websites": [
                    "http://petersontrainingllc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101426914624855"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2225 NW Wilson St",
                        "locality": "Portland",
                        "postcode": "97210-2300",
                        "region": "OR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101426914624855",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Peterson Training",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e880d8c5e71803e6c0e83b10da4e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.9218536,
                    41.0629078
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/345932705603630"
                ],
                "phones": [
                    "+393458263992"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Giuseppe Garibaldi, 55",
                        "locality": "Triggiano",
                        "postcode": "70019",
                        "region": "75",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "345932705603630",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hair DA.MA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194a716b1b91c0352c5b8b27a4eae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.3192912,
                    50.8297424
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dog_walkers",
                    "alternate": [
                        "pet_sitting",
                        "livestock_feed_and_supply_store"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.paws-outdoors.co.uk/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07966291667"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "133 Grinstead Lane",
                        "locality": "Lancing",
                        "postcode": "BN15 9DR",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908698112",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paws Outdoors Pet Care Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f61892536238c203b606693b45af8d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.64099,
                    12.96249
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_and_medical",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.medaxohealthcare.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109859618383857"
                ],
                "phones": [
                    "+918069640904"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "95 1st B Cross Road",
                        "locality": "Bengaluru",
                        "postcode": "560071",
                        "region": "KA",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109859618383857",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Medaxohealthcare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa7a32452ca03661a25f7fe53c0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.5671589,
                    55.7353623
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/193483720505144"
                ],
                "phones": [
                    "+74951898913"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Саввинская набережная 13",
                        "locality": "Москва",
                        "postcode": "119435",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "193483720505144",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oltremare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f397062db9dd8b036d4929041acce3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.5095488,
                    41.1194472
                ]
            },
            "properties": {
                "categories": {
                    "primary": "geological_services",
                    "alternate": [
                        "commercial_industrial",
                        "industrial_company"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.marmolesarnas.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/829068313820803"
                ],
                "phones": [
                    "+34978812050"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida de Andorra, 3",
                        "locality": "Albalate del Arzobispo",
                        "postcode": "44540",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "829068313820803",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Marmoles arnas sl",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29b6d1c98c6540358e6a62bd5171e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.07801,
                    33.52664
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "animal_shelter",
                        "charity_organization"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.azdoberescue.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/363744180354564"
                ],
                "phones": [
                    "+16024928139"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "PO Box 97425",
                        "locality": "Phoenix",
                        "postcode": "85060",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "363744180354564",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Desert Harbor Doberman Rescue of Arizona",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48a20146285340324329f03a68b04",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -100.1498709,
                    25.6109814
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110337688246106"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Juárez",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110337688246106",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Barber shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90b200d16c5503bff3a0fe53cf31",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -52.2752,
                    -27.63159
                ]
            },
            "properties": {
                "categories": {
                    "primary": "men's_clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.lojasmarcolin.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1403766799945704"
                ],
                "phones": [
                    "+555433215673"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Maurício Cardoso, 353",
                        "locality": "Erechim",
                        "postcode": "99700-000",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1403766799945704",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lojas Marcolin",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e7a649c31b031d3a422c75417e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.1325629,
                    51.7833704
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate_service"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.intercounty.co.uk/estate-agent/harlow?utm_source=bing&utm_medium=organic&utm_campaign=Uberall"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01279639666"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Station Road, The George",
                        "locality": "Harlow",
                        "postcode": "CM17 0DN",
                        "region": "Ess",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374887773527",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Intercounty",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81cd625766140332908c86473afd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.5468728,
                    -22.9756706
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.cronicastravessias.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100689254963917"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "São Paulo",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100689254963917",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Crônicas Travessias",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f859b310291b03f9c7b58d9b4412",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.1103461,
                    49.2757208
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gas_station",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://tankstelle.aral.de/tankstelle/28423400"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "068944468"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Saarbrücker Str. 6",
                        "locality": "St. Ingbert",
                        "postcode": "66386",
                        "region": "Saarland",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374889527481",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374884707584",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ARAL Tankstelle",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa87800e6671039ba899d8e1cd39",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.0401213,
                    38.803834
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "american_restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.989493699369937,
                "websites": [
                    "http://virtuefeedgrain.com/about-2/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129085270440362"
                ],
                "phones": [
                    "+15719703669"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "106 S Union St",
                        "locality": "Alexandria",
                        "postcode": "22314-3324",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129085270440362",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949959625137",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949959537876",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Virtue Feed & Grain",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f685cba66ae580035efe2bc5936ed3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    125.09978,
                    7.73093
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hiking_trail",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104178208888682"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Quezon Bukidnon",
                        "locality": "Quezon",
                        "postcode": "8715",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104178208888682",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yannakaay Outdoor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f652069cb5828d03a1fe5325e230d6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.0711678,
                    1.8485475
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sporting_goods",
                    "alternate": [
                        "clothing_store",
                        "sports_wear"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "https://www.redcsport.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/671523279605777"
                ],
                "phones": [
                    "+60192095997"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "65 Jalan Universiti 1",
                        "locality": "Parit Raja",
                        "postcode": "86400",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "671523279605777",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Red-c Sport",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12db036b6a25003897cac552c8bbe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.4765017,
                    47.9496417
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_parts_and_accessories",
                    "alternate": [
                        "automotive",
                        "automotive_dealer"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "https://www.autozone.com/locations/wa/deer-park/503-s-main-st.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/182111005217886"
                ],
                "phones": [
                    "+15092620215"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "AutoZone",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "503 S Main St",
                        "locality": "Deer Park",
                        "postcode": "99006-8241",
                        "region": "WA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "182111005217886",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955990873",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AutoZone",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650565a614b2c035133950edf6593",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.2521451,
                    3.3532352
                ]
            },
            "properties": {
                "categories": {
                    "primary": "farm",
                    "alternate": [
                        "fruits_and_vegetables",
                        "motorcycle_repair"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/291096544279902"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kuala Selangor",
                        "postcode": null,
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "291096544279902",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "小频温暖窝P.P Kuala Selangor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e748f319129403bc955e7fec5f38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.3970493,
                    36.3561807
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.unagi-fukagawa.com/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113140398743758"
                ],
                "phones": [
                    "+81284623443"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "栃木県足利市大前町７２４",
                        "locality": "足利市",
                        "postcode": "326-0845",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113140398743758",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ふか川",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe8d12e96d0ca0364ef6c32aaa1d7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    153.0355099,
                    -27.49734
                ]
            },
            "properties": {
                "categories": {
                    "primary": "men's_clothing_store",
                    "alternate": [
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.menshealth.org.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/124422194417484"
                ],
                "phones": [
                    "+61731762359"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Princess Alexandra Hospital, 199 Ipswich Rd",
                        "locality": "Brisbane",
                        "postcode": "4102",
                        "region": "QLD",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "124422194417484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MANDATE - Men's Health",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f0b95bb04646cb03ea3c49c9be6ae6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    86.10692,
                    55.3892
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111809006887276"
                ],
                "phones": [
                    "+79234990666"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ноградская улица 7, Кемерово, Россия, 650000",
                        "locality": "Кемерово",
                        "postcode": "650000",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111809006887276",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Как привлекать партнеров в сетевой бизнес",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694521601ac1903a79d1b92616c4d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.3362721,
                    16.0279657
                ]
            },
            "properties": {
                "categories": {
                    "primary": "donuts",
                    "alternate": [
                        "bakery"
                    ]
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101861898134503"
                ],
                "phones": [
                    "+639385760114"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Malued",
                        "locality": "Dagupan City",
                        "postcode": "2400",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101861898134503",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Roma's Donuts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb6b2f2bb203365c27470ac7eb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.8213791,
                    20.9834084
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.ishop21.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108719023832007"
                ],
                "phones": [
                    "+84366313295"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "141 Phố Định Công Thượng",
                        "locality": "Quận Hoàng Mai",
                        "postcode": "11717",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108719023832007",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "I'm 21",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f9aa70445c5903b65591c50493a5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.9570915,
                    44.7358538
                ]
            },
            "properties": {
                "categories": {
                    "primary": "counseling_and_mental_health",
                    "alternate": [
                        "beauty_and_spa",
                        "spas"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116139905227263"
                ],
                "phones": [
                    "+393355845503"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Torino, 64A",
                        "locality": "Corneliano d'Alba",
                        "postcode": "12040",
                        "region": "21",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116139905227263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centro Benessere Olistico JAIPUR",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48b14526d49000377515fa3dfadef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.5953843,
                    26.2301747
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": [
                        "fashion_accessories_store",
                        "jewelry_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/119434518451135"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Francisco I Madero",
                        "locality": "Gustavo Díaz Ordaz",
                        "postcode": "88400",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "119434518451135",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Novedades y Floreria Tellez",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1a514629052038540efe4e53d29",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.62601,
                    50.93097
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_delivery_service",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.dein-wursttaxi.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100829151573117"
                ],
                "phones": [
                    "+49366052422"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Fuchslöcherstraße 5",
                        "locality": "Jena",
                        "postcode": "07749",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100829151573117",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dein-Wursttaxi.de",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f268cc0888aba303c53fee72f57ecc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.8454104,
                    39.6002924
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "real_estate_service"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "http://www.bttrealestate.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106052866136683"
                ],
                "phones": [
                    "+17202911111"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6436 S Racine Cir",
                        "locality": "Centennial",
                        "postcode": "80111-6465",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106052866136683",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BTT Real Estate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28341134f439e0378d14f7569bfe2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.04315,
                    36.98395
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "limo_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.etsy.com/shop/bigblinghair"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/227622214019215"
                ],
                "phones": [
                    "+18314316773"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Santa Cruz",
                        "postcode": null,
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "227622214019215",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bigblinghair",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30ee9a3a5da00034a282875034281",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    127.941115,
                    37.322705
                ]
            },
            "properties": {
                "categories": {
                    "primary": "asian_restaurant",
                    "alternate": [
                        "restaurant",
                        "korean_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.soymilk.kr"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1293205230770427"
                ],
                "phones": [
                    "+10337651146"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "단구동 1536-5",
                        "locality": null,
                        "postcode": "220-944",
                        "region": null,
                        "country": "KR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1293205230770427",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "가나유통",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275d2b302e0f103afe510ccdbe60b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.9506878,
                    42.9836341
                ]
            },
            "properties": {
                "categories": {
                    "primary": "day_spa",
                    "alternate": [
                        "hair_removal",
                        "wellness_program"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.sevabeauty.com/location/wi/milwaukee-south-27th-street/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4143235179"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3355 S 27th St",
                        "locality": "Milwaukee",
                        "postcode": "53215",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324838752550",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SEVA Beauty",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f395670dd41b6003c0af4aeff1a868",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.7019129,
                    38.2677322
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store",
                        "children's_clothing_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.wix.com/abadia/abadia-moda"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167407186636174"
                ],
                "phones": [
                    "+34630483367"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carrer de Vicente Blasco Ibáñez, 13",
                        "locality": "Elx",
                        "postcode": "03201",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167407186636174",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Abadía",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbcc355570a8ab0350ad3e24a33c5a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    27.95505,
                    -26.10478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "event_photography"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.snapdragonpictures.net/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/141655962584245"
                ],
                "phones": [
                    "+27723559570"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Seder Street, Randpark Ridge",
                        "locality": "Johannesburg",
                        "postcode": null,
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "141655962584245",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Snapdragon Pictures",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a34635d95c990326032bfb556b54",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.4271474,
                    43.4581269
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpenter",
                    "alternate": [
                        "handyman",
                        "professional_services"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1928174550821922"
                ],
                "phones": [
                    "+12073911771"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "171 Guinea Rd",
                        "locality": "Biddeford",
                        "postcode": "04005-9028",
                        "region": "ME",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1928174550821922",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Superior Handyman Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0b6a5a5b0803872bdd9096d43d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.4340995,
                    25.1592531
                ]
            },
            "properties": {
                "categories": {
                    "primary": "ice_cream_and_frozen_yoghurt",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.ice888.tw/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0933811125"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "八里區 渡船頭街21巷22號",
                        "locality": null,
                        "postcode": "249",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949964483223",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "阿忠花生捲冰淇淋 八里加盟店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ef3b5430accc03fbe54ec986d19d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.13168,
                    42.6483599
                ]
            },
            "properties": {
                "categories": {
                    "primary": "b2b_textiles",
                    "alternate": [
                        "arts_and_crafts"
                    ]
                },
                "confidence": 0.9119318181818182,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1544951309103827"
                ],
                "phones": [
                    "+38344416940"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rr. Behije dashi (ish Rexhep Mala) ",
                        "locality": "Pristina",
                        "postcode": "10000",
                        "region": null,
                        "country": "XK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1544951309103827",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pacific Fashion",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d3496009895603a8728eb73246cb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.9513886,
                    40.2593302
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.926605504587156,
                "websites": [
                    "http://www.mikasamoor.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1595197970791182"
                ],
                "phones": [
                    "+902245010324"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sanayi Caddesi 521A",
                        "locality": "Nilüfer",
                        "postcode": "16225",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1595197970791182",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mikasa Moor Bursa-Endülüs Park",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e80cda0ea65103c5b0c83255a8eb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.5534363,
                    41.94374
                ]
            },
            "properties": {
                "categories": {
                    "primary": "brokers",
                    "alternate": [
                        "financial_service",
                        "real_estate"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.salveminiimmobiliare.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1508986496092746"
                ],
                "phones": [
                    "+393519029266"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Francesco D'Ovidio, 71",
                        "locality": "Roma",
                        "postcode": "00137",
                        "region": "62",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1508986496092746",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salvemini Immobiliare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66b4d8a26d350037d860ce701f6a5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.9321566,
                    9.8677736
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": [
                        "countertop_installation",
                        "construction_services"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1121355271243534"
                ],
                "phones": [
                    "+50625923382"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Cartago costado oeste de Mcdonalds metrocentro",
                        "locality": "Cartago",
                        "postcode": "30801",
                        "region": null,
                        "country": "CR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1121355271243534",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Muebles de Cocina by Muebles Eugenio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f608099e38d356039a903c9a0f44c8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.75098,
                    18.12855
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/293804193813892"
                ],
                "phones": [
                    "+919970624647"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Nilanga",
                        "locality": "Nilanga",
                        "postcode": "413521",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "293804193813892",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Armaan Insurance Services ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b8d60a54dad3033cec6b8fec83b7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.559849,
                    43.3087902
                ]
            },
            "properties": {
                "categories": {
                    "primary": "theatre",
                    "alternate": [
                        "topic_concert_venue",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://hudsonrivershakespeare.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/138617366201304"
                ],
                "phones": [
                    "+15187474418"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "66 Mountainview Dr",
                        "locality": "Kingsbury",
                        "postcode": "12839-1637",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "138617366201304",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hudson River Shakespeare Company",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3920cc315ad4803345b1ea46d207b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.6847132,
                    42.2566944
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "elementary_school",
                        "school"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.edu.xunta.es/centros/ceipsansalvador"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1383698588557774"
                ],
                "phones": [
                    "+34886120210"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida de Galicia, 181",
                        "locality": "Vigo",
                        "postcode": "36216",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1383698588557774",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Colexio Público San Salvador",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d32534d74bb60386306fa1a5e081",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.90361,
                    31.62233
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297872143404918"
                ],
                "phones": [
                    "+917011507414"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Near women khalsa college ",
                        "locality": "Amritsar",
                        "postcode": "143001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297872143404918",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Step N Style ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26567143134230354e54d99033552",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.7271503,
                    39.0149649
                ]
            },
            "properties": {
                "categories": {
                    "primary": "physical_therapy",
                    "alternate": [
                        "occupational_therapy",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.arcpt.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/176319489822073"
                ],
                "phones": [
                    "+19138156677"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "ARC Physical Therapy+",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "12156 Shawnee Mission Pkwy",
                        "locality": "Shawnee",
                        "postcode": "66216-1830",
                        "region": "KS",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "176319489822073",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ARC Physical Therapy+",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4a265650ccd4003a94a3a26739d91",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    127.6819169,
                    26.1826286
                ]
            },
            "properties": {
                "categories": {
                    "primary": "naturopathic_holistic",
                    "alternate": [
                        "acupuncture",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/229259600608950"
                ],
                "phones": [
                    "+81988501039"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "沖縄県豊見城市豊見城５９９",
                        "locality": "豊見城市",
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "229259600608950",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "すこやか鍼灸治療院",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f444683082b48603fe94223d128bb2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.7068139,
                    29.5879798
                ]
            },
            "properties": {
                "categories": {
                    "primary": "screen_printing_t_shirt_printing",
                    "alternate": [
                        "printing_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/476772542502721"
                ],
                "phones": [
                    "+19852239085"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1313 E Tunnel Blvd",
                        "locality": "Houma",
                        "postcode": "70363-4978",
                        "region": "LA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "476772542502721",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flawless Screen Printing",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f411caa0156160037f9bc188813203",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    114.0511215,
                    22.5383337
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "accommodation",
                        "business"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://parkhyattshenzhen.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2692004494158013"
                ],
                "phones": [
                    "+8675588291234"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Park Hyatt",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "5023 Yi Tian Road, Futian District",
                        "locality": "Shenzhen",
                        "postcode": "518033",
                        "region": null,
                        "country": "CN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2692004494158013",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Park Hyatt Shenzhen",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3825d5c11830003e5d10f17d60b1a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.705282,
                    37.663181
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "men's_clothing_store"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.solayvaillo.es"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/211155095921380"
                ],
                "phones": [
                    "+1968477102"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carretera de Granada Pg Ind los Penones S, s/n",
                        "locality": null,
                        "postcode": "30800",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "211155095921380",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sola y Vaillo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c60e10a9a98031bb47fbad85a34",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.3785322,
                    32.2054892
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pediatrician",
                    "alternate": [
                        "doctor",
                        "hospital"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.totstoteensmedical.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/283508531701054"
                ],
                "phones": [
                    "+19125379991"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "303 Harris Industrial Blvd",
                        "locality": "Vidalia",
                        "postcode": "30474-8853",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "283508531701054",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374891107763",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tots To Teens Medical Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8515426822103cc6ae4a4bff765",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.72026,
                    43.16164
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.bodyartmassaggi.it/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/128385320574302"
                ],
                "phones": [
                    "+393347186589"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Fermo",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "128385320574302",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Body Art",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29b2d1b518d40036e58b4381af640",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.0211506,
                    34.7282989
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accountant",
                    "alternate": [
                        "financial_advising",
                        "trusts"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://legacytaxaccounting.com/?y_source=1_nzixote4nzqtntu5lwxvy2f0aw9ulndlynnpdgu%3d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/337188400527186"
                ],
                "phones": [
                    "+19282024222"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "657 E Cottonwood St",
                        "locality": "Cottonwood",
                        "postcode": "86326-4407",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "337188400527186",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kinzey CPA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab372466b30a037281137246172b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.2199545,
                    41.1679868
                ]
            },
            "properties": {
                "categories": {
                    "primary": "plumbing",
                    "alternate": [
                        "hvac_services",
                        "contractor"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://lewisplumbingandhomerepair.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/490151637687125"
                ],
                "phones": [
                    "+14406473098"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "183 Depot St",
                        "locality": "Wellington",
                        "postcode": "44090",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "490151637687125",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960130795",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474977401722",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lewis Plumbing & Home Repair, Inc.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26f346a0dc444039055295fdfecad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.3479354,
                    37.1776925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "print_media",
                    "alternate": [
                        "broadcasting_media_production",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://hugotonhermesnews.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/118638108188730"
                ],
                "phones": [
                    "+16205444321"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "522 S Main St",
                        "locality": "Hugoton",
                        "postcode": "67951-2428",
                        "region": "KS",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "118638108188730",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hugoton Hermes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1942368af466c03e757134c3f28ec",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.8760268,
                    53.2067013
                ]
            },
            "properties": {
                "categories": {
                    "primary": "leather_goods",
                    "alternate": [
                        "luggage_storage",
                        "travel"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01777872189"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Gypsy Lodge Farm, Moorhouse Road",
                        "locality": "Newark",
                        "postcode": "NG22 0HH",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908666146",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Equissentials UK",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d440ea21545403ef7d445a3139af",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    39.7234728,
                    47.2254085
                ]
            },
            "properties": {
                "categories": {
                    "primary": "art_museum",
                    "alternate": [
                        "art_gallery",
                        "public_and_government_association"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://romii.ru/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/672312136249171"
                ],
                "phones": [
                    "+78632013982"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Rostov-on-Don",
                        "postcode": null,
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "672312136249171",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "РОМИИ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64b335889894d0348a672cf7daf41",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.2479787,
                    18.3034
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1457123121208431"
                ],
                "phones": [
                    "+66823842860"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18ม.1แม่ยางตาล",
                        "locality": "Ban Mae Yang Thon",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1457123121208431",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "แม่ยางตาล. บ้านครองรัฐ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446c14826ca140307eea06970e6e0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.2977,
                    29.6509
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/166925446496825"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Julius Diaz",
                        "locality": "Houston",
                        "postcode": "77001",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "166925446496825",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Julius Diaz",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f969bc25c03a0903ef63f0897ccfea",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.8992341,
                    -2.5189913
                ]
            },
            "properties": {
                "categories": {
                    "primary": "commercial_industrial",
                    "alternate": [
                        "soul_food"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1563922410490377"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "PO Box 10560",
                        "locality": "Mwanza",
                        "postcode": "<<not-applicable>>",
                        "region": null,
                        "country": "TZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1563922410490377",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nyamhongolo Industrial Area",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ce20928f4d2a035588e3b1e85920",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.40016,
                    24.7337023
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/159943663879857"
                ],
                "phones": [
                    "+8801716568032"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2100",
                        "locality": "Mymensingh",
                        "postcode": "2100",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "159943663879857",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jannat Handcrafts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26cbd94b2d345034807921bd478ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.4351971,
                    32.7344706
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "accommodation",
                        "travel"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://hamptoninn3.hilton.com/en/hotels/texas/hampton-inn-and-suites-fort..."
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1678945149020558"
                ],
                "phones": [
                    "+18177328585"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2700 Green Oaks Rd",
                        "locality": "Fort Worth",
                        "postcode": "76116-1722",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1678945149020558",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949956893043",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955203074",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955000430",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324837059094",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hampton Inn & Suites Fort Worth-West-I-30",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6acc54cc4a32103d5df55d103fcbd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.81997,
                    0.54686
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101520381206211"
                ],
                "phones": [
                    "+256753838454"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kassanda",
                        "postcode": null,
                        "region": null,
                        "country": "UG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101520381206211",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hope for Children Restoration Ministries Uganda",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6033864718793037472d60beece53",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.029352,
                    11.000331
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "doctor",
                        "family_practice"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.nghospital.in/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1578782062388096"
                ],
                "phones": [
                    "+914222595963"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "568 Trichy Road",
                        "locality": "Coimbatore",
                        "postcode": "641005",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1578782062388096",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "N.G Hospital Pvt Ltd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f588b046729232030920187a3f512b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.79958,
                    6.13964
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "comedy_club"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114156055106084"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "No 28 isiokwe road onitsha",
                        "locality": "Onitsha",
                        "postcode": null,
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114156055106084",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mr,jet -comedy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ec0e11271a03a5b423d398ebd8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.0406,
                    14.57366
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://youtube.com/@ronneluy-it7pf"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115010091604910"
                ],
                "phones": [
                    "+639668956635"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Agudo 98",
                        "locality": "Mandaluyong",
                        "postcode": "1550",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115010091604910",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mga Kabuang",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2da58cc8586303270067b809c207",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -54.6670432,
                    -30.9840652
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://www.instagram.com/ana_espacodabeleza_/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1818888844907331"
                ],
                "phones": [
                    "+555399205766"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Vinte e Um de Abril, 1224",
                        "locality": "Dom Pedrito",
                        "postcode": "96450-000",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1818888844907331",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ana Paula Espaço da Beleza",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44caa6b065b0303336bc256e766d3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.1442584,
                    35.8984568
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "health_and_medical",
                        "jewelry_store"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://mercy.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/161592640527474"
                ],
                "phones": [
                    "+18655457954"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10820 Parkside Dr",
                        "locality": "Farragut",
                        "postcode": "37934-1911",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "161592640527474",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mercy Medical Center St Mary's",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f823309c932cd0038a2a4664057e13",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.8461,
                    -4.79472
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "shopping"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://titiqueen2002.wixsite.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/231920057180587"
                ],
                "phones": [
                    "+242057263051"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "articles de maison, décoration, appareils de cuisine et divers accessoires enfants ,gadgets beauté femmes ",
                        "locality": "Pointe-Noire",
                        "postcode": "4415",
                        "region": null,
                        "country": "CG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "231920057180587",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Good house",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4143686d9c68b03ee7c1c2bcacdee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7550789,
                    20.9838422
                ]
            },
            "properties": {
                "categories": {
                    "primary": "industrial_equipment",
                    "alternate": [
                        "appliance_manufacturer"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "http://dpegroup.vn/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/685027828232305"
                ],
                "phones": [
                    "+84901858222"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "C01-L20, An Vượng Villa, KĐT Dương Nội, Phường Dương Nội, Quận Hà Đông, Thành phố Hà Nội",
                        "locality": "Hanoi",
                        "postcode": "10000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "685027828232305",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DPE",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f2b98038631903ac82f6bb2270e8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.8957177,
                    -2.1648817
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101949222441115"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9 de octubre",
                        "locality": "Guayaquil",
                        "postcode": null,
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101949222441115",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Decoraciones el Sol",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a19700f690603428f31e4af074c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.4535146,
                    25.4776635
                ]
            },
            "properties": {
                "categories": {
                    "primary": "barber",
                    "alternate": [
                        "beauty_and_spa",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/712929408895396"
                ],
                "phones": [
                    "+17862262809"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1665 NE 8th St",
                        "locality": "Homestead",
                        "postcode": "33033-4603",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "712929408895396",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sky Vista Barber Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1d491ad8602036ff8767de531ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.2626969,
                    52.5009986
                ]
            },
            "properties": {
                "categories": {
                    "primary": "stadium_arena",
                    "alternate": [
                        "active_life",
                        "football_stadium"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "https://www.parkopedia.de/parken/parkplatz/mommsenstadion/14055/berlin"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129466450437493"
                ],
                "phones": [
                    "+493028830231"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Waldschulallee 34",
                        "locality": "Berlin",
                        "postcode": "14055",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129466450437493",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mommsenstadion",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e5555aa3101035d75ca629a5048",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.74916,
                    30.14167
                ]
            },
            "properties": {
                "categories": {
                    "primary": "boat_parts_and_accessories",
                    "alternate": [
                        "automotive",
                        "boat_dealer"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://legendarymarine.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/444889382689122"
                ],
                "phones": [
                    "+18508305257"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4009 Thomas Dr",
                        "locality": "Panama City",
                        "postcode": "32408-7305",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "444889382689122",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Emerald Coast boating",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42d999a1345000376d1ea83447ee1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    72.8247,
                    21.21055
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108374240998124"
                ],
                "phones": [
                    "+919978810661"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "101",
                        "locality": "Surat",
                        "postcode": "395004",
                        "region": "GJ",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108374240998124",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Apeksha dress material",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2759982b324da03ad66c8b96381c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.1987242,
                    42.77276
                ]
            },
            "properties": {
                "categories": {
                    "primary": "american_restaurant",
                    "alternate": [
                        "italian_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://brunosdining.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/885171308208052"
                ],
                "phones": [
                    "+12625143663"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "730 Cornerstone Xing",
                        "locality": "Waterford",
                        "postcode": "53185-4578",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "885171308208052",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958465109",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bruno's Restaurant",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f58d12152a648103b94443c62a2073",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.13786,
                    5.97428
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9084967320261438,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116827614718636"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lagos",
                        "postcode": null,
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116827614718636",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Enrich Me Media",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9249b8b039603e87b38ea6ef963",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.15638,
                    39.95691
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.raymondjames.com/abbeyroadwealth"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3175731777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11611 N Meridian St Ste 600",
                        "locality": "Carmel",
                        "postcode": "46032",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374888616075",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Abbey Road Wealth Partners of Raymond James",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24372e2cb07003ee381f4f209390",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.1464628,
                    -31.4194682
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.servicejeans.com.ar/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129060703804290"
                ],
                "phones": [
                    "+543514030869"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Tristán Narvaja 918",
                        "locality": "Córdoba",
                        "postcode": "5000",
                        "region": "X",
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129060703804290",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Service Jeans",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c3a5ab319803d3b938c76d84f0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.8317181,
                    52.4427164
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "tire_dealer_and_repair",
                        "automotive"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/676882939019870"
                ],
                "phones": [
                    "+441216247676"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "41 Olton Boulevard East",
                        "locality": "Birmingham",
                        "postcode": "B27 7NH",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "676882939019870",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GNR Garage Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f9ed9241510503d5e9db7e20c301",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.7053963,
                    45.1834207
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_service",
                    "alternate": [
                        "financial_service",
                        "event_planning"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/521626415006564"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "30 Rue Ampère",
                        "locality": "Grenoble",
                        "postcode": "38000",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "521626415006564",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ZEN SYNDIC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8b8b388829c03012285dabd943a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    81.67472,
                    25.48031
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106336324322326"
                ],
                "phones": [
                    "+918130623296"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "near KV Manauri",
                        "locality": "Allahabad",
                        "postcode": "212212",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106336324322326",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fouji Footwear",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ea975bd2cd8003fbd39894e388f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    142.5694044,
                    44.547569
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "health_food_store",
                        "fruits_and_vegetables"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.sikisai.com/hitujikai"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1561523944156563"
                ],
                "phones": [
                    "+81165624045"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "北海道中川郡美深町仁宇布２１５",
                        "locality": "中川郡美深町",
                        "postcode": null,
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1561523944156563",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "チーズ工房羊飼い",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f38695838ce1b30321c2cc85a8c281",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.9735194,
                    36.8220877
                ]
            },
            "properties": {
                "categories": {
                    "primary": "winery",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/336668317100573"
                ],
                "phones": [
                    "+393920483517"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Contrada, Via Kaddiuggia",
                        "locality": null,
                        "postcode": "91017",
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "336668317100573",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Solidea Azienda Agricola",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa810c74553b0d033cdba63bb5251b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.44206,
                    -24.00685
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.926605504587156,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106955100916760"
                ],
                "phones": [
                    "+5513992042074"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Olga Coli, 318",
                        "locality": "Praia Grande",
                        "postcode": "11721-280",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106955100916760",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CredPlenium Soluções Financeira",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415c74d27351b03f2ecfbc243fe48",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.88557,
                    21.72462
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/122097284864007097"
                ],
                "phones": [
                    "+84869772462"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Baez Ashlee Brady",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "72462 Hoàng mai",
                        "locality": "Hanoi",
                        "postcode": "100000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "122097284864007097",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mallon Tommy Tanner",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c164cd7454b03e9532e833ef3ed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.9870071,
                    34.1225731
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "wedding_planning"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://1123eventsdesigns.wixsite.com/my-site-3"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107565744885112"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Buford",
                        "postcode": null,
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107565744885112",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "1123 LLC.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28f0005a9a56a039dd6c8953aa4b2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.70108,
                    45.53567
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chiropractor",
                    "alternate": [
                        "spas",
                        "family_practice"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.portlandbacksmith.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/248068228691192"
                ],
                "phones": [
                    "+15037166164"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2403 NW Thurman St",
                        "locality": "Portland",
                        "postcode": "97210-2522",
                        "region": "OR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "248068228691192",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Portland Backsmith Chiropractic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ed567960c003993679a6cf386c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.99862,
                    14.671271
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "public_and_government_association",
                        "school"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.life.net.ph"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/263993014060916"
                ],
                "phones": [
                    "+1023610328"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "De La Salle Araneta University Compound, Victoneta Avenue",
                        "locality": null,
                        "postcode": "1470",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "263993014060916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lasallian Institute for the Environment",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f608b92627131603e540118fcf4f35",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.1193706,
                    18.4370463
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_developer",
                    "alternate": [
                        "real_estate_service"
                    ]
                },
                "confidence": 0.9084967320261438,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108121292274883"
                ],
                "phones": [
                    "+919561161171"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "roha raigad",
                        "locality": "Roha",
                        "postcode": "402109",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108121292274883",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shreeyog Builders & Developers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a8912a0ab6d03c106cdd80fb4ac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.7708429,
                    27.2154297
                ]
            },
            "properties": {
                "categories": {
                    "primary": "agriculture",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/502043616638263"
                ],
                "phones": [
                    "+18637634928"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5550 SE 30th Pkwy",
                        "locality": "Okeechobee",
                        "postcode": "34974-1143",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "502043616638263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wayne Douglas Cattle Co",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c465476568e03ed66c5fcd1e70a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.3214471,
                    32.2588433
                ]
            },
            "properties": {
                "categories": {
                    "primary": "used_car_dealer",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://tricountymotorsonline.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4787837508"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3646 Antioch Church Rd",
                        "locality": "Eastman",
                        "postcode": "31023",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324838623885",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tri County Motors",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf321ad5b68403e18a927be87ee4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.3664454,
                    22.7046546
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bangladeshi_restaurant",
                    "alternate": [
                        "restaurant",
                        "chicken_restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1198739580182204"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bogra Road",
                        "locality": "Barisal",
                        "postcode": "8200",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1198739580182204",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Najem Restora",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1faeaeea61ae903cd76c0910afeef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.8603841,
                    50.1316511
                ]
            },
            "properties": {
                "categories": {
                    "primary": "door_sales_service",
                    "alternate": [
                        "business_to_business"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.teckentrup.biz/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "052465040"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Robert-Bosch-Str. 19",
                        "locality": "Maintal",
                        "postcode": "63477",
                        "region": "Hessen",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949955367956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Teckentrup GmbH & Co. KG",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da1a938d041b039b9683f00c2f18",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.3771311,
                    28.6252995
                ]
            },
            "properties": {
                "categories": {
                    "primary": "secretarial_services",
                    "alternate": [
                        "court_reporter",
                        "consultant_and_general_service"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.govanator.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01204182969"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "H-157, Ground Floor, Sector 63",
                        "locality": "Noida",
                        "postcode": "201301",
                        "region": "Uttar Pradesh",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932442244",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vanator Technology Private Limited",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6618361d2181803dddc342e1abab3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.61006,
                    6.24588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "patio_covers",
                    "alternate": [
                        "construction_services"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.puertasautomaticasdariorendon.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/134135503124344"
                ],
                "phones": [
                    "+573113098187"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carrera 86A 35C",
                        "locality": "Medellín",
                        "postcode": "050032",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "134135503124344",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Puertas eléctricas y automáticas ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cc6898ba3346036abbb10e273c57",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.8532643,
                    23.2919485
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.sjiblbd.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/127343545732563"
                ],
                "phones": [
                    "+8801755556164"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hajigonj east bazar,Maa mansion-1st floor,Hajigonj,Chandpur.",
                        "locality": "Chandpur",
                        "postcode": "3610",
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "127343545732563",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Shahjalal Islami Bank PLC,Hajigonj Branch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f481b49d24c06c03616a7f25c97e20",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -106.1239864,
                    28.7248099
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gym",
                    "alternate": [
                        "sports_club_and_league",
                        "sports_and_recreation_venue"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/564873713582618"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "F. Dostoyevski",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "564873713582618",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ROCCO GYM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3e4139e9028040355e7f7c2635b69",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    33.8232699,
                    27.1979885
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "chicken_restaurant",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "https://instagram.com/chipaza.eg"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101726371309161"
                ],
                "phones": [
                    "+201010515125"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kawther , Metro St , Next to El Masry Hospital",
                        "locality": "Hurghada",
                        "postcode": null,
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101726371309161",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chipaza",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275b3011284ee0302d8b82b09eabc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.4783,
                    41.8761
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "retirement_home"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/143911395624765"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dixon",
                        "postcode": null,
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "143911395624765",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mabley Developmental Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9b7b195a0d10316780ee5c97292",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.84764,
                    43.23209
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_entertainment",
                    "alternate": [
                        "music_production",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/990284511027012"
                ],
                "phones": [
                    "+19057483413"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "534 Upper Sherman Ave",
                        "locality": "Hamilton",
                        "postcode": "L8V 3M1",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "990284511027012",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Venue Rebic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb045e02548403b5f970895b6b75",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.743567,
                    47.997082
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_cleaning",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.bpms-nettoyage.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107611955397017"
                ],
                "phones": [
                    "+33618910167"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107611955397017",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BPMS Nettoyage",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d741091ac01403f0e291a3d1b824",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.585846,
                    13.976802
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/179479488578105"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Santa Ana",
                        "postcode": null,
                        "region": null,
                        "country": "SV"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "179479488578105",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gloss beauty",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f264c751d158a6036eb7a9dad877b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.8914657,
                    36.4791356
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "motel",
                        "accommodation"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://doverinnmotel.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1472201363041827"
                ],
                "phones": [
                    "+19312325556"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1545 Donelson Pkwy",
                        "locality": "Dover",
                        "postcode": "37058-3726",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1472201363041827",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799813754574",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863153784",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dover Inn Motel & Cabins",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26ee2c905458003d8323e87b4e0f5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.8554152,
                    36.0995058
                ]
            },
            "properties": {
                "categories": {
                    "primary": "life_insurance",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9188779099"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10820 E 45th St Ste 306",
                        "locality": "Tulsa",
                        "postcode": "74146",
                        "region": "OK",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799813879445",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trotter Insurance",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa10368dc18103f5b03d2b65fe0f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.1940064,
                    50.674216
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2461133220618075"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hauptstraße 400",
                        "locality": null,
                        "postcode": "Königswinter",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2461133220618075",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "lucasbrand_photography",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d1d09e9a5b2303132d03a6daeb68",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.3964656,
                    40.7475309
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "bakery"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/765666646923683"
                ],
                "phones": [
                    "+905336046354"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "korgan  caddesi alankent  mahallesi kabataş  ordu",
                        "locality": "Elbeyli",
                        "postcode": "52510",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "765666646923683",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alankent Endelek Uğur Pastanesi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195dd9b794d7203ae54d9722fb3d6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.3916796,
                    52.2439185
                ]
            },
            "properties": {
                "categories": {
                    "primary": "kids_recreation_and_party",
                    "alternate": [
                        "amusement_park"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08009709130"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unit 2, Warwick House Business P, Banbury Road",
                        "locality": "Southam",
                        "postcode": "CV47 2PT",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908729073",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "walkhigh.co.uk - Climb Boulder Walk & Scramble",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6741242d4a19c03c6ad5bce8ba781",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -66.8544803,
                    10.4893716
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_entertainment",
                    "alternate": [
                        "bookstore"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/291765554996546"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sambil",
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "VE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "291765554996546",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tecniciencias",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2f15663aa9a60384e770d7d8baf3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -56.147993,
                    -34.879099
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://instagram.com/ilmondounion?igshid=ymmymta2m2y%3d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105578942496651"
                ],
                "phones": [
                    "+59825069538"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida 8 de Octubre 3401",
                        "locality": "Montevideo",
                        "postcode": "11400",
                        "region": null,
                        "country": "UY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105578942496651",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ilmondounion",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1943585a582aa03fb31af3d8473ad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.0912535,
                    52.9561264
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": [
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/149364668965720"
                ],
                "phones": [
                    "+441159400571"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "227 Vale Road",
                        "locality": "Nottingham",
                        "postcode": "NG4 2GP",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "149364668965720",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Colwick Parish Council",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f184b542664b2503e726cbe4b693ce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.9409338,
                    43.2587161
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.agurpiojos.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2020816198176513"
                ],
                "phones": [
                    "+34688874514"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pérez Galdós kalea, 3",
                        "locality": "Bilbo",
                        "postcode": "48010",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2020816198176513",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799818848136",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Agur Piojos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a565abb2388039cd48324f600c8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.3931975,
                    33.9190267
                ]
            },
            "properties": {
                "categories": {
                    "primary": "legal_services",
                    "alternate": [
                        "lawyer",
                        "professional_services"
                    ]
                },
                "confidence": 0.9835557673975215,
                "websites": [
                    "http://www.donahuehorrow.com/contact"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/400755956646637"
                ],
                "phones": [
                    "+13103220300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1960 E Grand Ave",
                        "locality": "El Segundo",
                        "postcode": "90245-5000",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "400755956646637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324837171289",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863478338",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Donahue & Horrow LLP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1969c53d766580347a32ca9e3a3ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    5.2412337,
                    52.3644981
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "tanning_salon"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.schoonheidssalonelegance.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/894269514032105"
                ],
                "phones": [
                    "+31365376147"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Adrienne Solserstraat 83",
                        "locality": "Almere-Stad",
                        "postcode": "1325 PJ",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "894269514032105",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Schoonheidssalon Elegance",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195186086b8eb037c73b8c8e0b2dd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.4761203,
                    53.7036841
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "convenience_store",
                        "grocery_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/156817237526027"
                ],
                "phones": [
                    "+441254702925"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "55 Blackburn Road",
                        "locality": "Darwen",
                        "postcode": "BB3 1EJ",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "156817237526027",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sidco Newsagent & Convenience Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f42531cdea1303cc3e067a8d2674",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.98276,
                    53.83267
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1586346858271572"
                ],
                "phones": [
                    "+48793543333"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ulica Wypusty 9B",
                        "locality": "Augustów",
                        "postcode": "16-300",
                        "region": "20",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1586346858271572",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Myjnia samoobsługowa Wash Karcher",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c1201c29ec1a03b96ecac6d73ed3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    84.01665,
                    24.95434
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": [
                        "hotel"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/336818510066882"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "G. T. Road",
                        "locality": "Sasaram",
                        "postcode": "821115",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "336818510066882",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hotel Vijay-Sasaram",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fda95cb083619d03cfcbab548ddbc1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    172.2242266,
                    -43.2563981
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.thegreenhouseco.co.nz/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0274414010"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "875 German Rd",
                        "locality": "Starvation Hill",
                        "postcode": "7495",
                        "region": null,
                        "country": "NZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799821359745",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Greenhouse Co",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e9a24b596d40030531c506352e54",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.0156284,
                    38.0331269
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_goods_store",
                    "alternate": [
                        "souvenir_shop",
                        "newspaper_and_magazines_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.lagabbianellacefalu.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104008737850373"
                ],
                "phones": [
                    "+390921420895"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Roma, 126",
                        "locality": "Cefalù",
                        "postcode": "90015",
                        "region": "82",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104008737850373",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Totosystem per La Gabbianella Cefalù",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa862b5a908003cb869e177abeeb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.87591,
                    38.655841
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": [
                        "currency_exchange"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.bitcoinofamerica.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103725932127066"
                ],
                "phones": [
                    "+18885025003"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Bitcoin of America",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "2030 Crain Hwy",
                        "locality": "Waldorf",
                        "postcode": "20601-3147",
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103725932127066",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bitcoin of America ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2836af021da96039d9f4819ff7623",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.4375242,
                    37.739282
                ]
            },
            "properties": {
                "categories": {
                    "primary": "laundromat",
                    "alternate": [
                        "dry_cleaning",
                        "shopping"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.cleanlaundry.biz/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108339004337335"
                ],
                "phones": [
                    "+12093279686"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "824 W 11th St",
                        "locality": "Tracy",
                        "postcode": "95376-3715",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108339004337335",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "11th Street Laundromat",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f441abb001e4d003eb89f6be283c54",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.709433,
                    28.0612499
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tutoring_center",
                    "alternate": [
                        "school",
                        "specialty_school"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.mathnasium.com/palmharbor"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1881070212207656"
                ],
                "phones": [
                    "+17277719089"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "318 E Lake Rd",
                        "locality": "Palm Harbor",
                        "postcode": "34685",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1881070212207656",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949964726201",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911809553",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mathnasium",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f481b486a3633003ed757a10223a7a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -106.1039318,
                    28.6513967
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shoe_store",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2420477284844158"
                ],
                "phones": [
                    "+526143522526"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Chihuahua",
                        "locality": "Chihuahua",
                        "postcode": "31107",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2420477284844158",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Morena Mía",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19720cbb8c20303113841d2a38c2a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.1720653,
                    55.972959
                ]
            },
            "properties": {
                "categories": {
                    "primary": "skin_care",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://theskinstudio.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1083148355143042"
                ],
                "phones": [
                    "+447733322824"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "121 Giles Street",
                        "locality": "Edinburgh",
                        "postcode": "EH6 6BZ",
                        "region": "SCT",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1083148355143042",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Skin Studio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90e09d82e85e03eede7b9194e52b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -50.8729458,
                    -29.3789053
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "shopping",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.lupo.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1704051939868513"
                ],
                "phones": [
                    "+555432865963"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Praça Major Nicoletti, 33, loja 8, Centro",
                        "locality": "Gramado",
                        "postcode": "95670000",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1704051939868513",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Franquia Lupo Praça Major Nicoletti",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aaec1bcd4a0b0323c5e195cfa7f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.56903,
                    40.1332
                ]
            },
            "properties": {
                "categories": {
                    "primary": "interior_design",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101375241472700"
                ],
                "phones": [
                    "+17173316989"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Newburg Rd, Newburg, PA 17240, United States",
                        "locality": "Lurgan",
                        "postcode": "17240",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101375241472700",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Designs by Sarah",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66c40314067ab03f2e8db4e24f5de",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.45406,
                    2.58506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "professional_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1752556601449752"
                ],
                "phones": [
                    "+573209407348"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "C 3# D2-17 B. La Floresta",
                        "locality": "Algeciras",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1752556601449752",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Burger Salome",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19464f5b5dd2d03d96767b31cb54d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.5573999,
                    54.52739
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": [
                        "community_services_non_profits",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/293586177656994"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Darlington",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "293586177656994",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Darlington Folk Workshop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e5dc8da9333503485d1885b525fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.7430935,
                    46.4848604
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wedding_planning",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "http://www.im-photo.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1681541242092896"
                ],
                "phones": [
                    "+380932293063"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Odessa",
                        "postcode": null,
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1681541242092896",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Фотограф Ирина Мошняцкая Одесса",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62d0ad868f403adc17102a00ffe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.05107,
                    -11.91478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_entertainment",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1231282080351990"
                ],
                "phones": [
                    "+51992270637"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "051",
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1231282080351990",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chikimias Eventos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4249cad476a9e03f63942342fa6fa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    74.761015,
                    30.67461
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dental_supply_store",
                    "alternate": [
                        "medical_supply",
                        "perfume_store"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.federalbank.co.in/?utm_source=gmb&utm_medium=organic&utm_campaign=sulekhapromanage_federal_bank"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    ""
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Gill Complex, Circular Road, Near Bus Stand",
                        "locality": "Faridkot",
                        "postcode": "151203",
                        "region": "Punjab",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324842224082",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324842175638",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Federal Bank ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62c08c0932803b45a29115a6fac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.04058,
                    -12.0752946
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/747522168955171"
                ],
                "phones": [
                    "+51945979588"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Cuba 499",
                        "locality": "Jesús María",
                        "postcode": "15072",
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "747522168955171",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lady's estilistas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa811662c72cc503dd9745ffad2c51",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.64717,
                    -22.72682
                ]
            },
            "properties": {
                "categories": {
                    "primary": "financial_service",
                    "alternate": [
                        "shopping"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.bvfinanceira.com.br/site/bvf/conheca_bv_financeira/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2205661339689142"
                ],
                "phones": [
                    "+558007728028"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "BV",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Rua Benjamin Constant, 1033",
                        "locality": "Piracicaba",
                        "postcode": "13400-050",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2205661339689142",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BV",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1edcd227492f303d266f74c8d2b25",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.96047,
                    40.59375
                ]
            },
            "properties": {
                "categories": {
                    "primary": "occupational_therapy",
                    "alternate": [
                        "psychologist",
                        "speech_therapist"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109864734084057"
                ],
                "phones": [
                    "+306947639851"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Καθηγ. Κασσανδρέως Νικ. 8",
                        "locality": "Θεσσαλονίκη",
                        "postcode": "542 48",
                        "region": "B",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109864734084057",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Λογοθεραπεία & Ειδικές Θεραπείες - Κατερίνα Κουτσιμανή",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8107306e8364030a8493509bead4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.43364,
                    -23.52545
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "shopping"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.casanobremarmoraria.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1486333444984917"
                ],
                "phones": [
                    "+551128610528"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Damásio Pinto, 1284",
                        "locality": "São Paulo",
                        "postcode": "08247-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1486333444984917",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Casa Nobre Marmoraria",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec911ea9cd9d036039663c555fde",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.88828,
                    41.02659
                ]
            },
            "properties": {
                "categories": {
                    "primary": "atms",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.ziraatbank.com.tr/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08502200000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Gençosman Mahallesi Ytü-Davutpaşa Kampüsü",
                        "locality": "İstanbul",
                        "postcode": "34165",
                        "region": "İstanbul",
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374889569540",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ziraat Bankası ATM",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64821b468a8a203e2d394251ad91d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.984279,
                    18.9559584
                ]
            },
            "properties": {
                "categories": {
                    "primary": "vegetarian_restaurant",
                    "alternate": [
                        "delicatessen",
                        "thai_restaurant"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/177948105738657"
                ],
                "phones": [
                    "+66961015783"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "220 Tambon Mae Faek Mai, San Sai District, Chiang Mai 50290",
                        "locality": "Chiang Mai",
                        "postcode": "50290",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "177948105738657",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ปังญ่า",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f27580a9d169090378230d6f12b819",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.5320896,
                    43.0761398
                ]
            },
            "properties": {
                "categories": {
                    "primary": "divorce_and_family_law",
                    "alternate": [
                        "lawyer"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://kwvfamilylaw.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/403485853106866"
                ],
                "phones": [
                    "+16087095000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "725 Heartland Trl",
                        "locality": "Madison",
                        "postcode": "53717-1966",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "403485853106866",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474980700953",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kowalski, Wilson & Vang, LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f5106d10e85a03f3833792bf7e62",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.09176,
                    53.15055
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.salon-gabriela.pl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/319936561713611"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "gabrielaol1@wp.pl",
                        "locality": "Białystok",
                        "postcode": "15-774",
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "319936561713611",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Salon Gabriela",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e6038849d19503926f54f8b2c840",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.5859375,
                    -12.2111802
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://bit.ly/alfredohbl"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/713943405620940"
                ],
                "phones": [
                    "+51951533870"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "713943405620940",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Herbalife Distribuidor Independiente Alfredo Tovar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e71b6b8dadb3035ff431a2cb3996",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    136.8976512,
                    36.5178511
                ]
            },
            "properties": {
                "categories": {
                    "primary": "supermarket",
                    "alternate": [
                        "grocery_store",
                        "superstore"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://jalife-toyama.acoop.jp/shop/list/shop_7.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/163114967096442"
                ],
                "phones": [
                    "+81763628811"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "富山県南砺市野田５２",
                        "locality": "南砺市",
                        "postcode": "939-1842",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "163114967096442",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Aコープなんとセフレ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6945a70c6601103edec034c6fedc2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.33115,
                    16.49919
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101641335655981"
                ],
                "phones": [
                    "+639175930388"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "14 Mabini St., Central West, Bauang, La Union",
                        "locality": "Bauang",
                        "postcode": "2501",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101641335655981",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Distritto Coffee",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a92f378e70e031032a3fb557cc9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.218953,
                    37.066322
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mountain",
                    "alternate": null
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "http://en.wikipedia.org/wiki/california_state_highway_152"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/135671813133092"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "95023",
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "135671813133092",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pacheco Pass At San Luis Reservoir",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44d9803d89d29032ac61901a5d9af",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.554109,
                    35.625817
                ]
            },
            "properties": {
                "categories": {
                    "primary": "commercial_real_estate",
                    "alternate": [
                        "real_estate_agent",
                        "real_estate_service"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://ashevillerealtygroup.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8282521916"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "788 Merrimon Ave",
                        "locality": "Asheville",
                        "postcode": "28804",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849864403733",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Asheville Realty Group",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3e62870a400b503b0234720fc8e93",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.33154,
                    30.15474
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114442316645873"
                ],
                "phones": [
                    "+201147005184"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "تقسيم عمرو بن العاص امام مدرسه عمر بن الخطاب فيصل ",
                        "locality": "Cairo",
                        "postcode": null,
                        "region": null,
                        "country": "EG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114442316645873",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "R&Z",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa87518a9a0822038c5b6da9296c6e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -55.7222848,
                    -22.5337058
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pet_store",
                    "alternate": [
                        "pet_services",
                        "veterinarian"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/154197231404513"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Tiradentes, 998",
                        "locality": "Ponta Porã",
                        "postcode": "79904-504",
                        "region": "MS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "154197231404513",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "É o bicho Pet Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3da10629717a1033b4203904c4dd5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.32,
                    28.57
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychic",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102696457835773"
                ],
                "phones": [
                    "+919910160959"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "sunshine appartment sector 99",
                        "locality": "Noida",
                        "postcode": "201301",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102696457835773",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "योगाचार्य हरिओम शास्त्री",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c1ab4d10d5230332588d8a47b3b7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    87.58164,
                    25.5402
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "office_equipment",
                        "mobile_phone_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1192629144168568"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Katihar",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1192629144168568",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Aman Mobile",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1079d112b5103dd106bc4641433",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.3289767,
                    40.679656
                ]
            },
            "properties": {
                "categories": {
                    "primary": "divorce_and_family_law",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.keithfamilylaw.com/heather-c-keith-esq"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "9082939813"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "50 Cardinal Dr Ste 203",
                        "locality": "Westfield",
                        "postcode": "07090",
                        "region": "NJ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374890172166",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Heather C. Keith, Esq.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bd43a31931037d95a6915dc4a3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.2765552,
                    43.7486607
                ]
            },
            "properties": {
                "categories": {
                    "primary": "walk_in_clinic",
                    "alternate": [
                        "medical_center",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.jchealth.ca/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6136011136"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2251 Lawrence Ave E, Unit 102",
                        "locality": "Scarborough",
                        "postcode": "M1P2P5",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899910149740",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "JC Health Toronto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f687167154ab400342be4709e4532f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    123.1194957,
                    9.5912193
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": [
                        "delicatessen",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/137785076432697"
                ],
                "phones": [
                    "+63354022217"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Juan Luna Street",
                        "locality": null,
                        "postcode": "6206",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "137785076432697",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Tienda Lokal",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f499da8431c45503530dd281e069b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -100.972496,
                    22.14016
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "naturopathic_holistic"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104217091339812"
                ],
                "phones": [
                    "+524448567363"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "San Luis Potosí",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104217091339812",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Knbi'S",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f12c9056c32d4d0363fadcb6f7d479",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.963789,
                    48.99938
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.827925925925926,
                "websites": [
                    "http://www.outofthefirestudio.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4034928100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "214 1 Avenue South",
                        "locality": "Coutts",
                        "postcode": "T0K 0N0",
                        "region": "AB",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424934701619",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "110638344002",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Out of the Fire Studio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe089362b1b6b03599706147b7d6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    150.8683016,
                    -34.5771775
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/209990562361192"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Shellharbour",
                        "postcode": null,
                        "region": "NSW",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "209990562361192",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Village",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba2a10aaa4810321d52fa205a4f6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.9562111,
                    23.9782537
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mobile_phone_store",
                    "alternate": [
                        "school"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/358013084273616"
                ],
                "phones": [
                    "+886979657087"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Puli",
                        "postcode": null,
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "358013084273616",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "有間工作室",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e75182829203778fd9791e1323",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.4302772,
                    51.6135736
                ]
            },
            "properties": {
                "categories": {
                    "primary": "currency_exchange",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.postoffice.co.uk/travel-money?campaignid=gmb~tm~nil~bing~ac~06022023~bing_address_verification"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "01277626498"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10 Grange Road",
                        "locality": "Billericay",
                        "postcode": "CM11 2RB",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949963929252",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Post Office Travel Money",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb5553411e031bc825757778bb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.92755,
                    21.04034
                ]
            },
            "properties": {
                "categories": {
                    "primary": "passport_and_visa_services",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://bestvisa24h.com.vn/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/225124224028637"
                ],
                "phones": [
                    "+84988416193"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Chung cư ecohome-Phúc Lợi-Long Biên",
                        "locality": "Hanoi",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "225124224028637",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Best Visa - Dịch vụ tư vấn Visa toàn cầu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a4722bae7a403a4c9e5a38d5e45",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.0761904,
                    33.0249645
                ]
            },
            "properties": {
                "categories": {
                    "primary": "internal_medicine",
                    "alternate": [
                        "doctor",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://healthy.kaiserpermanente.org/southern-california/physicians/tracy-santos-1842249"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8335742273"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "17140 Bernardo Center Dr",
                        "locality": "San Diego",
                        "postcode": "92128",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374885146643",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tracy Fullenwider Santos, DO | Kaiser Permanente",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6435b8044aa4b03128c84f31be3fd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.89573,
                    8.19568
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104516152433430"
                ],
                "phones": [
                    "+66636797529"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "84 ม.7 ต.ทับปริก อ.เมือง",
                        "locality": "Krabi",
                        "postcode": "81000",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104516152433430",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ผักกางมุ้งป้าวันดี",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f130e8ed74615103f290c7ea3f6427",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -119.8222107,
                    65.4443091
                ]
            },
            "properties": {
                "categories": {
                    "primary": "men's_clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108202658594608"
                ],
                "phones": [
                    "+13133266957"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 41A Sur 12G-54",
                        "locality": "Bogotá, D.C.",
                        "postcode": "111821",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108202658594608",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Divinas a la moda",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694ecf571d861031c87c1c4709850",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.05965,
                    14.49148
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_advertising",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/309315976409793"
                ],
                "phones": [
                    "+639273048356"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "C6 Road, Barangay Calzada, Lower Bicutan",
                        "locality": "Taguig",
                        "postcode": "1632",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "309315976409793",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trees A Life",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f7a6e7849aeb0e03e7629144c30038",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    36.63947,
                    -1.10794
                ]
            },
            "properties": {
                "categories": {
                    "primary": "holiday_rental_home",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109104070842874"
                ],
                "phones": [
                    "+254790649073"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Limuru",
                        "postcode": null,
                        "region": null,
                        "country": "KE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109104070842874",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flats and apartments",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f660e3aeb4256e034f3e7f01b97567",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.855728,
                    7.063916
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "shopping",
                        "event_photography"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/861826317229478"
                ],
                "phones": [
                    "+573108517139"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 59 21-55",
                        "locality": "Barrancabermeja",
                        "postcode": "687031",
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "861826317229478",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Foto Española Digital",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a94d232c5d040327edbf5560efc1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.53558,
                    41.65155
                ]
            },
            "properties": {
                "categories": {
                    "primary": "media_news_company",
                    "alternate": [
                        "mass_media"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://www.tdoadvertising.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/228120677938438"
                ],
                "phones": [
                    "+14197247643"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "405 Madison Ave",
                        "locality": "Toledo",
                        "postcode": "43604-1203",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "228120677938438",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932347029",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474980040015",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "TDO Advertising",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90175b00d86903ffa49af9c6b640",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -51.0269637,
                    -30.0838079
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1273412022674440"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Marechal Deodoro, 137",
                        "locality": "Viamão",
                        "postcode": "94410-020",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1273412022674440",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centro Profissional Marechal Deodoro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f696ac34951a1403a6ad1437985e6e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.5768315,
                    16.449976
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/253666614497216"
                ],
                "phones": [
                    "+639947213246"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Dreamland subdivision ",
                        "locality": "Baguio City",
                        "postcode": "2600",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "253666614497216",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "WB Ollshop ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f11401804a950334d62edc75f8f5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.990303,
                    52.41276
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hair_salon",
                    "alternate": [
                        "beauty_and_spa"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://sellwerk.de/firmenprofil/hair66"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "051369727273"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Dorfstr. 53",
                        "locality": "Lehrte",
                        "postcode": "31275",
                        "region": "Lower Saxony",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949961109060",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tanja Windrich Hair 66",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28341a2a532c9032df351f54c572e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.96955,
                    36.986539
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8314253622"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2825 S Rodeo Gulch Rd Ste 10",
                        "locality": "Soquel",
                        "postcode": "95073",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976976570",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Walls Painting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba297174c3410311992dc549e99c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.591057,
                    24.182555
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_stand",
                    "alternate": [
                        "breakfast_and_brunch_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1394380800789470"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "臺灣大道五段3巷50號",
                        "locality": "台中市",
                        "postcode": "434",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1394380800789470",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "東海無名早餐",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c122856b05603e1310fbf3003a0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.3481428,
                    34.0337264
                ]
            },
            "properties": {
                "categories": {
                    "primary": "car_dealer",
                    "alternate": [
                        "automotive",
                        "automotive_consultant"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.autolantaga1.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/179359902224344"
                ],
                "phones": [
                    "+16785850101"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10467 Alpharetta St",
                        "locality": "Roswell",
                        "postcode": "30075-3747",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "179359902224344",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Autolanta Collection",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f80104eac8e1210393858f03e89c7d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -38.52862,
                    -3.75072
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102370877974013"
                ],
                "phones": [
                    "+5585999189694"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Padre Leopoldo Fernandes, 55b",
                        "locality": "Fortaleza",
                        "postcode": "60411-180",
                        "region": "CE",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102370877974013",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "thalytapatriciopsi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44a12362f3a2a031e4411925e1df8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.2344578,
                    26.2077872
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "restaurant",
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://locations.papajohns.com/united-states/fl/33068/north-lauderdale/8016-w-mcnab-rd?utm_source=facebook-store-pages&utm_medium=referral&y_source=1_mta2otm2mzetntu5lwxvy2f0aw9ulndlynnpdgu%3d"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/145888622140820"
                ],
                "phones": [
                    "+19547267272"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Papa John's Pizza",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "8016 W McNab Rd",
                        "locality": "North Lauderdale",
                        "postcode": "33068-4226",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "145888622140820",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958580582",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899906898928",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Papa John's Pizza",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f41436b18024d80351253d62bc171c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7635355,
                    20.9587345
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "japanese_restaurant",
                        "employment_law"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://xkldvietnhat.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108751271275100"
                ],
                "phones": [
                    "+84896445444"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Số 3 - LK26 KĐT Văn Phú, Phú La, Hà Đông",
                        "locality": "Hà Đông",
                        "postcode": "10000",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108751271275100",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Đơn Hàng Thực Phẩm Đi Nhật",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d3188c71e61c03bc3caa28a070b6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    31.60833,
                    40.734963
                ]
            },
            "properties": {
                "categories": {
                    "primary": "supermarket",
                    "alternate": [
                        "health_food_store",
                        "grocery_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/333165180799628"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "333165180799628",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gülaylar Manav Sebze Meyve Limited Şti.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6518764422ae203345bdd43103271",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.4558979,
                    7.0011744
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/626339867463360"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hat Yai",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "626339867463360",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "พระราชวังตากอากาศหาดใหญ่ใน",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f488b223a0d44603bcfa6b76a4e946",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -102.1071339,
                    31.9846122
                ]
            },
            "properties": {
                "categories": {
                    "primary": "skin_care",
                    "alternate": [
                        "beauty_and_spa",
                        "waxing"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.bloomingskinstudio.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105597841161452"
                ],
                "phones": [
                    "+14327560235"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3201 W Wall St",
                        "locality": "Midland",
                        "postcode": "79701-6759",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105597841161452",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blooming Skin Studio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f266c76d8c10f203f919c5c3c69bf1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.8255456,
                    38.7412198
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "used_car_dealer"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://www.rhondasrv.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/868788499846601"
                ],
                "phones": [
                    "+18127942222"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1251 IN-256",
                        "locality": "Austin",
                        "postcode": "47102-8902",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "868788499846601",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rhonda's RV/Auto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f61026e91436410395f59320c85732",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.3901574,
                    6.9992948
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "restaurant"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.ebonyresort.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105855011643918"
                ],
                "phones": [
                    "+94362287800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "D13 bibilioya ,kithulgala",
                        "locality": null,
                        "postcode": "71720",
                        "region": null,
                        "country": "LK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105855011643918",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "EBONY Kitulgala Riverside Resort",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2759ce82a627203f376fdd91fa2fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.5753822,
                    42.551272
                ]
            },
            "properties": {
                "categories": {
                    "primary": "agriculture",
                    "alternate": [
                        "agricultural_cooperatives"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/336342417110511"
                ],
                "phones": [
                    "+8801615900600"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Fremont, California 94539",
                        "locality": "Fremont",
                        "postcode": "94539",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "336342417110511",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Comics Club",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26c9d9c2cb7ab03e66436abcc6f21",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -96.1521658,
                    33.0643648
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "construction_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "https://smithqualitybuildings.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103924589948232"
                ],
                "phones": [
                    "+19032681694"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1771 Frontage Rd",
                        "locality": "Greenville",
                        "postcode": "75402-4663",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103924589948232",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Smith Quality Buildings",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f586d3811b8003a0397a00732ff6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.5377096,
                    35.3314512
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store",
                        "screen_printing_t_shirt_printing"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114126566702762"
                ],
                "phones": [
                    "+81467405660"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "神奈川県鎌倉市梶原３丁目３２−４",
                        "locality": "鎌倉市",
                        "postcode": "247-0063",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114126566702762",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "トム",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c21c9e472cae0365d7e7b0e4ae5d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    41.6336509,
                    41.6451842
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": [
                    "http://vanillacake.ge/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105673857847321"
                ],
                "phones": [
                    "+995555203918"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "26 მაისის ქუჩა 50",
                        "locality": "ბათუმი",
                        "postcode": null,
                        "region": null,
                        "country": "GE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105673857847321",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vanilla Cake• ვანილა ქეიქ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48a204ab1ea9b03e73ca07634df1d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -100.39184,
                    25.7810791
                ]
            },
            "properties": {
                "categories": {
                    "primary": "swimwear_store",
                    "alternate": null
                },
                "confidence": 0.9456869009584664,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/225957630600261"
                ],
                "phones": [
                    "+528134007770"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Pasto Verde 148",
                        "locality": "Monterrey",
                        "postcode": "64102",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "225957630600261",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Coco Bikini Monterrey ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65846a8d9a3950333f1143f508bdb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.9166977,
                    11.5556484
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103192595751957"
                ],
                "phones": [
                    "+85512845858"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Gas Toansamay - Modern Gas",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "មហាវិថី ព្រះសីហនុ 244",
                        "locality": "ភ្នំពេញ",
                        "postcode": "120103",
                        "region": null,
                        "country": "KH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103192595751957",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gas Toansamay - Modern Gas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b98c204e2aeb03ed050c85ec0273",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.8109784,
                    44.7903557
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "hotel",
                        "bookstore"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/149375369042546"
                ],
                "phones": [
                    "+17054548298"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1164 Moore Lake Estates Rd",
                        "locality": "Minden Hills",
                        "postcode": "K0M 2L1",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "149375369042546",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Noble Motel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f298c48c06e5034fa67f6cce3553",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.72345,
                    37.63111
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.vellinis.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/332136013497058"
                ],
                "phones": [
                    "+302751020401"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "KARIAS 1",
                        "locality": "�?rgos",
                        "postcode": "21200",
                        "region": null,
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "332136013497058",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Elastika Vellinis GP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6515335ae6862037868e992f4fc12",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.130994,
                    5.321702
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_dealer",
                    "alternate": [
                        "automotive_parts_and_accessories"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/272766290047758"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lot 1942",
                        "locality": null,
                        "postcode": "21000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "272766290047758",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "GS Multi Sdn. Bhd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1084528c2b203b03caf5e5b0388",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.8127886,
                    52.9057699
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "transportation",
                        "taxi_service"
                    ]
                },
                "confidence": 0.9588815789473685,
                "websites": [
                    "http://www.syker-fahrdienst.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1875931002533334"
                ],
                "phones": [
                    "+4942424487"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Clara-Schumann-Straße 14",
                        "locality": "Syke",
                        "postcode": "28857",
                        "region": "NI",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1875931002533334",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Syker Fahrdienst",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6585992a8978d03ac6dd0e914dad9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.3150568,
                    10.4800262
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": [
                        "desserts",
                        "cafe"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/295250553989034"
                ],
                "phones": [
                    "+855972607472"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "road 33a",
                        "locality": "Kep",
                        "postcode": "22101",
                        "region": null,
                        "country": "KH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "295250553989034",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kep Coffee Cafe",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19424c1d726050352f2d4e1d26228",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -2.12846,
                    53.54529
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "sports_club_and_league"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107129294433152"
                ],
                "phones": [
                    "+447802694378"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Oldham",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107129294433152",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Professional Tapeball accesories Uk",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a41ad16ac59037286eac8fd8547",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.1671132,
                    32.7204726
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "event_photography"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "http://ashgabes-photography.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/684270581658287"
                ],
                "phones": [
                    "+16196304474"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "425 W Beech St",
                        "locality": "San Diego",
                        "postcode": "92101-2955",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "684270581658287",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fesogu Photography",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26aa43276142a0394ffa30acd2d26",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.0734581,
                    40.3911428
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "religious_organization",
                        "pentecostal_church"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://www.calvarychurchloveland.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107778127324792"
                ],
                "phones": [
                    "+19709668042"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "201 S Lincoln Ave",
                        "locality": "Loveland",
                        "postcode": "80537-6487",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107778127324792",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474980571325",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Calvary Church",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4143696b540490348bf1d3aa1a52f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.7758516,
                    21.0222533
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_and_medical",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://sieuthisua247.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1386668638237194"
                ],
                "phones": [
                    "+84978054550"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Ngõ 139 Đường Mỹ Đình 11",
                        "locality": "Hà Nội",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1386668638237194",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sữa Bột Pha Sẵn IQ GOLD MILK Trẻ Tăng Cân - Phát triển Chiều Cao, Trí Não",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9146eb9251e031cbc959400e01c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3651034,
                    46.2230239
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.circlek.com/ca/ontario/store-locator/CA/callander/26-main-st-north-unit-5/0800028"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7057523815"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "26 Main St N, Unit 5",
                        "locality": "Callander",
                        "postcode": "P0H 1H0",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949961600357",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Circle K",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a0a640301510374d0debfd15edb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.949268,
                    33.866834
                ]
            },
            "properties": {
                "categories": {
                    "primary": "acupuncture",
                    "alternate": [
                        "naturopathic_holistic",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.dunamisacupuncture.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/183122745053176"
                ],
                "phones": [
                    "+17145780580"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1335 W Valencia Dr",
                        "locality": "Fullerton",
                        "postcode": "92833-4046",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "183122745053176",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dunamis Acupuncture & Herb Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec915a36c4400354d51df8819454",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.1247328,
                    40.9869429
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "hotel",
                        "accommodation"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108541390069456"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Altay Sokak 1",
                        "locality": "Ataşehir",
                        "postcode": "34750",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108541390069456",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Eğitimciler Apartmanı",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f728d6698b4503c522c12161f28e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.9996206,
                    35.5059173
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "landmark_and_historical_building",
                        "bar"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/722585141473135"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "parigoria 120",
                        "locality": "Chaniá",
                        "postcode": null,
                        "region": null,
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "722585141473135",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Παλαιικό Στην Παρηγοριά Χανίων",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274b73691b08403e8139a7ef86041",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.19717,
                    41.66544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "martial_arts_club",
                    "alternate": [
                        "tai_chi_studio",
                        "gym"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://michianataichi.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114128257968770"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3612 Mishawaka Ave",
                        "locality": "South Bend",
                        "postcode": "46615-2426",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114128257968770",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Michiana Tai Chi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f658a78db96040031d3917009dafeb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.36284,
                    13.7478
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "health_and_medical",
                        "shopping"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/233812770087056"
                ],
                "phones": [
                    "+1038551888"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "490 หมู่ 4, ถนนสาย 304",
                        "locality": null,
                        "postcode": "24120",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "233812770087056",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "โรงพยาบาลพนมสารคาม",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26c839a720d010354f3f27ed853d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -96.699528,
                    33.034495
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "oil_change_station",
                        "automotive"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "https://www.aamcoplanotx.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1104656056230908"
                ],
                "phones": [
                    "+19726331590"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "AAMCO",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "2601 K Ave",
                        "locality": "Plano",
                        "postcode": "75074-5305",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1104656056230908",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949966060852",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890156206",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AAMCO",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a331748aa15e03a607508b311a87",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.3455551,
                    41.8853979
                ]
            },
            "properties": {
                "categories": {
                    "primary": "baseball_field",
                    "alternate": [
                        "active_life",
                        "park"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/211780492179856"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "401 Daggett Ave",
                        "locality": "Pawtucket",
                        "postcode": "02861",
                        "region": "RI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "211780492179856",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Daggett Field",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6482989616ab20365004f0151da44",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.00948,
                    18.5805434
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bakery",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.facebook.com/profile.php?id=100088095892094&mibextid=zbwkwl"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100830656211165"
                ],
                "phones": [
                    "+66960025691"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ลำพูน-เชียงใหม่",
                        "locality": "Lamphun",
                        "postcode": "51150",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100830656211165",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Daily Donuts สาขาอำเภอเมืองลำพูน",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe6354cb564b30382dacec3c71ee2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.88992,
                    -37.79133
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "amateur_sports_team",
                        "college_university"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/221190998456686"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "70 Ballarat Rd",
                        "locality": "Melbourne",
                        "postcode": "3011",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "221190998456686",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "VU Outdoor Adventures Club",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3961bb655a434038be89524e3a3dd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.0773003,
                    44.0984055
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "arts_and_crafts"
                    ]
                },
                "confidence": 0.9084967320261438,
                "websites": [
                    "http://oogaya.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/331529200333995"
                ],
                "phones": [
                    "+33695189090"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "39 Rue Droite",
                        "locality": "Millau",
                        "postcode": "12100",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "331529200333995",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Oogaya créations teinture végétale",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3969a0c74438b03eef7c5fabad9db",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.262607,
                    43.710268
                ]
            },
            "properties": {
                "categories": {
                    "primary": "butcher_shop",
                    "alternate": [
                        "shopping",
                        "eat_and_drink"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/204736859601811"
                ],
                "phones": [
                    "+33493526997"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3 Rue Raiberti",
                        "locality": "Nice",
                        "postcode": "06000",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "204736859601811",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Boucherie Bosio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa68ca81425003958c764769b928",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.12787,
                    50.47112
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_utility_company",
                    "alternate": [
                        "hospital",
                        "energy_company"
                    ]
                },
                "confidence": 0.9084967320261438,
                "websites": [
                    "https://www.acdf.be/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1475220939384150"
                ],
                "phones": [
                    "+3264860337"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rue de la Croix-Rouge 15",
                        "locality": "La Louvière",
                        "postcode": "7110",
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1475220939384150",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Au Coin du Feu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c05b92c446034de1de0628fe33",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.904597,
                    52.4854384
                ]
            },
            "properties": {
                "categories": {
                    "primary": "education",
                    "alternate": [
                        "college_university",
                        "school"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.meducateacademy.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/469686076799677"
                ],
                "phones": [
                    "+441217263740"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11 St Paul's Square",
                        "locality": "Birmingham",
                        "postcode": "B3 1RB",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "469686076799677",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Meducate Academy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa5253b2896b03fce41e0de25468",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.88168,
                    41.17663
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.cmpcleaningservicesllc.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108277157575374"
                ],
                "phones": [
                    "+15704067655"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Mountain Top",
                        "postcode": null,
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108277157575374",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CMP Cleaning Services, LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f441a2b2591d7103b760718fc03c34",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.397332,
                    28.551569
                ]
            },
            "properties": {
                "categories": {
                    "primary": "truck_rentals",
                    "alternate": [
                        "automotive"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.uhaul.com/Locations/Truck-Rentals-near-Brooksville-FL-34601/017760/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3523974143"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "706 S Broad St",
                        "locality": "Brooksville",
                        "postcode": "34601",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899910060123",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "U-Haul Neighborhood Dealer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44d84c54ccb84034b77da8f3a3f6e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.9222341,
                    35.1902771
                ]
            },
            "properties": {
                "categories": {
                    "primary": "seafood_restaurant",
                    "alternate": [
                        "cajun_creole_restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.9797443181818182,
                "websites": [
                    "http://www.krustaceansclt.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102461417806970"
                ],
                "phones": [
                    "+19802073081"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2908 Oak Lake Blvd",
                        "locality": "Charlotte",
                        "postcode": "28208-7703",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102461417806970",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374888225416",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374886687109",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Krustaceans Seafood Charlotte",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1faa02ac417480394cb519099a425",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.21927,
                    49.14314
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1722300678094025"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Heilbronn",
                        "postcode": null,
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1722300678094025",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MTS Transporte.e.K.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f414348116544903bb26faa72e744f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.14796,
                    20.91187
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/261124661438964"
                ],
                "phones": [
                    "+84987040558"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "thi chán kể sặt bình giang hai dương ",
                        "locality": "Hai Duong",
                        "postcode": "1558",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "261124661438964",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Siphon hàng",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28f0036ba9a02030ab827e86dbc77",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.59515,
                    45.49771
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107234449110902"
                ],
                "phones": [
                    "+15037744124"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "TheBeelo",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "6611 SE Powell Blvd",
                        "locality": "Portland",
                        "postcode": "97206-2635",
                        "region": "OR",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107234449110902",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "TheBeelo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f274999c2eb4ec032c5117abbc1659",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.2344616,
                    42.3328679
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lake",
                    "alternate": [
                        "campground",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.michigandnr.com/parksandtrails/details.aspx?id=506&type=sprk"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152451358102572"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": "49240",
                        "region": null,
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152451358102572",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Portage Lake Beach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f40d1e8819930343898d7336d3d6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    23.8924,
                    54.9282
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sports_club_and_league",
                    "alternate": [
                        "fitness_trainer"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/591303521070786"
                ],
                "phones": [
                    "+37067705506"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rietavo gatvė 11",
                        "locality": "Kaunas",
                        "postcode": "48263",
                        "region": null,
                        "country": "LT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "591303521070786",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KangooLine",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664c1a2124b60368174d72eb86e2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.6328666,
                    41.8675906
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://www.arepartners.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172002713006265"
                ],
                "phones": [
                    "+13123007237"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "111 W Jackson Blvd",
                        "locality": "Chicago",
                        "postcode": "60604-1210",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172002713006265",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ARE Partners",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650546341802b035f77b2058880fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.728,
                    3.19882
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_hardware_company",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "http://compucats.com.my/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/491382144305762"
                ],
                "phones": [
                    "+60166719432"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10 Jalan Rampai Niaga 4",
                        "locality": "Setapak",
                        "postcode": "53300",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "491382144305762",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Compucats Sdn Bhd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa625054b800313c633cece7e06",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.6574061,
                    55.8773379
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "park",
                        "attractions_and_activities"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/333734906716148"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Сухонская улица 1",
                        "locality": "Москва",
                        "postcode": "127642",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "333734906716148",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Турники в парке у Яузы",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81954a381cdd037c0d8a3361f12c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -49.4001522,
                    -20.8355803
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "jewelry_and_watches_manufacturer"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://www.alltimerelojoaria.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/913950242098313"
                ],
                "phones": [
                    "+5517991281819"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Brigadeiro Faria Lima, 6363",
                        "locality": "São José do Rio Preto",
                        "postcode": "15090-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "913950242098313",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Relojoaria AllTime",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa3610429ac603fbdf8f05a4e45f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.7521322,
                    49.3160785
                ]
            },
            "properties": {
                "categories": {
                    "primary": "merchandising_service",
                    "alternate": [
                        "professional_services",
                        "printing_services"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.backyardmerch.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/209412269792808"
                ],
                "phones": [
                    "+4917679790391"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Augustinerstraße 1",
                        "locality": "Saarlouis",
                        "postcode": "66740",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "209412269792808",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Backyard Merch",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195da1549814d03d6564adef931f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.410381,
                    51.7215106
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_manufacturers_and_distributors",
                    "alternate": [
                        "auto_company",
                        "gas_station"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "http://www.jdepmotors.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1403100973059368"
                ],
                "phones": [
                    "+441923267477"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "56 High Street",
                        "locality": "Abbots Langley",
                        "postcode": "WD5 0RH",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1403100973059368",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "J D E P Motors",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe0b32100c35003a903d0f17a3a66",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    149.0989339,
                    -33.2852754
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_parts_and_accessories",
                    "alternate": [
                        "automotive",
                        "bar"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.repco.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/720373461384051"
                ],
                "phones": [
                    "+61263623777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "87 Kite St",
                        "locality": "Orange",
                        "postcode": "2800",
                        "region": "NSW",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "720373461384051",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Repco Auto Parts Orange",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bc55b62a9b03242b1bd3a28763",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3987071,
                    43.6429668
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "architectural_designer",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "http://zasa.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1798401733801864"
                ],
                "phones": [
                    "+16472881800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "517 Wellington St W",
                        "locality": "Toronto",
                        "postcode": "M5V 1G1",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1798401733801864",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ICKE Brochu Architects Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6015b26513408031ef4c52227f137",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.0955,
                    11.7094
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189680637560184"
                ],
                "phones": [
                    "+918606050200"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "MANIYANKODE PO VENGAPALLYnWAYANAD, PIN - 673121nMOB: 7902887496nState Name : Kerala, Code: 32",
                        "locality": "Wayanad",
                        "postcode": "673121",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189680637560184",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ayuralifecare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d33164081c5503d44d911dbcf75f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.397025,
                    39.794754
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_delivery_service",
                    "alternate": [
                        "food_beverage_service_distribution",
                        "comfort_food_restaurant"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "https://www.anadolugolrestaurant.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111369144510128"
                ],
                "phones": [
                    "+903125773777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "29 Ekim Caddesi 3",
                        "locality": "Sincan",
                        "postcode": "06909",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111369144510128",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Anadolu Göl Restaurant",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e506cd28e2b103a13a10f367ac06",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.77073,
                    46.24592
                ]
            },
            "properties": {
                "categories": {
                    "primary": "freight_and_cargo_service",
                    "alternate": null
                },
                "confidence": 0.9398496240601504,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/167644339760932"
                ],
                "phones": [
                    "+40727827011"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "C.D. Gherea, Nr. 8",
                        "locality": "Onesti",
                        "postcode": "601040",
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "167644339760932",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Andu Express",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30d9ac5d726200373955754576e7f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.4198611,
                    33.614425
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chicken_restaurant",
                    "alternate": [
                        "japanese_restaurant"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.jyuzou.com/sp/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1528042124156214"
                ],
                "phones": [
                    "+81926722020"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "福岡市東区舞松原2-11-7",
                        "locality": "Fukuoka-shi",
                        "postcode": "813-0042",
                        "region": "40",
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1528042124156214",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "焼鳥割烹 十蔵",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195c21279924303439b0b4db1045c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.90814,
                    52.2876
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08452419880"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Little Forge Road, Park Farm",
                        "locality": "Redditch",
                        "postcode": "B98 7SF",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908513336",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dragon Delight Foodservice Ltd.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba294a7b367403bbc032c8598620",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.6756005,
                    24.1468789
                ]
            },
            "properties": {
                "categories": {
                    "primary": "spas",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://i-formosa.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103885855714256"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103885855714256",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "按摩老船長私藏名單",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f609612bb96174031f192e746b2b38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.0733165,
                    21.1716934
                ]
            },
            "properties": {
                "categories": {
                    "primary": "graphic_designer",
                    "alternate": [
                        "event_photography"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://youtube.com/c/mrabhishekofficial"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106687322048276"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Urvai Gate, near Gwalior Fort",
                        "locality": null,
                        "postcode": "474012",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106687322048276",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ar.production",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e204734715a003b4180ea09da268",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.1109059,
                    51.1161771
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_manufacturers_and_distributors",
                    "alternate": [
                        "industrial_equipment",
                        "safety_equipment"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.volvogroup.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "713021700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mydlana 2a",
                        "locality": "Wroclaw",
                        "postcode": "51-502",
                        "region": "Dolnośląskie",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849866276609",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Volvo Group",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f42ceb5d1a33a003660a0963532584",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    72.53251,
                    23.0296999
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "educational_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/148806498663127"
                ],
                "phones": [
                    "+919879281829"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9/1 Himmatlal Park Road",
                        "locality": "Ahmedabad",
                        "postcode": "380015",
                        "region": "GJ",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "148806498663127",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "R.d.zala Consultancy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f619aa65b23d49036bcf16ae022df6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.6892679,
                    16.4824902
                ]
            },
            "properties": {
                "categories": {
                    "primary": "stock_and_bond_brokers",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://stockbroker.motilaloswal.com/motilal-oswal-financial-services-limited-stock-broker-kanuru-vijayawada-33765/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "09535955945"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "DN 1/9/1, 4th Flr, E Koteswara Rao Bldg, MG Road, Kanuru",
                        "locality": "Vijayawada",
                        "postcode": "520007",
                        "region": "Andhra Pradesh",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863347063",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Motilal Oswal Financial Services Limited",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90ca8b30653203df020a0ce5889d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -52.4190141,
                    -29.7633186
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "catholic_church"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/266263007219921"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Campinas, 169",
                        "locality": "Santa Cruz do Sul",
                        "postcode": "96835-070",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "266263007219921",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Comunidade Nossa Senhora Aparecida",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6862d9d50c38603dda8e5b9e60fed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    122.67031,
                    10.99917
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/123362320760496"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dingle",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "123362320760496",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Noly",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6031a4cb5cd0603916cccc2aa3614",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.3179574,
                    9.9504869
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tire_shop",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://brandshops.jktyre.com/jk-tyre-steel-wheels-global-tyres-tyre-shop-kannadikadu-ernakulam-102426/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08139007753"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Door No 1/587C, Vytilla Aroor Bypass, Kannadikadu",
                        "locality": "Ernakulam",
                        "postcode": "682304",
                        "region": "Kerala",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863849904",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "JK Tyre Steel Wheels, Global Tyres",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2c555e90eb4d038611fa3985a964",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.7189324,
                    -33.4604667
                ]
            },
            "properties": {
                "categories": {
                    "primary": "armed_forces_branch",
                    "alternate": [
                        "landmark_and_historical_building",
                        "accommodation"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111147739014015"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Neptuno 097",
                        "locality": "Lo Prado",
                        "postcode": "8980000",
                        "region": null,
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111147739014015",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Villa Militar Oeste",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e857756698b6033a36253b949f38",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.8562884,
                    42.8146964
                ]
            },
            "properties": {
                "categories": {
                    "primary": "wholesale_grocer",
                    "alternate": [
                        "wholesale_store",
                        "liquor_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.tormentibeverage.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/394465337971934"
                ],
                "phones": [
                    "+390861810296"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Viale Vibrata, 13",
                        "locality": "Corropoli",
                        "postcode": "64013",
                        "region": "65",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "394465337971934",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tormenti | Distribuzione Bevande",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f11aa78cb94a210388bc58dc32f3f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    37.6417969,
                    55.7461148
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "travel"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1865842593724443"
                ],
                "phones": [
                    "+74959876543"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Котельническая набережная 1",
                        "locality": "Москва",
                        "postcode": "109240",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1865842593724443",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Reliance tour",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a369a21b8003615344e4f6e3f8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.5751425,
                    35.6580935
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "japanese_restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "https://www.skylark.co.jp/gusto/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/202253533239935"
                ],
                "phones": [
                    "+81424400281"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "東京都調布市西つつじケ丘３丁目３５−１",
                        "locality": "調布市",
                        "postcode": "182-0006",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "202253533239935",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ガスト",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6846b620c341c0308647a854fe026",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    123.86534,
                    9.62513
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103007302224880"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Dauis, Central Visayas, Philippines",
                        "locality": "Dauis",
                        "postcode": "6339",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103007302224880",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "J&G 's Rent a car",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30ee759a5ba000326a29da63f59cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    128.618574,
                    36.813258
                ]
            },
            "properties": {
                "categories": {
                    "primary": "diner",
                    "alternate": [
                        "korean_restaurant"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/249249568536942"
                ],
                "phones": [
                    "+10546385538"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "가흥1동 1461-3",
                        "locality": null,
                        "postcode": "750-020",
                        "region": null,
                        "country": "KR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "249249568536942",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "개성손만두",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f675c44d49905303f7df8d32843308",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -69.2935867,
                    10.0627403
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.ferrofasil.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/208334589197344"
                ],
                "phones": [
                    "+582512522003"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Barquisimeto",
                        "postcode": null,
                        "region": null,
                        "country": "VE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "208334589197344",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "FerroFasil Barquisimeto",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6036b9951374003009264660e68f0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    78.672331,
                    10.824271
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113642700098634"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Mettu Street",
                        "locality": null,
                        "postcode": "620003",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113642700098634",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Geetha Cycle Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d06cb1080689030673ca60fdd8c8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    33.0392089,
                    40.1012769
                ]
            },
            "properties": {
                "categories": {
                    "primary": "topic_concert_venue",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "http://www.battalholding.com.tr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/534686800073520"
                ],
                "phones": [
                    "+903128376767"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Enver Paşa Caddesi 6",
                        "locality": "Ankara",
                        "postcode": "06750",
                        "region": "06",
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "534686800073520",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Battal Holding",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f61892db502151036df14bcb37e376",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.6247546,
                    13.1188222
                ]
            },
            "properties": {
                "categories": {
                    "primary": "woodworking_supply_store",
                    "alternate": [
                        "currency_exchange",
                        "business_to_business"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.vriddhitrust.org/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "09686246999"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "19, 2nd Floor, Mittaganahalli Cross Kogilu, Near Reva University, Yelahanka",
                        "locality": "Bengaluru",
                        "postcode": "560064",
                        "region": "Karnataka",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324839953658",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vriddhi Kala Kuteera",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e644d62956c003dbae04816c827e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    137.7409555,
                    34.7441049
                ]
            },
            "properties": {
                "categories": {
                    "primary": "printing_services",
                    "alternate": [
                        "sign_making",
                        "screen_printing_t_shirt_printing"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/233427500182200"
                ],
                "phones": [
                    "+81534718899"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "中区上島5丁目3-7",
                        "locality": null,
                        "postcode": "433-8122",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "233427500182200",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "杉森印刷浜松営業所",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195d2cc204072031990b7d547cb9d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.760829,
                    51.24818
                ]
            },
            "properties": {
                "categories": {
                    "primary": "chinese_restaurant",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "https://www.alleatapp.com/menu-mc-china-wok-away"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102472325069055"
                ],
                "phones": [
                    "+441252321800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "79 Victoria Road",
                        "locality": "Aldershot",
                        "postcode": "GU11 1",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102472325069055",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374891200816",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908703014",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "McChina Wok Away (Aldershot)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e6e6c20d6376031e60842f38d22f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.06368,
                    49.44068
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105426935798352"
                ],
                "phones": [
                    "+380999830504"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Огіркова вулиця, 52",
                        "locality": "Київ",
                        "postcode": "04128",
                        "region": null,
                        "country": "UA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105426935798352",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Syzygy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1959965cd06330331412426e53dc6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.8075437,
                    51.2028842
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105585641802484"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105585641802484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Santapod",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100ec53506903a1cbed3b2d53ed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.68476,
                    -23.59162
                ]
            },
            "properties": {
                "categories": {
                    "primary": "industrial_equipment",
                    "alternate": [
                        "commercial_industrial"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1807696789301872"
                ],
                "phones": [
                    "+551135554000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Presidente Juscelino Kubitschek, 3",
                        "locality": "São Paulo",
                        "postcode": "04543-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1807696789301872",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Asperbras Tecnologia Industrial e Agronegocios",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f268cd16c1c0e403189eb6843b094f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.9877703,
                    39.8134571
                ]
            },
            "properties": {
                "categories": {
                    "primary": "laboratory_testing",
                    "alternate": [
                        "surgical_appliances_and_supplies",
                        "hospital"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.medical-imaging-solutions.com/contact-us.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/790998057659431"
                ],
                "phones": [
                    "+13036234333"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6401 Broadway",
                        "locality": "Denver",
                        "postcode": "80221-2853",
                        "region": "CO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "790998057659431",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Medical Imaging Solutions",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e320a61740a1034e3de01999ae83",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.1717556,
                    48.4819649
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "sporting_goods",
                        "sports_club_and_league"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.golfschlaegerwerkstatt.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/585364861564693"
                ],
                "phones": [
                    "+4985359124041"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Am Dorfplatz 5",
                        "locality": "Haarbach",
                        "postcode": "94542",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "585364861564693",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Golfwerkstatt Bad Griesbach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f32663941880038d2f3f78e4055f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.17052,
                    53.709291
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beach",
                    "alternate": [
                        "hotel",
                        "holiday_rental_home"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://strandfliederhaus.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115262459929233"
                ],
                "phones": [
                    "+494932991317"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Am Fischerhafen 7",
                        "locality": "Norderney",
                        "postcode": "26548",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115262459929233",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Strandfliederhaus",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f588221aa15a8c03101c2cd1774293",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.43333,
                    6.8
                ]
            },
            "properties": {
                "categories": {
                    "primary": "farmers_market",
                    "alternate": [
                        "supermarket",
                        "grocery_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/268445016849950"
                ],
                "phones": [
                    "+2348033041202"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Mount Zion road Ogunrun, More,",
                        "locality": "Mowe",
                        "postcode": "23401",
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "268445016849950",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Geotech Farms",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28d540b34e62a0345935b2093219f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.32375,
                    47.710814
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "lawyer",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/121617221230311"
                ],
                "phones": [
                    "+12063672011"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "11301 5th Ave NE",
                        "locality": "Seattle",
                        "postcode": "98125-6152",
                        "region": "WA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "121617221230311",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bush John C DDS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f088e396b8aae6037560266cb3a283",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.5034751,
                    61.1233545
                ]
            },
            "properties": {
                "categories": {
                    "primary": "grocery_store",
                    "alternate": [
                        "shopping",
                        "convenience_store"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.picknpay.fi/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108387465847484"
                ],
                "phones": [
                    "+358444766714"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sahankatu 2",
                        "locality": "Rauma",
                        "postcode": "26100",
                        "region": null,
                        "country": "FI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108387465847484",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965096911",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pick N Pay Rauma",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e3db6c80bb103426930cb1c8634",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -57.957745,
                    -34.9287597
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campus_building",
                    "alternate": [
                        "college_university",
                        "education"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "https://institutolandolfi.com.ar/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/923276211025946"
                ],
                "phones": [
                    "+542216394062"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 56 1191",
                        "locality": "La Plata",
                        "postcode": "1900",
                        "region": "B",
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "923276211025946",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Instituto Landolfi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3904728365d8003c590536b1f2c95",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -7.5323844,
                    40.2096412
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "eat_and_drink",
                        "business"
                    ]
                },
                "confidence": 0.9588815789473685,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1040432982653061"
                ],
                "phones": [
                    "+351961279014"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bairro dos Marinheiros 2",
                        "locality": "Covilhã",
                        "postcode": "6200-511",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1040432982653061",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pensão o Marinheiro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f12c8261c3a403165f105d942d49",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.2853927,
                    51.4953639
                ]
            },
            "properties": {
                "categories": {
                    "primary": "florist",
                    "alternate": [
                        "gift_shop",
                        "toy_store"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.nici.de/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "02342397459"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Am Einkaufszentrum",
                        "locality": "Bochum",
                        "postcode": "44791",
                        "region": "Nordrhein-Westfalen",
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324838904972",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NICI Shop",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44ddb120ebb1d030b8dc2f9bc6ff6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.0274066,
                    34.8256119
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "diner",
                        "eat_and_drink"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103582705659167"
                ],
                "phones": [
                    "+18646380000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1308 Falcons Dr",
                        "locality": "Walhalla",
                        "postcode": "29691-3615",
                        "region": "SC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103582705659167",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tavern at Windsor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194d0494ed6c003cbcfeca069446e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.3359797,
                    50.8514067
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_entertainment",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/426875461174715"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "BE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "426875461174715",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kortrijkse Heerweg - Ringlaan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8c0da3b536c033fcfafb46dfbbb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.32987,
                    26.43562
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_beverage_service_distribution",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102322848874683"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kanpur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102322848874683",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Binish Masale",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f0b33133214603205b31c0f5f2d3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.86267,
                    53.10764
                ]
            },
            "properties": {
                "categories": {
                    "primary": "nursery_and_gardening",
                    "alternate": [
                        "shopping",
                        "gardener"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.centrumogrodniczewdrzewcach.pl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/436246133224720"
                ],
                "phones": [
                    "+48602684908"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ulica Drzewiecka 20",
                        "locality": "Białe Błota",
                        "postcode": "86-065",
                        "region": "04",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "436246133224720",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Centrum Ogrodnicze w Drzewcach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1d4ab5483b0032da74a98df7330",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.3657545,
                    52.554742
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "sports_club_and_league",
                        "physical_therapy"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.zentrum-sportmedizin.de"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1885299218402194"
                ],
                "phones": [
                    "+493045083550"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Reinickendorfer Straße 61",
                        "locality": "Berlin",
                        "postcode": "13347",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1885299218402194",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963019383",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sport-Gesundheitspark Berlin e.V. Berlin-Wedding",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b99235612059038cc64173fae0c1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.6185332,
                    43.1229429
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_food_store",
                    "alternate": [
                        "vitamins_and_supplements",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.fitnessedgemedia.com/?q=media%2frochester-supplement-consultants"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1692563030984856"
                ],
                "phones": [
                    "+15856238709"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1385 Mt Hope Ave",
                        "locality": "Rochester",
                        "postcode": "14620-3923",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1692563030984856",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rochester Supplement Consultants",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ed130252189503dea25521a6fadf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    22.509462,
                    40.2705662
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.allianz.com.gr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1729591470613172"
                ],
                "phones": [
                    "+302351079056"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "25ης Μαρτίου 8",
                        "locality": "Κατερίνη",
                        "postcode": "601 32",
                        "region": "B",
                        "country": "GR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1729591470613172",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ασφαλιστικά Γραφεία Φλογέρα",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f58abb3076a06003fd31339ac4eb97",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.00944,
                    9.10488
                ]
            },
            "properties": {
                "categories": {
                    "primary": "farmers_market",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/354965887705602"
                ],
                "phones": [
                    "+2348132971811"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Musa bello area",
                        "locality": "Bida",
                        "postcode": null,
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "354965887705602",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Farmer Alhji Umaru",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8b09c2198e20318c38cfd8eebf0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.77327,
                    46.47664
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.mascherecanazeigries.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/350311772319582"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Canazei",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "350311772319582",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Grop de la Mescres Cianacei e Gries",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1943a1012176d03e99ac79d69c4e9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.15398,
                    52.65044
                ]
            },
            "properties": {
                "categories": {
                    "primary": "farm",
                    "alternate": [
                        "butcher_shop"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.fruitpig.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/148474771839015"
                ],
                "phones": [
                    "+441945739455"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6 Anglia Way",
                        "locality": "Wisbech",
                        "postcode": "PE13 2TY",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "148474771839015",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Fruit Pig Company",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a86ca0c8189c0317449d7037be7e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.4257217,
                    40.8479343
                ]
            },
            "properties": {
                "categories": {
                    "primary": "thrift_store",
                    "alternate": [
                        "community_services_non_profits",
                        "charity_organization"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://www.goodwill.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103006024499780"
                ],
                "phones": [
                    "+12343608564"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Goodwill Industries of Greater Cleveland and East Central Ohio, Inc.",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "4379 Whipple Ave NW",
                        "locality": "Canton",
                        "postcode": "44718-2643",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103006024499780",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932985398",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932424883",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799819064576",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863082257",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Canton Outlet — Goodwill Industries of Greater Cleveland and East Central Ohio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8e62d52cc17a1034ad8b061def04f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.01063,
                    -11.97235
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "sports_club_and_league"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/460776504409535"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pedro sanchez",
                        "locality": "Lima",
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "460776504409535",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Meli g",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44d86757982d103bdf063d66a7e1d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.243919,
                    35.474828
                ]
            },
            "properties": {
                "categories": {
                    "primary": "industrial_equipment",
                    "alternate": [
                        "tools_wholesaler",
                        "wholesaler"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.harborfreight.com/storelocator/1010-east-main-street-lincolnton-28092?number=3232"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7047480686"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1010 E Main St",
                        "locality": "Lincolnton",
                        "postcode": "28092",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949962532891",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Harbor Freight Tools",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa86156eb42903f04cb25df1eb77",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.97899,
                    38.69176
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mexican_restaurant",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/201974556489155"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Accokeek",
                        "postcode": null,
                        "region": "MD",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "201974556489155",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Casa Manansala.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba05b51605030398e44a0efeaf86",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.625434,
                    24.343468
                ]
            },
            "properties": {
                "categories": {
                    "primary": "breakfast_and_brunch_restaurant",
                    "alternate": [
                        "restaurant",
                        "delicatessen"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/404183269762077"
                ],
                "phones": [
                    "+886426885330"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "37台中市大甲區光明路3號",
                        "locality": "台中市",
                        "postcode": "437",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "404183269762077",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "太陽小舖早午餐專賣店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f589c9985b684203f046119fd37f22",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.4041182,
                    6.4499718
                ]
            },
            "properties": {
                "categories": {
                    "primary": "anglican_church",
                    "alternate": [
                        "church_cathedral",
                        "catholic_church"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "http://www.stdavidslafiaji.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/157728374272666"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "13 Okesuna St",
                        "locality": "Lagos",
                        "postcode": null,
                        "region": "LA",
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "157728374272666",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "111541927239430",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "St. David's Anglican Church, Lafiaji, Lagos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f49a966e8118830332aa55a69e33ba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.2315,
                    20.63576
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/152171964640162"
                ],
                "phones": [
                    "+523221400050"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Av. Francisco Medina Ascencio, Las Glorias",
                        "locality": "Puerto Vallarta",
                        "postcode": "48333",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "152171964640162",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Monoi.monoipv",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29b6c0051224a032ce6eb0cd0ef92",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -112.084351,
                    33.664288
                ]
            },
            "properties": {
                "categories": {
                    "primary": "appliance_repair_service",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.fitnessaz2002.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6024058555"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "802 W Sequoia Dr",
                        "locality": "Phoenix",
                        "postcode": "85027",
                        "region": "AZ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474976878728",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fitness Equipment Repair LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100aa45615903c652709a681a4b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.51637,
                    -23.63669
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "accountant"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://www.confistec.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/196289987836034"
                ],
                "phones": [
                    "+551149758833"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Oratório, 1780",
                        "locality": "Santo André",
                        "postcode": "09280-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "196289987836034",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Confistec Assessoria Contábil",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a96d8041c2cc03f7cd5f6a987971",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.2593631,
                    41.4407397
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "charity_organization"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://dekkofoundation.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/335912236551743"
                ],
                "phones": [
                    "+12603471278"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "401 E Diamond St",
                        "locality": "Kendallville",
                        "postcode": "46755-2280",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "335912236551743",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dekko Foundation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65050831987a0035c2867f2124e98",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.65357,
                    3.08937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "catholic_church"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.sfx.com.my/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/660898957313493"
                ],
                "phones": [
                    "+60379565617"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "134 Jalan Gasing",
                        "locality": "Petaling Jaya",
                        "postcode": "46000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "660898957313493",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Church of St. Francis Xavier",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651d45328cd0603a933a6d9cf3f0f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.42074,
                    6.09435
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109365728560293"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "kampung melintang",
                        "locality": "Perlis",
                        "postcode": "02700",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109365728560293",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cantik BY aurani",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2c50b1b5a42c03e54aa894a6392d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.538,
                    -33.4651
                ]
            },
            "properties": {
                "categories": {
                    "primary": "convenience_store",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.dulcineas.cl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/782526521866133"
                ],
                "phones": [
                    "+56981883879"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Volcán Puyehue 659",
                        "locality": "Peñalolén",
                        "postcode": "7910000",
                        "region": "RM",
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "782526521866133",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dulcineas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6422c0665636b03708b7330092248",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.29868,
                    8.1965422
                ]
            },
            "properties": {
                "categories": {
                    "primary": "eat_and_drink",
                    "alternate": [
                        "diner",
                        "professional_services"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108152748104717"
                ],
                "phones": [
                    "+66980135627"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ซอยร่วมใจ",
                        "locality": "Amphoe Thalang",
                        "postcode": "83110",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108152748104717",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ครัวโก๊อู๊ด",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa1ca99aa69b03fe9cee10591ac6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.7044597,
                    50.6372142
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "hvac_services"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.cool-down.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102459621777054"
                ],
                "phones": [
                    "+491778343903"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Nikolausstraße 1",
                        "locality": "Mechernich",
                        "postcode": "53894",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102459621777054",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Goehrke Klimatechnik",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f2b98366682b03aa0df7288f8c70",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.90109,
                    -2.19164
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.instagram.com/servicar2019/?hl=es-la"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106039191319424"
                ],
                "phones": [
                    "+593968318817"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10 de Agosto e Ismael Pérez Pazmiño",
                        "locality": "Guayaquil",
                        "postcode": null,
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106039191319424",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Servicar",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b5a1bb1d6f50308e1960c14426a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.70766,
                    10.16373
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/176120752258047"
                ],
                "phones": [
                    "+84953315955"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Đặng Anh Khoa",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "WDjK JVRXh",
                        "locality": "Ho Chi Minh City",
                        "postcode": "20745",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "176120752258047",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tạ Thị Bích Dân",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa89539488e3a903140536ad061414",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -40.3309393,
                    -20.4423547
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "screen_printing_t_shirt_printing",
                        "printing_services"
                    ]
                },
                "confidence": 0.9456869009584664,
                "websites": [
                    "http://www.printcenterbrasil.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/632235296979038"
                ],
                "phones": [
                    "+5527998007793"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Antônio de Almeida Filho, 24b",
                        "locality": "Vila Velha",
                        "postcode": "29102-330",
                        "region": "ES",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "632235296979038",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Print Center Sublimação & Transfer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f68cb1c800a60361e3ff7fc090c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.77041,
                    36.85187
                ]
            },
            "properties": {
                "categories": {
                    "primary": "barber",
                    "alternate": [
                        "beauty_salon",
                        "art_gallery"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1475794862715667"
                ],
                "phones": [
                    "+905365226979"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Barınaklar Bulvarı 119B",
                        "locality": "Muratpaşa",
                        "postcode": "07230",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1475794862715667",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MS Different Murat güner",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f450a47232db420373b09ceee5c831",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.8999,
                    20.8523016
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106280679194571"
                ],
                "phones": [
                    "+529983072884"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Almendro a espaldas del Dunosusa de la Carretera Federal, colonia Joaquín Zetina Gasca, Puerto Morelos Quintana Roo...",
                        "locality": "Puerto Morelos",
                        "postcode": "77580",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106280679194571",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Jarochita de Puerto Morelos Quintana Roo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e61409306b4003829adacab9b2c9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    135.767021,
                    35.0146122
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "sushi_restaurant",
                        "restaurant"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129738907073816"
                ],
                "phones": [
                    "+81752311264"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "京都府京都市中京区要法寺前町７０５",
                        "locality": "京都市中京区",
                        "postcode": "604-0916",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129738907073816",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ふくろ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f696c40cd0286103bb67aaa0c9d6cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.4843,
                    17.87284
                ]
            },
            "properties": {
                "categories": {
                    "primary": "makeup_artist",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110263925234666"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pacis Sinait, Ilocos sur",
                        "locality": "Sinait",
                        "postcode": "2733",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110263925234666",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Clensy's Magical ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab66529199860315de8dda7537c3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.7288058,
                    42.6878343
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": [
                        "non_governmental_association",
                        "central_government_office"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.amvets.org"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100700759549408"
                ],
                "phones": [
                    "+15867250865"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "51285 County Line Rd",
                        "locality": "New Baltimore",
                        "postcode": "48047-1136",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100700759549408",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amvets Post 52",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f8d73530560103f6a70530ef7546",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.6658062,
                    48.2281908
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "janitorial_services"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.mimaris-hausservice.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/922732001191014"
                ],
                "phones": [
                    "+4915751326630"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Lindenstraße 29",
                        "locality": "Ismaning",
                        "postcode": "85737",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "922732001191014",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hausmeisterservice Mimaris",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28316f64849ad03cae259eb3ef610",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -123.2077399,
                    39.1480623
                ]
            },
            "properties": {
                "categories": {
                    "primary": "liquor_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://caddellwilliams.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/209538719079841"
                ],
                "phones": [
                    "+17074687896"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "110 W Clay St",
                        "locality": "Ukiah",
                        "postcode": "95482-5420",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "209538719079841",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Caddell & Williams",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9ab3256431d03fc43207a21c815",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.6488829,
                    44.3456441
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_improvement_store",
                    "alternate": [
                        "professional_services",
                        "home_service"
                    ]
                },
                "confidence": 0.990054286783976,
                "websites": [
                    "http://www.jprenovations.ca"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105635024338172"
                ],
                "phones": [
                    "+17057910479"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5 Benjamin Ln",
                        "locality": "Barrie",
                        "postcode": "L4N 0S3",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105635024338172",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949960195335",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "JP Renovations",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e80d1d5514a403058b6998d0f63b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    12.336657,
                    42.2404051
                ]
            },
            "properties": {
                "categories": {
                    "primary": "courier_and_delivery_services",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://locator.dhl.com/results?address=id:ROM1P2&language=en&lc=IT&resultUom=km&clientAppCode=GYD"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "199199345"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Roma 99/101",
                        "locality": "Nepi",
                        "postcode": "01036",
                        "region": "VT",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324841860621",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "DHL Service Point (ITALIANA SERVIZI POSTALI)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651c68ccf2dad034e711be18f56fc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.280904,
                    6.541076
                ]
            },
            "properties": {
                "categories": {
                    "primary": "buddhist_temple",
                    "alternate": [
                        "park",
                        "religious_organization"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/348059331937087"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "348059331937087",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "591762460895312",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ศาลเจ้าพ่อหลักเมืองยะลา",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe08c5a635cc003148488375459d7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    150.7377396,
                    -34.0436476
                ]
            },
            "properties": {
                "categories": {
                    "primary": "park",
                    "alternate": [
                        "attractions_and_activities",
                        "hotel"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/862117317244180"
                ],
                "phones": [
                    "+61246547777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Elyard St",
                        "locality": null,
                        "postcode": "2567",
                        "region": null,
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "862117317244180",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Elyard Reserve",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f26d8b3a81640316978099272bcc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.176,
                    56.61819
                ]
            },
            "properties": {
                "categories": {
                    "primary": "bicycle_shop",
                    "alternate": [
                        "bike_repair_maintenance",
                        "hotel"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/170608379644673"
                ],
                "phones": [
                    "+4597835701"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Søndergade 44",
                        "locality": "Harboøre",
                        "postcode": "7673",
                        "region": "82",
                        "country": "DK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "170608379644673",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Harboøre Cykelværksted",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2d869b631aa203414329d459a1a4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.0517381,
                    -36.8463518
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": [
                        "software_development",
                        "business_to_business_services"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://help.uber.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    ""
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pedro de Valdivia 1010",
                        "locality": "Concepción",
                        "postcode": "4070123",
                        "region": "BI",
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949961352067",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Atención Presencial Uber - Concepción",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4b6584532c95a03e6d5c72a7fdcc5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    132.4542289,
                    34.1864503
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_health_care",
                    "alternate": [
                        "pharmacy",
                        "home_service"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "https://sites.google.com/view/zaienn"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109616508187070"
                ],
                "phones": [
                    "+81823276035"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1576-7 Ogakicho Obure",
                        "locality": null,
                        "postcode": "737-2215",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109616508187070",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "居宅介護支援事業所えん寿",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f972d82c2e881d037674a5a2b13ec7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    29.7315503,
                    -23.8855879
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108283181466503"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "ZA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108283181466503",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mosading",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275d0cb90d60e0332e3f20ec7394c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.96366,
                    43.1439925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "elementary_school",
                    "alternate": [
                        "public_school",
                        "school"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.milwaukee.k12.wi.us"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1576012079286591"
                ],
                "phones": [
                    "+14142477200"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6945 N 41st St",
                        "locality": "Milwaukee",
                        "postcode": "53209-2204",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1576012079286591",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hawthorne School",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44da35e0ea52c03363ae6773ab3d2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.4404332,
                    35.6134688
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel_services",
                    "alternate": [
                        "scuba_diving_instruction",
                        "scuba_diving_center"
                    ]
                },
                "confidence": 0.9554838709677419,
                "websites": [
                    "http://3dscuba.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100569719533021"
                ],
                "phones": [
                    "+17042092209"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "403 S Salisbury Ave",
                        "locality": "Granite Quarry",
                        "postcode": "28146-8153",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100569719533021",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "3D Scuba",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81010d38065603cb368b5d33f431",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.7033008,
                    -23.8204061
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/696351000743137"
                ],
                "phones": [
                    "+5511997569063"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Domenico Lanzetti, 38b",
                        "locality": "São Paulo",
                        "postcode": "04884-210",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "696351000743137",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Amanda Designer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fab16b41405c031801531c9105a9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.9771136,
                    49.4196726
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": [
                        "professional_services",
                        "contractor"
                    ]
                },
                "confidence": 0.9905482859305721,
                "websites": [
                    "http://warnick-bau.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/183897398329674"
                ],
                "phones": [
                    "+49911691549"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Winterstraße 7",
                        "locality": "Oberasbach",
                        "postcode": "90522",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "183897398329674",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958906115",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Warnick Bau GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f481a7184a0091039d34580f76279a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -105.45828,
                    28.17916
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store",
                        "fashion_accessories_store"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2143622988991983"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Delicias",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2143622988991983",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Boutique de Mary regalos & accesorios",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3388ecaa0ce035ebb9bc47b1e66",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.354012,
                    42.0378883
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.psychobunny.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7743071145"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Outlet Blvd",
                        "locality": "Wrentham",
                        "postcode": "02093",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474980675097",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Psycho Bunny",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bc76a69b9803ef0a259a1115e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3924164,
                    43.6970583
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "laboratory_testing",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.incisaledge.ca/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/438594299522346"
                ],
                "phones": [
                    "+14164896533"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "124 Merton St",
                        "locality": "Toronto",
                        "postcode": "M4S 2Z2",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "438594299522346",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Incisal Edge Dental Lab Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c1a812a05050333e93ded414316",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.3891701,
                    33.7560363
                ]
            },
            "properties": {
                "categories": {
                    "primary": "smoothie_juice_bar",
                    "alternate": [
                        "eat_and_drink",
                        "gluten_free_restaurant"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "https://locations.smoothieking.com/ll/us/ga/atlanta/60-luckie-suite-136/?utm_source=facebook&utm_medium=social&utm_content=soci"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/117508724935375"
                ],
                "phones": [
                    "+14042230770"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Smoothie King",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "60 Luckie St NW",
                        "locality": "Atlanta",
                        "postcode": "30303-1904",
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "117508724935375",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890151406",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912113834",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Smoothie King",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8b618cb6825010369816cde84f240",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.9743031,
                    -13.5152569
                ]
            },
            "properties": {
                "categories": {
                    "primary": "peruvian_restaurant",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109757274590886"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "PE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109757274590886",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Morena Peruvian",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa84e804c4410336835fd6809d4c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.07598,
                    38.90878
                ]
            },
            "properties": {
                "categories": {
                    "primary": "business_advertising",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://web.facebook.com/groups/244482857837902/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/160596383807697"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": " w",
                        "locality": "Washington D.C.",
                        "postcode": " 10002",
                        "region": "DC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "160596383807697",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ameliya",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aac87503570003c5c646705289c1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.39598,
                    40.0875
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sports_bar",
                    "alternate": [
                        "bar",
                        "burger_restaurant"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.foxandhound.com/locations/king-of-prussia/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6109620922"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "160 N Gulph Rd Ste. 211",
                        "locality": "King Of Prussia",
                        "postcode": "19406",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799818466853",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fox & Hound King Of Prussia",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f6d161af15a10307925310ab4495",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    32.4461866,
                    37.8623363
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "hospital",
                        "health_and_medical"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.onureczanesi.net"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/2126555114140115"
                ],
                "phones": [
                    "+103323239598"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Armağan Mahallesi Muhtarlığı, Yeni Meram Caddesi 42",
                        "locality": "Meram",
                        "postcode": "42090",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "2126555114140115",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yeniyol eczanesi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650d4e6302a2603bbeafc0b34d855",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.7184453,
                    3.5813329
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": [
                        "cafe"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1911443542278971"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Medan",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1911443542278971",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Waroeng Kopi Djogja",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275c675c76d2003f9d2c26ce5e554",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -89.2016244,
                    43.77066
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100757802830838"
                ],
                "phones": [
                    "+12029227981"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "KoMo Itzayana Meredith Styles",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "W781 Fox Ct",
                        "locality": "Montello",
                        "postcode": "53949-8535",
                        "region": "WI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100757802830838",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "KoMo Itzayana Meredith Styles",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8008875d1d62a031657787801b136",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -44.29622,
                    -2.52858
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beer_garden",
                    "alternate": [
                        "cultural_center",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/458406414735023"
                ],
                "phones": [
                    "+559832340457"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Rio Branco, 420",
                        "locality": "São Luís",
                        "postcode": "65065-780",
                        "region": "MA",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "458406414735023",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Solar Cultural da Terra Maria Firmina dos Reis",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c14685c1413603a68dd1bfcd508c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    107.51139,
                    -6.88801
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shoe_store",
                    "alternate": [
                        "shopping"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111852846888035"
                ],
                "phones": [
                    "+82116883058"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "sindang sari barat",
                        "locality": "Bandung",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111852846888035",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gudang Sepatu",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aaaa6108d700035861612ffaa62f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.2599886,
                    38.6836465
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": [
                        "fabric_store",
                        "shopping"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.yarncloud.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/82018480142"
                ],
                "phones": [
                    "+15714084236"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "202 Mill St",
                        "locality": "Occoquan",
                        "postcode": "22125-8000",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "82018480142",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yarn Cloud",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64266f1b01c680362ee44614c9a67",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    98.392586,
                    7.8787628
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/462915217791516"
                ],
                "phones": [
                    "+66954281339"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Phuket",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "462915217791516",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nantiya Sweets Home",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b56ed8c697103254ee97bf2ba36",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.6788294,
                    10.8966141
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112274134293133"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Ho Chi Minh City",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112274134293133",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rượu Nhà Thóc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f444056495c7440303aa1ab9689efb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -91.1952403,
                    30.6294765
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant_wholesale",
                    "alternate": [
                        "live_and_raw_food_restaurant"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110749488190126"
                ],
                "phones": [
                    "+12254052462"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18498 Old Scenic Hwy",
                        "locality": "Zachary",
                        "postcode": "70791-8136",
                        "region": "LA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110749488190126",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trot’s Tackle Box",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa95ec1b6888820378073a0334f361",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -54.64783,
                    -25.38767
                ]
            },
            "properties": {
                "categories": {
                    "primary": "notary_public",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105406478749427"
                ],
                "phones": [
                    "+595982643300"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avda las acacias e/ Mcal Lòpez y Chaco Boreal ",
                        "locality": "Hernandarias",
                        "postcode": null,
                        "region": null,
                        "country": "PY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105406478749427",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Escribanìa Romero Maggi",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c106a1d64b740322ec6e72f567ff",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.7702033,
                    -6.189543
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/148271935308554"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Jakarta",
                        "postcode": null,
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "148271935308554",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kamar Istikomah",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e74a554b574003dfe2a5339dc44e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.8827918,
                    36.2564262
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "professional_services",
                        "eat_and_drink"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/747254218682136"
                ],
                "phones": [
                    "+81274621974"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "群馬県富岡市七日市１０８６−３",
                        "locality": "富岡市",
                        "postcode": "370-2343",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "747254218682136",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "カナイ写真店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe6342b2884cc038d3b2edb8b24a9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    144.9516932,
                    -37.6447029
                ]
            },
            "properties": {
                "categories": {
                    "primary": "builders",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.ozhd.com.au/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0409123104"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3/ 2122 Hume hyw",
                        "locality": "Campbellfield",
                        "postcode": "3061",
                        "region": "Victoria",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949963534350",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963534149",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "OzHomes And Developers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1228652a6f003d8192a2d15ef15",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.35405,
                    40.44279
                ]
            },
            "properties": {
                "categories": {
                    "primary": "oral_surgeon",
                    "alternate": [
                        "professional_services",
                        "doctor"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104492571499425"
                ],
                "phones": [
                    "+12155368133"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Valley Oral Surgery",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "1402 W Broad St",
                        "locality": "Quakertown",
                        "postcode": "18951-1182",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104492571499425",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Valley Oral Surgery",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651ba93a9d78603b7f077a953727c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.6213439,
                    7.5330523
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "automotive_repair",
                        "car_dealer"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.toyota.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100296144746126"
                ],
                "phones": [
                    "+6675228140"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "209 หมู่10 ถนนตรัง-ปะเหลียน ต.โคกหล่อ อ.เมืองตรัง จ.ตรัง",
                        "locality": "Trang",
                        "postcode": "92000",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100296144746126",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "โตโยต้าเมืองตรังสาขาศรีตรัง",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f1d489b98c56033ef73c156fdaa6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.41398,
                    52.52996
                ]
            },
            "properties": {
                "categories": {
                    "primary": "software_development",
                    "alternate": [
                        "internet_service_provider",
                        "web_designer"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.modernes-web.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/712644535445513"
                ],
                "phones": [
                    "+493052547095"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Straßburger Straße 11",
                        "locality": "Berlin",
                        "postcode": "10405",
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "712644535445513",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Z3 Web GmbH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f60a391257441603007365761f989c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.37,
                    16.2
                ]
            },
            "properties": {
                "categories": {
                    "primary": "motorcycle_dealer",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://dealers.heromotocorp.com/anand-motors-hero-motocorp-two-wheeler-dealer-gangavathi-road-raichur-26008/home?utm_source=locator&utm_medium=facebook"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/231976287473120"
                ],
                "phones": [
                    "+919289922943"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Hero MotoCorp",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Plot No 2008, NS Complex, Gangavathi Road",
                        "locality": "Raichur",
                        "postcode": "584128",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "231976287473120",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hero MotoCorp",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3076ebb2a0203d2c2d2e7017918",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.945521,
                    42.4643399
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "http://www.brewonthegrid.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "7818426365"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "23 Central Ave",
                        "locality": "Lynn",
                        "postcode": "01901",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978492779",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Brew on the Grid",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f834e68a45b50333c49eb0ea3414",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.485147,
                    46.82738
                ]
            },
            "properties": {
                "categories": {
                    "primary": "painting",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.deko-malerei.ch/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "0795635232"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Weiermattweg 10",
                        "locality": "Rümligen",
                        "postcode": "3128",
                        "region": "Bern",
                        "country": "CH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949959461356",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dekorationsmalerei",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf13b06054d50360cf247ecfd27d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.42121,
                    23.81178
                ]
            },
            "properties": {
                "categories": {
                    "primary": "organic_grocery_store",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/179862575217931"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bashundhara Residential Area",
                        "locality": "Dhaka",
                        "postcode": null,
                        "region": null,
                        "country": "BD"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "179862575217931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "পালংকি ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f489b664a5821d030820ab6e4a99c6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -98.16844,
                    32.238663
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.northwesternmutual.com/financial-professional-locator?address=3324%20N%20US%20Highway%20377,76401&distance=1&cmpid=LL-Lo3-Search"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4325709800"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3324 N US Highway 377",
                        "locality": "Stephenville",
                        "postcode": "76401",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "281474978344261",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Northwestern Mutual",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8120dd00d20003f9780f3ee8efb6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -45.564772,
                    -23.032267
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pizza_restaurant",
                    "alternate": [
                        "fast_food_restaurant"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://oreidopedaco.menudino.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107723008816626"
                ],
                "phones": [
                    "+5512991679320"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Doutor Emílio Winther, 775",
                        "locality": "Taubaté",
                        "postcode": "12030-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107723008816626",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "O Rei do Pedaço",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a00aba59a66037917692d02d1f0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.1640636,
                    34.0655939
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campus_building",
                    "alternate": [
                        "school",
                        "educational_services"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.redlands.edu/student-life/academic-success-and-disability-services/academic-success/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/260049210813623"
                ],
                "phones": [
                    "+19097488069"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Redlands",
                        "postcode": null,
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "260049210813623",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Academic Success and Disability Services",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b618b2a096803b6b67fcac5e709",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    108.5576425,
                    11.8720086
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1916817081733945"
                ],
                "phones": [
                    "+842633591234"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Đà Lạt",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1916817081733945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cơm Phở Trung Cẩm",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39446036800880381515feb995bc5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.1546257,
                    41.3765484
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gift_shop",
                    "alternate": [
                        "active_life",
                        "bookstore"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.infoplaca.es/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/552777561442511"
                ],
                "phones": [
                    "+34934431545"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Carrer d'Entença, 25",
                        "locality": "Barcelona",
                        "postcode": "08015",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "552777561442511",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BBB Beumer",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe88a867b49730393dc484f18de45",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    153.0901871,
                    -26.3918377
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "real_estate",
                        "professional_services"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://www.kleinhunterpropertybuyers.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1841394195896881"
                ],
                "phones": [
                    "+61449640204"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "RISE APARTMENTS, 37 Noosa Dr",
                        "locality": "Sunshine Coast",
                        "postcode": "4567",
                        "region": "QLD",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1841394195896881",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912402702",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Klein Hunter Property Buyers Agent",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e60aad80649e03b72e9b3329a0c5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    136.5044745,
                    34.7194704
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "coffee_shop"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102258398351617"
                ],
                "phones": [
                    "+81592255777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "36-23 Nishimarunouchi",
                        "locality": null,
                        "postcode": "514-0035",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102258398351617",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nakamura Coffee",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9cae164040d03b2d9862b5946d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.6360141,
                    38.3479777
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": [
                        "employment_law",
                        "professional_services"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.karenmillerlaborlaw.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/110830338077955"
                ],
                "phones": [
                    "+13043437910"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2 Hale St",
                        "locality": "Charleston",
                        "postcode": "25301-2806",
                        "region": "WV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "110830338077955",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Miller & Amos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aa879359832003cb05089032950c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.1386798,
                    38.8041397
                ]
            },
            "properties": {
                "categories": {
                    "primary": "carpet_store",
                    "alternate": [
                        "shopping",
                        "contractor"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://www.alexandriacarpetone.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1303367353065652"
                ],
                "phones": [
                    "+15713508617"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "851 S Pickett St",
                        "locality": "Alexandria",
                        "postcode": "22304-4605",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1303367353065652",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424931462364",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799821273159",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799820699879",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890698988",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908993466",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alexandria Carpet One Floor & Home",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f260d9596444ea03bfc49582f4583e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.55018,
                    41.60802
                ]
            },
            "properties": {
                "categories": {
                    "primary": "life_coach",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101421972275547"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3323 E Washington Ave",
                        "locality": "Des Moines",
                        "postcode": "50317-3224",
                        "region": "IA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101421972275547",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rick Bachman",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a8b06005511c03001c3ff2c0c7f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.48082,
                    36.06772
                ]
            },
            "properties": {
                "categories": {
                    "primary": "retirement_home",
                    "alternate": null
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://nuimagebody.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100218108718804"
                ],
                "phones": [
                    "+13365430151"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2806 Eric Ln",
                        "locality": "Burlington",
                        "postcode": "27215-5491",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100218108718804",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nu Image Body Sculpting",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8ac14510a0e203ff82ef7f74789b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -45.7136087,
                    -22.2461144
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_salon",
                    "alternate": [
                        "hair_removal",
                        "spas"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": [
                    "https://www.instagram.com/micheleinaciostudio/?hl=pt-br"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/685374208277132"
                ],
                "phones": [
                    "+5535992088680"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Capitão Vicente Ribeiro do Vale, 862",
                        "locality": "Santa Rita do Sapucaí",
                        "postcode": "37540-000",
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "685374208277132",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Studio Michele Inácio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a107288cc40903b110cf4f8c22fe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.009275,
                    40.706262
                ]
            },
            "properties": {
                "categories": {
                    "primary": "property_management",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2125091080"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "48 Wall St Ste 1100",
                        "locality": "New York",
                        "postcode": "10005",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799813705710",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Masom Property Management",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f81899612b2a2b038066d619491c27",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -38.2833,
                    -6.31667
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "automotive",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1677936535790018"
                ],
                "phones": [
                    "+5584996678258"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "José da Penha",
                        "postcode": null,
                        "region": "RN",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1677936535790018",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paredinha Do Moura",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6088550468a0d033361a7d40795b7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.76571,
                    18.5182499
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.9285033365109628,
                "websites": [
                    "http://www.nachiketsonawane.smugmug.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/294811483962064"
                ],
                "phones": [
                    "+919762109906"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Pune",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "294811483962064",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Nachiket Sonawane Photography",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2664d824e6c54035dad5d2e3c98ae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -87.7472286,
                    42.0319686
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pharmacy",
                    "alternate": [
                        "vitamins_and_supplements",
                        "medical_supply"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://mobile.supercarerx.comcastbiz.net/contact-us"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102868568066574"
                ],
                "phones": [
                    "+18479838856"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "8305 Skokie Blvd",
                        "locality": "Skokie",
                        "postcode": "60077-2546",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102868568066574",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Super Care Pharmacy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2661ad0c036340337e2bc3815ab25",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.3704519,
                    39.613116
                ]
            },
            "properties": {
                "categories": {
                    "primary": "roofing",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/148977114958155"
                ],
                "phones": [
                    "+13175845522"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "148 E Main St",
                        "locality": "Mooresville",
                        "postcode": "46158-1404",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "148977114958155",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Intelligent Exteriors",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194e144996b40035b7cd8476983f6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.8918117,
                    51.9116838
                ]
            },
            "properties": {
                "categories": {
                    "primary": "dentist",
                    "alternate": [
                        "hospital",
                        "doctor"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://dentalimplantcolchester.co.uk/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/244730469253343"
                ],
                "phones": [
                    "+441206752500"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "13a Nayland Road",
                        "locality": "Colchester",
                        "postcode": "CO4 5EG",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "244730469253343",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dental Implant Centre Colchester",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa883cedd4c75a032eaf90dafc5f46",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -42.11308,
                    -19.7273336
                ]
            },
            "properties": {
                "categories": {
                    "primary": "aircraft_dealer",
                    "alternate": [
                        "business_to_business_services"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://instagram.com/afscompraevendadeaeronaves?igshid=1gr10oxlxcqo7"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108667860615596"
                ],
                "phones": [
                    "+5533999917589"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Caratinga",
                        "postcode": null,
                        "region": "MG",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108667860615596",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AFS Brasil Compra e venda de aeronaves",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81394936b50c037616e54cbba05f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.9876086,
                    -23.0310624
                ]
            },
            "properties": {
                "categories": {
                    "primary": "travel",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.localiza.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08009792020"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Estr. da Boiada 97",
                        "locality": "Vinhedo",
                        "postcode": "13280-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1407374887153289",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Localiza",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39336522313b50305791fafbbfd7d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -9.0636989,
                    38.6465588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/196477087062363"
                ],
                "phones": [
                    "+351966088924"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Cabinda 2e",
                        "locality": "Barreiro",
                        "postcode": "2830-169",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "196477087062363",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Anna Pedroso estética",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650570175d2020302b7d94e92d38b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    101.5233,
                    3.1880986
                ]
            },
            "properties": {
                "categories": {
                    "primary": "agricultural_service",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/190931220777248"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Elmina",
                        "locality": "Shah Alam",
                        "postcode": "40160",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "190931220777248",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AF Fisheries",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f288545575b2f603e62d3c92bed8d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -116.9253971,
                    44.0068951
                ]
            },
            "properties": {
                "categories": {
                    "primary": "prosthetics",
                    "alternate": [
                        "disability_services_and_support_organization",
                        "professional_services"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://evergreenpo.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/136604193486392"
                ],
                "phones": [
                    "+12088841294"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Evergreen Prosthetics and Orthotics",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "431 S Whitley Dr",
                        "locality": "Fruitland",
                        "postcode": "83619-2542",
                        "region": "ID",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "136604193486392",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978620624",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912986951",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Evergreen Prosthetics & Orthotics",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e8ad364ca8c03f598d910dd3f99",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.785148,
                    33.331612
                ]
            },
            "properties": {
                "categories": {
                    "primary": "history_museum",
                    "alternate": [
                        "arts_and_entertainment",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": [
                    "http://www.livenation.com/venues/14486/oak-mountain-amphitheatre"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/956216014413908"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1000 Amphitheater Rd",
                        "locality": "Pelham",
                        "postcode": "35124-4345",
                        "region": "AL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "956216014413908",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lynyrd Skynyrd",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f266d488652a000303144f6ac21be9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.57415,
                    38.21659
                ]
            },
            "properties": {
                "categories": {
                    "primary": "resort",
                    "alternate": [
                        "hotel"
                    ]
                },
                "confidence": 0.8828720836685439,
                "websites": [
                    "https://www.extendedstayamerica.com/hotels/ky/louisville/hurstbourne"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "5024996215"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9801 Bunsen Way",
                        "locality": "Louisville",
                        "postcode": "40299",
                        "region": "KY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932391287",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949955259498",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949954988278",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912072510",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "103026214515656",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Extended Stay America - Louisville - Hurstbourne",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fb4258201c820398121e73cdce0d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.8082558,
                    49.0424265
                ]
            },
            "properties": {
                "categories": {
                    "primary": "police_department",
                    "alternate": [
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.gendarmerie.interieur.gouv.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/166706267497068"
                ],
                "phones": [
                    "+33160015007"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "14 Rue du Point du Jour",
                        "locality": "Saint-Soupplets",
                        "postcode": "77165",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "166706267497068",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Gendarmerie Nationale",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28949907a062d0344f4517359b262",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.9813895,
                    43.4888287
                ]
            },
            "properties": {
                "categories": {
                    "primary": "massage",
                    "alternate": [
                        "health_and_medical",
                        "naturopathic_holistic"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.ahhhsomerelaxation.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/333488286796442"
                ],
                "phones": [
                    "+12085231209"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "939 S 25th E",
                        "locality": "Ammon",
                        "postcode": "83406-5731",
                        "region": "ID",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "333488286796442",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ahhhsome Relaxation",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a486454b69c03698e1ef74f18d6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.69447,
                    13.66305
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108527092257961"
                ],
                "phones": [
                    "+66954592296"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ข้างร้านหมอฟันราม2 สไมล์ ตรงข้ามKFC นัมเบอร์วันราม2",
                        "locality": "Bangkok",
                        "postcode": "10250",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108527092257961",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Chill Chill we’re drink",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6e708c4d4400360aab86a4e13ef",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    134.6300786,
                    35.6430798
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive",
                    "alternate": [
                        "cafe",
                        "auto_company"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/270486910078121"
                ],
                "phones": [
                    "+81796363870"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "兵庫県美方郡香美町香住区香住１８５５",
                        "locality": "美方郡香美町",
                        "postcode": "669-6544",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "270486910078121",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "（有）ワタナベマリンサービス",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195d09a025836033a5114d46a032b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.2578,
                    51.7519
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "dog_trainer",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "http://www.tobyshair.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/318683334947263"
                ],
                "phones": [
                    "+447906073673"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Oxford",
                        "postcode": null,
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "318683334947263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tobys hair groomers",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e2922080e01003c06f1baf2ff3e2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    140.0118574,
                    36.8527701
                ]
            },
            "properties": {
                "categories": {
                    "primary": "agricultural_cooperatives",
                    "alternate": [
                        "shopping",
                        "farm"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.furuya-farm.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/929460827132866"
                ],
                "phones": [
                    "+81287233502"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "95-19 Kajiya",
                        "locality": null,
                        "postcode": "324-0046",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "929460827132866",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "古谷農産",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66e474122006803d97123afc2c54c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.216527,
                    4.83172
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/775938939283373"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "775938939283373",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hacienda La Capilla",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe63cc88b4606038c2a86a568944c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    145.0162,
                    -37.90094
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landscaping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": [
                    "http://www.nativeelements.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/569477533214315"
                ],
                "phones": [
                    "+61418545176"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Gardenvale",
                        "postcode": null,
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "569477533214315",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Native Elements Landscaping",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f182026d43662e038cb391c99de14c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.3652625,
                    54.3720067
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mountain",
                    "alternate": [
                        "structure_and_geography"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/181592841873775"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "IE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "181592841873775",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Truskmore SE Cairn",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d4552e91b02b03cadb0f31aeefc8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    40.2157673,
                    47.7093946
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_plaza",
                    "alternate": [
                        "landmark_and_historical_building",
                        "park"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/299169030675031"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "299169030675031",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Площадь им. В.И. Ленина",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba01342d51b3035f6e723248a60d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.92706,
                    24.79152
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_stand",
                    "alternate": [
                        "grocery_store",
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/459160134220006"
                ],
                "phones": [
                    "+886933522541"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "香北路145-6號",
                        "locality": "新竹市",
                        "postcode": "300",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "459160134220006",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "孫家炸.烤.吉布來",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28d542c91669e033c683859dfdff4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.33275,
                    47.6047
                ]
            },
            "properties": {
                "categories": {
                    "primary": "public_and_government_association",
                    "alternate": [
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://seattle.gov/laborstandards"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1411559342508084"
                ],
                "phones": [
                    "+12062565297"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "810 3rd Ave",
                        "locality": "Seattle",
                        "postcode": "98104-1602",
                        "region": "WA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1411559342508084",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Seattle Office of Labor Standards",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39664615a2a93031e0365131ff3a2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    0.0786451,
                    43.2320034
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "cosmetic_and_beauty_supplies"
                    ]
                },
                "confidence": 0.948076923076923,
                "websites": [
                    "https://www.sephora.fr/information-magasin?storeid=s4211"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/116073835222527"
                ],
                "phones": [
                    "+33562340164"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "SEPHORA",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "73 Rue Maréchal Foch",
                        "locality": "Tarbes",
                        "postcode": "65000",
                        "region": "OCC",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "116073835222527",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SEPHORA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f0884b9532bb160378c7e46351fb6f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.97009,
                    60.309559
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pet_store",
                    "alternate": [
                        "motorsports_store",
                        "retail"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "https://www.motocrossbutiken.se/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129654407051197"
                ],
                "phones": [
                    "+46704674301"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bältarbo 143",
                        "locality": "Hedemora",
                        "postcode": "776 90",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129654407051197",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Doghill Racing - motocrossbutiken.se",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9302e502552037be8c4e6d8d4f9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.3811646,
                    39.1998601
                ]
            },
            "properties": {
                "categories": {
                    "primary": "american_restaurant",
                    "alternate": [
                        "restaurant",
                        "bar_and_grill_restaurant"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://www.triobistro.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/280130912012"
                ],
                "phones": [
                    "+15139841905"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7565 Kenwood Rd",
                        "locality": "Cincinnati",
                        "postcode": "45236-2800",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "280130912012",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965467494",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Trio Bistro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6585ada6699140314a9af0b39a05e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.5251,
                    10.6232
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mountain",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107044580994834"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Sihanoukville (city)",
                        "postcode": null,
                        "region": null,
                        "country": "KH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107044580994834",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ជ្រោះអណ្ដាតពង្រូល",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc22d36ab4d1100345a5a41bee3fad",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.48477,
                    -36.94609
                ]
            },
            "properties": {
                "categories": {
                    "primary": "arts_and_crafts",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111311580246842"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7400",
                        "locality": "Olavarría",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111311580246842",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Artesanías & Manías",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e2935c5b124003be3224d7e3b926",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.9325449,
                    36.807509
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "sushi_restaurant"
                    ]
                },
                "confidence": 0.9588815789473685,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/305103249538227"
                ],
                "phones": [
                    "+81287431663"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "栃木県矢板市扇町１丁目１２−２０",
                        "locality": "矢板市",
                        "postcode": "329-2161",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "305103249538227",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "とんかつ松島",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28d54297b29980376c42372aa88fb",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.3522491,
                    47.6479607
                ]
            },
            "properties": {
                "categories": {
                    "primary": "engineering_services",
                    "alternate": [
                        "architectural_designer",
                        "contractor"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.ssaacoustics.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/199146286791566"
                ],
                "phones": [
                    "+12068390819"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7409 Greenwood Ave N",
                        "locality": "Seattle",
                        "postcode": "98103-5063",
                        "region": "WA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "199146286791566",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SSA Acoustics, LLP",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f80295cd8994032619d54e8c7bbd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.348157,
                    47.760157
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.ecotel.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/312146438979020"
                ],
                "phones": [
                    "+33389452332"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "158 Rue d'Illzach",
                        "locality": "Mulhouse",
                        "postcode": "68100",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "312146438979020",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Plaisir de Table Ecotel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a926c60e0499033add3d38030a1d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.7763496,
                    39.5535285
                ]
            },
            "properties": {
                "categories": {
                    "primary": "burger_restaurant",
                    "alternate": [
                        "fast_food_restaurant",
                        "breakfast_and_brunch_restaurant"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://locations.wendys.com/united-states/in/shelbyville/2035-n-riley-hwy"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/198864230159852"
                ],
                "phones": [
                    "+13174211703"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Wendy's",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "2035 N Riley Hwy",
                        "locality": "Shelbyville",
                        "postcode": "46176-9465",
                        "region": "IN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "198864230159852",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949958091316",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978022263",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wendy's",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3919333018ca1034ee450a59271ed",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -3.5698322,
                    37.1254119
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "coffee_shop",
                        "bar"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/390038527795464"
                ],
                "phones": [
                    "+34652567473"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle Cervantes, 1",
                        "locality": "Cájar",
                        "postcode": "18199",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "390038527795464",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Blanco y Negro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f396919828d21403daf1df1120c88e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.6347624,
                    43.3108231
                ]
            },
            "properties": {
                "categories": {
                    "primary": "painting",
                    "alternate": [
                        "home_improvement_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://www.tollens.com/magasin/sainte-maxime"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109824958129346"
                ],
                "phones": [
                    "+33494965045"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "16 Place Jean Mermoz",
                        "locality": "Sainte-Maxime",
                        "postcode": "83120",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109824958129346",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tollens",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415cb4b1b648203877b5b55e2c806",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.8104051,
                    21.0365701
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_goods_store",
                    "alternate": [
                        "shopping",
                        "vietnamese_restaurant"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1721151434791582"
                ],
                "phones": [
                    "+841644883595"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Phố Linh Lang 22",
                        "locality": "Hà Nội",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1721151434791582",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "22 linh lang đội cấn ba đình hà nội",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a2a2b8d31b03e009dc2fed6555",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.7556267,
                    35.980062
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_cleaning",
                    "alternate": [
                        "clothing_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/794390500711815"
                ],
                "phones": [
                    "+81487522535"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "埼玉県春日部市粕壁東１丁目８−２６",
                        "locality": "春日部市",
                        "postcode": "344-0062",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "794390500711815",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "やまとや京染店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e1b2d6c6e50103307055740efbff",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    20.4828699,
                    44.80759
                ]
            },
            "properties": {
                "categories": {
                    "primary": "caterer",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1960718520870527"
                ],
                "phones": [
                    "+381113621551"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Belgrade",
                        "postcode": null,
                        "region": null,
                        "country": "RS"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1960718520870527",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Catering and Bake.rs",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f30db2ec4467400366189bf8aad47c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    130.1892792,
                    32.4585645
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "asian_restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/658025687715467"
                ],
                "phones": [
                    "+81969241458"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "熊本県天草市大浜町９−２２",
                        "locality": "天草市",
                        "postcode": "863-0015",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "658025687715467",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "花むら",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8dc9b4d1c0d035c92208101e143",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.86797,
                    26.7545
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cinema",
                    "alternate": [
                        "movie_television_studio"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/129718790230627"
                ],
                "phones": [
                    "+918382094497"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "सिराज हाउस",
                        "locality": "Lucknow",
                        "postcode": "261201",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "129718790230627",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "slmane siraj",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f694e50cc9a1aa03169c7d7a420cd2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.092211,
                    14.325954
                ]
            },
            "properties": {
                "categories": {
                    "primary": "emergency_room",
                    "alternate": [
                        "medical_center"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/403443313781733"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "403443313781733",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BDH Emergency Room",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3950c9c6ac26e037cc21f32604246",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.072231,
                    38.5725952
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "immigration_law",
                        "professional_services"
                    ]
                },
                "confidence": 0.9504067173970087,
                "websites": [
                    "https://www.grupoglobalgest.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/672444182788164"
                ],
                "phones": [
                    "+34673689263"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avinguda de l'Albir, 66",
                        "locality": "l'Alfàs del Pi",
                        "postcode": "03581",
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "672444182788164",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Real Estate - Real Estate Personal Shopper / Real Estates Costa Blanca - Global Gest Group",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44dd02b48a93203669105902c6e45",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.6631318,
                    34.9504506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "construction_services",
                        "professional_services"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://hershbergerconstruction.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/165758704044074"
                ],
                "phones": [
                    "+18648781900"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "125 Wash Lesley Rd",
                        "locality": "Pickens",
                        "postcode": "29671-9757",
                        "region": "SC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "165758704044074",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hershberger Construction Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe63cd12d9c1b0348da6d217d26d8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    145.09406,
                    -37.85692
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "psychiatrist",
                        "counseling_and_mental_health"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.delmonthospital.com.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111287815599230"
                ],
                "phones": [
                    "+61398057333"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "300 Warrigal Rd",
                        "locality": "Melbourne",
                        "postcode": "3146",
                        "region": "VIC",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111287815599230",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Delmont Private Hospital",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a30431ac599a034840279758b7a1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.3246133,
                    42.8906925
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_product_supplier",
                    "alternate": [
                        "business_equipment_and_supply",
                        "business_to_business"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://stores.sallybeauty.com/nh/derry/beauty-supply-derry-nh-1749.html"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "6034252352"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "55 Crystal Ave Ste 13",
                        "locality": "Derry",
                        "postcode": "03038",
                        "region": "NH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899911345931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899908100751",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sally Beauty",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e202311980de0311186f85bea093",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    17.99059,
                    51.28328
                ]
            },
            "properties": {
                "categories": {
                    "primary": "graphic_designer",
                    "alternate": [
                        "arts_and_crafts"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104497302578451"
                ],
                "phones": [
                    "+48123123123"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Kępno gmina",
                        "postcode": null,
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104497302578451",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dream Design PL",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f48b23722b010e036415b2ce621215",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.2080281,
                    26.076501
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_health_care",
                    "alternate": [
                        "pharmacy"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109384147576676"
                ],
                "phones": [
                    "+19565450081"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "302 E Queen Isabella Blvd",
                        "locality": "Port Isabel",
                        "postcode": "78578-2407",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109384147576676",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Vida Divina, LLC",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad680e6b634c03185455ab853688",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -78.5285737,
                    35.5792374
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "https://mobileenginemedics.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113028747168175"
                ],
                "phones": [
                    "+19162565962"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "65 Vintage Ct",
                        "locality": "Clayton",
                        "postcode": "27520-8738",
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113028747168175",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mobile Engine Medics",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a238dda5c4203d60311cbc5c9da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    99.7619491,
                    16.2041735
                ]
            },
            "properties": {
                "categories": {
                    "primary": "parking",
                    "alternate": [
                        "thai_restaurant"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/394329900677436"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Khlong Khlung",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "394329900677436",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ร้านตะวันแดง โค้ววิไล",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa90e90236d21603812f755c789aee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -51.17908,
                    -29.92183
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/290513014919908"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Ipiranga, 95",
                        "locality": "Canoas",
                        "postcode": "92010-290",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "290513014919908",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Flá Silva Tattoo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f685890699483203888c80ec7b86df",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    125.47676,
                    7.03911
                ]
            },
            "properties": {
                "categories": {
                    "primary": "housing_authorities",
                    "alternate": [
                        "real_estate_agent",
                        "real_estate"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/187499258732585"
                ],
                "phones": [
                    "+639916162656"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Davao City",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "187499258732585",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Camella Toril",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa901298c680c303fbcbeb1f08ff1f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -51.17067,
                    -30.02795
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "real_estate_agent"
                    ]
                },
                "confidence": 0.9398496240601504,
                "websites": [
                    "http://www.auxiliadorapredial.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104181705096405"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Doutor Nilo Peçanha, 2146",
                        "locality": "Porto Alegre",
                        "postcode": "91330-002",
                        "region": "RS",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104181705096405",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Regina Rocha - Consultora Imobiliária",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f599e095ae678103cf0f4cf9e6273e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.11333,
                    10.9922
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": [
                        "hotel",
                        "medical_service_organizations"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100578364881722"
                ],
                "phones": [
                    "+233593205765"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "P. O BOX PG16 PAGA Kum High Street. ADJCENT CHIEF CROCODILE POND",
                        "locality": "Paga",
                        "postcode": null,
                        "region": null,
                        "country": "GH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100578364881722",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Paga Motel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f28347343767850317d352a8a8b385",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.9319,
                    37.28499
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accountant",
                    "alternate": [
                        "lawyer",
                        "financial_service"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://perisho.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/439254062863047"
                ],
                "phones": [
                    "+14089855125"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2105 S Bascom Ave",
                        "locality": "Campbell",
                        "postcode": "95008-3271",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "439254062863047",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Perisho Tombor Brown",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a1057201c380033964f88320f242",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.150708,
                    41.033585
                ]
            },
            "properties": {
                "categories": {
                    "primary": "music_and_dvd_store",
                    "alternate": [
                        "shopping",
                        "music_venue"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.musicandvideo.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/401053283298558"
                ],
                "phones": [
                    "+12012369107"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1 Surrey Ln",
                        "locality": "Allendale",
                        "postcode": "07401-1416",
                        "region": "NJ",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "401053283298558",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Music and Video.com",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f195dba6d64c8d03c888fa4934e2dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.4491881,
                    51.8939136
                ]
            },
            "properties": {
                "categories": {
                    "primary": "discount_store",
                    "alternate": [
                        "nursery_and_gardening"
                    ]
                },
                "confidence": 0.988593545001312,
                "websites": [
                    "https://www.bmstores.co.uk/stores/luton-488"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/605865736291416"
                ],
                "phones": [
                    "+443308389488"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "B&M Stores",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "38 Wingate Road",
                        "locality": "Luton",
                        "postcode": "LU4 8",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "605865736291416",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949962189904",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "B&M Stores",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65a02167a348503d213051529b7bc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    105.1611633,
                    9.18392
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://ristudio.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/193766013817078"
                ],
                "phones": [
                    "+84898821777"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "195 Đường Trần Hưng Đạo",
                        "locality": "Cà Mau",
                        "postcode": "98110",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "193766013817078",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RI'Studio ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f68156581107b6032f5b7f07ce632a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    116.1427449,
                    6.0233128
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9119318181818182,
                "websites": [
                    "https://www.mudah.my/eddie-lo-autohaven-superstore-kota-kinabalu"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/640994229368726"
                ],
                "phones": [
                    "+60103839833"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "640994229368726",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Quality New & Used Car By Nora",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eeeb6e89a22b033634913a6d95ea",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.0576765,
                    44.4626068
                ]
            },
            "properties": {
                "categories": {
                    "primary": "adult_entertainment",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/224742720718544"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calea Griviței 216",
                        "locality": "București",
                        "postcode": "010759",
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "224742720718544",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "XeX",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8a061c28d54a03ae4d7413adac5a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.28565,
                    -22.88042
                ]
            },
            "properties": {
                "categories": {
                    "primary": "plastic_fabrication_company",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.rebrinde.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104372763289092"
                ],
                "phones": [
                    "+5521964923465"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua José dos Reis, 1990",
                        "locality": "Rio de Janeiro",
                        "postcode": "20760-246",
                        "region": "RJ",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104372763289092",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rebrinde",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f5652e3a9a550361cd452622d9f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    18.5893958,
                    53.0177878
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": [
                        "dj_service"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": [
                    "https://737flight.pl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106064228951726"
                ],
                "phones": [
                    "+48732737737"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ulica gen. Józefa Bema 73",
                        "locality": "Toruń",
                        "postcode": "87-100",
                        "region": "04",
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106064228951726",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "737Flight",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f652626575006c0331190b87b7c6ee",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.7625639,
                    1.4781544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "auto_detailing",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111011211846686"
                ],
                "phones": [
                    "+60123808602"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Johor Bahru",
                        "postcode": null,
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111011211846686",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "R&R Auto Detailer  Tebrau",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3f304e1b3419b0316ca9a18b27ca2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.4675562,
                    35.9023429
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flea_market",
                    "alternate": [
                        "shopping",
                        "bar"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/362188480489008"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "MT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "362188480489008",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bkara Market",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c164ed86d61b038014e6301f53c8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    83.0398235,
                    25.3083613
                ]
            },
            "properties": {
                "categories": {
                    "primary": "electronics",
                    "alternate": [
                        "retail"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.samsungsmartplaza.co.in/samsung-smartplaza-national-industries-electronics-retail-and-repair-shop-bindra-bazar-azamgarh-109953/Home?utm_source=locator&utm_medium=bing"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07039003516"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Varanasi Road, Bindra Bazar",
                        "locality": "Azamgarh",
                        "postcode": "276205",
                        "region": "Uttar Pradesh",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1688849863994570",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Samsung SmartPlaza - National Industries",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f658b59025b2d90344bd17c3e1d5f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.7431859,
                    13.5044215
                ]
            },
            "properties": {
                "categories": {
                    "primary": "seafood_restaurant",
                    "alternate": [
                        "restaurant",
                        "delicatessen"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100349968613938"
                ],
                "phones": [
                    "+66876881468"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Sukhumvit",
                        "locality": "Bang Pu",
                        "postcode": "10280",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100349968613938",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ร้านอาหารลมทะเล บางปู",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ad0303505c7303a934b480c6d246",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.91433,
                    34.3291899
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_repair",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/123653742370732"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Wilmington",
                        "postcode": null,
                        "region": "NC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "123653742370732",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mike's Auto Repair",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f441a89a169a4b03e9aac671e56dc9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.4558029,
                    27.9473002
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": [
                    "https://www.youtube.com/channel/ucf2cmcj3e81y0oy2vhgbckq"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106332011050033"
                ],
                "phones": [
                    "+18138988564"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Tampa",
                        "postcode": null,
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106332011050033",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La cocina de pino",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb91689b06e5720385b26025b55015",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    138.667727,
                    -34.663299
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "pet_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100587091668443"
                ],
                "phones": [
                    "+61478768397"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "88 Peerless Rd",
                        "locality": "Adelaide",
                        "postcode": "5115",
                        "region": "SA",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100587091668443",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The TBAWW Collective",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81888a80840a0352a7c5203f80ca",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.6882949,
                    -21.7349055
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_store",
                    "alternate": [
                        "electronics",
                        "mobile_phone_store"
                    ]
                },
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.mscsoft.com.br/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/187310008040598"
                ],
                "phones": [
                    "+551633852081"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Prudente de Morais, 743",
                        "locality": "Tabatinga",
                        "postcode": "14910-000",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "187310008040598",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MscSoft - Informática e Eletrônicos",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f498eacb25308403da9411bd252770",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -102.30397,
                    21.8617
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/255719255145213"
                ],
                "phones": [
                    "+524494651137"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Aguascalientes",
                        "postcode": null,
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "255719255145213",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jacqueline & Daniel / Bienes Raíces",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fcfa471189284803602bb2ec627592",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -69.1942956,
                    -51.6407175
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/119224619485192"
                ],
                "phones": [
                    "+542966418808"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rogelio Yrurtia 749",
                        "locality": "Rio Gallegos",
                        "postcode": "Z9400",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "119224619485192",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Solo Tortas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6d69ad1364b6a039c52478a2bf2e7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.11755,
                    9.99931
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.926605504587156,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1194804794031172"
                ],
                "phones": [
                    "+50685506013"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Heredia",
                        "locality": "Heredia",
                        "postcode": "0000",
                        "region": null,
                        "country": "CR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1194804794031172",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Camaleonstorecr",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4986551d821910306a71e9080adba",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -99.5912399,
                    19.1015891
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shoe_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/247345438454264"
                ],
                "phones": [
                    "+5217291442717"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle de la Independencia 208",
                        "locality": "Tenango del Valle",
                        "postcode": "52300",
                        "region": null,
                        "country": "MX"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "247345438454264",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "NERO Sneakers ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e88c1832db5e03aa15209de949c8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    16.2837734,
                    41.3211208
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cocktail_bar",
                    "alternate": [
                        "beach",
                        "bar"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/469277853405131"
                ],
                "phones": [
                    "+393917481094"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Barletta",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "469277853405131",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beach Supperr Club",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44e509b4ad9200305e9006143950b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.8585018,
                    30.3324488
                ]
            },
            "properties": {
                "categories": {
                    "primary": "paving_contractor",
                    "alternate": [
                        "mining"
                    ]
                },
                "confidence": 0.9285033365109628,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108798721601394"
                ],
                "phones": [
                    "+18508904708"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "9931 Highway 79",
                        "locality": "Panama City Beach",
                        "postcode": "32413-9329",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108798721601394",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "79 Rock & Dirt",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f19422848e622b03dd4e2a37f7122f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -1.4266313,
                    53.2258195
                ]
            },
            "properties": {
                "categories": {
                    "primary": "psychologist",
                    "alternate": [
                        "sports_medicine",
                        "doctor"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "07968258848"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "14 Jawbones Hill",
                        "locality": "Chesterfield",
                        "postcode": "S40 2EN",
                        "region": null,
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1125899908539642",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Optimum Sports Rehab",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f446d51510549a0385965a2227506a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.585217,
                    30.216496
                ]
            },
            "properties": {
                "categories": {
                    "primary": "endodontist",
                    "alternate": [
                        "pediatric_dentist",
                        "periodontist"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://denttistpro.com/?utm_source=BingListing&utm_medium=Organic"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "2815006026"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "32919 Tamina Rd Ste A",
                        "locality": "Magnolia",
                        "postcode": "77354",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799819094095",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Denttist Pro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f65b56cacd17b30329a7d82642d7d7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.6736412,
                    11.0079265
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lake",
                    "alternate": null
                },
                "confidence": 0.45940594059405937,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/260634707432585"
                ],
                "phones": [
                    "+84966861123"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "51 Đường Phạm Ngọc Thạch",
                        "locality": "Thủ Dầu Một",
                        "postcode": "75111",
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "260634707432585",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Vật Liệu & Thiết Bị Hồ Cá Đại Lộc Phát",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a180bc92ab1037512a97f8fb204",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.64672,
                    34.151861
                ]
            },
            "properties": {
                "categories": {
                    "primary": "central_government_office",
                    "alternate": [
                        "fast_food_restaurant",
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://www.cityseekr.com/burbank/entertainment-venues/poi-calabasas-civic-center-amphitheatre-674860.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/159069754135161"
                ],
                "phones": [
                    "+18182241657"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "200 Civic Center Way",
                        "locality": "Calabasas",
                        "postcode": "91302-4114",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "159069754135161",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Calabasas Civic Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e0a50174a4d00349baf2b172829a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    21.02891,
                    46.82381
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9140030441400304,
                "websites": [
                    "https://beta-doterra.myvoffice.com/csaladiesszenciak"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/136734796190006"
                ],
                "phones": [
                    "+36307570395"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Mezobereny",
                        "postcode": null,
                        "region": null,
                        "country": "HU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "136734796190006",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Családi Esszenciák - Family Essentials",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb24354b7324e40303dafb82943ac2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -64.29107,
                    -31.29288
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1293529307417147"
                ],
                "phones": [
                    "+543543579412"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Villa Allende",
                        "postcode": null,
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1293529307417147",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Silvia Minasian",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0a4508305a030b313ff8d90592",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.52442,
                    25.05793
                ]
            },
            "properties": {
                "categories": {
                    "primary": "medical_service_organizations",
                    "alternate": [
                        "health_and_medical",
                        "community_services_non_profits"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": [
                    "https://www.tade.org.tw/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/182736472369937"
                ],
                "phones": [
                    "+886225603118"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "民生東路一段42號",
                        "locality": "台北市",
                        "postcode": "104",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "182736472369937",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "社團法人中華民國糖尿病衛教學會",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a12cf5b2a0c003c4e2203e27aa8a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.454514,
                    41.119625
                ]
            },
            "properties": {
                "categories": {
                    "primary": "attractions_and_activities",
                    "alternate": [
                        "park",
                        "lake"
                    ]
                },
                "confidence": 0.5739644970414202,
                "websites": [
                    "http://www.lakenaomiclub.com/web/pages/home"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1089354731089402"
                ],
                "phones": [
                    "+15706469191"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rt. 423",
                        "locality": "Pocono Pines",
                        "postcode": "18350",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1089354731089402",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Lake Naomi Timber Trails Community",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ee8d18d6219b03f1fe512412e260",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.35351,
                    44.21774
                ]
            },
            "properties": {
                "categories": {
                    "primary": "town_hall",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://www.primaria-herasti.ro/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/685449078556155"
                ],
                "phones": [
                    "+40246253495"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Herasti",
                        "postcode": null,
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "685449078556155",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Primăria Herăști",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f537369c7b172a03173a27c082332a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    46.67064,
                    24.74122
                ]
            },
            "properties": {
                "categories": {
                    "primary": "men's_clothing_store",
                    "alternate": null
                },
                "confidence": 0.9245689655172413,
                "websites": [
                    "https://www.elmwada.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/377671348763945"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "شارع الملك فهد الرياض",
                        "locality": "Riyadh",
                        "postcode": null,
                        "region": null,
                        "country": "SA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "377671348763945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mawada KSA",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f659951a8acb2d0315bbb9f97cc5bd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    102.15972,
                    14.76079
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101731358893253"
                ],
                "phones": [
                    "+66843269798"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Amphoe Chok Chai",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101731358893253",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ดับเบิ้ลชา สาขาโชคชัย",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e9b0e24c2b92035351e8d30ba065",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.7320572,
                    38.1432523
                ]
            },
            "properties": {
                "categories": {
                    "primary": "holiday_rental_home",
                    "alternate": [
                        "social_service_organizations",
                        "landmark_and_historical_building"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "https://www.casevacanzacapodorlando.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/317294348125215"
                ],
                "phones": [
                    "+393518885869"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Torrente Forno, 56b",
                        "locality": "Capo d'Orlando",
                        "postcode": "98071",
                        "region": "82",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "317294348125215",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Magico Apartments - 450m dal lungomare",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2aac8c96e322203ffe1d360823d4a",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.5877074,
                    39.9424377
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate",
                    "alternate": [
                        "real_estate_agent",
                        "professional_services"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.tiffanydirocco.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106140918237962"
                ],
                "phones": [
                    "+16107661551"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "300 Willowbrook Ln",
                        "locality": "West Chester",
                        "postcode": "19382-5594",
                        "region": "PA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106140918237962",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tiffany DiRocco Real Estate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e30614e652e03217ec626d1b2f6",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.60476,
                    -34.45084
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108335678558411"
                ],
                "phones": [
                    "+541158182548"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Los Troncos del Talar, Buenos Aires, Argentina",
                        "locality": "Virreyes",
                        "postcode": "1618",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108335678558411",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MARNA Calzados",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f618eb29b5cae903af95472e6a0dc9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.15103,
                    13.114
                ]
            },
            "properties": {
                "categories": {
                    "primary": "life_coach",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106201118739148"
                ],
                "phones": [
                    "+919445512011"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "GNG Street vardharajapuramnAMBATTUR chennai. ",
                        "locality": "Chennai",
                        "postcode": "600053 ",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106201118739148",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SitaraAnsar Wellness Coach",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f68e45a55a1da403cb87c37ec9b5da",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    119.8926,
                    5.14047
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/285385797987455"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bongao,Tawi-Tawi",
                        "locality": "Bongao",
                        "postcode": "7500",
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "285385797987455",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "A&Z Mee Goreng-Hot&Spicy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2d30993301c9803263838c1e5ac4e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    30.5196495,
                    39.7733002
                ]
            },
            "properties": {
                "categories": {
                    "primary": "women's_clothing_store",
                    "alternate": [
                        "shopping",
                        "clothing_store"
                    ]
                },
                "confidence": 0.45940594059405937,
                "websites": [
                    "http://taksimmagazalari.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/164458393890916"
                ],
                "phones": [
                    "+902222202894"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Hamam Yolu Caddesi 26",
                        "locality": "Odunpazarı",
                        "postcode": "26010",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "164458393890916",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Taksim Büyük Beden",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2b9bd5203345603a8e6bd963bcd2c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.3906128,
                    43.7815801
                ]
            },
            "properties": {
                "categories": {
                    "primary": "day_care_preschool",
                    "alternate": [
                        "preschool",
                        "home_service"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "http://www.ghns.ca/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/423050947797132"
                ],
                "phones": [
                    "+14162229405"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3125 Bayview Ave",
                        "locality": "Toronto",
                        "postcode": "M2K 1G2",
                        "region": "ON",
                        "country": "CA"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "423050947797132",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374890540747",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bayview Gardens Child Care",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f2e4f3c9643203c07adbdd1cf688",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.1749991,
                    55.8181999
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "bed_and_breakfast",
                        "agriculture"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1419412021603731"
                ],
                "phones": [
                    "+46702677734"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Virkevägen 34-19",
                        "locality": "Kävlinge",
                        "postcode": "244 91",
                        "region": null,
                        "country": "SE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1419412021603731",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Wirketorp Country Hotel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a8d90235a18e0366496673897afa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.32679,
                    37.52539
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "hotel"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://richmondairport.homewoodsuites.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/203689173624818"
                ],
                "phones": [
                    "+18043286824"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "5996 Audubon Dr",
                        "locality": "Sandston",
                        "postcode": "23150-1340",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "203689173624818",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "RIC Shamin Hospitality",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fda84266872333036a653697c096c9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    170.4857272,
                    -45.8639519
                ]
            },
            "properties": {
                "categories": {
                    "primary": "accommodation",
                    "alternate": [
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/366217290096496"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Dunedin",
                        "postcode": null,
                        "region": null,
                        "country": "NZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "366217290096496",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kaikorai Community Common",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f393376491ba4603c39017c073a1ab",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -9.2264797,
                    38.9188836
                ]
            },
            "properties": {
                "categories": {
                    "primary": "financial_service",
                    "alternate": [
                        "insurance_agency"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1545618575663875"
                ],
                "phones": [
                    "+351219663801"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Ninho do Mocho 6",
                        "locality": "Mafra",
                        "postcode": "2665-605",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1545618575663875",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Abrantes Pinheiro",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a996caa2118b0371188cb8d99be0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.1814492,
                    36.3570001
                ]
            },
            "properties": {
                "categories": {
                    "primary": "holiday_rental_home",
                    "alternate": [
                        "accommodation",
                        "motel"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://wataugariverrental.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/102622215989945"
                ],
                "phones": [
                    "+14235422100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1413 Broad St",
                        "locality": "Elizabethton",
                        "postcode": "37643-6129",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "102622215989945",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Watauga River Rental",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa52d2cf63a003bd873a58ac6798",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.0130217,
                    51.1930615
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://haan.adfc.de/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/434625036716157"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Stadt Haan",
                        "postcode": null,
                        "region": null,
                        "country": "DE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "434625036716157",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ADFC Haan",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a56ab7438a203f00619b5b6ded1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.168596,
                    33.879279
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sand_and_gravel_supplier",
                    "alternate": [
                        "business_to_business"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "https://www.martinmarietta.com/locations/west/southern-california-aggregates-district/garfield-recycle"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8883042274"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6956 Cherry Ave",
                        "locality": "Long Beach",
                        "postcode": "90805",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324839783574",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Martin Marietta - Garfield Recycle",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c297680b376a034fc7a3ac3ea6dc",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    45.71836,
                    43.29605
                ]
            },
            "properties": {
                "categories": {
                    "primary": "computer_store",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109046387994990"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "улица Узуева 2",
                        "locality": "Грозный",
                        "postcode": "364015",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109046387994990",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PC LUX",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a307408ddc9d0321f7b9af49faf4",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.00971,
                    42.46532
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.30856423173803527,
                "websites": [
                    "http://www.1stingrafix.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/163679150216"
                ],
                "phones": [
                    "+16172011247"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "P.O. Box 1025",
                        "locality": "Saugus",
                        "postcode": "01906",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "163679150216",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "1st-in Grafix",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e8332248e14a0332e78993f5b16b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    14.16984,
                    41.18606
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/240096792809614"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Pignataro Maggiore",
                        "postcode": null,
                        "region": null,
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "240096792809614",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pirelli cavi e Sistemi spa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1948b5b60d076037404ce0aa45975",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    2.3560268,
                    50.839481
                ]
            },
            "properties": {
                "categories": {
                    "primary": "sewing_and_alterations",
                    "alternate": [
                        "clothing_store",
                        "retail"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://labobineamimine.fr/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1440161792957605"
                ],
                "phones": [
                    "+33675275847"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "4 Route de Broxeele",
                        "locality": "Rubrouck",
                        "postcode": "59285",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1440161792957605",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Bobine à Mimine - artisan d'art - Couturier-Tailleur",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8100c151c38203f4698869a7447c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.6406021,
                    -23.548879
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": [
                        "business_to_business_services",
                        "business_to_business"
                    ]
                },
                "confidence": 0.8409697732997481,
                "websites": [
                    "https://quattroinfo.com.br/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "1132929898"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua João Adolfo 118",
                        "locality": "São Paulo",
                        "postcode": "01050-020",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "1970324839482931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1970324839445497",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "165395643626037",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Quattroinfo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f651dc4b33510103e50d9a707f9c3e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.51218,
                    5.64071
                ]
            },
            "properties": {
                "categories": {
                    "primary": "health_food_store",
                    "alternate": [
                        "grocery_store",
                        "bakery"
                    ]
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111873636840856"
                ],
                "phones": [
                    "+60124956009"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "110 Jalan Seruling Indah 4",
                        "locality": "Sungai Petani",
                        "postcode": "08000",
                        "region": "02",
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111873636840856",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sweet&yummy home bakery",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ca8c9b65c6aa0355ad9365e77e1f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.31817,
                    23.3514
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": [
                        "contractor",
                        "building_supply_store"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://skybuildcon.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105876255783630"
                ],
                "phones": [
                    "+919102089990"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "215, Skyline Tower, Kadru Main Road, Kadru, ",
                        "locality": "Ranchi",
                        "postcode": "834002",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105876255783630",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "SKY BuildCon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3c18b4ed2d41503943bac0fe38b98",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    87.8348833,
                    26.5722015
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hospital",
                    "alternate": [
                        "pharmacy"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/105991511155221"
                ],
                "phones": [
                    "+9779848507147"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Shivasatakshi-06, Shivagunj Bus-Stop",
                        "locality": "Jhapa District",
                        "postcode": "57213",
                        "region": null,
                        "country": "NP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "105991511155221",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sirjana Clinic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a8c5b5d5b98a0306d0bf8f213f83",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.1614569,
                    38.2261064
                ]
            },
            "properties": {
                "categories": {
                    "primary": "topic_concert_venue",
                    "alternate": [
                        "community_center",
                        "social_service_organizations"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/159704137393760"
                ],
                "phones": [
                    "+15403376000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "3809 Churchville Ave",
                        "locality": "Churchville",
                        "postcode": "24421-2501",
                        "region": "VA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "159704137393760",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Churchville Community Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f264d1159a85910320f0abe7f65b14",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.8045559,
                    36.1700937
                ]
            },
            "properties": {
                "categories": {
                    "primary": "flowers_and_gifts_shop",
                    "alternate": [
                        "shopping",
                        "jewelry_store"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.jubileeflowers.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/717223631745515"
                ],
                "phones": [
                    "+16153293083"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1702 Jefferson St",
                        "locality": "Nashville",
                        "postcode": "37208-2934",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "717223631745515",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Jubilee Flowers and Gifts",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a9cae104946403f3f5815493d0f7",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.62758,
                    38.352063
                ]
            },
            "properties": {
                "categories": {
                    "primary": "liquor_store",
                    "alternate": [
                        "winery",
                        "grocery_store"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.capitolmarket.net/wineandcheese.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/184361851600"
                ],
                "phones": [
                    "+13043439463"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "800 Smith St",
                        "locality": "Charleston",
                        "postcode": "25301-1208",
                        "region": "WV",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "184361851600",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Wine Shop at Capitol Market",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f262cd2bbaa15103ebbc2d25f78ad9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.2886938,
                    44.8645224
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "noodles_restaurant",
                        "asian_restaurant"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://locations.noodles.com/mn/richfield/7630-lyndale-ave-at-77th.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/476889889050433"
                ],
                "phones": [
                    "+16128693386"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Noodles & Company",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "7630 Lyndale Ave S",
                        "locality": "Richfield",
                        "postcode": "55423-4169",
                        "region": "MN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "476889889050433",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949956997389",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Noodles & Company",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f10c22934456d303c730148c57eb6b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    60.49188,
                    56.79514
                ]
            },
            "properties": {
                "categories": {
                    "primary": "marketing_agency",
                    "alternate": [
                        "business_advertising"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101331121499825"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "улица Евгения Савкова 8",
                        "locality": "Екатеринбург",
                        "postcode": "620036",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101331121499825",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Smm",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8023992ab0331037f2386c0f06600",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -43.0167614,
                    -6.7651767
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1564360070527282"
                ],
                "phones": [
                    "+5589999882058"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Coelho Rodrigues, 270",
                        "locality": "Floriano",
                        "postcode": "64800-000",
                        "region": "PI",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1564360070527282",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Karolzynha Store",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb2c4080cc165d0326561ecc1ee8e0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.5578283,
                    -33.0184146
                ]
            },
            "properties": {
                "categories": {
                    "primary": "pub",
                    "alternate": [
                        "shopping",
                        "arts_and_entertainment"
                    ]
                },
                "confidence": 0.602112676056338,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/194710270608447"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Calle 3 Norte 4",
                        "locality": "Viña del Mar",
                        "postcode": "2520000",
                        "region": null,
                        "country": "CL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "194710270608447",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pub Alcasaba",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ba990e72669903dc267110c04ae0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.156724,
                    44.959065
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mexican_restaurant",
                    "alternate": [
                        "restaurant",
                        "bar"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "http://rollingfatties.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/318900064869548"
                ],
                "phones": [
                    "+12073999246"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "268 Main St",
                        "locality": "Kingfield",
                        "postcode": "04947-4246",
                        "region": "ME",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "318900064869548",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424934235914",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rolling Fatties",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2ab66de1a06160319cddd0c29c894",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.91596,
                    42.6269544
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "hair_salon"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://today-s-headlines.hub.biz/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104421576290141"
                ],
                "phones": [
                    "+15867833101"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "20670 Hall Rd",
                        "locality": "Clinton Twp",
                        "postcode": "48038",
                        "region": "MI",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104421576290141",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Today's Headlines",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa8103b6a867990309932720e73326",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.7194422,
                    -23.5337765
                ]
            },
            "properties": {
                "categories": {
                    "primary": "tire_dealer_and_repair",
                    "alternate": [
                        "auto_company",
                        "automotive"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/288312874557643"
                ],
                "phones": [
                    "+551138365825"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua Barbalha, 281",
                        "locality": "São Paulo",
                        "postcode": "05083-020",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "288312874557643",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tubarão Rodas",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44cd5924dc8b203eb792f671149bd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -85.1659112,
                    35.0748141
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.farmers.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/222244681165008"
                ],
                "phones": [
                    "+14234909200"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "6441 Bonny Oaks Dr",
                        "locality": "Chattanooga",
                        "postcode": "37416",
                        "region": "TN",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "222244681165008",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Farmers Insurance - Jonathan Hunter",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbb29411368c040377816a303140d9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    174.94733,
                    -41.26019
                ]
            },
            "properties": {
                "categories": {
                    "primary": "contractor",
                    "alternate": [
                        "roofing"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/186561384549777"
                ],
                "phones": [
                    "+64226837060"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Wainuiomata ",
                        "locality": "Lower Hutt",
                        "postcode": "5014",
                        "region": null,
                        "country": "NZ"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "186561384549777",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Strictly Roofing Solutions ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d9d876d0370a03e48acaec349f6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    79.5839936,
                    24.9056228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "water_park",
                    "alternate": [
                        "amusement_park",
                        "topic_concert_venue"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/504005550074241"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Bundeli Radio, Dauria, Nowgaov, Chhatarpur",
                        "locality": "Chhatarpur",
                        "postcode": null,
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "504005550074241",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bundeli Radio",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f194ad16a1286403492e8e1773a922",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.1439836,
                    51.4888588
                ]
            },
            "properties": {
                "categories": {
                    "primary": "post_office",
                    "alternate": [
                        "public_service_and_government"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/396274667085915"
                ],
                "phones": [
                    "+443457223344"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "18 Sussex Street",
                        "locality": "London",
                        "postcode": "SW1V 4",
                        "region": "ENG",
                        "country": "GB"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "396274667085915",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963918477",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863712470",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sussex Street Post Office",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a100d396c982038b219c2f2339b3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -73.9574373,
                    40.7296961
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "men's_clothing_store",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.alterbrooklyn.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/159396954916145"
                ],
                "phones": [
                    "+17183490203"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Alter",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "140 Franklin St",
                        "locality": "New York",
                        "postcode": "11222-2042",
                        "region": "NY",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "159396954916145",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Alter",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa83598d8f237003910e048085a2e3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -48.90684,
                    -27.07753
                ]
            },
            "properties": {
                "categories": {
                    "primary": "clothing_store",
                    "alternate": [
                        "b2b_textiles"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104250417926612"
                ],
                "phones": [
                    "+554732300911"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rodovia Ivo Silveira, 1",
                        "locality": "Brusque",
                        "postcode": "88355-000",
                        "region": "SC",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104250417926612",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Mini Mundo Fashion",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4ba0a4c46ac80038da2544bc273be",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    121.56097,
                    25.04763
                ]
            },
            "properties": {
                "categories": {
                    "primary": "medical_supply",
                    "alternate": [
                        "pharmacy"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/165265226675295"
                ],
                "phones": [
                    "+886227692615"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "八德路四段106巷4弄2號",
                        "locality": "台北市",
                        "postcode": "105",
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "165265226675295",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "新生復健器材有限公司",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2e6124d440b90037070f071d20249",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    134.9962759,
                    34.6470619
                ]
            },
            "properties": {
                "categories": {
                    "primary": "seafood_restaurant",
                    "alternate": [
                        "bar",
                        "restaurant"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.cosmicdiner.com"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1256624037684914"
                ],
                "phones": [
                    "+81789187977"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "桜町5-9",
                        "locality": null,
                        "postcode": "673-0885",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1256624037684914",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "北海道知床漁場明石桜町店",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fbe8d88a99d05c03e15b8c1f2eae68",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    153.1206828,
                    -27.5404228
                ]
            },
            "properties": {
                "categories": {
                    "primary": "church_cathedral",
                    "alternate": [
                        "social_service_organizations",
                        "religious_organization"
                    ]
                },
                "confidence": 0.9543204320432043,
                "websites": [
                    "http://www.wesleyan.org.au/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/575244069237335"
                ],
                "phones": [
                    "+61732110066"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "519 Mount Petrie Rd",
                        "locality": "Brisbane",
                        "postcode": "4156",
                        "region": "QLD",
                        "country": "AU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "575244069237335",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "ThreeSixteen Wesleyan Methodist Church",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f6580c262f396c03787d8471953cb3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    104.75,
                    11.8
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/584588205556564"
                ],
                "phones": [
                    "+85592706661"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "oudong Market",
                        "locality": "Oudong",
                        "postcode": null,
                        "region": null,
                        "country": "KH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "584588205556564",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Maliny Cosmitic",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44466a24d8db003936d2c6589789b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.0894457,
                    30.3859838
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://remodelyourhome.net/waterdamagerestorationservice"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8886340161"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1321 N Causeway Blvd",
                        "locality": "Mandeville",
                        "postcode": "70471",
                        "region": "LA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949966021537",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912903107",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899912884773",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Water Damage Restoration by RYH",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2832b1198c15c03ba839437dff2f3",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -121.4744083,
                    38.5716482
                ]
            },
            "properties": {
                "categories": {
                    "primary": "first_aid_class",
                    "alternate": [
                        "occupational_safety",
                        "medical_service_organizations"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://sacramentocprcertification.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109893238550811"
                ],
                "phones": [
                    "+19162458378"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2501 Capitol Ave",
                        "locality": "Sacramento",
                        "postcode": "95816-5880",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109893238550811",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424934470547",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965949806",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849864154227",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1125899911503462",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Safety Training Seminars",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3922064cc886e03a6ae77b6f6d326",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -8.5507779,
                    41.3692726
                ]
            },
            "properties": {
                "categories": {
                    "primary": "furniture_store",
                    "alternate": [
                        "mattress_store"
                    ]
                },
                "confidence": 0.9285033365109628,
                "websites": [
                    "https://inovlar.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1526775130738404"
                ],
                "phones": [
                    "+351919512992"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Famalicão Central Park",
                        "locality": "Vila Nova de Famalicão",
                        "postcode": "4760-727 Ribeirão",
                        "region": null,
                        "country": "PT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1526775130738404",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Inovlar :: Mobiliário & Decoração",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a3078041374d0395285bb3bd1b4d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.3516856,
                    42.5973012
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "coffee_shop",
                        "internet_cafe"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.tinytoesenrichment.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/115983554436592"
                ],
                "phones": [
                    "+19782546211"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "61 Central Sq",
                        "locality": "Chelmsford",
                        "postcode": "01824-3096",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "115983554436592",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tiny Toes Enrichment Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1fa6d738cd1130378a76e497ffa96",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.5488701,
                    50.4214287
                ]
            },
            "properties": {
                "categories": {
                    "primary": "active_life",
                    "alternate": [
                        "financial_service"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": [
                    "http://mymodule25.com/bobby59278"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/386289638246246"
                ],
                "phones": [
                    "+33983398826"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "7 Rue des Érables",
                        "locality": "Escautpont",
                        "postcode": "59278",
                        "region": "HDF",
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "386289638246246",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Bachelet",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a94d232e253403db1c8ddba5bd52",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.5356751,
                    41.6519602
                ]
            },
            "properties": {
                "categories": {
                    "primary": "interior_design",
                    "alternate": [
                        "architect"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://www.thecollaborativeinc.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "4192427405"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "500 Madison Ave",
                        "locality": "Toledo",
                        "postcode": "43604",
                        "region": "OH",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424930487160",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Collaborative Inc",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa810ce6700d7603b0a80d10d37415",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -46.3367047,
                    -23.9328808
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.8828720836685439,
                "websites": [
                    "http://www.loca-tudo.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "13997727627"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Av. Getúlio Dornelles Vargas 227",
                        "locality": "Santos",
                        "postcode": "11010-250",
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "2251799821390001",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "meta",
                        "record_id": "108295204073313",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Loca-Tudo Santos - Aluguel de Equipamentos, Máquinas e Andaimes",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a148c26954e203257be2962fe418",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.7902204,
                    41.9175711
                ]
            },
            "properties": {
                "categories": {
                    "primary": "aquatic_pet_store",
                    "alternate": [
                        "pet_store"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://emmonstropicalfish.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/117694358304050"
                ],
                "phones": [
                    "+18606585401"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1612 Hopmeadow St",
                        "locality": "Simsbury",
                        "postcode": "06070-1448",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "117694358304050",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Emmons Tropical Fish",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a494a876ca503dd4df58548f9fe",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.71144,
                    13.63293
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": [
                        "cafe"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109492235418514"
                ],
                "phones": [
                    "+6620023100"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ร้านคอฟฟี่ทูเดย์ ชั้น2 มาร์เก็ตวิลเลจ สุวรรณภูมิ ต.ราชาเทวะ อ.บางพลี",
                        "locality": null,
                        "postcode": "10540",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109492235418514",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Coffee Today MKVS",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f09044b360430372c2faf571a890",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    18.530056,
                    53.9635647
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.77,
                "websites": [
                    "https://www.smyk.com/"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "224480000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pomorska 7, Galeria Neptun",
                        "locality": "Starogard Gdański",
                        "postcode": "83-200",
                        "region": null,
                        "country": "PL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949965997712",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965996404",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Smyk - Cały dla małych!",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f685d528a5998503260d11e0644d21",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    125.82423,
                    7.43397
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": null
                },
                "confidence": 0.9456869009584664,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/349467184920840"
                ],
                "phones": [
                    "+639564857080"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Purok 2-A Durian Apokon  fronting Apokon Elementary School, near Rose Bakeshop",
                        "locality": "Tagum City",
                        "postcode": null,
                        "region": null,
                        "country": "PH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "349467184920840",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hola Coffee - Tagum",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fb25240a30da0103bd5c05cca6d5b5",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -68.5242276,
                    -31.5383677
                ]
            },
            "properties": {
                "categories": {
                    "primary": "money_transfer_services",
                    "alternate": null
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "08104441000"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Gral Mariano Acha Sur 342",
                        "locality": "San Juan",
                        "postcode": "5400",
                        "region": "San Juan",
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949965573216",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965571956",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949965570930",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Western Union",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f289459313a003d061b2137bf30f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.4665711,
                    -1.0239715
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.2459499263622975,
                "websites": [
                    "https://www.youtube.com/channel/ucdxkovb4j01-blslx5gu-zq"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104649115338093"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "ecuador",
                        "locality": "Quevedo",
                        "postcode": "090306",
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104649115338093",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Adrian FF",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fa81ed2e30a40603f055818837b7e2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -47.3967072,
                    -22.556434
                ]
            },
            "properties": {
                "categories": {
                    "primary": "landmark_and_historical_building",
                    "alternate": [
                        "fountain",
                        "accommodation"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1025883130807908"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Limeira",
                        "postcode": null,
                        "region": "SP",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1025883130807908",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Manutençoes residencias em geral",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ea07b418651a035b00265fdf7147",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    11.8276347,
                    44.4458361
                ]
            },
            "properties": {
                "categories": {
                    "primary": "physical_therapy",
                    "alternate": [
                        "beauty_salon",
                        "spas"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.fisioterapiaebenessere.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/437360692973065"
                ],
                "phones": [
                    "+39054584276"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Aurelio Saffi, 11",
                        "locality": "Massa Lombarda",
                        "postcode": "48024",
                        "region": "45",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "437360692973065",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Fisioterapia e Benessere di Cavina Cristina",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d12cd0914340035f5eab90da64c1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    76.976906,
                    29.37076
                ]
            },
            "properties": {
                "categories": {
                    "primary": "transportation",
                    "alternate": [
                        "travel"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112283490216961"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "26",
                        "locality": "Panipat",
                        "postcode": "132104",
                        "region": "HR",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112283490216961",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "New Dhillon Star Carrier",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f9d69a2c066d031e98cfffde7a51",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    8.8065275,
                    45.784404
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hair_salon",
                    "alternate": [
                        "beauty_and_spa",
                        "beauty_salon"
                    ]
                },
                "confidence": 0.9589055910024873,
                "websites": [
                    "http://www.lacortecaffi.it"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/336847093039995"
                ],
                "phones": [
                    "+390332890258"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Sardegna, 13",
                        "locality": "Buguggiate",
                        "postcode": "21020",
                        "region": "25",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "336847093039995",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "La Corte Acconciature Estetica",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f39547ad22018d0318439b1032f794",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -0.310842,
                    39.2023915
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon"
                    ]
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1688853921195850"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Valencia",
                        "postcode": null,
                        "region": null,
                        "country": "ES"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1688853921195850",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Ana Espai de Bellesa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f618925e0a6cf003002fc69ba7621e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    77.6254196,
                    12.9507799
                ]
            },
            "properties": {
                "categories": {
                    "primary": "professional_services",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/253791988083935"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "85 2nd Main Road",
                        "locality": "Bengaluru",
                        "postcode": "560094",
                        "region": "KA",
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "253791988083935",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Frozen Framez Photography",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8c1078872ed51035f63fa6d2c1352",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.80665,
                    -6.2258
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": null
                },
                "confidence": 0.9140030441400304,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/317227408149080"
                ],
                "phones": [
                    "+6285973877383"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "52, Jalan Jenderal Sudirman",
                        "locality": "Jakarta",
                        "postcode": "12190",
                        "region": null,
                        "country": "ID"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "317227408149080",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Emados Elite",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f650690ea718a30322b1af180b7b6f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.32607,
                    3.80486
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": null
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104178668274050"
                ],
                "phones": [
                    "+60193724667"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "12 Jalan Mahkota",
                        "locality": "Kuantan",
                        "postcode": "25000",
                        "region": null,
                        "country": "MY"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104178668274050",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "PTC Jalan Mahkota",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f316c54928128303ab2bac729807ce",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    131.88077,
                    43.12001
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "cosmetic_and_beauty_supplies",
                        "professional_services"
                    ]
                },
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/103690865484977"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Пограничная улица 12",
                        "locality": "Владивосток",
                        "postcode": "690091",
                        "region": null,
                        "country": "RU"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "103690865484977",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "AlterEgo Italy Владивосток",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f5882643bb30db0385649226e72b45",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    3.32382,
                    6.61198
                ]
            },
            "properties": {
                "categories": {
                    "primary": "community_services_non_profits",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1767857170188158"
                ],
                "phones": [
                    "+2347031663268"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "40 ashiata street Eke Abatete",
                        "locality": "Ikeja",
                        "postcode": "+234",
                        "region": null,
                        "country": "NG"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1767857170188158",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "MichealRose Orphanage Home.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f242f2ba622a035411a203957407",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    10.4763627,
                    57.3174276
                ]
            },
            "properties": {
                "categories": {
                    "primary": "recycling_center",
                    "alternate": [
                        "metal_supplier"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.saeby-produkthandel.dk/index.html"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/249459051818421"
                ],
                "phones": [
                    "+4528682243"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Jupitervej 14",
                        "locality": "Sæby",
                        "postcode": "9300",
                        "region": "81",
                        "country": "DK"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "249459051818421",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Sæby Produkthandel",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f27594c445dcea03199b38e18cd07d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.9806536,
                    42.2620423
                ]
            },
            "properties": {
                "categories": {
                    "primary": "children's_clothing_store",
                    "alternate": [
                        "thrift_store"
                    ]
                },
                "confidence": 0.980220700152207,
                "websites": [
                    "http://www.onceuponachildrockford.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1651358198471880"
                ],
                "phones": [
                    "+17797749329"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "991 S Perryville Rd",
                        "locality": "Rockford",
                        "postcode": "61108-4341",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1651358198471880",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1688849863014955",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Once Upon A Child - Rockford, IL",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3969a41cac2d30370e0e25cb8a6ae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    7.4278377,
                    43.7339453
                ]
            },
            "properties": {
                "categories": {
                    "primary": "shopping",
                    "alternate": [
                        "education",
                        "scuba_diving_center"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": [
                    "https://xccr-by-prodive.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112700453464391"
                ],
                "phones": [
                    "+33640626233"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "16 Quai Antoine 1er",
                        "locality": "Monaco",
                        "postcode": "98000",
                        "region": null,
                        "country": "MC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112700453464391",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CCR by Prodive",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2c366a46717920371b691845dbab2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    40.59116,
                    37.19072
                ]
            },
            "properties": {
                "categories": {
                    "primary": "information_technology_company",
                    "alternate": null
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/661872537318253"
                ],
                "phones": [
                    "+905444726818"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Yenı Tansas Gıyım Maga, Kilise Caddesi 27",
                        "locality": "Kızıltepe",
                        "postcode": "47400",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "661872537318253",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Yildiz Güvenlik Sistemleri",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a486a12ac4a03f39c97e68bd40c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.6185222,
                    13.7013423
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beer_bar",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/101910424964645"
                ],
                "phones": [
                    "+66989755177"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "สุขุมวิท​93​",
                        "locality": "Bangkok",
                        "postcode": "10260",
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "101910424964645",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Beer จะไปไหน",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a1985ad6d0303f9ba54f849c01e",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.4702258,
                    34.0027427
                ]
            },
            "properties": {
                "categories": {
                    "primary": "automotive_parts_and_accessories",
                    "alternate": [
                        "sporting_goods",
                        "active_life"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.rackattack.com/store/los-angeles/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/293038242222"
                ],
                "phones": [
                    "+14242591993"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Rack Attack",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "3127 Lincoln Blvd",
                        "locality": "Santa Monica",
                        "postcode": "90405-5736",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "293038242222",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424932411994",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949963881486",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Rack Attack",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3d8dcd4b691150393bc9c40cb78ae",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    80.93614,
                    26.85552
                ]
            },
            "properties": {
                "categories": {
                    "primary": "police_department",
                    "alternate": [
                        "professional_services"
                    ]
                },
                "confidence": 0.30856423173803527,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/421042711616127"
                ],
                "phones": [
                    "+919335914806"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "University Road",
                        "locality": "Lucknow",
                        "postcode": "226001",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "421042711616127",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Police Chowki-Hazratganj",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26de799813371034bff628a7381cd",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -101.8693862,
                    33.5884506
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "hair_salon"
                    ]
                },
                "confidence": 0.9901847010204943,
                "websites": [
                    "https://l.instagram.com/?u=https%3a%2f%2fwww.thesocialitesalonlubbock.com%2f%3ffbclid%3dpazxh0bgnhzw0cmteaaabufllhlszy-rofad9b8rmt0nloucqsiyv4qktwkt0aol5apmqo-6lyo2e_aem_5vhv34b5echzjdwqznpbbg&e=at0sk--vdiimwjtj9hyfnbdy-m_ghl8oobhskfmf_ilaah7dghizjfq3xd1gdcs_yvjbnkastre2x8pmtounlstu250utulxetcdv9u"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/113491361690480"
                ],
                "phones": [
                    "+18065437313"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "2400 Glenna Goodacre Blvd",
                        "locality": "Lubbock",
                        "postcode": "79401-2254",
                        "region": "TX",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "113491361690480",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "2251799821286066",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "The Socialite Salon",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f659949c932a5a034ec5d181402510",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    102.101872,
                    14.99811
                ]
            },
            "properties": {
                "categories": {
                    "primary": "funeral_services_and_cemeteries",
                    "alternate": [
                        "religious_organization"
                    ]
                },
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/334218897343073"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "334218897343073",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "วัดเวฬุวนาราม",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f196b861c210e603a86bfafc1778f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    4.3931218,
                    52.1443645
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lingerie_store",
                    "alternate": [
                        "clothing_store",
                        "women's_clothing_store"
                    ]
                },
                "confidence": 0.989360400078963,
                "websites": [
                    "https://www.hunkemoller.nl/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/567897010255136"
                ],
                "phones": [
                    "+31707370674"
                ],
                "brand": {
                    "wikidata": null,
                    "names": {
                        "primary": "Hunkemöller",
                        "common": null,
                        "rules": null
                    }
                },
                "addresses": [
                    {
                        "freeform": "Langstraat 34",
                        "locality": "Wassenaar",
                        "postcode": "2242 KM",
                        "region": null,
                        "country": "NL"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "567897010255136",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "1407374888656104",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Hunkemöller",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1ec91a8121072038cb499571f2da9",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    28.84499,
                    40.99223
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.926605504587156,
                "websites": [
                    "http://truescho.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/222980014866091"
                ],
                "phones": [
                    "+905536599104"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Meriç Sokak 11",
                        "locality": "Bahçelievler",
                        "postcode": "34188",
                        "region": null,
                        "country": "TR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "222980014866091",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "تروسكو - الإقامة في تركيا",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e94656084605031f3f85820d7821",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    9.6112642,
                    40.3838554
                ]
            },
            "properties": {
                "categories": {
                    "primary": "hotel",
                    "alternate": [
                        "accommodation"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "http://www.anticoborgogaltrelli.it/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/114041788427133"
                ],
                "phones": [
                    "+393407989291"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Grazia Deledda, 36",
                        "locality": "Galtellì",
                        "postcode": "08020",
                        "region": "88",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "114041788427133",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Castello Malicas Antico Borgo",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f4bb101424b5480301980f0580df4b",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    120.3217666,
                    22.6741566
                ]
            },
            "properties": {
                "categories": {
                    "primary": "food_stand",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/328211580670527"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "鼎貴路上",
                        "locality": "Kaohsiung",
                        "postcode": null,
                        "region": null,
                        "country": "TW"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "328211580670527",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "大姐頭黃金涼麵",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f182c891204686031138488f33eb6d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -6.4005503,
                    53.5114266
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "hair_salon"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.lavenue.ie/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/172850869521355"
                ],
                "phones": [
                    "+35318352016"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Unit 9 Killegland St",
                        "locality": null,
                        "postcode": "A84 RR71",
                        "region": null,
                        "country": "IE"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "172850869521355",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "L'Avenue",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44f6d00d809b20318520b5dfb1dbf",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.900664,
                    28.9709366
                ]
            },
            "properties": {
                "categories": {
                    "primary": "fire_and_water_damage_restoration",
                    "alternate": [
                        "damage_restoration"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    ""
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "3862102960"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1831 Evergreen Drive",
                        "locality": "Edgewater",
                        "postcode": "32132",
                        "region": "FL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "562949962647385",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Water Damage Services Edgewater",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1eec39a0627340330621134568193",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    26.62636,
                    44.7170662
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.25185185185185177,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/290888397450375"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Urziceni",
                        "locality": "Urziceni Padure",
                        "postcode": "<<not-applicable>>",
                        "region": null,
                        "country": "RO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "290888397450375",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "nepal contain",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3ce4774902d1b03cbfce28464c442",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    90.0634718,
                    26.5676963
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.5592783505154639,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111992400473048"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Kachugaon Central Range Forest Office ",
                        "locality": "Kokrajhar",
                        "postcode": "783360",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111992400473048",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Raimona National Park",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f275922082a0db03c1b5fed746fbac",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.06542,
                    42.02617
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/104389789406348"
                ],
                "phones": [
                    "+13316457812"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Schaumburg",
                        "postcode": null,
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "104389789406348",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Familia con Brenda ",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f26462768352f603ecaaeea1d23d70",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.4100305,
                    38.6744629
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": [
                        "beauty_salon",
                        "makeup_artist"
                    ]
                },
                "confidence": 0.9835557673975215,
                "websites": [
                    "https://linktr.ee/bareluxebeauty_stl"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1934253236786444"
                ],
                "phones": [
                    "+13147449904"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "10401 Olive Blvd",
                        "locality": "St Louis",
                        "postcode": "63141-7894",
                        "region": "MO",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1934253236786444",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "562949966312658",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "281474978816856",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "BareLUXE Beauty (powered by Winked by Carmen)",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08fc2e3103cb27800370309582e80419",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -58.429472,
                    -34.615122
                ]
            },
            "properties": {
                "categories": {
                    "primary": "campus_building",
                    "alternate": [
                        "college_university",
                        "education"
                    ]
                },
                "confidence": 0.4907481898632341,
                "websites": [
                    "http://www.cenv.org/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/189990201016701"
                ],
                "phones": [
                    "+541149826336"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Avenida Rivadavia 4529",
                        "locality": "Ciudad de Buenos Aires",
                        "postcode": "C1424",
                        "region": null,
                        "country": "AR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "189990201016701",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CENV | Centro de Estudios Nueva Vida",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f3cf2c618d439103971664974ac33c",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    88.39601,
                    22.57898
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.9140030441400304,
                "websites": [
                    "http://www.pragyodayafoundation.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/108730670831915"
                ],
                "phones": [
                    "+917535969681"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Pragyodaya Yoga & Wellness Center,n175/G, maniktala main road, Kankurgachi, kolkata",
                        "locality": "Kolkata",
                        "postcode": "700054",
                        "region": null,
                        "country": "IN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "108730670831915",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Pragyodaya Yoga & Wellness Center",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f29a1465015d4103c3f4c6c07a2af1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -118.156061,
                    34.6027656
                ]
            },
            "properties": {
                "categories": {
                    "primary": "real_estate_agent",
                    "alternate": [
                        "accommodation",
                        "professional_services"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://homesbyangelak.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/106403028679877"
                ],
                "phones": [
                    "+18187310087"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "1401 W Rancho Vista Blvd",
                        "locality": "Palmdale",
                        "postcode": "93551-3990",
                        "region": "CA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "106403028679877",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Homesbyjoannag",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f64a485e901c1b03f28eee506706fa",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    100.64974,
                    13.78555
                ]
            },
            "properties": {
                "categories": {
                    "primary": "insurance_agency",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": [
                    "http://www.kanokprakanpai.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1118930918144576"
                ],
                "phones": [
                    "+66864794646"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Bangkok",
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1118930918144576",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "กนกประกันภัย",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44dca1c49cb0e030f5678e86bf49d",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.173757,
                    34.2062522
                ]
            },
            "properties": {
                "categories": {
                    "primary": "home_health_care",
                    "alternate": [
                        "home_service",
                        "retirement_home"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "https://caregiversoftheupstate.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/327041934462733"
                ],
                "phones": [
                    "+18642291488"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "712a Montague Ave",
                        "locality": "Greenwood",
                        "postcode": "29649-1439",
                        "region": "SC",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "327041934462733",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Caregivers of the Upstate",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f415c94563488403e9644e74bdde45",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    106.331109,
                    20.9376431
                ]
            },
            "properties": {
                "categories": {
                    "primary": "cafe",
                    "alternate": [
                        "pub",
                        "bar"
                    ]
                },
                "confidence": 0.2459499263622975,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/239008279556931"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Hai Duong",
                        "postcode": null,
                        "region": null,
                        "country": "VN"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "239008279556931",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Cafe Nam Cường Hải Dương",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2f5a30578c24003ecd04bec19b4f1",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    139.7981812,
                    35.7466283
                ]
            },
            "properties": {
                "categories": {
                    "primary": "japanese_restaurant",
                    "alternate": [
                        "sushi_restaurant",
                        "chicken_restaurant"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "https://motohara.owst.jp"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/100679138072550"
                ],
                "phones": [
                    "+81368062717"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "東京都足立区千住宮元町１４−１",
                        "locality": "足立区",
                        "postcode": "120-0043",
                        "region": null,
                        "country": "JP"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "100679138072550",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "炭焼地鶏もとはら",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f659ea4dd48c480330b4b2bcbc2239",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    103.6333389,
                    14.5664043
                ]
            },
            "properties": {
                "categories": null,
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107047365157548"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "TH"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107047365157548",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "รพ.สต.บ้านโคกสะอาด",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f66040414f30ab03ee3893b7306274",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.59881,
                    9.90374
                ]
            },
            "properties": {
                "categories": {
                    "primary": "event_planning",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/107189730992193"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Tenerife",
                        "postcode": null,
                        "region": null,
                        "country": "CO"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "107189730992193",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Tecnomusic94",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f432ea6482332d038dc3b4a18e60c0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    54.7638889,
                    32.2427778
                ]
            },
            "properties": {
                "categories": {
                    "primary": "mountain",
                    "alternate": null
                },
                "confidence": 0.265179677819083,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/1186100161464447"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": null,
                        "postcode": null,
                        "region": null,
                        "country": "IR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "1186100161464447",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Kūh-e Kalūt-e Talkh Av",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e1028b7b38560302f4eaf7cfba1f",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    15.6295564,
                    46.5631234
                ]
            },
            "properties": {
                "categories": {
                    "primary": "restaurant",
                    "alternate": [
                        "vegetarian_restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.9213349225268176,
                "websites": [
                    "http://www.restavracija-mango.si/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/511790295533113"
                ],
                "phones": [
                    "+38631374375"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Turnerjeva ulica 17",
                        "locality": "Maribor",
                        "postcode": "2000",
                        "region": null,
                        "country": "SI"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "511790295533113",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Restavracija Mango Maribor",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8f7699e44d54503b07ef7e713ff65",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.003458,
                    -2.8934308
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": null
                },
                "confidence": 0.27546777546777546,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/111377287128046"
                ],
                "phones": [
                    "+593994676192"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Presidente Luis Cordero 10",
                        "locality": "Cuenca",
                        "postcode": "010101",
                        "region": null,
                        "country": "EC"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "111377287128046",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Patricio Aguirre Ochoa",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a141736366ed03ff6d7c93c80442",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.8911045,
                    41.823581
                ]
            },
            "properties": {
                "categories": {
                    "primary": "american_restaurant",
                    "alternate": [
                        "restaurant",
                        "diner"
                    ]
                },
                "confidence": 0.9544565521095278,
                "websites": [
                    "http://www.dishrestaurantgroup.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/147148035317458"
                ],
                "phones": [
                    "+18606934927"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "144 Albany Tpke",
                        "locality": "Canton",
                        "postcode": "06019-2509",
                        "region": "CT",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "147148035317458",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Dish N Dat",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f44c19aba8e65a03239cfd0d271fc2",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.267,
                    33.24119
                ]
            },
            "properties": {
                "categories": {
                    "primary": "gift_shop",
                    "alternate": [
                        "arts_and_crafts",
                        "hobby_shop"
                    ]
                },
                "confidence": 0.9245689655172413,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/320184814502171"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": null,
                        "locality": "Griffin",
                        "postcode": null,
                        "region": "GA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "320184814502171",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "CV-3D",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2759048db20cd03029b3c967e9332",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.1829834,
                    42.1877708
                ]
            },
            "properties": {
                "categories": {
                    "primary": "doctor",
                    "alternate": [
                        "health_and_medical"
                    ]
                },
                "confidence": 0.77,
                "websites": [
                    "http://doctors.advocatehealth.com/p-richard-ferolo-lake-barrington-family-medicine"
                ],
                "emails": null,
                "socials": null,
                "phones": [
                    "8472779700"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "22285 N Pepper Rd Ste 211",
                        "locality": "Lake Barrington",
                        "postcode": "60010",
                        "region": "IL",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "msft",
                        "record_id": "844424932234789",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    },
                    {
                        "property": "/properties/existence",
                        "dataset": "msft",
                        "record_id": "844424931738328",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Richard Ferolo M.D.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f2a33a7439409c036057284b633219",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -70.9315642,
                    41.6149711
                ]
            },
            "properties": {
                "categories": {
                    "primary": "lawyer",
                    "alternate": [
                        "professional_services",
                        "legal_services"
                    ]
                },
                "confidence": 0.9567577686259828,
                "websites": [
                    "http://www.wqolaw.com/"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/222930394498437"
                ],
                "phones": [
                    "+15089927911"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "651 Orchard St",
                        "locality": "New Bedford",
                        "postcode": "02744-1017",
                        "region": "MA",
                        "country": "US"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "222930394498437",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Quintin Raymond J",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1e9a0562558c8035b5321fda085c0",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    13.341865,
                    38.1430335
                ]
            },
            "properties": {
                "categories": {
                    "primary": "construction_services",
                    "alternate": [
                        "contractor",
                        "building_supply_store"
                    ]
                },
                "confidence": 0.9537408699085346,
                "websites": [
                    "http://www.impresadigiovanna.it/web/index.php"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/109501678085431"
                ],
                "phones": [
                    "+39091307114"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Via Sicilia, 2",
                        "locality": "Palermo",
                        "postcode": "90144",
                        "region": "82",
                        "country": "IT"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "109501678085431",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Di Giovanna S.r.l.",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f1f912a5a32a24034030f20aa9b9e8",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    6.1262803,
                    45.9024516
                ]
            },
            "properties": {
                "categories": {
                    "primary": "coffee_shop",
                    "alternate": [
                        "restaurant",
                        "cafe"
                    ]
                },
                "confidence": 0.9573247870456271,
                "websites": [
                    "https://www.slake-coffee.com/annecy"
                ],
                "emails": null,
                "socials": [
                    "https://www.facebook.com/112746128076630"
                ],
                "phones": [
                    "+33450051651"
                ],
                "brand": null,
                "addresses": [
                    {
                        "freeform": "29 Rue Sommeiller",
                        "locality": "Annecy",
                        "postcode": "74000",
                        "region": null,
                        "country": "FR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "112746128076630",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Slake Coffee I Annecy",
                    "common": null,
                    "rules": null
                }
            }
        },
        {
            "id": "08f8af6bb4c8e12303ac3d52ef3a5209",
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -60.06736,
                    -3.07668
                ]
            },
            "properties": {
                "categories": {
                    "primary": "beauty_and_spa",
                    "alternate": null
                },
                "confidence": 0.9213349225268176,
                "websites": null,
                "emails": null,
                "socials": [
                    "https://www.facebook.com/297907136733967"
                ],
                "phones": null,
                "brand": null,
                "addresses": [
                    {
                        "freeform": "Rua guanabara",
                        "locality": "Manaus",
                        "postcode": "69090-090",
                        "region": "AM",
                        "country": "BR"
                    }
                ],
                "theme": "places",
                "type": "place",
                "version": 1,
                "sources": [
                    {
                        "property": "",
                        "dataset": "meta",
                        "record_id": "297907136733967",
                        "update_time": "2024-09-10T00:00:00.000Z",
                        "confidence": null
                    }
                ],
                "names": {
                    "primary": "Descontos de Cozinha",
                    "common": null,
                    "rules": null
                }
            }
        }
    ]
}